(function() {
    'use strict';

    window.App = angular
        .module('crm2PrintApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'ui.bootstrap',
            'oc.lazyLoad',
            'infinite-scroll',
            'angular-loading-bar',
            'ui.select','ngSanitize',
            'angularPayments',
            'summernote'
            // jhipster-needle-angularjs-add-module JHipster will add new module here
        ])
        .run(run);

    run.$inject = ['$rootScope', 'uiHelpers', 'stateHandler', 'translationHandler', '$location', '$cookies', '$window'];

    function run($rootScope, uiHelpers, stateHandler, translationHandler, $location, $cookies, $window) {
        stateHandler.initialize();
        translationHandler.initialize();


        //OneUI start
        // Access uiHelpers easily from all controllers
        $rootScope.helpers = uiHelpers;

        // On window resize or orientation change resize #main-container & Handle scrolling
        var resizeTimeout;

        jQuery(window).on('resize orientationchange', function () {
            clearTimeout(resizeTimeout);

            resizeTimeout = setTimeout(function(){
                $rootScope.helpers.uiHandleScroll();
                $rootScope.helpers.uiHandleMain();
            }, 150);
        });

        //https://www.tjvantoll.com/2012/06/15/detecting-print-requests-with-javascript/
        var beforePrint = function() {
            Tawk_API.hideWidget();
        };
        var afterPrint = function() {
            Tawk_API.showWidget();
        };
        if (window.matchMedia) {
            var mediaQueryList = window.matchMedia('print');
            mediaQueryList.addListener(function(mql) {
                if (mql.matches) {
                    beforePrint();
                } else {
                    afterPrint();
                }
            });
        }
        window.onbeforeprint = beforePrint;
        window.onafterprint = afterPrint;

        /*var search = $location.search();
        if(search.utm_source) {
            var utmSource = search.utm_source.split(":");
            $cookies.put("utm."+utmSource[0],utmSource[1]);
            $location.search({}).replace();
        }*/

        $rootScope.utm = {
            source: $cookies.get('utm_source')
        };

        //Google Analytics
        $window.ga('create','UA-80464593-1');
        $rootScope.$on('$stateChangeSuccess', function (event) {
            $window.ga('send', 'pageview', $location.path());
        });
    }

    /*
     *  Document   : app.js
     *  Author     : pixelcave
     *  Description: Setting up and vital functionality for our App
     *
     */

// Router configuration
    App.config(['$stateProvider', '$urlRouterProvider',
        function ($stateProvider, $urlRouterProvider) {
            //$urlRouterProvider.otherwise('/angularjs');
            $stateProvider
                .state('angularjs', {
                    url: '/angularjs',
                    templateUrl: 'content/views/ready_angularjs.html'
                })
                .state('dashboard', {
                    parent: 'admin',
                    url: '/dashboard',
                    controller: 'DashboardCtrl',
                    views: {
                        'content@': {
                            templateUrl: 'content/views/ready_dashboard.html',
                            controller: 'DashboardCtrl',
                            controllerAs: 'vm'
                        }
                    },
                    data: {
                        authorities: ['ROLE_USER'],
                        pageTitle: 'dashboard.title'
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('dashboard');
                            return $translate.refresh();
                        }],
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/slick/slick.min.css',
                                    'content/js/plugins/slick/slick-theme.min.css',
                                    'content/js/plugins/slick/slick.min.js',
                                    'content/js/plugins/chartjs/Chart.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('uiActivity', {
                    url: '/ui/activity',
                    templateUrl: 'content/views/ui_activity.html',
                    controller: 'UiActivityCtrl',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/sweetalert2/sweetalert2.min.css',
                                    'content/js/plugins/bootstrap-notify/bootstrap-notify.min.js',
                                    'content/js/plugins/sweetalert2/sweetalert2.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('uiTabs', {
                    url: '/ui/tabs',
                    templateUrl: 'content/views/ui_tabs.html'
                })
                .state('uiModalsTooltips', {
                    url: '/ui/modals-tooltips',
                    templateUrl: 'content/views/ui_modals_tooltips.html'
                })
                .state('uiColorThemes', {
                    url: '/ui/color-themes',
                    templateUrl: 'content/views/ui_color_themes.html'
                })
                .state('uiBlocksDraggable', {
                    url: '/ui/blocks-draggable',
                    templateUrl: 'content/views/ui_blocks_draggable.html',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/jquery-ui/jquery-ui.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('uiChatFull', {
                    url: '/ui/chat/full',
                    templateUrl: 'content/views/ui_chat_full.html',
                    controller: 'UiChatCtrl'
                })
                .state('uiChatFixed', {
                    url: '/ui/chat/fixed',
                    templateUrl: 'content/views/ui_chat_fixed.html',
                    controller: 'UiChatCtrl'
                })
                .state('uiChatPopup', {
                    url: '/ui/chat/popup',
                    templateUrl: 'content/views/ui_chat_popup.html',
                    controller: 'UiChatCtrl'
                })
                .state('tablesTools', {
                    url: '/tables/tools',
                    templateUrl: 'content/views/tables_tools.html'
                })
                .state('tablesDatatables', {
                    url: '/tables/datatables',
                    templateUrl: 'content/views/tables_datatables.html',
                    controller: 'TablesDatatablesCtrl',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/datatables/jquery.dataTables.min.css',
                                    'content/js/plugins/datatables/jquery.dataTables.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('formsPickersMore', {
                    url: '/forms/pickers-more',
                    templateUrl: 'content/views/forms_pickers_more.html',
                    controller: 'FormsPickersMoreCtrl',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/bootstrap-datepicker/bootstrap-datepicker3.min.css',
                                    'content/js/plugins/bootstrap-datetimepicker/bootstrap-datetimepicker.min.css',
                                    'content/js/plugins/bootstrap-colorpicker/css/bootstrap-colorpicker.min.css',
                                    'content/js/plugins/select2/select2.min.css',
                                    'content/js/plugins/select2/select2-bootstrap.min.css',
                                    'content/js/plugins/jquery-auto-complete/jquery.auto-complete.min.css',
                                    'content/js/plugins/ion-rangeslider/css/ion.rangeSlider.min.css',
                                    'content/js/plugins/ion-rangeslider/css/ion.rangeSlider.skinHTML5.min.css',
                                    'content/js/plugins/dropzonejs/dropzone.min.css',
                                    'content/js/plugins/jquery-tags-input/jquery.tagsinput.min.css',
                                    'content/js/plugins/bootstrap-datepicker/bootstrap-datepicker.min.js',
                                    'content/js/plugins/bootstrap-datetimepicker/moment.min.js',
                                    'content/js/plugins/bootstrap-datetimepicker/bootstrap-datetimepicker.min.js',
                                    'content/js/plugins/bootstrap-colorpicker/bootstrap-colorpicker.min.js',
                                    'content/js/plugins/bootstrap-maxlength/bootstrap-maxlength.min.js',
                                    'content/js/plugins/select2/select2.full.min.js',
                                    'content/js/plugins/masked-inputs/jquery.maskedinput.min.js',
                                    'content/js/plugins/jquery-auto-complete/jquery.auto-complete.min.js',
                                    'content/js/plugins/ion-rangeslider/js/ion.rangeSlider.min.js',
                                    'content/js/plugins/dropzonejs/dropzone.min.js',
                                    'content/js/plugins/jquery-tags-input/jquery.tagsinput.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('formsEditors', {
                    url: '/forms/editors',
                    templateUrl: 'content/views/forms_editors.html',
                    controller: 'FormsEditorsCtrl',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/summernote/summernote.min.css',
                                    'content/js/plugins/summernote/summernote-bs3.min.css',
                                    'content/js/plugins/summernote/summernote.min.js',
                                    'content/js/plugins/ckeditor/ckeditor.js'
                                ]
                            });
                        }]
                    }
                })
                .state('formsValidation', {
                    url: '/forms/validation',
                    templateUrl: 'content/views/forms_validation.html',
                    controller: 'FormsValidationCtrl',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/select2/select2.min.css',
                                    'content/js/plugins/select2/select2-bootstrap.min.css',
                                    'content/js/plugins/select2/select2.full.min.js',
                                    'content/js/plugins/jquery-validation/jquery.validate.min.js',
                                    'content/js/plugins/jquery-validation/additional-methods.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('formsWizard', {
                    url: '/forms/wizard',
                    templateUrl: 'content/views/forms_wizard.html',
                    controller: 'FormsWizardCtrl',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/bootstrap-wizard/jquery.bootstrap.wizard.min.js',
                                    'content/js/plugins/jquery-validation/jquery.validate.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('compCharts', {
                    url: '/components/charts',
                    templateUrl: 'content/views/comp_charts.html',
                    controller: 'CompChartsCtrl',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/sparkline/jquery.sparkline.min.js',
                                    'content/js/plugins/easy-pie-chart/jquery.easypiechart.min.js',
                                    'content/js/plugins/chartjs/Chart.min.js',
                                    'content/js/plugins/flot/jquery.flot.min.js',
                                    'content/js/plugins/flot/jquery.flot.pie.min.js',
                                    'content/js/plugins/flot/jquery.flot.stack.min.js',
                                    'content/js/plugins/flot/jquery.flot.resize.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('compCalendar', {
                    url: '/components/calendar',
                    templateUrl: 'content/views/comp_calendar.html',
                    controller: 'CompCalendarCtrl',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/fullcalendar/fullcalendar.min.css',
                                    'content/js/plugins/jquery-ui/jquery-ui.min.js',
                                    'content/js/plugins/fullcalendar/moment.min.js',
                                    'content/js/plugins/fullcalendar/fullcalendar.min.js',
                                    'content/js/plugins/fullcalendar/gcal.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('compSliders', {
                    url: '/components/sliders',
                    templateUrl: 'content/views/comp_sliders.html',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/slick/slick.min.css',
                                    'content/js/plugins/slick/slick-theme.min.css',
                                    'content/js/plugins/slick/slick.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('compScrolling', {
                    url: '/components/scrolling',
                    templateUrl: 'content/views/comp_scrolling.html'
                })
                .state('compSyntaxHighlighting', {
                    url: '/components/syntax-highlighting',
                    templateUrl: 'content/views/comp_syntax_highlighting.html',
                    controller: 'CompSyntaxHighlightingCtrl',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/highlightjs/github-gist.min.css',
                                    'content/js/plugins/highlightjs/highlight.pack.js'
                                ]
                            });
                        }]
                    }
                })
                .state('compRating', {
                    url: '/components/rating',
                    templateUrl: 'content/views/comp_rating.html',
                    controller: 'CompRatingCtrl',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/jquery-raty/jquery.raty.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('compTreeview', {
                    url: '/components/treeview',
                    templateUrl: 'content/views/comp_treeview.html',
                    controller: 'CompTreeviewCtrl',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/bootstrap-treeview/bootstrap-treeview.min.css',
                                    'content/js/plugins/bootstrap-treeview/bootstrap-treeview.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('compMapsGoogle', {
                    url: '/components/maps/google',
                    templateUrl: 'content/views/comp_maps.html',
                    controller: 'CompMapsGoogleCtrl',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    { type: 'js', path: '//maps.google.com/maps/api/js' },
                                    'content/js/plugins/gmapsjs/gmaps.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('compMapsGoogleFull', {
                    url: '/components/maps/google-full',
                    templateUrl: 'content/views/comp_maps_full.html',
                    controller: 'CompMapsGoogleFullCtrl',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    { type: 'js', path: '//maps.google.com/maps/api/js' },
                                    'content/js/plugins/gmapsjs/gmaps.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('compMapsVector', {
                    url: '/components/maps/vector',
                    templateUrl: 'content/views/comp_maps_vector.html',
                    controller: 'CompMapsVectorCtrl',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/jquery-jvectormap/jquery-jvectormap.min.css',
                                    'content/js/plugins/jquery-jvectormap/jquery-jvectormap.min.js',
                                    'content/js/plugins/jquery-jvectormap/maps/jquery-jvectormap-au-mill-en.js',
                                    'content/js/plugins/jquery-jvectormap/maps/jquery-jvectormap-cn-mill-en.js',
                                    'content/js/plugins/jquery-jvectormap/maps/jquery-jvectormap-de-mill-en.js',
                                    'content/js/plugins/jquery-jvectormap/maps/jquery-jvectormap-europe-mill-en.js',
                                    'content/js/plugins/jquery-jvectormap/maps/jquery-jvectormap-fr-mill-en.js',
                                    'content/js/plugins/jquery-jvectormap/maps/jquery-jvectormap-in-mill-en.js',
                                    'content/js/plugins/jquery-jvectormap/maps/jquery-jvectormap-us-aea-en.js',
                                    'content/js/plugins/jquery-jvectormap/maps/jquery-jvectormap-world-mill-en.js',
                                    'content/js/plugins/jquery-jvectormap/maps/jquery-jvectormap-za-mill-en.js'
                                ]
                            });
                        }]
                    }
                })
                .state('compGallerySimple', {
                    url: '/components/gallery/simple',
                    templateUrl: 'content/views/comp_gallery_simple.html',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/magnific-popup/magnific-popup.min.css',
                                    'content/js/plugins/magnific-popup/magnific-popup.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('compGalleryAdvanced', {
                    url: '/components/gallery/advanced',
                    templateUrl: 'content/views/comp_gallery_advanced.html',
                    resolve: {
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/magnific-popup/magnific-popup.min.css',
                                    'content/js/plugins/magnific-popup/magnific-popup.min.js'
                                ]
                            });
                        }]
                    }
                })
                .state('blocks', {
                    url: '/blocks',
                    templateUrl: 'content/views/api_blocks.html'
                })
                .state('layout', {
                    url: '/layout',
                    templateUrl: 'content/views/api_layout.html'
                })
                .state('create', {
                    url: '/create',
                    templateUrl: 'content/views/ready_create.html'
                });
        }
    ]);

// Tooltips and Popovers configuration
    App.config(['$uibTooltipProvider',
        function ($uibTooltipProvider) {
            $uibTooltipProvider.options({
                appendToBody: true
            });
        }
    ]);

// Custom UI helper functions
    App.factory('uiHelpers', function () {
        return {
            // Handles active color theme
            uiHandleColorTheme: function (themeName) {
                var colorTheme = jQuery('#css-theme');

                if (themeName) {
                    if (colorTheme.length && (colorTheme.prop('href') !== 'content/css/themes/' + themeName + '.min.css')) {
                        jQuery('#css-theme').prop('href', 'content/css/themes/' + themeName + '.min.css');
                    } else if (!colorTheme.length) {
                        jQuery('#css-main').after('<link rel="stylesheet" id="css-theme" href="content/css/themes/' + themeName + '.min.css">');
                    }
                } else {
                    if (colorTheme.length) {
                        colorTheme.remove();
                    }
                }
            },
            // Handles #main-container height resize to push footer to the bottom of the page
            uiHandleMain: function () {
                var lMain       = jQuery('#main-container');
                var hWindow     = jQuery(window).height();
                var hHeader     = jQuery('#header-navbar').outerHeight();
                var hFooter     = jQuery('#page-footer').outerHeight();

                if (jQuery('#page-container').hasClass('header-navbar-fixed')) {
                    lMain.css('min-height', hWindow - hFooter);
                } else {
                    lMain.css('min-height', hWindow - (hHeader + hFooter));
                }
            },
            // Handles transparent header functionality (solid on scroll - used in frontend pages)
            uiHandleHeader: function () {
                var lPage = jQuery('#page-container');

                if (lPage.hasClass('header-navbar-fixed') && lPage.hasClass('header-navbar-transparent')) {
                    jQuery(window).on('scroll', function(){
                        if (jQuery(this).scrollTop() > 20) {
                            lPage.addClass('header-navbar-scroll');
                        } else {
                            lPage.removeClass('header-navbar-scroll');
                        }
                    });
                }
            },
            // Handles sidebar and side overlay custom scrolling functionality
            uiHandleScroll: function(mode) {
                var windowW            = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                var lPage              = jQuery('#page-container');
                var lSidebar           = jQuery('#sidebar');
                var lSidebarScroll     = jQuery('#sidebar-scroll');
                var lSideOverlay       = jQuery('#side-overlay');
                var lSideOverlayScroll = jQuery('#side-overlay-scroll');

                // Init scrolling
                if (mode === 'init') {
                    // Init scrolling only if required the first time
                    uiHandleScroll();
                } else {
                    // If screen width is greater than 991 pixels and .side-scroll is added to #page-container
                    if (windowW > 991 && lPage.hasClass('side-scroll') && (lSidebar.length || lSideOverlay.length)) {
                        // If sidebar exists
                        if (lSidebar.length) {
                            // Turn sidebar's scroll lock off (slimScroll will take care of it)
                            jQuery(lSidebar).scrollLock('disable');

                            // If sidebar scrolling does not exist init it..
                            if (lSidebarScroll.length && (!lSidebarScroll.parent('.slimScrollDiv').length)) {
                                lSidebarScroll.slimScroll({
                                    height: lSidebar.outerHeight(),
                                    color: '#fff',
                                    size: '5px',
                                    opacity : .35,
                                    wheelStep : 15,
                                    distance : '2px',
                                    railVisible: false,
                                    railOpacity: 1
                                });
                            }
                            else { // ..else resize scrolling height
                                lSidebarScroll
                                    .add(lSidebarScroll.parent())
                                    .css('height', lSidebar.outerHeight());
                            }
                        }

                        // If side overlay exists
                        if (lSideOverlay.length) {
                            // Turn side overlay's scroll lock off (slimScroll will take care of it)
                            jQuery(lSideOverlay).scrollLock('disable');

                            // If side overlay scrolling does not exist init it..
                            if (lSideOverlayScroll.length && (!lSideOverlayScroll.parent('.slimScrollDiv').length)) {
                                lSideOverlayScroll.slimScroll({
                                    height: lSideOverlay.outerHeight(),
                                    color: '#000',
                                    size: '5px',
                                    opacity : .35,
                                    wheelStep : 15,
                                    distance : '2px',
                                    railVisible: false,
                                    railOpacity: 1
                                });
                            }
                            else { // ..else resize scrolling height
                                lSideOverlayScroll
                                    .add(lSideOverlayScroll.parent())
                                    .css('height', lSideOverlay.outerHeight());
                            }
                        }
                    } else {
                        // If sidebar exists
                        if (lSidebar.length) {
                            // If sidebar scrolling exists destroy it..
                            if (lSidebarScroll.length && lSidebarScroll.parent('.slimScrollDiv').length) {
                                lSidebarScroll
                                    .slimScroll({destroy: true});
                                lSidebarScroll
                                    .attr('style', '');
                            }

                            // Turn sidebars's scroll lock on
                            jQuery(lSidebar).scrollLock();
                        }

                        // If side overlay exists
                        if (lSideOverlay.length) {
                            // If side overlay scrolling exists destroy it..
                            if (lSideOverlayScroll.length && lSideOverlayScroll.parent('.slimScrollDiv').length) {
                                lSideOverlayScroll
                                    .slimScroll({destroy: true});
                                lSideOverlayScroll
                                    .attr('style', '');
                            }

                            // Turn side overlay's scroll lock on
                            jQuery(lSideOverlay).scrollLock();
                        }
                    }
                }
            },
            // Handles page loader functionality
            uiLoader: function (mode) {
                var lBody       = jQuery('body');
                var lpageLoader = jQuery('#page-loader');

                if (mode === 'show') {
                    if (lpageLoader.length) {
                        lpageLoader.fadeIn(250);
                    } else {
                        lBody.prepend('<div id="page-loader"></div>');
                    }
                } else if (mode === 'hide') {
                    if (lpageLoader.length) {
                        lpageLoader.fadeOut(250);
                    }
                }
            },
            // Handles blocks API functionality
            uiBlocks: function (block, mode, button) {
                // Set default icons for fullscreen and content toggle buttons
                var iconFullscreen         = 'si si-size-fullscreen';
                var iconFullscreenActive   = 'si si-size-actual';
                var iconContent            = 'si si-arrow-up';
                var iconContentActive      = 'si si-arrow-down';

                if (mode === 'init') {
                    // Auto add the default toggle icons
                    switch(button.data('action')) {
                        case 'fullscreen_toggle':
                            button.html('<i class="' + (button.closest('.block').hasClass('block-opt-fullscreen') ? iconFullscreenActive : iconFullscreen) + '"></i>');
                            break;
                        case 'content_toggle':
                            button.html('<i class="' + (button.closest('.block').hasClass('block-opt-hidden') ? iconContentActive : iconContent) + '"></i>');
                            break;
                        default:
                            return false;
                    }
                } else {
                    // Get block element
                    var elBlock = (block instanceof jQuery) ? block : jQuery(block);

                    // If element exists, procceed with blocks functionality
                    if (elBlock.length) {
                        // Get block option buttons if exist (need them to update their icons)
                        var btnFullscreen  = jQuery('[data-js-block-option][data-action="fullscreen_toggle"]', elBlock);
                        var btnToggle      = jQuery('[data-js-block-option][data-action="content_toggle"]', elBlock);

                        // Mode selection
                        switch(mode) {
                            case 'fullscreen_toggle':
                                elBlock.toggleClass('block-opt-fullscreen');

                                // Enable/disable scroll lock to block
                                elBlock.hasClass('block-opt-fullscreen') ? jQuery(elBlock).scrollLock() : jQuery(elBlock).scrollLock('off');

                                // Update block option icon
                                if (btnFullscreen.length) {
                                    if (elBlock.hasClass('block-opt-fullscreen')) {
                                        jQuery('i', btnFullscreen)
                                            .removeClass(iconFullscreen)
                                            .addClass(iconFullscreenActive);
                                    } else {
                                        jQuery('i', btnFullscreen)
                                            .removeClass(iconFullscreenActive)
                                            .addClass(iconFullscreen);
                                    }
                                }
                                break;
                            case 'fullscreen_on':
                                elBlock.addClass('block-opt-fullscreen');

                                // Enable scroll lock to block
                                jQuery(elBlock).scrollLock();

                                // Update block option icon
                                if (btnFullscreen.length) {
                                    jQuery('i', btnFullscreen)
                                        .removeClass(iconFullscreen)
                                        .addClass(iconFullscreenActive);
                                }
                                break;
                            case 'fullscreen_off':
                                elBlock.removeClass('block-opt-fullscreen');

                                // Disable scroll lock to block
                                jQuery(elBlock).scrollLock('off');

                                // Update block option icon
                                if (btnFullscreen.length) {
                                    jQuery('i', btnFullscreen)
                                        .removeClass(iconFullscreenActive)
                                        .addClass(iconFullscreen);
                                }
                                break;
                            case 'content_toggle':
                                elBlock.toggleClass('block-opt-hidden');

                                // Update block option icon
                                if (btnToggle.length) {
                                    if (elBlock.hasClass('block-opt-hidden')) {
                                        jQuery('i', btnToggle)
                                            .removeClass(iconContent)
                                            .addClass(iconContentActive);
                                    } else {
                                        jQuery('i', btnToggle)
                                            .removeClass(iconContentActive)
                                            .addClass(iconContent);
                                    }
                                }
                                break;
                            case 'content_hide':
                                elBlock.addClass('block-opt-hidden');

                                // Update block option icon
                                if (btnToggle.length) {
                                    jQuery('i', btnToggle)
                                        .removeClass(iconContent)
                                        .addClass(iconContentActive);
                                }
                                break;
                            case 'content_show':
                                elBlock.removeClass('block-opt-hidden');

                                // Update block option icon
                                if (btnToggle.length) {
                                    jQuery('i', btnToggle)
                                        .removeClass(iconContentActive)
                                        .addClass(iconContent);
                                }
                                break;
                            case 'refresh_toggle':
                                elBlock.toggleClass('block-opt-refresh');

                                // Return block to normal state if the demostration mode is on in the refresh option button - data-action-mode="demo"
                                if (jQuery('[data-js-block-option][data-action="refresh_toggle"][data-action-mode="demo"]', elBlock).length) {
                                    setTimeout(function(){
                                        elBlock.removeClass('block-opt-refresh');
                                    }, 2000);
                                }
                                break;
                            case 'state_loading':
                                elBlock.addClass('block-opt-refresh');
                                break;
                            case 'state_normal':
                                elBlock.removeClass('block-opt-refresh');
                                break;
                            case 'close':
                                elBlock.hide();
                                break;
                            case 'open':
                                elBlock.show();
                                break;
                            default:
                                return false;
                        }
                    }
                }
            }
        };
    });

// Run our App
    /*
     App.run(function($rootScope, uiHelpers) {
     // Access uiHelpers easily from all controllers
     $rootScope.helpers = uiHelpers;

     // On window resize or orientation change resize #main-container & Handle scrolling
     var resizeTimeout;

     jQuery(window).on('resize orientationchange', function () {
     clearTimeout(resizeTimeout);

     resizeTimeout = setTimeout(function(){
     $rootScope.helpers.uiHandleScroll();
     $rootScope.helpers.uiHandleMain();
     }, 150);
     });
     });
     */

// Application Main Controller
    App.controller('AppCtrl', ['$scope', '$localStorage', '$window', 'Principal',
        function ($scope, $localStorage, $window, Principal) {
            $scope.vm = this;
            this.isAuthenticated = Principal.isAuthenticated;

            // Template Settings
            $scope.oneui = {
                version: '2.0', // Template version
                localStorage: false, // Enable/Disable local storage
                settings: {
                    activeColorTheme: false, // Set a color theme of your choice, available: 'amethyst', 'city, 'flat', 'modern' and 'smooth'
                    sidebarLeft: true, // true: Left Sidebar and right Side Overlay, false: Right Sidebar and left Side Overlay
                    sidebarOpen: true, // Visible Sidebar by default (> 991px)
                    sidebarOpenXs: false, // Visible Sidebar by default (< 992px)
                    sidebarMini: false, // Mini hoverable Sidebar (> 991px)
                    sideOverlayOpen: false, // Visible Side Overlay by default (> 991px)
                    sideOverlayHover: false, // Hoverable Side Overlay (> 991px)
                    sideScroll: true, // Enables custom scrolling on Sidebar and Side Overlay instead of native scrolling (> 991px)
                    headerFixed: true // Enables fixed header
                }
            };

            // If local storage setting is enabled
            if ($scope.oneui.localStorage) {
                // Save/Restore local storage settings
                if ($scope.oneui.localStorage) {
                    if (angular.isDefined($localStorage.oneuiSettings)) {
                        $scope.oneui.settings = $localStorage.oneuiSettings;
                    } else {
                        $localStorage.oneuiSettings = $scope.oneui.settings;
                    }
                }

                // Watch for settings changes
                $scope.$watch('oneui.settings', function () {
                    // If settings are changed then save them to localstorage
                    $localStorage.oneuiSettings = $scope.oneui.settings;
                }, true);
            }

            // Watch for activeColorTheme variable update
            $scope.$watch('oneui.settings.activeColorTheme', function () {
                // Handle Color Theme
                $scope.helpers.uiHandleColorTheme($scope.oneui.settings.activeColorTheme);
            }, true);

            // Watch for sideScroll variable update
            $scope.$watch('oneui.settings.sideScroll', function () {
                // Handle Scrolling
                setTimeout(function () {
                    $scope.helpers.uiHandleScroll();
                }, 150);
            }, true);

            // When view content is loaded
            $scope.$on('$viewContentLoaded', function () {
                // Hide page loader
                $scope.helpers.uiLoader('hide');

                // Resize #main-container
                $scope.helpers.uiHandleMain();
            });
        }
    ]);


    /*
     * Partial views controllers
     *
     */

// Side Overlay Controller
    App.controller('SideOverlayCtrl', ['$scope', '$localStorage', '$window',
        function ($scope, $localStorage, $window) {
            // When view content is loaded
            $scope.$on('$includeContentLoaded', function () {
                // Handle Scrolling
                $scope.helpers.uiHandleScroll();
            });
        }
    ]);

// Sidebar Controller
    App.controller('SidebarCtrl', ['$scope', '$localStorage', '$window', '$location',
        function ($scope, $localStorage, $window, $location) {
            // When view content is loaded
            $scope.$on('$includeContentLoaded', function () {
                // Handle Scrolling
                $scope.helpers.uiHandleScroll();

                // Get current path to use it for adding active classes to our submenus
                $scope.path = $location.path();
            });
        }
    ]);

// Header Controller
    App.controller('HeaderCtrl', ['$scope', '$localStorage', '$window',
        function ($scope, $localStorage, $window) {
            // When view content is loaded
            $scope.$on('$includeContentLoaded', function () {
                // Transparent header functionality
                $scope.helpers.uiHandleHeader();
            });
        }
    ]);


    //http://stackoverflow.com/questions/23324545/angularjs-ng-style-does-not-update-css-background-property
    App.directive('backgroundImage', function(){
        return function(scope, element, attrs){
            attrs.$observe('backgroundImage', function(value) {
                element.css({
                    'background': 'transparent url(' + value +') center center no-repeat'
                });
            });
        };
    });

    App.directive('aDisabled', function() {
        return {
            compile: function(tElement, tAttrs, transclude) {
                //Disable ngClick
                tAttrs["ngClick"] = "!("+tAttrs["aDisabled"]+") && ("+tAttrs["ngClick"]+")";

                //return a link function
                return function (scope, iElement, iAttrs) {

                    //Toggle "disabled" to class when aDisabled becomes true
                    scope.$watch(iAttrs["aDisabled"], function(newValue) {
                        if (newValue !== undefined) {
                            iElement.toggleClass("disabled", newValue);
                        }
                    });

                    //Disable href on click
                    iElement.on("click", function(e) {
                        if (scope.$eval(iAttrs["aDisabled"])) {
                            e.preventDefault();
                        }
                    });
                };
            }
        };
    });

    /*
     * Custom helper directives
     *
     */

// View loader functionality
// By adding the attribute 'data-js-view-loader'
    App.directive('jsViewLoader', function () {
        return {
            link: function (scope, element) {
                var el = jQuery(element);

                // Hide the view loader, populate it with content and style it
                el
                    .hide()
                    .html('<i class="fa-fw fa fa-refresh fa-spin text-primary"></i>')
                    .css({
                        'position': 'fixed',
                        'top': '20px',
                        'left': '50%',
                        'height': '20px',
                        'width': '20px',
                        'margin-left': '-10px',
                        'z-index': 99999
                    });

                // On state change start event, show the element
                scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
                    el.fadeIn(250);
                });

                // On state change success event, hide the element
                scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
                    el.fadeOut(250);
                });
            }
        };
    });

// Main navigation functionality
// By adding the attribute 'data-js-main-nav'
    App.directive('jsMainNav', function () {
        return {
            link: function (scope, element) {
                // When a submenu link is clicked
                jQuery('[data-toggle="nav-submenu"]', element).on('click', function(e){
                    // Get link
                    var link = jQuery(this);

                    // Get link's parent
                    var parentLi = link.parent('li');

                    if (parentLi.hasClass('open')) { // If submenu is open, close it..
                        parentLi.removeClass('open');
                    } else { // .. else if submenu is closed, close all other (same level) submenus first before open it
                        link
                            .closest('ul')
                            .find('> li')
                            .removeClass('open');

                        parentLi
                            .addClass('open');
                    }

                    return false;
                });

                // Remove focus when clicking on a link
                jQuery('a', element).on('click', function(){
                    jQuery(this).blur();
                });

                // On state change success event, hide the sidebar in mobile devices
                scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
                    scope.oneui.settings.sidebarOpenXs = false;
                });
            }
        };
    });

// Form helper functionality (placeholder support for IE9 which uses HTML5 Placeholder plugin + Material forms)
// Auto applied to all your form elements (<form>)
    App.directive('form', function () {
        return {
            restrict: 'E',
            link: function (scope, element) {
                // Init form placeholder (for IE9)
                jQuery('.form-control', element).placeholder();

                // Init material forms
                jQuery('.form-material.floating > .form-control', element).each(function(){
                    var input  = jQuery(this);
                    var parent = input.parent('.form-material');

                    if (input.val()) {
                        parent.addClass('open');
                    }

                    input.on('change', function(){
                        if (input.val()) {
                            parent.addClass('open');
                        } else {
                            parent.removeClass('open');
                        }
                    });
                });
            }
        };
    });

// Blocks options functionality
// By adding the attribute 'data-js-block-option'
    App.directive('jsBlockOption', function () {
        return {
            link: function (scope, element) {
                var el = jQuery(element);

                // Init Icons
                scope.helpers.uiBlocks(false, 'init', el);

                // Call blocks API on click
                el.on('click', function(){
                    scope.helpers.uiBlocks(el.closest('.block'), el.data('action'));
                });
            }
        };
    });

    App.directive('jsBlockAction', function () {
        return {
            link: function (scope, element) {
                var el = jQuery(element);

                // Call blocks API on click
                el.on('click', function(){
                    scope.helpers.uiBlocks(el.closest('.block'), el.data('action'));
                });
            }
        };
    });

// Print page on click
// By adding the attribute 'data-js-print'
    App.directive('jsPrint', function () {
        return {
            link: function(scope, element) {
                jQuery(element).on('click', function () {
                    // Store all #page-container classes
                    var lPage   = jQuery('#page-container');
                    var pageCls = lPage.prop('class');

                    // Remove all classes from #page-container
                    lPage.prop('class', '');

                    // Print the page
                    window.print();

                    // Restore all #page-container classes
                    lPage.prop('class', pageCls);
                });
            }
        };
    });

// Populate element's content with the correct copyright year
// By adding the attribute 'data-js-year-copy'
    App.directive('jsYearCopy', function () {
        return {
            link: function (scope, element) {
                var gdate     = new Date();
                var copyright = '2015';

                if (gdate.getFullYear() !== 2015) {
                    copyright = copyright + '-' + gdate.getFullYear().toString().substr(2,2);
                }

                element.text(copyright);
            }
        };
    });

// Animated scroll to an element
// By adding the attribute (with custom values) 'data-js-scroll-to="{target: '#target_element_id', speed: 'milliseconds'}"' to a button or a link
    App.directive('jsScrollTo', function () {
        return {
            link: function (scope, element, attrs) {
                var options = (typeof scope.$eval(attrs.jsScrollTo) !== 'undefined') ? scope.$eval(attrs.jsScrollTo) : new Object();

                jQuery(element).on('click', function () {
                    jQuery('html, body').animate({
                        scrollTop: jQuery(options.target).offset().top
                    }, options.speed ? options.speed : 1000);
                });
            }
        };
    });

// Toggle a class to a target element
// By adding the attribute (with custom values) 'data-js-toggle-class="{target: '#target_element_id', class: 'class_name_to_toggle'}'
    App.directive('jsToggleClass', function () {
        return {
            link: function (scope, element, attrs) {
                var options = (typeof scope.$eval(attrs.jsToggleClass) !== 'undefined') ? scope.$eval(attrs.jsToggleClass) : new Object();

                jQuery(element).on('click', function () {
                    jQuery(options.target).toggleClass(options.class);
                });
            }
        };
    });

// Removes focus from an element on click
// By adding the attribute 'data-js-blur'
    App.directive('jsBlur', function () {
        return {
            link: function (scope, element) {
                element.bind('click', function (){
                    element.blur();
                });
            }
        };
    });


    /*
     * Third party jQuery plugin inits or custom ui helpers packed in Angular directives for easy
     *
     */

// Bootstrap Tabs (legacy init - if you like, you can use the native implementation from Angular UI Bootstrap)
// By adding the attribute 'data-js-tabs' to a ul with Bootstrap tabs markup
    App.directive('jsTabs', function () {
        return {
            link: function (scope, element) {
                jQuery('a', element).on('click', function (e) {
                    e.preventDefault();
                    jQuery(this).tab('show');
                });
            }
        };
    });

// Custom Table functionality: Section toggling
// By adding the attribute 'data-js-table-sections' to your table
    App.directive('jsTableSections', function () {
        return {
            link: function (scope, element) {
                var table      = jQuery(element);
                var tableRows  = jQuery('.js-table-sections-header > tr', table);

                tableRows.on('click', function(e) {
                    var row    = jQuery(this);
                    var tbody  = row.parent('tbody');

                    if (! tbody.hasClass('open')) {
                        jQuery('tbody', table).removeClass('open');
                    }

                    tbody.toggleClass('open');
                });
            }
        };
    });

// Custom Table functionality: Checkable rows
// By adding the attribute 'data-js-table-checkable' to your table
    App.directive('jsTableCheckable', function () {
        return {
            link: function (scope, element) {
                var table = jQuery(element);

                // When a checkbox is clicked in thead
                jQuery('thead input:checkbox', table).click(function() {
                    var checkedStatus = jQuery(this).prop('checked');

                    // Check or uncheck all checkboxes in tbody
                    jQuery('tbody input:checkbox', table).each(function() {
                        var checkbox = jQuery(this);

                        checkbox.prop('checked', checkedStatus);
                        uiCheckRow(checkbox, checkedStatus);
                    });
                });

                // When a checkbox is clicked in tbody
                jQuery('tbody input:checkbox', table).click(function() {
                    var checkbox = jQuery(this);

                    uiCheckRow(checkbox, checkbox.prop('checked'));
                });

                // When a row is clicked in tbody
                jQuery('tbody > tr', table).click(function(e) {
                    if (e.target.type !== 'checkbox'
                        && e.target.type !== 'button'
                        && e.target.tagName.toLowerCase() !== 'a'
                        && !jQuery(e.target).parent('label').length) {
                        var checkbox       = jQuery('input:checkbox', this);
                        var checkedStatus  = checkbox.prop('checked');

                        checkbox.prop('checked', ! checkedStatus);
                        uiCheckRow(checkbox, ! checkedStatus);
                    }
                });

                // Checkable table functionality helper - Checks or unchecks table row
                var uiCheckRow = function(checkbox, checkedStatus) {
                    if (checkedStatus) {
                        checkbox
                            .closest('tr')
                            .addClass('active');
                    } else {
                        checkbox
                            .closest('tr')
                            .removeClass('active');
                    }
                };
            }
        };
    });

// jQuery Appear, for more examples you can check out https://github.com/bas2k/jquery.appear
// By adding the attribute (with custom values) 'data-js-appear="{speed: 1000, refreshInterval: 10, ...}'
    App.directive('jsAppear', function () {
        return {
            link: function (scope, element, attrs) {
                var options = (typeof scope.$eval(attrs.jsAppear) !== 'undefined') ? scope.$eval(attrs.jsAppear) : new Object();
                var el       = jQuery(element);
                var windowW  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

                el.bind('appear',function() {
                    setTimeout(function(){
                        el.removeClass('visibility-hidden')
                            .addClass(options.class ? options.class : 'animated fadeIn');
                    }, (jQuery('html').hasClass('ie9') || windowW < 992) ? 0 : (options.timeout ? options.timeout : 0));
                });
            }
        };
    });

// jQuery Appear + jQuery countTo, for more examples you can check out https://github.com/bas2k/jquery.appear and https://github.com/mhuggins/jquery-countTo
// By adding the attribute (with custom values) 'data-js-count-to="{speed: 1000, refreshInterval: 10, ...}'
    App.directive('jsCountTo', function () {
        return {
            link: function (scope, element, attrs) {
                var options = (typeof scope.$eval(attrs.jsCountTo) !== 'undefined') ? scope.$eval(attrs.jsCountTo) : new Object();
                var el      = jQuery(element);

                el.bind('appear',function() {
                    el.countTo({
                        speed: options.speed ? options.speed : 1500,
                        refreshInterval: options.refreshInterval ? options.refreshInterval : 15,
                        onComplete: function() {
                            if(options.after) {
                                el.html(el.html() + options.after);
                            }
                        }
                    });
                });
            }
        };
    });

// SlimScroll, for more examples you can check out http://rocha.la/jQuery-slimScroll
// By adding the attribute (with custom values) 'data-js-slimscroll="{height: '100px', size: '3px', ...}'
    App.directive('jsSlimscroll', function () {
        return {
            link: function (scope, element, attrs) {
                var options = (typeof scope.$eval(attrs.jsSlimscroll) !== 'undefined') ? scope.$eval(attrs.jsSlimscroll) : new Object();

                jQuery(element).slimScroll({
                    height: options.height ? options.height : '200px',
                    size: options.size ? options.size : '5px',
                    position: options.position ? options.position : 'right',
                    color: options.color ? options.color : '#000',
                    alwaysVisible: options.alwaysVisible ? true : false,
                    railVisible: options.railVisible ? true : false,
                    railColor: options.railColor ? options.railColor : '#999',
                    railOpacity: options.railOpacity ? options.railOpacity : .3
                });
            }
        };
    });

    /*
     ********************************************************************************************
     *
     * All the following directives require each plugin's resources (JS, CSS) to be lazy loaded in
     * the page in order to work, so please make sure you've included them in your route configuration
     *
     ********************************************************************************************
     */

// Magnific Popup, for more examples you can check out http://dimsemenov.com/plugins/magnific-popup/
// By adding the attribute (with custom value) 'data-js-magnific="{advancedGallery: false}'
    App.directive('jsMagnific', function () {
        return {
            link: function (scope, element, attrs) {
                var options = (typeof scope.$eval(attrs.jsMagnific) !== 'undefined') ? scope.$eval(attrs.jsMagnific) : new Object();

                jQuery(element).magnificPopup({
                    delegate: options.advancedGallery ? 'a.img-lightbox' : 'a.img-link',
                    type: 'image',
                    gallery: {
                        enabled: true
                    }
                });
            }
        };
    });

// Slick, for more examples you can check out http://kenwheeler.github.io/slick/
// By adding the attribute (with custom values) 'data-js-slider="{arrows: true, dots: true, ...}'
    App.directive('jsSlider', function () {
        return {
            link: function (scope, element, attrs) {
                var options = (typeof scope.$eval(attrs.jsSlider) !== 'undefined') ? scope.$eval(attrs.jsSlider) : new Object();

                jQuery(element).slick({
                    arrows: options.arrows ? options.arrows : false,
                    dots: options.dots ? options.dots : false,
                    slidesToShow: options.slidesToShow ? options.arrows : 1,
                    autoplay: options.autoplay ? options.autoplay : false,
                    autoplaySpeed: options.autoplaySpeed ? options.autoplaySpeed : 3000
                });
            }
        };
    });

// Bootstrap Datepicker, for more examples you can check out https://github.com/eternicode/bootstrap-datepicker
// By adding the attribute 'data-js-datepicker'
    App.directive('jsDatepicker', function () {
        return {
            link: function (scope, element) {
                jQuery(element).datepicker({
                    weekStart: 1,
                    autoclose: true,
                    todayHighlight: true
                });
            }
        };
    });

// Bootstrap Colorpicker, for more examples you can check out http://mjolnic.com/bootstrap-colorpicker/
// By adding the attribute (with custom value) 'data-js-colorpicker="{format: 'hex', inline: true}'
    App.directive('jsColorpicker', function () {
        return {
            link: function (scope, element, attrs) {
                var options = (typeof scope.$eval(attrs.jsColorpicker) !== 'undefined') ? scope.$eval(attrs.jsColorpicker) : new Object();

                jQuery(element).colorpicker({
                    format: options.format ? options.format : 'hex',
                    inline: options.inline ? true : false
                });
            }
        };
    });

// Masked Inputs, for more examples you can check out http://digitalbush.com/projects/masked-input-plugin/
// By adding the attribute (with custom value) 'data-js-masked-input="99/99/9999"'
    App.directive('jsMaskedInput', function () {
        return {
            link: function (scope, element, attrs) {
                jQuery(element).mask(attrs.jsMaskedInput);
            }
        };
    });

// Tags Inputs, for more examples you can check out https://github.com/xoxco/jQuery-Tags-Input
// By adding the attribute 'data-js-tags-input'
    App.directive('jsTagsInput', function () {
        return {
            link: function (scope, element) {
                jQuery(element).tagsInput({
                    height: '36px',
                    width: '100%',
                    defaultText: 'Add tag',
                    removeWithBackspace: true,
                    delimiter: [',']
                });
            }
        };
    });

// Bootstrap Notify, for more examples you can check out http://bootstrap-growl.remabledesigns.com/
// By adding the attribute (with custom values) 'data-js-notify="{icon: 'fa fa-check', message: 'Your message!', ... }'
    App.directive('jsNotify', function () {
        return {
            link: function (scope, element, attrs) {
                var options = (typeof scope.$eval(attrs.jsNotify) !== 'undefined') ? scope.$eval(attrs.jsNotify) : new Object();

                jQuery(element).on('click', function(){
                    jQuery.notify({
                            icon: options.icon ? options.icon : '',
                            message: options.message,
                            url: options.url ? options.url : ''
                        },
                        {
                            element: 'body',
                            type: options.type ? options.type : 'info',
                            allow_dismiss: true,
                            newest_on_top: true,
                            showProgressbar: false,
                            placement: {
                                from: options.from ? options.from : 'top',
                                align: options.align ? options.align : 'right'
                            },
                            offset: 20,
                            spacing: 10,
                            z_index: 1033,
                            delay: 5000,
                            timer: 1000,
                            animate: {
                                enter: 'animated fadeIn',
                                exit: 'animated fadeOutDown'
                            }
                        });
                });
            }
        };
    });

// Draggable items with jQuery, for more examples you can check out https://jqueryui.com/sortable/
// By adding the attribute 'data-js-draggable-items'
    App.directive('jsDraggableItems', function () {
        return {
            link: function (scope, element) {
                jQuery('.draggable-column', element).sortable({
                    connectWith: '.draggable-column',
                    items: '.draggable-item',
                    dropOnEmpty: true,
                    opacity: .75,
                    handle: '.draggable-handler',
                    placeholder: 'draggable-placeholder',
                    tolerance: 'pointer',
                    start: function(e, ui){
                        ui.placeholder.css({
                            'height': ui.item.outerHeight(),
                            'margin-bottom': ui.item.css('margin-bottom')
                        });
                    }
                });
            }
        };
    });

// Easy Pie Chart, for more examples you can check out http://rendro.github.io/easy-pie-chart/
// By adding the attribute (with custom values) 'data-js-pie-chart="{barColor: '#000', trackColor: '#eee', ... }'
    App.directive('jsPieChart', function () {
        return {
            link: function (scope, element, attrs) {
                var options = (typeof scope.$eval(attrs.jsPieChart) !== 'undefined') ? scope.$eval(attrs.jsPieChart) : new Object();

                jQuery(element).easyPieChart({
                    barColor: options.barColor ? options.barColor : '#777777',
                    trackColor: options.trackColor ? options.trackColor : '#eeeeee',
                    lineWidth: options.lineWidth ? options.lineWidth : 3,
                    size: options.size ? options.size : '80',
                    animate: options.animate ? options.animate : 750,
                    scaleColor: options.scaleColor ? options.scaleColor : false
                });
            }
        };
    });

// Bootstrap Maxlength, for more examples you can check out https://github.com/mimo84/bootstrap-maxlength
// By adding the attribute (with custom values) 'data-js-maxlength="{alwaysShow: 'true', threshold: '10', ... }'
    App.directive('jsMaxlength', function () {
        return {
            link: function (scope, element, attrs) {
                var options = (typeof scope.$eval(attrs.jsMaxlength) !== 'undefined') ? scope.$eval(attrs.jsMaxlength) : new Object();

                jQuery(element).maxlength({
                    alwaysShow: options.alwaysShow ? true : false,
                    threshold: options.threshold ? options.threshold : 10,
                    warningClass: options.warningClass ? options.warningClass : 'label label-warning',
                    limitReachedClass: options.limitReachedClass ? options.limitReachedClass : 'label label-danger',
                    placement: options.placement ? options.placement : 'bottom',
                    preText: options.preText ? options.preText : '',
                    separator: options.separator ? options.separator : '/',
                    postText: options.postText ? options.postText : ''
                });
            }
        };
    });

// Bootstrap Datetimepicker, for more examples you can check out https://github.com/Eonasdan/bootstrap-datetimepicker
// By adding the attribute (with custom values) 'data-js-datetimepicker="{format: 'false', useCurrent: 'false', ... }'
    App.directive('jsDatetimepicker', function () {
        return {
            link: function (scope, element, attrs) {
                var options = (typeof scope.$eval(attrs.jsDatetimepicker) !== 'undefined') ? scope.$eval(attrs.jsDatetimepicker) : new Object();

                jQuery(element).datetimepicker({
                    format: options.format ? options.format : false,
                    useCurrent: options.useCurrent ? options.useCurrent : false,
                    locale: moment.locale('' + (options.locale ? options.locale : '') +''),
                    showTodayButton: options.showTodayButton ? options.showTodayButton : false,
                    showClear: options.showClear ? options.showClear : false,
                    showClose: options.showClose ? options.showClose : false,
                    sideBySide: options.sideBySide ? options.sideBySide : false,
                    inline: options.inline ? options.inline : false,
                    icons: {
                        time: 'si si-clock',
                        date: 'si si-calendar',
                        up: 'si si-arrow-up',
                        down: 'si si-arrow-down',
                        previous: 'si si-arrow-left',
                        next: 'si si-arrow-right',
                        today: 'si si-size-actual',
                        clear: 'si si-trash',
                        close: 'si si-close'
                    }
                });
            }
        };
    });

// Ion Range Slider, for more examples you can check out https://github.com/IonDen/ion.rangeSlider
// By adding the attribute 'data-js-range-slider'
    App.directive('jsRangeSlider', function () {
        return {
            link: function (scope, element) {
                jQuery(element).ionRangeSlider({
                    input_values_separator: ';'
                });
            }
        };
    });

// Dropzone, for more examples you can check out http://www.dropzonejs.com/#usage
// By adding the attribute 'data-js-dropzone' to your form
    App.directive('jsDropzone', function () {
        return {
            link: function(scope, element, attrs) {
                var config, dropzone;

                config = scope[attrs.dropzone];

                // create a Dropzone for the element with the given options
                config.dropzone = new Dropzone(element[0], config.options);

                // bind the given event handlers
                angular.forEach(config.eventHandlers, function (handler, event) {
                    config.dropzone.on(event, handler);
                });
            }
        }
    });

    App.filter('html', ['$sce',function($sce) {
        return function(val) {
            return $sce.trustAsHtml(val);
        };
    }]);

    App.filter("blankout", function() {
        return function(str) {
            return str ? str.replace(/./g, "X") : "";
        };
    });

    App.filter('csv', function() {
        return function(arr) {
            return arr ? arr.join(", ") : null;
        };
    });

    App.filter('propsFilter', function() {
        return function(items, props) {
            var out = [];

            if (angular.isArray(items)) {
                var keys = Object.keys(props);

                items.forEach(function(item) {
                    var itemMatches = false;

                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var text = props[prop].toLowerCase();
                        if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                            itemMatches = true;
                            break;
                        }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        };
    });

})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('widget-preview', {
            parent: 'app',
            url: '/widget-preview',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_APIUSER'],
                pageTitle: 'Widget Demo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/widget/widget-preview.html',
                    controller: 'WidgetPreviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('WidgetPreviewController', WidgetPreviewController);

    WidgetPreviewController.$inject = ['$scope', 'Principal', '$state', '$http'];

    function WidgetPreviewController ($scope, Principal, $state, $http) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;

        vm.credentials = {
            grant_type: 'password',
            username: '',
            password: ''
        };

        vm.getToken = function () {
            $.ajax('/oauth/token', {
                method: 'POST',
                data: vm.credentials,
                headers: vm.header()
            }).done(function (resp) {
                vm.token = resp;
                vm.preview();
                $scope.$digest();
            }).fail(function (resp) {
                alert("An Expected Error has occurred. "+resp);
            });
        };

        vm.preview = function () {
            vm.previewUrl = "/api/widget?access_token=" + vm.token.access_token+ "&cache_buster=" + new Date().getTime();
        };

        vm.header = function() {
            return {
                "Authorization": "Basic " + btoa(vm.clientId + ":" + vm.clientSecret)
            };
        };


    }
})();
;
(function () {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('/api/users/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'search': {
                method:'GET',
                url:'/api/_search/users/:query',
                isArray: true
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'billingAccount': {
                method:'GET',
                url:'/api/billing-account'
            },
            'deleteBillingAccount': {
                method:'DELETE',
                url:'/api/billing-account'
            },
            'updateLastViewedWelcome': {
                method:'POST',
                url:'/api/user/track/views/welcome-guide'
            },
            'updateBillingAccount': {
                method:'PUT',
                url:'/api/billing-account?stripe-token=:stripeToken',
                params: {stripeToken:"@stripeToken"}
            },
            'sendActivationEmail': {
                method:'POST',
                url:'/api/users/:id/send-activation-email',
                params: {id:"@id"}
            },
            'reIndexAllUsers': {
                method:'POST',
                url:'/api/users/re-index'
            },
            'syncMailchimp': {
                method:'POST',
                url:'/api/users/sync-mailchimp'
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('/api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerDisabled = result.data.activeProfiles.indexOf("no-swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('/api/register', {}, {});
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('/api/account/reset_password/init', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('/api/account/reset_password/finish', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('/api/account/change_password', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$timeout', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $timeout, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            ssoLogin: ssoLogin,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                if (isAuthenticated) {
                    $timeout(function() {
                        $rootScope.$broadcast('authenticationSuccess');
                    }, 2000);
                }

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function ssoLogin (token, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();
            AuthServerProvider.ssoLogin(token)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();
;
(function() {
    /*jshint camelcase: false */
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', 'Base64'];

    function AuthServerProvider ($http, $localStorage, Base64) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            ssoLogin: ssoLogin,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken;
        }

        function hasValidToken () {
            var token = this.getToken();
            return token && token.expires_at && token.expires_at > new Date().getTime();
        }

        function login (credentials) {
            var data = 'username=' +  encodeURIComponent(credentials.username) + '&password=' +
                encodeURIComponent(credentials.password) + '&grant_type=password&scope=read%20write&' +
                'client_secret=EUwTaU376EYW363DX65xS478n9I4Q33H&client_id=crm2printapp';

            return $http.post('/oauth/token', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'Authorization': 'Basic ' + Base64.encode('crm2printapp' + ':' + 'EUwTaU376EYW363DX65xS478n9I4Q33H')
                }
            }).success(authSuccess);

            function authSuccess (response) {
                var expiredAt = new Date();
                expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
                response.expires_at = expiredAt.getTime();
                $localStorage.authenticationToken = response;
                return response;
            }
        }

        function ssoLogin (token) {
            return $http.get('/api/from-sso-token?access_token='+token).success(authSuccess);

            function authSuccess (response) {
                var expiredAt = new Date();
                expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
                response.expires_at = expiredAt.getTime();
                $localStorage.authenticationToken = response;
                return response;
            }
        }

        function logout () {
            $http.post('/api/logout').then(function() {
                delete $localStorage.authenticationToken;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('/api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('/api/account/:userId', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$rootScope', '$state', '$cookies',  'Auth', 'Principal', 'ProfileService', 'LoginService', 'SplashScreenService', 'UserProfile'];

    function NavbarController ($rootScope, $state, $cookies, Auth, Principal, ProfileService, LoginService, SplashScreenService, UserProfile) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.costCenterInviteToken = $cookies.get('cost_center_invite');

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerDisabled = response.swaggerDisabled;
        });

        $rootScope.$on('authenticationSuccess', function() {
            getUser();
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.showWelcomeGuide = showWelcomeGuide;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function getUser() {
            Principal.identity().then(function(user) {
                vm.user = user;
                vm.isAuthenticated = Principal.isAuthenticated;
                vm.showWelcomeGuide(true);
                if(user.timestamps) {
                    if(user.timestamps.lastViewedWelcome) {
                        user.timestamps.lastViewedWelcome = Date.parse(user.timestamps.lastViewedWelcome)
                    }
                }
            });
            UserProfile.get(function(resp){
                vm.userProfile = resp;
                vm.showWelcomeGuide(true);
            });
        }

        function showWelcomeGuide(autoShow) {
            if(autoShow) {
                // debugger;
                if(!vm.user
                    || !vm.userProfile
                    || !vm.userProfile.showWelcomeGuide
                    /*|| vm.user.timestamps.lastViewedWelcome > Date.now()*/) {
                    return
                }
            }
            SplashScreenService.open(vm.userProfile);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('privacy', {
            parent: 'app',
            url: '/privacy',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/privacy.html',
                }
            }
        })
        .state('terms', {
            parent: 'app',
            url: '/terms',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/terms.html',
                }
            }
        })
        .state('about-us', {
            parent: 'app',
            url: '/about-us',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/about-us.html',
                }
            }
        })
        .state('contact-us', {
            parent: 'app',
            url: '/contact-us',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/contact-us.html',
                    controller: 'ContactUsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'UserPricing'];

    function HomeController ($scope, Principal, LoginService, $state, UserPricing) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.userPricings = [];
        vm.login = LoginService.open;
        vm.register = register;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        loadAll();


        function loadAll() {
            getAccount();

            UserPricing.query(function(result) {
                var lookup = {};
                result.forEach(function(up){
                    lookup[up.currency+up.duplex+up.pageCount+up.envelopeCode] = up;
                });
                vm.userPricings = result.filter(function(up){
                    return up.currency === 'AUD'
                        && !up.duplex
                        && up.envelopeCode === 'DLX'
                        && up.pageCount <= 5
                        && up.minQuantity === 1
                        && !up.addressedEnvelope;
                }).map(function(up){
                    var duplex = lookup[up.currency+true+up.pageCount+up.envelopeCode];
                    if(duplex) {
                        up.duplexPrice = duplex.amount;
                    }
                    return up
                });
            });
        }
        //App.initHelpers(['appear', 'appear-countTo']);

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('ContactUsController', ContactUsController);

    ContactUsController.$inject = ['$scope', 'Principal', 'ContactService', '$state'];

    function ContactUsController ($scope, Principal, ContactService, $state) {
        var vm = this;

        vm.message = {};
        vm.contactUs = contactUs;

        Principal.identity().then(function(account) {
            vm.account = account;
            if(Principal.isAuthenticated()) {
                vm.message.firstName = account.firstName;
                vm.message.lastName = account.lastName;
                vm.message.email = account.email;
                vm.message.userId = account.id;
                vm.message.login = account.login;
            }
        });

        function contactUs () {
            ContactService.contactUs(vm.message,function (r) {
               swal("Sent","Your message has been sent.","success");
            });
            // $state.go('register');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VoucherCodeDialogController', VoucherCodeDialogController);

    VoucherCodeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'VoucherCode', 'User', 'PrintJobCharge'];

    function VoucherCodeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, VoucherCode, User, PrintJobCharge) {
        var vm = this;

        vm.voucherCode = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.users = User.query();
        vm.printjobcharges = PrintJobCharge.query({filter: 'vouchercode-is-null'});
        $q.all([vm.voucherCode.$promise, vm.printjobcharges.$promise]).then(function() {
            if (!vm.voucherCode.printJobCharge || !vm.voucherCode.printJobCharge.id) {
                return $q.reject();
            }
            return PrintJobCharge.get({id : vm.voucherCode.printJobCharge.id}).$promise;
        }).then(function(printJobCharge) {
            vm.printjobcharges.push(printJobCharge);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.voucherCode.id !== null) {
                VoucherCode.update(vm.voucherCode, onSaveSuccess, onSaveError);
            } else {
                VoucherCode.save(vm.voucherCode, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:voucherCodeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;
        vm.datePickerOpenStatus.expires = false;
        vm.datePickerOpenStatus.used = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VoucherCodeDetailController', VoucherCodeDetailController);

    VoucherCodeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'VoucherCode', 'User', 'PrintJobCharge'];

    function VoucherCodeDetailController($scope, $rootScope, $stateParams, entity, VoucherCode, User, PrintJobCharge) {
        var vm = this;

        vm.voucherCode = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:voucherCodeUpdate', function(event, result) {
            vm.voucherCode = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VoucherCodeDeleteController',VoucherCodeDeleteController);

    VoucherCodeDeleteController.$inject = ['$uibModalInstance', 'entity', 'VoucherCode'];

    function VoucherCodeDeleteController($uibModalInstance, entity, VoucherCode) {
        var vm = this;

        vm.voucherCode = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VoucherCode.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('voucher-code', {
            parent: 'entity',
            url: '/voucher-code?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.voucherCode.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/voucher-code/voucher-codes.html',
                    controller: 'VoucherCodeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('voucherCode');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('voucher-code-detail', {
            parent: 'entity',
            url: '/voucher-code/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.voucherCode.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/voucher-code/voucher-code-detail.html',
                    controller: 'VoucherCodeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('voucherCode');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VoucherCode', function($stateParams, VoucherCode) {
                    return VoucherCode.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('voucher-code.new', {
            parent: 'voucher-code',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voucher-code/voucher-code-dialog.html',
                    controller: 'VoucherCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                created: null,
                                expires: null,
                                useCount: null,
                                discount: null,
                                minimumOrder: null,
                                used: null,
                                reference: null,
                                demo: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('voucher-code', null, { reload: true });
                }, function() {
                    $state.go('voucher-code');
                });
            }]
        })
        .state('voucher-code.edit', {
            parent: 'voucher-code',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voucher-code/voucher-code-dialog.html',
                    controller: 'VoucherCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VoucherCode', function(VoucherCode) {
                            return VoucherCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('voucher-code', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('voucher-code.delete', {
            parent: 'voucher-code',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voucher-code/voucher-code-delete-dialog.html',
                    controller: 'VoucherCodeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VoucherCode', function(VoucherCode) {
                            return VoucherCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('voucher-code', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('VoucherCode', VoucherCode);

    VoucherCode.$inject = ['$resource', 'DateUtils'];

    function VoucherCode ($resource, DateUtils) {
        var resourceUrl =  'api/voucher-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                        data.expires = DateUtils.convertDateTimeFromServer(data.expires);
                        data.used = DateUtils.convertDateTimeFromServer(data.used);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('VoucherCodeSearch', VoucherCodeSearch);

    VoucherCodeSearch.$inject = ['$resource'];

    function VoucherCodeSearch($resource) {
        var resourceUrl =  'api/_search/voucher-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VoucherCodeController', VoucherCodeController);

    VoucherCodeController.$inject = ['$scope', '$state', 'VoucherCode', 'VoucherCodeSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function VoucherCodeController ($scope, $state, VoucherCode, VoucherCodeSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                VoucherCodeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                VoucherCode.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.voucherCodes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VendorStaffDialogController', VendorStaffDialogController);

    VendorStaffDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'VendorStaff', 'Vendor', 'User'];

    function VendorStaffDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, VendorStaff, Vendor, User) {
        var vm = this;

        vm.vendorStaff = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.vendors = Vendor.query();
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.vendorStaff.id !== null) {
                VendorStaff.update(vm.vendorStaff, onSaveSuccess, onSaveError);
            } else {
                VendorStaff.save(vm.vendorStaff, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:vendorStaffUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VendorStaffDetailController', VendorStaffDetailController);

    VendorStaffDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'VendorStaff', 'Vendor', 'User'];

    function VendorStaffDetailController($scope, $rootScope, $stateParams, entity, VendorStaff, Vendor, User) {
        var vm = this;

        vm.vendorStaff = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:vendorStaffUpdate', function(event, result) {
            vm.vendorStaff = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VendorStaffDeleteController',VendorStaffDeleteController);

    VendorStaffDeleteController.$inject = ['$uibModalInstance', 'entity', 'VendorStaff'];

    function VendorStaffDeleteController($uibModalInstance, entity, VendorStaff) {
        var vm = this;

        vm.vendorStaff = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VendorStaff.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('vendor-staff', {
            parent: 'entity',
            url: '/vendor-staff?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.vendorStaff.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vendor-staff/vendor-staffs.html',
                    controller: 'VendorStaffController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vendorStaff');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('vendor-staff-detail', {
            parent: 'entity',
            url: '/vendor-staff/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.vendorStaff.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vendor-staff/vendor-staff-detail.html',
                    controller: 'VendorStaffDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vendorStaff');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VendorStaff', function($stateParams, VendorStaff) {
                    return VendorStaff.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('vendor-staff.new', {
            parent: 'vendor-staff',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vendor-staff/vendor-staff-dialog.html',
                    controller: 'VendorStaffDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                created: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('vendor-staff', null, { reload: true });
                }, function() {
                    $state.go('vendor-staff');
                });
            }]
        })
        .state('vendor-staff.edit', {
            parent: 'vendor-staff',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vendor-staff/vendor-staff-dialog.html',
                    controller: 'VendorStaffDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VendorStaff', function(VendorStaff) {
                            return VendorStaff.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vendor-staff', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vendor-staff.delete', {
            parent: 'vendor-staff',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vendor-staff/vendor-staff-delete-dialog.html',
                    controller: 'VendorStaffDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VendorStaff', function(VendorStaff) {
                            return VendorStaff.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vendor-staff', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('VendorStaff', VendorStaff);

    VendorStaff.$inject = ['$resource', 'DateUtils'];

    function VendorStaff ($resource, DateUtils) {
        var resourceUrl =  'api/vendor-staffs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                    }
                    return data;
                }
            },
            'current': {
                method: 'GET',
                url: 'api/vendor-staffs/current',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('VendorStaffSearch', VendorStaffSearch);

    VendorStaffSearch.$inject = ['$resource'];

    function VendorStaffSearch($resource) {
        var resourceUrl =  'api/_search/vendor-staffs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VendorStaffController', VendorStaffController);

    VendorStaffController.$inject = ['$scope', '$state', 'VendorStaff', 'VendorStaffSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function VendorStaffController ($scope, $state, VendorStaff, VendorStaffSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                VendorStaffSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                VendorStaff.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.vendorStaffs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VendorJobTicketDialogController', VendorJobTicketDialogController);

    VendorJobTicketDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VendorJobTicket', 'PostalAccount', 'Vendor'];

    function VendorJobTicketDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VendorJobTicket, PostalAccount, Vendor) {
        var vm = this;

        vm.vendorJobTicket = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.postalaccounts = PostalAccount.query();
        vm.vendors = Vendor.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.vendorJobTicket.id !== null) {
                VendorJobTicket.update(vm.vendorJobTicket, onSaveSuccess, onSaveError);
            } else {
                VendorJobTicket.save(vm.vendorJobTicket, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:vendorJobTicketUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;
        vm.datePickerOpenStatus.send = false;
        vm.datePickerOpenStatus.received = false;
        vm.datePickerOpenStatus.started = false;
        vm.datePickerOpenStatus.finished = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VendorJobTicketDetailController', VendorJobTicketDetailController);

    VendorJobTicketDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'VendorJobTicket', 'PostalAccount', 'Vendor'];

    function VendorJobTicketDetailController($scope, $rootScope, $stateParams, entity, VendorJobTicket, PostalAccount, Vendor) {
        var vm = this;

        vm.vendorJobTicket = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:vendorJobTicketUpdate', function(event, result) {
            vm.vendorJobTicket = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VendorJobTicketDeleteController',VendorJobTicketDeleteController);

    VendorJobTicketDeleteController.$inject = ['$uibModalInstance', 'entity', 'VendorJobTicket'];

    function VendorJobTicketDeleteController($uibModalInstance, entity, VendorJobTicket) {
        var vm = this;

        vm.vendorJobTicket = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VendorJobTicket.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('vendor-job-ticket', {
            parent: 'entity',
            url: '/vendor-job-ticket',
            data: {
                authorities: ['ROLE_VENDOR'],
                pageTitle: 'crm2PrintApp.vendorJobTicket.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vendor-job-ticket/vendor-job-tickets.html',
                    controller: 'VendorJobTicketController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vendorJobTicket');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('vendor-job-ticket-detail', {
            parent: 'entity',
            url: '/vendor-job-ticket/{id}',
            data: {
                authorities: ['ROLE_VENDOR'],
                pageTitle: 'crm2PrintApp.vendorJobTicket.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vendor-job-ticket/vendor-job-ticket-detail.html',
                    controller: 'VendorJobTicketDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vendorJobTicket');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VendorJobTicket', function($stateParams, VendorJobTicket) {
                    return VendorJobTicket.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('vendor-job-ticket.new', {
            parent: 'vendor-job-ticket',
            url: '/new',
            data: {
                authorities: ['ROLE_VENDOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vendor-job-ticket/vendor-job-ticket-dialog.html',
                    controller: 'VendorJobTicketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                created: null,
                                send: null,
                                received: null,
                                started: null,
                                finished: null,
                                letterCount: null,
                                pageCount: null,
                                sheetCount: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('vendor-job-ticket', null, { reload: true });
                }, function() {
                    $state.go('vendor-job-ticket');
                });
            }]
        })
        .state('vendor-job-ticket.edit', {
            parent: 'vendor-job-ticket',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_VENDOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vendor-job-ticket/vendor-job-ticket-dialog.html',
                    controller: 'VendorJobTicketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VendorJobTicket', function(VendorJobTicket) {
                            return VendorJobTicket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vendor-job-ticket', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vendor-job-ticket.delete', {
            parent: 'vendor-job-ticket',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_VENDOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vendor-job-ticket/vendor-job-ticket-delete-dialog.html',
                    controller: 'VendorJobTicketDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VendorJobTicket', function(VendorJobTicket) {
                            return VendorJobTicket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vendor-job-ticket', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('VendorJobTicket', VendorJobTicket);

    VendorJobTicket.$inject = ['$resource', 'DateUtils'];

    function VendorJobTicket ($resource, DateUtils) {
        var resourceUrl =  '/api/vendor-job-tickets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                        data.send = DateUtils.convertDateTimeFromServer(data.send);
                        data.received = DateUtils.convertDateTimeFromServer(data.received);
                        data.started = DateUtils.convertDateTimeFromServer(data.started);
                        data.finished = DateUtils.convertDateTimeFromServer(data.finished);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'sendUndelivered': {
                method: 'POST',
                url: '/api/vendor-job-tickets/deliver-unsent'
            },
            'markJobTicketsComplete': {
                method: 'POST',
                url: '/api/vendor-job-tickets/mark-all-complete'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('VendorJobTicketSearch', VendorJobTicketSearch);

    VendorJobTicketSearch.$inject = ['$resource'];

    function VendorJobTicketSearch($resource) {
        var resourceUrl =  '/api/_search/vendor-job-tickets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VendorJobTicketController', VendorJobTicketController);

    VendorJobTicketController.$inject = ['$scope', '$state', 'VendorJobTicket', 'VendorJobTicketSearch'];

    function VendorJobTicketController ($scope, $state, VendorJobTicket, VendorJobTicketSearch) {
        var vm = this;

        vm.vendorJobTickets = [];
        vm.search = search;
        vm.sendNewTickets = sendNewTickets;

        loadAll();

        function loadAll() {
            VendorJobTicket.query(function(result) {
                vm.vendorJobTickets = result;
            });
        }

        function sendNewTickets() {
            VendorJobTicket.sendUndelivered(function (result) {
                swal("Done!","Queued "+result.count+" Jobtickets for delivery", "success");
            })
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            VendorJobTicketSearch.query({query: vm.searchQuery}, function(result) {
                vm.vendorJobTickets = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VendorDialogController', VendorDialogController);

    VendorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Vendor', 'Envelope', 'Country'];

    function VendorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Vendor, Envelope, Country) {
        var vm = this;

        vm.vendor = entity;
        vm.clear = clear;
        vm.save = save;
        vm.envelopes = Envelope.query();
        vm.countries = Country.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.vendor.id !== null) {
                Vendor.update(vm.vendor, onSaveSuccess, onSaveError);
            } else {
                Vendor.save(vm.vendor, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:vendorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VendorDetailController', VendorDetailController);

    VendorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Vendor', 'Envelope', 'Country'];

    function VendorDetailController($scope, $rootScope, $stateParams, entity, Vendor, Envelope, Country) {
        var vm = this;

        vm.vendor = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:vendorUpdate', function(event, result) {
            vm.vendor = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VendorDeleteController',VendorDeleteController);

    VendorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Vendor'];

    function VendorDeleteController($uibModalInstance, entity, Vendor) {
        var vm = this;

        vm.vendor = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Vendor.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('vendor', {
            parent: 'entity',
            url: '/vendor',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.vendor.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vendor/vendors.html',
                    controller: 'VendorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vendor');
                    $translatePartialLoader.addPart('deliveryMethod');
                    $translatePartialLoader.addPart('featureStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('vendor-detail', {
            parent: 'entity',
            url: '/vendor/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.vendor.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vendor/vendor-detail.html',
                    controller: 'VendorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vendor');
                    $translatePartialLoader.addPart('deliveryMethod');
                    $translatePartialLoader.addPart('featureStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Vendor', function($stateParams, Vendor) {
                    return Vendor.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('vendor.new', {
            parent: 'vendor',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vendor/vendor-dialog.html',
                    controller: 'VendorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                logo: null,
                                website: null,
                                deliveryMethod: null,
                                deliveryFormat: null,
                                email: null,
                                ftpUser: null,
                                ftpPassword: null,
                                ftpTls: null,
                                barcodeScheme: null,
                                trayCapacity: null,
                                deliveryPaperSize: null,
                                status: null,
                                maxPageCount: null,
                                minLetterCount: null,
                                lodgementState: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('vendor', null, { reload: true });
                }, function() {
                    $state.go('vendor');
                });
            }]
        })
        .state('vendor.edit', {
            parent: 'vendor',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vendor/vendor-dialog.html',
                    controller: 'VendorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Vendor', function(Vendor) {
                            return Vendor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vendor', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vendor.delete', {
            parent: 'vendor',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vendor/vendor-delete-dialog.html',
                    controller: 'VendorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Vendor', function(Vendor) {
                            return Vendor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vendor', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('Vendor', Vendor);

    Vendor.$inject = ['$resource'];

    function Vendor ($resource) {
        var resourceUrl =  '/api/vendors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'current': {
                method: 'GET',
                url: '/api/vendors/current',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'vendorLimitationsForCountry': {
                method: 'GET', isArray: true,
                url: '/api/vendors/country/:countryCode3/limitations'
            },
            'checkVendorAvailabilityForPrintJob': {
                method: 'GET', isArray: true,
                url: '/api/vendors/country/:countryCode3/print-job/:printJobId/check?letter-count=:letterCount'
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('VendorSearch', VendorSearch);

    VendorSearch.$inject = ['$resource'];

    function VendorSearch($resource) {
        var resourceUrl =  '/api/_search/vendors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('VendorController', VendorController);

    VendorController.$inject = ['$scope', '$state', 'Vendor', 'VendorSearch'];

    function VendorController ($scope, $state, Vendor, VendorSearch) {
        var vm = this;
        
        vm.vendors = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            Vendor.query(function(result) {
                vm.vendors = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            VendorSearch.query({query: vm.searchQuery}, function(result) {
                vm.vendors = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('UserProfileDialogController', UserProfileDialogController);

    UserProfileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'UserProfile', 'Country', 'User', 'Vendor', 'Principal', 'Stationery'];

    function UserProfileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, UserProfile, Country, User, Vendor, Principal, Stationery) {
        var vm = this;

        vm.userProfile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.countries = Country.query();
        vm.billingAccount = User.billingAccount();
        vm.stationeries = Stationery.query();

        Principal.hasAuthority('ROLE_DEMO_MODE').then(function (demoMode) {
            $scope.demoMode = demoMode;
            if(window.Stripe) {//prevent errors during offline debugging
                Stripe.setPublishableKey(demoMode ? 'pk_test_NAwIc50T7FTa46UoeswbkTqb' : 'pk_live_PS4h0U30PcdeIywnhy7yYrj6');
            }
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            UserProfile.update(vm.userProfile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:userProfileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.selectedCountry = function() {
            vm.countries.forEach(function (c) {
                if(c.id == vm.userProfile.countryId) {
                    vm.country = c;
                }
            })
            if(vm.country) {
                Vendor.vendorLimitationsForCountry({countryCode3:vm.country.code3},function(resp){
                    if(resp.length == 0) {
                        vm.vendorLimitation = "At the moment no Mailhouses are available for "+vm.country.name+". " +
                            "You may still explore CRM2Print to be ready for when Print & Mail becomes available";
                        swal("No Mailhouses available yet!",vendorLimitation,"error");
                    } else if(resp[0] != "") {
                        vm.vendorLimitation = "A Mailhouse is available in "+vm.country.name+", but it has some limitations: "+resp[0];
                        swal("Limitations apply!",vm.vendorLimitation,"warning");
                    }
                });
            }
        }


        vm.hasExistingSource = function() {
            return !!vm.billingAccount && !!vm.billingAccount.sources && vm.billingAccount.sources.totalCount >= 1;
        };
        vm.getExistingSource = function() {
            return vm.hasExistingSource() ? vm.billingAccount.sources.data[0] : null;
        };

        vm.deleteCard = function () {
            User.deleteBillingAccount(function (resp) {
                swal("Deleted!!", "Credit card deleted.", "success");
                delete vm.billingAccount.sources;
            });
        };

        $scope.handleStripe = function(status, response){
            if(response.error) {
                // there was an error. Fix it.
                swal("Payment Type Verification Error", response.error, "error");
            } else {
                vm.billingAccount = User.updateBillingAccount({stripeToken: response.id}, function (resp) {
                    swal("Success!!", "Credit Card saved.", "success");
                });
            }
        };

        $timeout(function (){
            // Init Card, for more info and examples you can check out https://github.com/jessepollak/card
            jQuery('.js-card-form').card({
                container: '.js-card-container',
                formSelectors: {
                    numberInput: '#cc_number',
                    expiryInput: '#cc_expiry',
                    cvcInput: '#cc_cvc',
                    nameInput: '#cc_name'
                }
            });
        });


    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-profile', {
            parent: 'settings',
            url: '/user-profile',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-profile/user-profile-dialog.html',
                    controller: 'UserProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserProfile', function(UserProfile) {
                            return UserProfile.get().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('costCenterStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('UserProfile', UserProfile);

    UserProfile.$inject = ['$resource', 'DateUtils'];

    function UserProfile ($resource, DateUtils) {
        var resourceUrl =  '/api/user-profiles/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                url: '/api/user-profile',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.approverEmailVerified = DateUtils.convertDateTimeFromServer(data.approverEmailVerified);
                    }
                    return data;
                }
            },
            'getByUserId': {
                method: 'GET',
                url: '/api/user-profiles/:userId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.approverEmailVerified = DateUtils.convertDateTimeFromServer(data.approverEmailVerified);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'markGuideAsSeen': {
                method: 'POST',
                url: '/api/user-profile/toggle-show-welcome-guide'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('UserProfileSearch', UserProfileSearch);

    UserProfileSearch.$inject = ['$resource'];

    function UserProfileSearch($resource) {
        var resourceUrl =  'api/_search/user-profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('UserProfileController', UserProfileController);

    UserProfileController.$inject = ['$scope', '$state', 'UserProfile', 'UserProfileSearch'];

    function UserProfileController ($scope, $state, UserProfile, UserProfileSearch) {
        var vm = this;
        
        vm.userProfiles = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            UserProfile.query(function(result) {
                vm.userProfiles = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            UserProfileSearch.query({query: vm.searchQuery}, function(result) {
                vm.userProfiles = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('UserPricingDialogController', UserPricingDialogController);

    UserPricingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'UserPricing', 'Envelope', 'Country', 'User'];

    function UserPricingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, UserPricing, Envelope, Country, User) {
        var vm = this;

        vm.userPricing = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.envelopes = Envelope.query();
        vm.countries = Country.query();
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.userPricing.id !== null) {
                UserPricing.update(vm.userPricing, onSaveSuccess, onSaveError);
            } else {
                UserPricing.save(vm.userPricing, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:userPricingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastModified = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('UserPricingDetailController', UserPricingDetailController);

    UserPricingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'UserPricing', 'Envelope', 'Country', 'User'];

    function UserPricingDetailController($scope, $rootScope, $stateParams, entity, UserPricing, Envelope, Country, User) {
        var vm = this;

        vm.userPricing = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:userPricingUpdate', function(event, result) {
            vm.userPricing = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('UserPricingDeleteController',UserPricingDeleteController);

    UserPricingDeleteController.$inject = ['$uibModalInstance', 'entity', 'UserPricing'];

    function UserPricingDeleteController($uibModalInstance, entity, UserPricing) {
        var vm = this;

        vm.userPricing = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            UserPricing.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-pricing', {
            parent: 'entity',
            url: '/user-pricing',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.userPricing.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-pricing/user-pricings.html',
                    controller: 'UserPricingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userPricing');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-pricing-detail', {
            parent: 'entity',
            url: '/user-pricing/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.userPricing.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-pricing/user-pricing-detail.html',
                    controller: 'UserPricingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userPricing');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'UserPricing', function($stateParams, UserPricing) {
                    return UserPricing.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('user-pricing.new', {
            parent: 'user-pricing',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-pricing/user-pricing-dialog.html',
                    controller: 'UserPricingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                duplex: false,
                                lastModified: null,
                                amount: null,
                                pageCount: 1,
                                minQuantity: 1,
                                addressedEnvelope: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-pricing', null, { reload: true });
                }, function() {
                    $state.go('user-pricing');
                });
            }]
        })
        .state('user-pricing.edit', {
            parent: 'user-pricing',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-pricing/user-pricing-dialog.html',
                    controller: 'UserPricingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserPricing', function(UserPricing) {
                            return UserPricing.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-pricing', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-pricing.delete', {
            parent: 'user-pricing',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-pricing/user-pricing-delete-dialog.html',
                    controller: 'UserPricingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UserPricing', function(UserPricing) {
                            return UserPricing.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-pricing', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('UserPricing', UserPricing);

    UserPricing.$inject = ['$resource', 'DateUtils'];

    function UserPricing ($resource, DateUtils) {
        var resourceUrl =  '/api/user-pricings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastModified = DateUtils.convertDateTimeFromServer(data.lastModified);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('UserPricingSearch', UserPricingSearch);

    UserPricingSearch.$inject = ['$resource'];

    function UserPricingSearch($resource) {
        var resourceUrl =  '/api/_search/user-pricings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('UserPricingController', UserPricingController);

    UserPricingController.$inject = ['$scope', '$state', 'UserPricing', 'UserPricingSearch'];

    function UserPricingController ($scope, $state, UserPricing, UserPricingSearch) {
        var vm = this;
        
        vm.userPricings = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            UserPricing.query(function(result) {
                vm.userPricings = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            UserPricingSearch.query({query: vm.searchQuery}, function(result) {
                vm.userPricings = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('TemplateEditController', TemplateEditController);

    TemplateEditController.$inject = ['$timeout', '$cookies', '$scope', '$state', '$stateParams', 'entity', '$uibModal', 'Template', 'TemplateDoc', 'Envelope', 'Site', 'SiteDataSource', 'User', 'UserProfile', 'Stationery'];

    function TemplateEditController ($timeout, $cookies, $scope, $state, $stateParams, entity, $uibModal, Template, TemplateDoc, Envelope, Site, SiteDataSource, User, UserProfile, Stationery) {

        Dropzone.autoDiscover = false;

        var vm = this;
        vm.template = entity;
        vm.envelopes = Envelope.query();
        // vm.sites = Site.query();
        SiteDataSource.queryLinked(function(resp){
            vm.dataSources = resp;
            vm.hideCRMLinkWarning = false;
            vm.dataSources.forEach(function(dataSource) {
                dataSource.label = dataSource.siteName + " - "+dataSource.name;
                if(dataSource.status != 'ACTIVE') {
                    dataSource.label += " ["+dataSource.status+"]"
                }
                vm.hideCRMLinkWarning |= dataSource.requiresUser;
            });
        });
        vm.templates = Template.query();
        vm.stationeries = Stationery.query();
        vm.allChecked = true;
        vm.windowLessEnvelope = false;
        UserProfile.get(function (resp) {
            if(!resp.postcode || !resp.countryId) {
                swal({
                    title: "User Profile Incomplete",
                    text: "Please complete your user profile before proceeding with creating templates as your geographical location is required to determine which local mail houses offer which services.",
                    type: "warning",
                    closeOnConfirm: true
                }).then(function(){
                    $state.go('user-profile');
                });
            }
        });

        vm.categories = [
            "Just Listed"
            ,"Just Sold"
            ,"Auction"
            ,"Birthday"
            ,"Anniversary"
            ,"Market Appraisal"
            ,"Market Report"
            ,"Recent Sales"
            ,"Local Expertise"
            ,"Property Specific"
            ,"Buyers Ready"
            ,"Thinking of Selling"
            ,"Expiring Listing"
            ,"Expired Listing"
            ,"Withdrawn Listing"
            ,"Property Comparison"
            ,"Referrals"
            ,"Newsletter"
            ,"FSBO"
            ,"Internet Lead"
            ,"Farming"
            ,"Open House Follow Up"
            ,"Rising Market"
            ,"Buyers"
            ,"Sellers"
            ,"Competition"
            ,"Thank you"
            ,"Other"
        ];
        vm.showSampleAddress = false;

        $scope.dropzoneConfig = {
            'options': { // passed into the Dropzone constructor
                'url': '/api/assets/templates',
                dictDefaultMessage: 'Upload new template.<div class="file-formats"><i class="fa fa-file-word-o"></i></div>',
                maxFiles: 1,
                parallelUploads: 1,
                maxFilesize : 10,
                uploadMultiple: false,
                // acceptedFiles: '.docx,.doc,.rtf'
                acceptedFiles: '.docx,.doc'
            },
            'eventHandlers': {
                'sending': function (file, xhr, formData) {
                    // console.log("sending: "+file);
                },
                'success': function (file, response) {
                    // console.log(response);
                    $scope.dropzoneConfig.dropzone.removeFile(file);
                    vm.doc = response;
                    vm.approvedCode = generateApprovalCode(5);
                    vm.template.name = vm.doc.originalFilename.substr(0,vm.doc.originalFilename.lastIndexOf('.')).replace("_"," ");
                    // vm.previewImg = $(file.previewElement).addClass("doc-preview").find(".dz-image img").get(0);
                    vm.updatePreview();
                    vm.extractFields();
                    swal({title:"Template Uploaded",
                        text:"Please inspect the preview and remove all mail merge fields that overlap the address box by un-checking the corresponding field name in the list.",
                        type:"success"
                    }).then(vm.initTour);
                }
            }
        };

        function generateApprovalCode(length) {
            var code = '';
            while (code.length < length) {
                code = Math.random().toString(36).replace(/[^a-z]+/g, '');
            }
            return code.substr(0, length);
        }

        $scope.dropzoneConfigStationery = {
            'options': { // passed into the Dropzone constructor
                'url': '/api/assets/templates',
                dictDefaultMessage: 'Upload new stationery or letterhead.<div class="file-formats"><i class="fa fa-file-pdf-o"></i><i class="fa fa-file-word-o"></i></div>',
                maxFiles: 1,
                parallelUploads: 1,
                maxFilesize : 2,
                uploadMultiple: false,
                // acceptedFiles: '.docx,.doc,.rtf'
                acceptedFiles: '.jpg,.pdf,.docx,.doc,.rtf'
            },
            'eventHandlers': {
                'sending': function (file, xhr, formData) {
                    // console.log("sending: "+file);
                },
                'success': function (file, response) {
                    $scope.dropzoneConfigStationery.dropzone.removeFile(file);
                    Stationery.save({name: response.originalFilename, file: response.key}, function(stationery){
                        vm.stationeries.push(stationery);
                        vm.selectStationery(stationery)
                    }, function(resp){
                        swal("Stationery upload failed",resp.statusText,"error");
                    });
                }
            }
        };

        vm.previewStationery = function(stationery) {
            //todo clear dropbox
            //vm.previewStationeryImg = $(file.previewElement).addClass("doc-preview").find(".dz-image img").get(0);
            vm.stationeryPreviewUrl = "/api/assets/stationeries/"+stationery.id+"-full.png";
            vm.previewUrl = vm.generatePreviewUrl();
            vm.previewUrlPDF = vm.generatePreviewUrlPDF();
        };

        vm.selectStationery = function(stationery) {
            vm.stationery = vm.template.stationery = stationery;
            vm.previewStationery(stationery);
        };

        vm.tickAll = function () {
            vm.getUserMergeFields().forEach(function(f){
                f.display = vm.allChecked;
            });
            vm.updatePreviewTrigger();
        };

        vm.dataSourceSelected = function() {
            vm.extractFields();
            if(vm.template.dataSource && vm.template.dataSource.disclaimer) {
                swal("Data Source Disclaimer",vm.template.dataSource.disclaimer,"info");
            }
        };

        vm.envelopeSelected = function() {
            vm.windowLessEnvelope = !vm.template.envelope.hasWindow;
            if(vm.windowLessEnvelope) {
                if(!vm.hasOwnProperty('addressBoxSpaceBackup')) {
                    vm.addressBoxSpaceBackup = vm.template.addressBoxSpace;
                    vm.template.addressBoxSpace = false;
                    swal({
                        title: "Premium Feature",
                        text: "Window-less and hand written envelopes will attract a higher cost per letter.",
                        type: "warning"
                    })
                }
            } else {
                if(vm.hasOwnProperty('addressBoxSpaceBackup')) {
                    vm.template.addressBoxSpace = vm.addressBoxSpaceBackup;
                    delete vm.addressBoxSpaceBackup;
                }
            }
        };

        vm.extractFields = function() {
            TemplateDoc.extractFields({id:vm.doc.key,dataSourceId:vm.template.dataSource ? vm.template.dataSource.id : ''}, function(resp) {
                vm.mappingScheme = resp.mappingScheme;
                if(vm.mappingScheme) {
                    vm.template.fields = vm.mappingScheme.fields;
                }
                vm.template.size = resp.pageSize;
                if(vm.template.size != 'A4') {
                    swal({
                        title: "Template is not A4!",
                        text: "This template is of "+vm.template.size+" paper size. Please ensure your document is " +
                                "A4 to prevent unexpected layout issues during printing.",
                        type: "warning"
                    });
                }
                vm.template.numberOfPages = resp.pageCount;
                vm.template.wordCount = resp.wordCount;
                vm.template.documentText = resp.text;
                vm.template.documentLastSavedBy = resp.lastSavedBy;
                vm.template.containsNonFixedPositionBleeds = resp.containsNonFixedPositionBleeds;
                vm.template.addressBoxSpace = resp.addressBoxSpace;
                if(vm.template.containsNonFixedPositionBleeds) {
                    swal({
                        title: "Potential Layout Issue!!!",
                        html: "Your template contains bleed (i.e. objects touching the edge of the page), but that are" +
                            " not positioned relative to the page edge. This can cause layout issues if bleed is required." +
                            " Please check that all bleeds are positioned correctly on the preview PDF." +
                            " See <a href='#/faq' target='_blank'>FAQ &gt; Bleed</a> how to update your template to prevent this warning.",
                        type: "warning"
                        // showCancelButton: true,
                        // confirmButtonText: "Would you like to highlight the bleeds",
                        // cancelButtonText: "No, just take me back to my templates.",
                        // closeOnConfirm: true,
                        // closeOnCancel: true
                    }).then(function(isConfirm){
                        $scope.$emit('template-change');
                    });
                } else {
                    // vm.template.documentLastSavedTime = resp.lastSavedTime;
                    $scope.$emit('template-change');
                }
            }, function(res) {
                //no fields found
            });
        };

        vm.getStandardMergeFields = function() {
            if(!vm.template.fields) return [];
            return vm.template.fields.filter(function(f){
                return f.templateField.startsWith("c2p_");
            })
        };
        vm.getUserMergeFields = function() {
            if(!vm.template.fields) return [];
            return vm.template.fields.filter(function(f){
                return !f.templateField.startsWith("c2p_");
            })
        };

        vm.getUnMappedFields = function() {
            if(!vm.template.fields
                || !vm.dataSources.adapterName  // no adapter => fields as per template
            ) return [];
            return vm.template.fields.filter(function(f){
                return f.display && !f.readOnly && !f.mappedField && !f.expression && f.mode != 'CUSTOM';
            });
        };

        vm.updatePreviewTrigger = function() {
            if(vm.updatePreviewPromise) $timeout.cancel(vm.updatePreviewPromise);
            vm.updatePreviewPromise = $timeout(vm.updatePreview,500);
        };

        vm.getHiddenFieldnames = function () {
            return !vm.mappingScheme || !vm.template.fields ? [] : vm.template.fields
                .filter(function(f){ return !f.display;})
                .map(function(f){return f.templateField;});
        };
        vm.getMappedFieldnames = function (isExpr) {
            return !vm.mappingScheme || !vm.template.fields ? [] : vm.template.fields
                .filter(function(f){
                    return f.display && (f.mode=='EXPRESSION' || (!isExpr && !!f.mappedField && f.templateField != f.mappedField));
                })
                .map(function(f){
                    return f.templateField+"=>"+(f.mode=='FIELD' ? f.mappedField : f.expression);
                });
        };
        vm.generatePreviewUrl = function () {
            return "/api/assets/templates/"+vm.doc.key+"/preview?hideFieldnames="+encodeURIComponent(vm.getHiddenFieldnames().join("|"))
                +"&mappedFieldnames="+encodeURIComponent(vm.getMappedFieldnames().join("|"))
                +"&sampleAddress="+vm.showSampleAddress
                +"&dataSourceId="+(vm.template.dataSource ? vm.template.dataSource.id : '')
                +"&addressBlock="+(vm.template.addressBoxSpace || true);
        };
        vm.generatePreviewUrlPDF = function () {
            return vm.generatePreviewUrl()
                    .replace("/preview?","/preview.pdf?")
                    .replace("&sampleAddress=true","&sampleAddress=false")
                + "&stationery="+(vm.stationery ? vm.stationery.id : "")
                + "&approvalCode="+vm.approvedCode;
        };
        vm.updatePreview = function () {
            delete vm.updatePreviewPromise;
            var newUrl = vm.generatePreviewUrl();
            if (newUrl != vm.previewUrl) {
                $("#final-preview").addClass("loading");
                vm.previewUrl = vm.generatePreviewUrl();
                vm.previewUrlPDF = vm.generatePreviewUrlPDF();
            }
        };

        vm.showLetterMatchingSurchargeWarning = function() {
            if(vm.template.addressBoxSpace === false) {
                swal({
                    title: "Letter matching surcharge!!!",
                    html: "Letters that do not have an address block cannot use window envelopes and require extra processing.\n" +
                        " Additional charges will apply.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, accept surcharge and use non-window envelope.",
                    cancelButtonText: "No, use window-envelope.",
                    closeOnConfirm: true,
                    closeOnCancel: true
                }).then(function(resp){
                    if (!resp.value) {
                        vm.template.addressBoxSpace = true;
                    }
                    vm.updatePreviewTrigger();
                });
            }
            vm.updatePreviewTrigger();
        };

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            Template.updateTemplateDoc({
                templateId: result.id,
                docId: vm.doc.key,
                hideFieldnames: vm.getHiddenFieldnames().join("|"),
                sampleAddress: vm.showSampleAddress,
                stationery: (vm.stationery ? {id: vm.stationery.id} : null),
                approvalCode: vm.approvedCode
            },function(){
                $scope.$emit('crm2PrintApp:templateUpdate', result);
                // $uibModalInstance.close(result);
                vm.isSaving = false;
                swal({
                    title: "Success!!!",
                    html: "Your new template has been saved.<br/>Would you like to start a new Print Job based on this template?",
                    type: "success",
                    showCancelButton: true,
                    confirmButtonText: "Yes, start new Print Job.",
                    cancelButtonText: "No, just take me back to my templates.",
                    closeOnConfirm: true,
                    closeOnCancel: true
                }).then(function(resp){
                    if (resp.value) {
                        $state.go('print-job.new',{templateId:result.id});
                    } else {
                        $state.go('template');
                    }
                });
            },function(){
                debugger;
                alert("fail");
            })
        };

        vm.verifyApprovedCode = function() {
            vm.approved = !!vm.template.approvedCode && vm.template.approvedCode.toLowerCase() != vm.approvedCode.toLowerCase();
        };

        vm.onPasteCode = function() {
            $timeout(function() {
                $("#field_approvedCode").blur();
            })
        };

        var onSaveError = function (resp) {
            vm.isSaving = false;
            swal("Saving of the template failed",resp.statusText,"error");
        };

        vm.editFieldMapping = function(mapping) {
            $uibModal.open({
                templateUrl: 'app/entities/template/field-mapping.modal.html',
                controller: 'FieldMappingModalController',
                controllerAs: 'vm',
                size: 'lg',
                scope: $scope,
                resolve: {
                    mapping: function() {
                        return mapping;
                    },
                    mappingScheme: function() {
                        return vm.mappingScheme;
                    }
                }
            });
        };

        vm.save = function () {
            if(vm.getUnMappedFields().length > 0) {
                swal("Unmapped Fields!","Please ensure that all merge fields are either mapped or hidden.","error");
                return;
            }
            vm.isSaving = true;
            //vm.template.categories = $("form[name=step1_form] select").val()
            if (vm.template.id !== null) {
                Template.update(vm.template, onSaveSuccess, onSaveError);
            } else {
                Template.save(vm.template, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            // $uibModalInstance.dismiss('cancel');
            vm.template = {};
            delete vm.doc;
            delete vm.stationery;
            delete vm.previewUrl;
            delete vm.previewUrlPDF;
            delete vm.stationeryPreviewUrl
            delete vm.mappingScheme;
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.created = false;
        vm.datePickerOpenStatus.validated = false;
        vm.datePickerOpenStatus.approved = false;
        vm.datePickerOpenStatus.lastModified = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        $scope.$on('template-change',vm.updatePreviewTrigger.bind(vm));
        /*$scope.$on('template-change',function(){
            vm.displayExpressionWarning = vm.containsExpression();
        });*/

        vm.initTour = function () {
            //http://linkedin.github.io/hopscotch/
            var tour = {
                id: "hs-templateEdit",
                steps: [
                    {
                        title: "Begin here",
                        content: "Give your template a descriptive name, by typing it in this field.",
                        target: ["field_name"],
                        placement: "right"
                    },
                    {
                        title: "Tag your template",
                        content: "To quickly search for your template later, save it under a specific category.",
                        target: ["field_category"],
                        placement: "right"
                    },
                    {
                        title: "Select your CRM provider",
                        content: "Click on the box and choose your CRM or list provider. If your CRM is not listed here <a href='/contact-us' target='_blank'>contacts us</a> so we can add it.",
                        target: ["field_datasource"],
                        placement: "right"
                    },
                    {
                        title: "Map Address Fields",
                        content: "CRM2Print has already pre-matched the address block fields to the appropriate fields from the selected list provider. Expand the list by clicking on the down-arrow and then click on the link button next to the mail merge field to verify or update the merge field.",
                        target: ["standard_merge_fields_block"],
                        placement: "right"
                    },
                    {
                        title: "Remove Duplicate Address Merge Fields",
                        content: "Untick all other address merge fields to remove them from your template's address block. You may also map your custom fields to those available by the selected CRM or list provider.",
                        target: ["user_defined_fields_block"],
                        placement: "right"
                    },
                    {
                        title: "Preview Sample",
                        content: "Tick this box to preview your template with sample contact details. Note: sample addresses are not available for all data source.",
                        target: ["field_sample_address_label"],
                        placement: "right"
                    },
                    {
                        title: "Add Stationary or Letterhead",
                        content: "If your template does not contain a letterhead, click this button to select or upload your letterhead or stationery PDF/DOC/RTF file",
                        target: ["template-options"],
                        placement: "left"
                    },
                    {
                        title: "Preview Template Output",
                        content: "If you agree to the terms click the two boxes and then ‘Preview PDF’ to verify your template is formatted correctly.  The template will open in a new tab for your review.",
                        target: ["previewTemplateButton"],
                        placement: "left"
                    },
                    {
                        title: "Approval Code",
                        content: "On the top left of the template preview is an approval code. Copy this code and if you are satisfied with the template paste it into the 'Approval Code' field and then click SAVE.",
                        target: ["field_approvedCode"],
                        placement: "bottom",
                        xOffset: -150
                    }
                ],
                showPrevButton: true,
                scrollTopMargin: 100,
                delay: 300,
                onEnd: function () {
                    hopscotch.endTour(false, false);//clearCookie=false
                    $cookies.put(tour.id,"-1");
                },
                onClose: function () {
                    hopscotch.endTour(false, false);//clearCookie=false
                    $cookies.put(tour.id,"-1");
                }
            };
            var startStep = $cookies.get(tour.id);
            if (startStep == undefined  || startStep >= 0) {
                $cookies.remove(tour.id);
                hopscotch.startTour(tour, startStep);
            }
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('TemplateDialogController', TemplateDialogController);

    TemplateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Template', 'Envelope', 'Site', 'User', 'Stationery', 'SiteDataSource'];

    function TemplateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Template, Envelope, Site, User, Stationery, SiteDataSource) {
        var vm = this;

        vm.template = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.envelopes = Envelope.query();
        vm.sites = Site.query();
        vm.users = User.query();
        vm.stationeries = Stationery.query();
        vm.sitedatasources = SiteDataSource.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.template.id !== null) {
                Template.update(vm.template, onSaveSuccess, onSaveError);
            } else {
                Template.save(vm.template, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:templateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;
        vm.datePickerOpenStatus.validated = false;
        vm.datePickerOpenStatus.approved = false;
        vm.datePickerOpenStatus.lastModified = false;
        vm.datePickerOpenStatus.documentLastSavedTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('TemplateDetailController', TemplateDetailController);

    TemplateDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Template', 'Envelope', 'Site', 'User', 'Stationery', 'SiteDataSource', 'AuthServerProvider', 'Principal', '$uibModal'];

    function TemplateDetailController($scope, $rootScope, $stateParams, entity, Template, Envelope, Site, User, Stationery, SiteDataSource, AuthServerProvider, Principal, $uibModal) {
        var vm = this;

        vm.template = entity;
        vm.token = AuthServerProvider.getToken().access_token;

        Principal.identity().then(function(account) {
            vm.account = account;
            vm.isAuthenticated = Principal.isAuthenticated;
        });

        $scope.$on('template-change', function (event) {
            vm.showSave = true;
        });

        vm.canEdit = function() {
            return vm.template.creator.login == vm.account.login || Principal.hasAuthority('ROLE_ADMIN');
        };

        var unsubscribe = $rootScope.$on('crm2PrintApp:templateUpdate', function(event, result) {
            vm.template = result;
        });

        vm.subsequentPageIndicies = function() {
          var indicies = [];
          for (var i = 1; i < vm.template.numberOfPages; i++) {
              indicies.push(i)
          }
          return indicies
        };
        vm.share = function () {
            Template.share(vm.template,function(result) {
                $rootScope.$emit('crm2PrintApp:templateUpdate', result);
            });
        };
        vm.makePublic = function () {
            Template.makePublic(vm.template,function(result) {
                $rootScope.$emit('crm2PrintApp:templateUpdate', result);
            });
        };
        vm.clearCacheAndPreviews = function () {
            Template.clearCache({id:vm.template.id});
        };
        vm.editFieldMapping = function(mapping) {
            if(!vm.mappingScheme) {
                Template.extractFields({id: vm.template.id}, function (resp) {
                    vm.mappingScheme = resp.mappingScheme;
                    vm.editFieldMapping(mapping);
                });
                return;
            }
            $uibModal.open({
                templateUrl: 'app/entities/template/field-mapping.modal.html',
                controller: 'FieldMappingModalController',
                controllerAs: 'vm',
                size: 'lg',
                scope: $scope,
                resolve: {
                    mapping: function() {
                        return mapping;
                    },
                    mappingScheme: function() {
                        return vm.mappingScheme;
                    }
                }
            });
        };

        vm.saveFields = function () {
            Template.saveFields({id:vm.template.id, fields: vm.template.fields},function () {
                vm.showSave = false;
            });
        };

        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('TemplateDeleteController',TemplateDeleteController);

    TemplateDeleteController.$inject = ['$uibModalInstance', 'entity', 'Template'];

    function TemplateDeleteController($uibModalInstance, entity, Template) {
        var vm = this;

        vm.template = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Template.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
        vm.confirmArchive = function (id) {
            Template.archive({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('template', {
            parent: 'entity',
            url: '/template',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.template.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/template/templates.html',
                    controller: 'TemplateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('template');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('template-detail', {
            parent: 'entity',
            url: '/template/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.template.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/template/template-detail.html',
                    controller: 'TemplateDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('template');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Template', function($stateParams, Template) {
                    return Template.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('template.new', {
            parent: 'template',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/template/template-edit.html',
                    controller: 'TemplateEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('template');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        status: null,
                        name: null,
                        fileFormat: null,
                        size: null,
                        visibility: null,
                        created: null,
                        validated: null,
                        approved: null,
                        lastModified: null,
                        numberOfPages: null,
                        mailMergefields: null,
                        addressBoxSpace: true,
                        category: null,
                        approvedCode: null,
                        wordCount: null,
                        documentText: null,
                        documentLastSavedBy: null,
                        documentLastSavedTime: null,
                        shareToken: null,
                        stationeryFirstPageOnly: true,
                        id: null
                    };
                }
            }
        })
        .state('template.edit', {
            parent: 'template',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/template/template-edit.html',
                    controller: 'TemplateEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('template');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Template', function($stateParams, Template) {
                    return Template.get({id : $stateParams.id});
                }]
            }
        })
        .state('template.delete', {
            parent: 'template',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/template/template-delete-dialog.html',
                    controller: 'TemplateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Template', function(Template) {
                            return Template.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('template', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('Template', Template)
        .factory('TemplateDoc', TemplateDoc);

    Template.$inject = ['$resource', 'DateUtils'];

    function Template ($resource, DateUtils) {
        var resourceUrl =  '/api/templates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.created = DateUtils.convertDateTimeFromServer(data.created);
                    data.validated = DateUtils.convertDateTimeFromServer(data.validated);
                    data.approved = DateUtils.convertDateTimeFromServer(data.approved);
                    data.lastModified = DateUtils.convertDateTimeFromServer(data.lastModified);
                    data.documentLastSavedTime = DateUtils.convertDateTimeFromServer(data.documentLastSavedTime);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'archive': { method:'DELETE', url: '/api/templates/:id?archive=true', },
            'updateTemplateDoc': {
                url: '/api/templates/:id/document',
                params: {id:"@templateId"},
                method:'PUT'
            },
            'share': {
                url: '/api/templates/:id/share',
                params: {id:"@id"},
                method:'PUT'
            },
            'makePublic': {
                url: '/api/templates/:id/make-public',
                params: {id:"@id"},
                method:'PUT'
            },
            'clearCache': {
                url: '/api/templates/:id/cache',
                params: {id:"@id"},
                method:'DELETE'
            },
            'extractFields': {
                url: '/api/templates/:id/fieldnames',
                method: 'GET'
            },
            'saveFields': {
                url: '/api/templates/:id/fields',
                params: {id:"@id"},
                method: 'PUT'
            }
        });
    }

    TemplateDoc.$inject = ['$resource'];

    function TemplateDoc ($resource) {
        var resourceUrl =  '/api/assets/templates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.documentLastSavedTime = DateUtils.convertLocalDateToServer(data.documentLastSavedTime);
                    return angular.toJson(data);
                }
            },
            'extractFields': {
                url: '/api/assets/templates/:id/fieldnames?data-source-id=:dataSourceId',
                method: 'GET'
            },
            'substituteExpressions': {
                url: '/api/assets/templates/:id/substitute-expressions?data-source-id=:dataSourceId',
                method: 'GET'
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.documentLastSavedTime = DateUtils.convertLocalDateToServer(data.documentLastSavedTime);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('TemplateSearch', TemplateSearch);

    TemplateSearch.$inject = ['$resource'];

    function TemplateSearch($resource) {
        var resourceUrl =  '/api/_search/templates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('TemplateController', TemplateController);

    TemplateController.$inject = ['$timeout','$scope', '$state', 'Template', 'TemplateSearch', 'ParseLinks', 'AlertService'];

    function TemplateController ($timeout, $scope, $state, Template, TemplateSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.templates = [];
        vm.categories = [];
        vm.industry = null;
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.search = search;

        loadAll();

        function loadAll() {
            if(vm.loading) return;
            vm.loading = true;
            if (vm.currentSearch) {
                TemplateSearch.query({
                    query: vm.currentSearch,
                    industry: vm.industry,
                    // page: vm.page,
                    // size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Template.query({
                    // page: vm.page,
                    industry: vm.industry,
                    // size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                if(data.length > 0) {
                    vm.categories = {};
                    for (var i = 0; i < data.length; i++) {
                        vm.templates.push(data[i]);
                        vm.categories[data[i].category || "Other"] = (vm.categories[data[i].category || "Other"] || 0) + 1;
                    }
                }
                //prevent infinite scroll from going crazy... update after render
                $timeout(function(){
                    vm.loading = false;
                });
            }
            function onError(error) {
                vm.loading = false;
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.templates = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.templates = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.templates = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            loadAll();
        }

        vm.showIndustry = function(industry) {
            vm.industry = industry;
            vm.clear();
        }
    }
})();
;
(function() {
    'use strict';

    angular.module('crm2PrintApp')
        .controller('FieldMappingModalController', FieldMappingModalController);

    FieldMappingModalController.$inject = ['$scope', '$uibModalInstance', 'mapping', 'mappingScheme'];

    function FieldMappingModalController ($scope, $uibModalInstance, mapping, mappingScheme) {
        var vm = this;

        vm.save = save;
        vm.mapping = mapping;
        vm.mapping.mode = !!mapping.expression  ? 'EXPRESSION' : 'FIELD';
        vm.mappingScheme = mappingScheme;
        vm.updateFieldMappingMode = updateFieldMappingMode;
        vm.createCustomField = createCustomField;

        function updateMapableFields() {
            vm.mapableFields = vm.mappingScheme.availableFields.map(function(f){
                return {
                    field: f,
                    group: 'Standard'
                }
            }).concat(vm.mappingScheme.customFields.map(function(f){
                return {
                    field: f,
                    group: 'User Defined'
                }
            }));
        }

        function updateFieldMappingMode(item) {
            if(!vm.mapping.mappedField) {
                //TODO mark required
                return;
            }
            if(vm.mappingScheme.customFields.indexOf(vm.mapping.mappedField) >= 0) {
                vm.mapping.mode = 'CUSTOM';
            } else {
                vm.mapping.mode = 'FIELD'
            }
        }

        function createCustomField(detectAddress) {
            swal({
                title: 'Create Custom Field',
                text: detectAddress
                    ? "The system will attempt to detect an address and save the parts into separate fields"
                    : null,
                input: 'text',
                inputPlaceholder: 'Field Name',
                showCancelButton: true,
                confirmButtonText: "Create",
                closeOnCancel: true
            }).then(function(result){
                if (result.value) {
                    var fld = result.value.trim();
                    addField(fld, false, detectAddress);
                    if(detectAddress) {
                        addField(fld+" Address1", true);
                        addField(fld+" City", true);
                        addField(fld+" Postcode", true);
                        addField(fld+" State", true);
                        addField(fld+" Country Code", true);
                    }
                    updateMapableFields();
                }
            });
        }

        function addField(name, generated, detectAddress) {
            vm.mappingScheme.fields.push({
                "valid": true,
                "display": true,
                "mode": "CUSTOM",
                "readOnly": true,
                "templateField": name,
                "detectAddress": detectAddress,
                "generated": generated
            });
            vm.mappingScheme.customFields.push(name);
        }

        function save() {
            if(vm.mapping.mode == 'FIELD' || vm.mapping.mode == 'CUSTOM' ) {
                delete vm.mapping.expression;
            } else {
                delete vm.mapping.mappedField;
            }
            vm.mapping.match = 'MANUAL';
            $uibModalInstance.dismiss('cancel');
            $scope.$emit('template-change');
        }

        updateMapableFields();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('StationeryDialogController', StationeryDialogController);

    StationeryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Stationery', 'User'];

    function StationeryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Stationery, User) {
        var vm = this;

        vm.stationery = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.stationery.id !== null) {
                Stationery.update(vm.stationery, onSaveSuccess, onSaveError);
            } else {
                Stationery.save(vm.stationery, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:stationeryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('StationeryDetailController', StationeryDetailController);

    StationeryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Stationery', 'User', 'AuthServerProvider'];

    function StationeryDetailController($scope, $rootScope, $stateParams, entity, Stationery, User, AuthServerProvider) {
        var vm = this;

        vm.stationery = entity;
        vm.token = AuthServerProvider.getToken().access_token;

        var unsubscribe = $rootScope.$on('crm2PrintApp:stationeryUpdate', function(event, result) {
            vm.stationery = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('StationeryDeleteController',StationeryDeleteController);

    StationeryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Stationery'];

    function StationeryDeleteController($uibModalInstance, entity, Stationery) {
        var vm = this;

        vm.stationery = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Stationery.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('stationery', {
            parent: 'entity',
            url: '/stationery?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.stationery.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stationery/stationeries.html',
                    controller: 'StationeryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('stationery');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('stationery-detail', {
            parent: 'entity',
            url: '/stationery/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.stationery.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stationery/stationery-detail.html',
                    controller: 'StationeryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('stationery');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Stationery', function($stateParams, Stationery) {
                    return Stationery.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('stationery.new', {
            parent: 'stationery',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stationery/stationery-dialog.html',
                    controller: 'StationeryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                status: null,
                                name: null,
                                fileFormat: null,
                                size: null,
                                created: null,
                                file: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('stationery', null, { reload: true });
                }, function() {
                    $state.go('stationery');
                });
            }]
        })
        .state('stationery.edit', {
            parent: 'stationery',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stationery/stationery-dialog.html',
                    controller: 'StationeryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Stationery', function(Stationery) {
                            return Stationery.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('stationery', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('stationery.delete', {
            parent: 'stationery',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stationery/stationery-delete-dialog.html',
                    controller: 'StationeryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Stationery', function(Stationery) {
                            return Stationery.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('stationery', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('Stationery', Stationery);

    Stationery.$inject = ['$resource', 'DateUtils'];

    function Stationery ($resource, DateUtils) {
        var resourceUrl =  '/api/stationeries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('StationerySearch', StationerySearch);

    StationerySearch.$inject = ['$resource'];

    function StationerySearch($resource) {
        var resourceUrl =  '/api/_search/stationeries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('StationeryController', StationeryController);

    StationeryController.$inject = ['$scope', '$state', 'Stationery', 'StationerySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function StationeryController ($scope, $state, Stationery, StationerySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        Dropzone.autoDiscover = false;

        $scope.dropzoneConfigStationery = {
            'options': { // passed into the Dropzone constructor
                'url': '/api/assets/templates',
                dictDefaultMessage: 'Upload new stationery or letterhead.<div class="file-formats"><i class="fa fa-file-pdf-o"></i><i class="fa fa-file-word-o"></i></div>',
                maxFiles: 1,
                parallelUploads: 1,
                maxFilesize : 2,
                uploadMultiple: false,
                // acceptedFiles: '.docx,.doc,.rtf'
                acceptedFiles: '.jpg,.pdf,.docx,.doc,.rtf'
            },
            'eventHandlers': {
                'sending': function (file, xhr, formData) {
                    // console.log("sending: "+file);
                },
                'success': function (file, response) {
                    $scope.dropzoneConfigStationery.dropzone.removeFile(file);
                    Stationery.save({name: response.originalFilename, file: response.key}, function(stationery){
                        vm.stationeries.push(stationery);
                    }, function(resp){
                        swal("Stationery upload failed",resp.statusText,"error");
                    });
                }
            }
        };


        function loadAll () {
            if (pagingParams.search) {
                StationerySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Stationery.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.stationeries = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteAPIDialogController', SiteAPIDialogController);

    SiteAPIDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'SiteAPI', 'Site'];

    function SiteAPIDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, SiteAPI, Site) {
        var vm = this;

        vm.siteAPI = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.sites = Site.query({filter: 'siteapi-is-null'});
        $q.all([vm.siteAPI.$promise, vm.sites.$promise]).then(function() {
            if (!vm.siteAPI.site || !vm.siteAPI.site.id) {
                return $q.reject();
            }
            return Site.get({id : vm.siteAPI.site.id}).$promise;
        }).then(function(site) {
            vm.sites.push(site);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.siteAPI.id !== null) {
                SiteAPI.update(vm.siteAPI, onSaveSuccess, onSaveError);
            } else {
                SiteAPI.save(vm.siteAPI, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:siteAPIUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.verified = false;
        vm.datePickerOpenStatus.created = false;
        vm.datePickerOpenStatus.lastModified = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteAPIDetailController', SiteAPIDetailController);

    SiteAPIDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SiteAPI', 'Site'];

    function SiteAPIDetailController($scope, $rootScope, $stateParams, entity, SiteAPI, Site) {
        var vm = this;

        vm.siteAPI = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:siteAPIUpdate', function(event, result) {
            vm.siteAPI = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteAPIDeleteController',SiteAPIDeleteController);

    SiteAPIDeleteController.$inject = ['$uibModalInstance', 'entity', 'SiteAPI'];

    function SiteAPIDeleteController($uibModalInstance, entity, SiteAPI) {
        var vm = this;

        vm.siteAPI = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SiteAPI.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('site-web-service', {
            parent: 'entity',
            url: '/site-web-service',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.siteAPI.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-web-service/site-web-services.html',
                    controller: 'SiteAPIController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('siteAPI');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('site-web-service-detail', {
            parent: 'entity',
            url: '/site-web-service/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.siteAPI.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-web-service/site-web-service-detail.html',
                    controller: 'SiteAPIDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('siteAPI');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SiteAPI', function($stateParams, SiteAPI) {
                    return SiteAPI.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('site-web-service.new', {
            parent: 'site-web-service',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-web-service/site-web-service-dialog.html',
                    controller: 'SiteAPIDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                oauthLoginUrl: null,
                                clientId: null,
                                clientSecrect: null,
                                verified: null,
                                created: null,
                                lastModified: null,
                                apiKey: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('site-web-service', null, { reload: true });
                }, function() {
                    $state.go('site-web-service');
                });
            }]
        })
        .state('site-web-service.edit', {
            parent: 'site-web-service',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-web-service/site-web-service-dialog.html',
                    controller: 'SiteAPIDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SiteAPI', function(SiteAPI) {
                            return SiteAPI.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-web-service', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('site-web-service.delete', {
            parent: 'site-web-service',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-web-service/site-web-service-delete-dialog.html',
                    controller: 'SiteAPIDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SiteAPI', function(SiteAPI) {
                            return SiteAPI.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-web-service', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('SiteAPI', SiteAPI);

    SiteAPI.$inject = ['$resource', 'DateUtils'];

    function SiteAPI ($resource, DateUtils) {
        var resourceUrl =  '/api/site-apis/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.verified = DateUtils.convertDateTimeFromServer(data.verified);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                        data.lastModified = DateUtils.convertDateTimeFromServer(data.lastModified);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('SiteAPISearch', SiteAPISearch);

    SiteAPISearch.$inject = ['$resource'];

    function SiteAPISearch($resource) {
        var resourceUrl =  '/api/_search/site-apis/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteAPIController', SiteAPIController);

    SiteAPIController.$inject = ['$scope', '$state', 'SiteAPI', 'SiteAPISearch'];

    function SiteAPIController ($scope, $state, SiteAPI, SiteAPISearch) {
        var vm = this;
        
        vm.siteAPIS = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            SiteAPI.query(function(result) {
                vm.siteAPIS = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            SiteAPISearch.query({query: vm.searchQuery}, function(result) {
                vm.siteAPIS = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteUserDialogController', SiteUserDialogController);

    SiteUserDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SiteUser', 'Site', 'User', 'SiteToken'];

    function SiteUserDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SiteUser, Site, User, SiteToken) {
        var vm = this;

        if(entity.$promise) {
            entity.$promise.then(function (resp) {
                vm.siteUser = resp;
                $timeout(vm.siteSelected);
            });
        } else {
            vm.siteUser = entity;
        }
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.sites = Site.queryWithApi();
        vm.users = User.query();

        vm.siteSelected = function() {
            if(!vm.siteUser.site) return;
            Site.authenticationMethod({siteId:vm.siteUser.site.id},function(resp){
                vm.siteAuthenticationMethod = resp.method;
                if(resp.method == 'OAUTH') {
                    Site.oauthLoginUrl({siteId:vm.siteUser.site.id},function(resp){
                        vm.siteOauthLoginUrl = resp.url;
                    });
                }
            });
        };

        var tokenCheck = function() {
            Site.oauthSiteToken({siteId:vm.siteUser.site.id},function(resp){
                vm.token = resp;
                if(vm.token.siteUser) {
                    vm.siteUser.username = vm.token.siteUser.username;
                    vm.siteUser.externalUserId = vm.token.siteUser.externalUserId;
                    vm.siteUser.externalSubUserId = vm.token.siteUser.externalSubUserId;
                    vm.siteUser.displayName = vm.token.siteUser.displayName;
                }
            },vm.startTokenCheck);
        }

        vm.startTokenCheck = function() {
            setTimeout(tokenCheck,3000);
            return true;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.generateToken = function () {
            vm.isSaving = true;
            SiteToken.generate(vm.siteUser, function (resp) {
                vm.token = resp;
                vm.siteUser.externalUserId = vm.token.siteUser.externalUserId;
                vm.siteUser.externalSubUserId = vm.token.siteUser.externalSubUserId;
                vm.siteUser.displayName = vm.token.siteUser.displayName;
                vm.isSaving = false;
            }, function (resp) {
                vm.isSaving = false;
                swal('Authentication failed!',"Please verify your username and password and try again.",'error');
            });
        };

        function save () {
            vm.isSaving = true;
            if (vm.siteUser.id !== null) {
                SiteUser.update(vm.siteUser, onSaveSuccess, onSaveError);
            } else {
                SiteUser.save(vm.siteUser, onSaveSuccess, onSaveError);
            }
        }

        var onSaveSuccess = function (result) {
            $scope.$emit('crm2PrintApp:siteUserUpdate', result);
            if (vm.token) {
                vm.token.siteUser = result;
                SiteToken.save(vm.token, function () {
                    $uibModalInstance.close(result);
                    vm.isSaving = false;
                }, onSaveError);
            } else {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        };

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        // vm.siteSelected();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteUserDetailController', SiteUserDetailController);

    SiteUserDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SiteUser', 'Site', 'User'];

    function SiteUserDetailController($scope, $rootScope, $stateParams, entity, SiteUser, Site, User) {
        var vm = this;

        vm.siteUser = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:siteUserUpdate', function(event, result) {
            vm.siteUser = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteUserDeleteController',SiteUserDeleteController);

    SiteUserDeleteController.$inject = ['$uibModalInstance', 'entity', 'SiteUser'];

    function SiteUserDeleteController($uibModalInstance, entity, SiteUser) {
        var vm = this;

        vm.siteUser = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SiteUser.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('site-user', {
            parent: 'entity',
            url: '/site-user',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.siteUser.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-user/site-users.html',
                    controller: 'SiteUserController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('siteUser');
                    $translatePartialLoader.addPart('siteToken');
                    $translatePartialLoader.addPart('entityStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('site-user-detail', {
            parent: 'entity',
            url: '/site-user/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.siteUser.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-user/site-user-detail.html',
                    controller: 'SiteUserDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('siteUser');
                    $translatePartialLoader.addPart('entityStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SiteUser', function($stateParams, SiteUser) {
                    return SiteUser.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('site-user.new', {
            parent: 'site-user',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-user/site-user-dialog.html',
                    controller: 'SiteUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                externalUserId: null,
                                creationDate: null,
                                username: null,
                                password: null,
                                externalSubUserId: null,
                                displayName: null,
                                status: 'ACTIVE',
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('site-user', null, { reload: true });
                }, function() {
                    $state.go('site-user');
                });
            }]
        })
        .state('site-user.edit', {
            parent: 'site-user',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-user/site-user-dialog.html',
                    controller: 'SiteUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SiteUser', function(SiteUser) {
                            return SiteUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-user', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('site-user.delete', {
            parent: 'site-user',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-user/site-user-delete-dialog.html',
                    controller: 'SiteUserDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SiteUser', function(SiteUser) {
                            return SiteUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-user', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('SiteUser', SiteUser);

    SiteUser.$inject = ['$resource', 'DateUtils'];

    function SiteUser ($resource, DateUtils) {
        var resourceUrl =  'api/site-users/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryActive': { method: 'GET', isArray: true, url: 'api/site-users/active'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('SiteUserSearch', SiteUserSearch);

    SiteUserSearch.$inject = ['$resource'];

    function SiteUserSearch($resource) {
        var resourceUrl =  'api/_search/site-users/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteUserController', SiteUserController);

    SiteUserController.$inject = ['$scope', '$state', 'SiteUser', 'SiteUserSearch'];

    function SiteUserController ($scope, $state, SiteUser, SiteUserSearch) {
        var vm = this;
        
        vm.siteUsers = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            SiteUser.query(function(result) {
                vm.siteUsers = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            SiteUserSearch.query({query: vm.searchQuery}, function(result) {
                vm.siteUsers = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteTokenDialogController', SiteTokenDialogController);

    SiteTokenDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'SiteToken', 'SiteUser'];

    function SiteTokenDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, SiteToken, SiteUser) {
        var vm = this;

        vm.siteToken = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.siteusers = SiteUser.query({filter: 'sitetoken-is-null'});
        $q.all([vm.siteToken.$promise, vm.siteusers.$promise]).then(function() {
            if (!vm.siteToken.siteUser || !vm.siteToken.siteUser.id) {
                return $q.reject();
            }
            return SiteUser.get({id : vm.siteToken.siteUser.id}).$promise;
        }).then(function(siteUser) {
            vm.siteusers.push(siteUser);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.siteToken.id !== null) {
                SiteToken.update(vm.siteToken, onSaveSuccess, onSaveError);
            } else {
                SiteToken.save(vm.siteToken, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:siteTokenUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationDate = false;
        vm.datePickerOpenStatus.expiryDate = false;
        vm.datePickerOpenStatus.refreshTokenExpiryDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteTokenDetailController', SiteTokenDetailController);

    SiteTokenDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SiteToken', 'SiteUser'];

    function SiteTokenDetailController($scope, $rootScope, $stateParams, entity, SiteToken, SiteUser) {
        var vm = this;

        vm.siteToken = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:siteTokenUpdate', function(event, result) {
            vm.siteToken = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteTokenDeleteController',SiteTokenDeleteController);

    SiteTokenDeleteController.$inject = ['$uibModalInstance', 'entity', 'SiteToken'];

    function SiteTokenDeleteController($uibModalInstance, entity, SiteToken) {
        var vm = this;

        vm.siteToken = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SiteToken.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('site-token', {
            parent: 'entity',
            url: '/site-token',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.siteToken.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-token/site-tokens.html',
                    controller: 'SiteTokenController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('siteToken');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('site-token-detail', {
            parent: 'entity',
            url: '/site-token/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.siteToken.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-token/site-token-detail.html',
                    controller: 'SiteTokenDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('siteToken');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SiteToken', function($stateParams, SiteToken) {
                    return SiteToken.get({id : $stateParams.id});
                }]
            }
        })
        .state('site-token.new', {
            parent: 'site-token',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-token/site-token-dialog.html',
                    controller: 'SiteTokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                siteTokenId: null,
                                authenticationMethod: null,
                                clientId: null,
                                clientSecret: null,
                                accessToken: null,
                                creationDate: null,
                                expiryDate: null,
                                refreshToken: null,
                                refreshTokenExpiryDate: null,
                                id: null
                            };
                        },
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/sweetalert2/sweetalert2.min.js', 'content/js/plugins/sweetalert/sweetalert.css'
                                ]
                            });
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-token', null, { reload: true });
                }, function() {
                    $state.go('site-token');
                });
            }]
        })
        .state('site-token.edit', {
            parent: 'site-token',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-token/site-token-dialog.html',
                    controller: 'SiteTokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SiteToken', function(SiteToken) {
                            return SiteToken.get({id : $stateParams.id});
                        }],
                        deps: ['$ocLazyLoad', function($ocLazyLoad) {
                            return $ocLazyLoad.load({
                                insertBefore: '#css-bootstrap',
                                serie: true,
                                files: [
                                    'content/js/plugins/sweetalert2/sweetalert2.min.js', 'content/js/plugins/sweetalert/sweetalert.css'
                                ]
                            });
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-token', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('site-token.delete', {
            parent: 'site-token',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-token/site-token-delete-dialog.html',
                    controller: 'SiteTokenDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SiteToken', function(SiteToken) {
                            return SiteToken.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-token', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('SiteToken', SiteToken);

    SiteToken.$inject = ['$resource', 'DateUtils'];

    function SiteToken ($resource, DateUtils) {
        var resourceUrl =  '/api/site-tokens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                        data.expiryDate = DateUtils.convertDateTimeFromServer(data.expiryDate);
                        data.refreshTokenExpiryDate = DateUtils.convertDateTimeFromServer(data.refreshTokenExpiryDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'generate': {
                method:'POST',
                url :'/api/site-tokens/generate'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('SiteTokenSearch', SiteTokenSearch);

    SiteTokenSearch.$inject = ['$resource'];

    function SiteTokenSearch($resource) {
        var resourceUrl =  '/api/_search/site-tokens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteTokenController', SiteTokenController);

    SiteTokenController.$inject = ['$scope', '$state', 'SiteToken', 'SiteTokenSearch'];

    function SiteTokenController ($scope, $state, SiteToken, SiteTokenSearch) {
        var vm = this;
        
        vm.siteTokens = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            SiteToken.query(function(result) {
                vm.siteTokens = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            SiteTokenSearch.query({query: vm.searchQuery}, function(result) {
                vm.siteTokens = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteDataSourceDialogController', SiteDataSourceDialogController);

    SiteDataSourceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SiteDataSource', 'User', 'Site'];

    function SiteDataSourceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SiteDataSource, User, Site) {
        var vm = this;

        vm.siteDataSource = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.users = User.query();
        vm.sites = Site.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.siteDataSource.id !== null) {
                SiteDataSource.update(vm.siteDataSource, onSaveSuccess, onSaveError);
            } else {
                SiteDataSource.save(vm.siteDataSource, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:siteDataSourceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastModified = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteDataSourceDetailController', SiteDataSourceDetailController);

    SiteDataSourceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SiteDataSource', 'User', 'Site'];

    function SiteDataSourceDetailController($scope, $rootScope, $stateParams, entity, SiteDataSource, User, Site) {
        var vm = this;

        vm.siteDataSource = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:siteDataSourceUpdate', function(event, result) {
            vm.siteDataSource = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteDataSourceDeleteController',SiteDataSourceDeleteController);

    SiteDataSourceDeleteController.$inject = ['$uibModalInstance', 'entity', 'SiteDataSource'];

    function SiteDataSourceDeleteController($uibModalInstance, entity, SiteDataSource) {
        var vm = this;

        vm.siteDataSource = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SiteDataSource.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('site-data-source', {
            parent: 'entity',
            url: '/site-data-source?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.siteDataSource.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-data-source/site-data-sources.html',
                    controller: 'SiteDataSourceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('siteDataSource');
                    $translatePartialLoader.addPart('dataSourceType');
                    $translatePartialLoader.addPart('featureStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('site-data-source-detail', {
            parent: 'entity',
            url: '/site-data-source/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.siteDataSource.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-data-source/site-data-source-detail.html',
                    controller: 'SiteDataSourceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('siteDataSource');
                    $translatePartialLoader.addPart('dataSourceType');
                    $translatePartialLoader.addPart('featureStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SiteDataSource', function($stateParams, SiteDataSource) {
                    return SiteDataSource.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('site-data-source.new', {
            parent: 'site-data-source',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-data-source/site-data-source-dialog.html',
                    controller: 'SiteDataSourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                lastModified: null,
                                type: null,
                                adapterName: null,
                                sampleData: null,
                                status: null,
                                requiresUser: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('site-data-source', null, { reload: true });
                }, function() {
                    $state.go('site-data-source');
                });
            }]
        })
        .state('site-data-source.edit', {
            parent: 'site-data-source',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-data-source/site-data-source-dialog.html',
                    controller: 'SiteDataSourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SiteDataSource', function(SiteDataSource) {
                            return SiteDataSource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-data-source', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('site-data-source.delete', {
            parent: 'site-data-source',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-data-source/site-data-source-delete-dialog.html',
                    controller: 'SiteDataSourceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SiteDataSource', function(SiteDataSource) {
                            return SiteDataSource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-data-source', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('SiteDataSource', SiteDataSource);

    SiteDataSource.$inject = ['$resource', 'DateUtils'];

    function SiteDataSource ($resource, DateUtils) {
        var resourceUrl =  '/api/site-data-sources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryLinked': { method: 'GET', isArray: true, url: '/api/site-data-sources/linked'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastModified = DateUtils.convertDateTimeFromServer(data.lastModified);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'contactsSourceSubscriptionStatus': {
                method:'POST',
                url: '/api/site-data-sources/:dataSourceId/by-site-user/:siteUserId/subscription-status?print-job=:printJobId',
                params: {printJobId: "@printJobId", siteUserId:"@siteUserId", dataSourceId:"@dataSourceId"}
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('SiteDataSourceSearch', SiteDataSourceSearch);

    SiteDataSourceSearch.$inject = ['$resource'];

    function SiteDataSourceSearch($resource) {
        var resourceUrl =  '/api/_search/site-data-sources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteDataSourceController', SiteDataSourceController);

    SiteDataSourceController.$inject = ['$scope', '$state', 'SiteDataSource', 'SiteDataSourceSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SiteDataSourceController ($scope, $state, SiteDataSource, SiteDataSourceSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                SiteDataSourceSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SiteDataSource.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.siteDataSources = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteCustomisationDialogController', SiteCustomisationDialogController);

    SiteCustomisationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'SiteCustomisation', 'Site'];

    function SiteCustomisationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, SiteCustomisation, Site) {
        var vm = this;

        vm.siteCustomisation = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.sites = Site.query({filter: 'sitecustomisation-is-null'});
        $q.all([vm.siteCustomisation.$promise, vm.sites.$promise]).then(function() {
            if (!vm.siteCustomisation.site || !vm.siteCustomisation.site.id) {
                return $q.reject();
            }
            return Site.get({id : vm.siteCustomisation.site.id}).$promise;
        }).then(function(site) {
            vm.sites.push(site);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.siteCustomisation.id !== null) {
                SiteCustomisation.update(vm.siteCustomisation, onSaveSuccess, onSaveError);
            } else {
                SiteCustomisation.save(vm.siteCustomisation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:siteCustomisationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastModified = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteCustomisationDetailController', SiteCustomisationDetailController);

    SiteCustomisationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SiteCustomisation', 'Site'];

    function SiteCustomisationDetailController($scope, $rootScope, $stateParams, entity, SiteCustomisation, Site) {
        var vm = this;

        vm.siteCustomisation = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:siteCustomisationUpdate', function(event, result) {
            vm.siteCustomisation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteCustomisationDeleteController',SiteCustomisationDeleteController);

    SiteCustomisationDeleteController.$inject = ['$uibModalInstance', 'entity', 'SiteCustomisation'];

    function SiteCustomisationDeleteController($uibModalInstance, entity, SiteCustomisation) {
        var vm = this;

        vm.siteCustomisation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SiteCustomisation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('site-customisation', {
            parent: 'entity',
            url: '/site-customisation',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.siteCustomisation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-customisation/site-customisations.html',
                    controller: 'SiteCustomisationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('siteCustomisation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('site-customisation-detail', {
            parent: 'entity',
            url: '/site-customisation/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.siteCustomisation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-customisation/site-customisation-detail.html',
                    controller: 'SiteCustomisationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('siteCustomisation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SiteCustomisation', function($stateParams, SiteCustomisation) {
                    return SiteCustomisation.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('site-customisation.new', {
            parent: 'site-customisation',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-customisation/site-customisation-dialog.html',
                    controller: 'SiteCustomisationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                siteCustomisationId: null,
                                headerCss: null,
                                headerHtml: null,
                                footerHtml: null,
                                userUrlPattern: null,
                                printUrlPattern: null,
                                lastModified: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('site-customisation', null, { reload: true });
                }, function() {
                    $state.go('site-customisation');
                });
            }]
        })
        .state('site-customisation.edit', {
            parent: 'site-customisation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-customisation/site-customisation-dialog.html',
                    controller: 'SiteCustomisationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SiteCustomisation', function(SiteCustomisation) {
                            return SiteCustomisation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-customisation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('site-customisation.delete', {
            parent: 'site-customisation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-customisation/site-customisation-delete-dialog.html',
                    controller: 'SiteCustomisationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SiteCustomisation', function(SiteCustomisation) {
                            return SiteCustomisation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-customisation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('SiteCustomisation', SiteCustomisation);

    SiteCustomisation.$inject = ['$resource', 'DateUtils'];

    function SiteCustomisation ($resource, DateUtils) {
        var resourceUrl =  '/api/site-customisations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastModified = DateUtils.convertDateTimeFromServer(data.lastModified);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('SiteCustomisationSearch', SiteCustomisationSearch);

    SiteCustomisationSearch.$inject = ['$resource'];

    function SiteCustomisationSearch($resource) {
        var resourceUrl =  '/api/_search/site-customisations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteCustomisationController', SiteCustomisationController);

    SiteCustomisationController.$inject = ['$scope', '$state', 'SiteCustomisation', 'SiteCustomisationSearch'];

    function SiteCustomisationController ($scope, $state, SiteCustomisation, SiteCustomisationSearch) {
        var vm = this;
        
        vm.siteCustomisations = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            SiteCustomisation.query(function(result) {
                vm.siteCustomisations = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            SiteCustomisationSearch.query({query: vm.searchQuery}, function(result) {
                vm.siteCustomisations = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteDialogController', SiteDialogController);

    SiteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Site', 'SiteUser'];

    function SiteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Site, SiteUser) {
        var vm = this;

        vm.site = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.siteusers = SiteUser.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.site.id !== null) {
                Site.update(vm.site, onSaveSuccess, onSaveError);
            } else {
                Site.save(vm.site, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:siteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteDetailController', SiteDetailController);

    SiteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Site', 'SiteUser'];

    function SiteDetailController($scope, $rootScope, $stateParams, entity, Site, SiteUser) {
        var vm = this;

        vm.site = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:siteUpdate', function(event, result) {
            vm.site = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteDeleteController',SiteDeleteController);

    SiteDeleteController.$inject = ['$uibModalInstance', 'entity', 'Site'];

    function SiteDeleteController($uibModalInstance, entity, Site) {
        var vm = this;

        vm.site = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Site.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('site', {
            parent: 'entity',
            url: '/site?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.site.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site/sites.html',
                    controller: 'SiteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('site');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('site-detail', {
            parent: 'entity',
            url: '/site/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.site.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site/site-detail.html',
                    controller: 'SiteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('site');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Site', function($stateParams, Site) {
                    return Site.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('site.new', {
            parent: 'site',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site/site-dialog.html',
                    controller: 'SiteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                homepageUrl: null,
                                created: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('site', null, { reload: true });
                }, function() {
                    $state.go('site');
                });
            }]
        })
        .state('site.edit', {
            parent: 'site',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site/site-dialog.html',
                    controller: 'SiteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Site', function(Site) {
                            return Site.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('site', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('site.delete', {
            parent: 'site',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site/site-delete-dialog.html',
                    controller: 'SiteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Site', function(Site) {
                            return Site.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('site', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('Site', Site);

    Site.$inject = ['$resource', 'DateUtils'];

    function Site ($resource, DateUtils) {
        var resourceUrl =  '/api/sites/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryWithApi': {
                method: 'GET',
                url: '/api/sites?api-only=true',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                    }
                    return data;
                }
            },
            'authenticationMethod': {
                method: 'GET',
                url: '/api/sites/:siteId/authentication-method',
                params: {siteId:"@siteId"}
            },
            'oauthLoginUrl': {
                method: 'GET',
                url: '/api/sites/:siteId/oauth-login-url',
                params: {siteId:"@siteId"}
            },
            'oauthSiteToken': {
                method: 'GET',
                url: '/api/sites/:siteId/oauth-site-token',
                params: {siteId:"@siteId"}
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('SiteSearch', SiteSearch);

    SiteSearch.$inject = ['$resource'];

    function SiteSearch($resource) {
        var resourceUrl =  '/api/_search/sites/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SiteController', SiteController);

    SiteController.$inject = ['$scope', '$state', 'Site', 'SiteSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SiteController ($scope, $state, Site, SiteSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                SiteSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Site.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sites = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('ReturnToSenderDialogController', ReturnToSenderDialogController);

    ReturnToSenderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'ReturnToSender', 'Vendor', 'PrintJobRecord', 'VendorStaff'];

    function ReturnToSenderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, ReturnToSender, Vendor, PrintJobRecord, VendorStaff) {
        var vm = this;

        vm.returnToSender = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        Vendor.current(function(resp){
            vm.returnToSender.vendor = resp;
        });
        VendorStaff.current(function(resp){
            vm.returnToSender.vendorStaff = resp;
        });
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.returnToSender.id !== null) {
                ReturnToSender.update(vm.returnToSender, onSaveSuccess, onSaveError);
            } else {
                ReturnToSender.save(vm.returnToSender, onSaveSuccess, onSaveError);
            }
        }

        vm.validateBarcode = function() {
            ReturnToSender.validateBarcode({barcode:vm.barcode}, function(resp){
                vm.returnToSender.printJobRecord = resp;
                vm.barcodePreviewUrl = "/api/barcodes/4state/"+vm.barcode+".png";
            }, function(resp){
                delete vm.barcodePreviewUrl;
                swal("Invalid Barcode","Invalid code or print job record not found","error");
            });
        };

        vm.validatePrintJobRecordId = function() {
            ReturnToSender.validatePrintJobRecordId({printJobRecordId:vm.printJobRecordId}, function(resp){
                vm.returnToSender.printJobRecord = resp;
                vm.barcodePreviewUrl = "/api/barcodes/4state/"+resp.c2p_address_barcode+".png";
            }, function(resp){
                delete vm.barcodePreviewUrl;
                swal("Invalid Barcode","Invalid code or print job record not found","error");
            });
        };

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:returnToSenderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('ReturnToSenderDetailController', ReturnToSenderDetailController);

    ReturnToSenderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ReturnToSender', 'Vendor', 'PrintJobRecord', 'VendorStaff'];

    function ReturnToSenderDetailController($scope, $rootScope, $stateParams, entity, ReturnToSender, Vendor, PrintJobRecord, VendorStaff) {
        var vm = this;

        vm.returnToSender = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:returnToSenderUpdate', function(event, result) {
            vm.returnToSender = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('ReturnToSenderDeleteController',ReturnToSenderDeleteController);

    ReturnToSenderDeleteController.$inject = ['$uibModalInstance', 'entity', 'ReturnToSender'];

    function ReturnToSenderDeleteController($uibModalInstance, entity, ReturnToSender) {
        var vm = this;

        vm.returnToSender = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ReturnToSender.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('return-to-sender', {
            parent: 'entity',
            url: '/return-to-sender?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.returnToSender.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/return-to-sender/return-to-senders.html',
                    controller: 'ReturnToSenderController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('returnToSender');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('return-to-sender-detail', {
            parent: 'entity',
            url: '/return-to-sender/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.returnToSender.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/return-to-sender/return-to-sender-detail.html',
                    controller: 'ReturnToSenderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('returnToSender');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ReturnToSender', function($stateParams, ReturnToSender) {
                    return ReturnToSender.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('return-to-sender.new', {
            parent: 'return-to-sender',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/return-to-sender/return-to-sender-dialog.html',
                    controller: 'ReturnToSenderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                created: new Date(),
                                notifiedUser: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('return-to-sender', null, { reload: true });
                }, function() {
                    $state.go('return-to-sender');
                });
            }]
        })
        .state('return-to-sender.edit', {
            parent: 'return-to-sender',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/return-to-sender/return-to-sender-dialog.html',
                    controller: 'ReturnToSenderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ReturnToSender', function(ReturnToSender) {
                            return ReturnToSender.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('return-to-sender', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('return-to-sender.delete', {
            parent: 'return-to-sender',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/return-to-sender/return-to-sender-delete-dialog.html',
                    controller: 'ReturnToSenderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ReturnToSender', function(ReturnToSender) {
                            return ReturnToSender.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('return-to-sender', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('ReturnToSender', ReturnToSender);

    ReturnToSender.$inject = ['$resource', 'DateUtils'];

    function ReturnToSender ($resource, DateUtils) {
        var resourceUrl =  'api/return-to-senders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'validateBarcode': {
                method: 'GET',
                url: 'api/return-to-senders/validate-barcode/:barcode'
            },
            'validatePrintJobRecordId': {
                method: 'GET',
                url: 'api/return-to-senders/validate-printjobrecordid/:printJobRecordId'
            },
            'sentNotifications': {
                method: 'GET',
                url: 'api/return-to-senders/send-notifications'
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('ReturnToSenderSearch', ReturnToSenderSearch);

    ReturnToSenderSearch.$inject = ['$resource'];

    function ReturnToSenderSearch($resource) {
        var resourceUrl =  'api/_search/return-to-senders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('ReturnToSenderController', ReturnToSenderController);

    ReturnToSenderController.$inject = ['$scope', '$state', 'ReturnToSender', 'ReturnToSenderSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ReturnToSenderController ($scope, $state, ReturnToSender, ReturnToSenderSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.sendNotifications = sendNotifications;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ReturnToSenderSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ReturnToSender.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.returnToSenders = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function sendNotifications() {
            ReturnToSender.sentNotifications(function (resp) {
                swal("Done.", "RTS Notifications have been batched and emailed to the respective users", "success");
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintStreamDialogController', PrintStreamDialogController);

    PrintStreamDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PrintStream', 'Vendor', 'PrintJob'];

    function PrintStreamDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PrintStream, Vendor, PrintJob) {
        var vm = this;

        vm.printStream = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.vendors = Vendor.query();
        vm.printjobs = PrintJob.query();
        vm.vendorjobtickets = VendorJobTicket.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.printStream.id !== null) {
                PrintStream.update(vm.printStream, onSaveSuccess, onSaveError);
            } else {
                PrintStream.save(vm.printStream, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:printStreamUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;
        vm.datePickerOpenStatus.archived = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintStreamDetailController', PrintStreamDetailController);

    PrintStreamDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PrintStream', 'Vendor', 'PrintJob'];

    function PrintStreamDetailController($scope, $rootScope, $stateParams, entity, PrintStream, Vendor, PrintJob) {
        var vm = this;

        vm.printStream = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:printStreamUpdate', function(event, result) {
            vm.printStream = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintStreamDeleteController',PrintStreamDeleteController);

    PrintStreamDeleteController.$inject = ['$uibModalInstance', 'entity', 'PrintStream'];

    function PrintStreamDeleteController($uibModalInstance, entity, PrintStream) {
        var vm = this;

        vm.printStream = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PrintStream.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('print-stream', {
            parent: 'entity',
            url: '/print-stream?page&sort&search&type&printjobid',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.printStream.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/print-stream/print-streams.html',
                    controller: 'PrintStreamController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null,
                type: {
                    value: 'FINAL'
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printStream');
                    $translatePartialLoader.addPart('printStreamType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('print-stream-detail', {
            parent: 'entity',
            url: '/print-stream/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.printStream.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/print-stream/print-stream-detail.html',
                    controller: 'PrintStreamDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printStream');
                    $translatePartialLoader.addPart('printStreamType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PrintStream', function($stateParams, PrintStream) {
                    return PrintStream.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('print-stream.edit', {
            parent: 'print-stream',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-stream/print-stream-dialog.html',
                    controller: 'PrintStreamDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PrintStream', function(PrintStream) {
                            return PrintStream.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('print-stream', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('print-stream.delete', {
            parent: 'print-stream',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-stream/print-stream-delete-dialog.html',
                    controller: 'PrintStreamDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PrintStream', function(PrintStream) {
                            return PrintStream.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('print-stream', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('PrintStream', PrintStream);

    PrintStream.$inject = ['$resource', 'DateUtils'];

    function PrintStream ($resource, DateUtils) {
        var resourceUrl =  '/api/print-streams/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                        data.archived = DateUtils.convertDateTimeFromServer(data.archived);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('PrintStreamSearch', PrintStreamSearch);

    PrintStreamSearch.$inject = ['$resource'];

    function PrintStreamSearch($resource) {
        var resourceUrl =  '/api/_search/print-streams/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintStreamController', PrintStreamController);

    PrintStreamController.$inject = ['$scope', '$state', 'PrintStream', 'PrintStreamSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PrintStreamController ($scope, $state, PrintStream, PrintStreamSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PrintStreamSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    type: $state.params.type,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PrintStream.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort(),
                    type: $state.params.type,
                    printjobid: $state.params.printjobid
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.printStreams = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                type: $state.params.type,
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobRecordDialogController', PrintJobRecordDialogController);

    PrintJobRecordDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PrintJobRecord', 'PrintJob', 'PrintStream'];

    function PrintJobRecordDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PrintJobRecord, PrintJob, PrintStream) {
        var vm = this;

        vm.printJobRecord = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.printjobs = PrintJob.query();
        vm.printstreams = PrintStream.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.printJobRecord.id !== null) {
                PrintJobRecord.update(vm.printJobRecord, onSaveSuccess, onSaveError);
            } else {
                PrintJobRecord.save(vm.printJobRecord, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:printJobRecordUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.receivedReturnMail = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobRecordDetailController', PrintJobRecordDetailController);

    PrintJobRecordDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PrintJobRecord', 'PrintJob', 'PrintStream'];

    function PrintJobRecordDetailController($scope, $rootScope, $stateParams, entity, PrintJobRecord, PrintJob, PrintStream) {
        var vm = this;

        vm.printJobRecord = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:printJobRecordUpdate', function(event, result) {
            vm.printJobRecord = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobRecordDeleteController',PrintJobRecordDeleteController);

    PrintJobRecordDeleteController.$inject = ['$uibModalInstance', 'entity', 'PrintJobRecord'];

    function PrintJobRecordDeleteController($uibModalInstance, entity, PrintJobRecord) {
        var vm = this;

        vm.printJobRecord = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PrintJobRecord.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('print-job-record', {
            parent: 'entity',
            url: '/print-job-record?printjobid',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.printJobRecord.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/print-job-record/print-job-records.html',
                    controller: 'PrintJobRecordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printJobRecord');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('print-job-record-detail', {
            parent: 'entity',
            url: '/print-job-record/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.printJobRecord.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/print-job-record/print-job-record-detail.html',
                    controller: 'PrintJobRecordDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printJobRecord');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PrintJobRecord', function($stateParams, PrintJobRecord) {
                    return PrintJobRecord.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('print-job-record.new', {
            parent: 'print-job-record',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-job-record/print-job-record-dialog.html',
                    controller: 'PrintJobRecordDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                barcode: null,
                                sortPlan: null,
                                dpid: null,
                                bsp: null,
                                recipient1: null,
                                recipient2: null,
                                address1: null,
                                address2: null,
                                city: null,
                                state: null,
                                postcode: null,
                                country: null,
                                pageCount: null,
                                receivedReturnMail: null,
                                flag: null,
                                countryCode: null,
                                addressId: null,
                                printStreamPage: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('print-job-record', null, { reload: true });
                }, function() {
                    $state.go('print-job-record');
                });
            }]
        })
        .state('print-job-record.edit', {
            parent: 'print-job-record',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-job-record/print-job-record-dialog.html',
                    controller: 'PrintJobRecordDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PrintJobRecord', function(PrintJobRecord) {
                            return PrintJobRecord.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('print-job-record', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('print-job-record.delete', {
            parent: 'print-job-record',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-job-record/print-job-record-delete-dialog.html',
                    controller: 'PrintJobRecordDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PrintJobRecord', function(PrintJobRecord) {
                            return PrintJobRecord.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('print-job-record', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('PrintJobRecord', PrintJobRecord);

    PrintJobRecord.$inject = ['$resource', 'DateUtils'];

    function PrintJobRecord ($resource, DateUtils) {
        var resourceUrl =  '/api/print-job-records/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.receivedReturnMail = DateUtils.convertDateTimeFromServer(data.receivedReturnMail);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('PrintJobRecordSearch', PrintJobRecordSearch);

    PrintJobRecordSearch.$inject = ['$resource'];

    function PrintJobRecordSearch($resource) {
        var resourceUrl =  '/api/_search/print-job-records/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobRecordController', PrintJobRecordController);

    PrintJobRecordController.$inject = ['$scope', '$state', 'PrintJobRecord', 'PrintJobRecordSearch'];

    function PrintJobRecordController ($scope, $state, PrintJobRecord, PrintJobRecordSearch) {
        var vm = this;

        vm.printJobRecords = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            if(!$state.params.printjobid) return;
            PrintJobRecord.query({printjobid: $state.params.printjobid}, function(result) {
                vm.printJobRecords = result;
            });
        }

        function search () {
            if (!vm.searchQueryRecipient || !vm.searchQueryAddress1) {
                return vm.loadAll();
            }
            PrintJobRecordSearch.query({recipient: vm.searchQueryRecipient, address1: vm.searchQueryAddress1}, function(result) {
                vm.printJobRecords = result;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobHistoryDialogController', PrintJobHistoryDialogController);

    PrintJobHistoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PrintJobHistory', 'PrintJob', 'Invoice'];

    function PrintJobHistoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PrintJobHistory, PrintJob, Invoice) {
        var vm = this;

        vm.printJobHistory = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.printjobs = PrintJob.query();
        vm.invoices = Invoice.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.printJobHistory.id !== null) {
                PrintJobHistory.update(vm.printJobHistory, onSaveSuccess, onSaveError);
            } else {
                PrintJobHistory.save(vm.printJobHistory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:printJobHistoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobHistoryDetailController', PrintJobHistoryDetailController);

    PrintJobHistoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PrintJobHistory', 'PrintJob', 'Invoice'];

    function PrintJobHistoryDetailController($scope, $rootScope, $stateParams, entity, PrintJobHistory, PrintJob, Invoice) {
        var vm = this;

        vm.printJobHistory = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:printJobHistoryUpdate', function(event, result) {
            vm.printJobHistory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobHistoryDeleteController',PrintJobHistoryDeleteController);

    PrintJobHistoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'PrintJobHistory'];

    function PrintJobHistoryDeleteController($uibModalInstance, entity, PrintJobHistory) {
        var vm = this;

        vm.printJobHistory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PrintJobHistory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('print-job-history', {
            parent: 'entity',
            url: '/print-job-history',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.printJobHistory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/print-job-history/print-job-histories.html',
                    controller: 'PrintJobHistoryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printJobHistory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('print-job-history-detail', {
            parent: 'entity',
            url: '/print-job-history/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.printJobHistory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/print-job-history/print-job-history-detail.html',
                    controller: 'PrintJobHistoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printJobHistory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PrintJobHistory', function($stateParams, PrintJobHistory) {
                    return PrintJobHistory.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('print-job-history.new', {
            parent: 'print-job-history',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-job-history/print-job-history-dialog.html',
                    controller: 'PrintJobHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                comment: null,
                                created: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('print-job-history', null, { reload: true });
                }, function() {
                    $state.go('print-job-history');
                });
            }]
        })
        .state('print-job-history.edit', {
            parent: 'print-job-history',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-job-history/print-job-history-dialog.html',
                    controller: 'PrintJobHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PrintJobHistory', function(PrintJobHistory) {
                            return PrintJobHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('print-job-history', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('print-job-history.delete', {
            parent: 'print-job-history',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-job-history/print-job-history-delete-dialog.html',
                    controller: 'PrintJobHistoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PrintJobHistory', function(PrintJobHistory) {
                            return PrintJobHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('print-job-history', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('PrintJobHistory', PrintJobHistory);

    PrintJobHistory.$inject = ['$resource', 'DateUtils'];

    function PrintJobHistory ($resource, DateUtils) {
        var resourceUrl =  'api/print-job-histories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('PrintJobHistorySearch', PrintJobHistorySearch);

    PrintJobHistorySearch.$inject = ['$resource'];

    function PrintJobHistorySearch($resource) {
        var resourceUrl =  'api/_search/print-job-histories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobHistoryController', PrintJobHistoryController);

    PrintJobHistoryController.$inject = ['$scope', '$state', 'PrintJobHistory', 'PrintJobHistorySearch'];

    function PrintJobHistoryController ($scope, $state, PrintJobHistory, PrintJobHistorySearch) {
        var vm = this;
        
        vm.printJobHistories = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            PrintJobHistory.query(function(result) {
                vm.printJobHistories = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            PrintJobHistorySearch.query({query: vm.searchQuery}, function(result) {
                vm.printJobHistories = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobChargeDialogController', PrintJobChargeDialogController);

    PrintJobChargeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PrintJobCharge', 'PrintJob', 'Invoice'];

    function PrintJobChargeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PrintJobCharge, PrintJob, Invoice) {
        var vm = this;

        vm.printJobCharge = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.printjobs = PrintJob.query();
        vm.invoices = Invoice.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.printJobCharge.id !== null) {
                PrintJobCharge.update(vm.printJobCharge, onSaveSuccess, onSaveError);
            } else {
                PrintJobCharge.save(vm.printJobCharge, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:printJobChargeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.paymentDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobChargeDetailController', PrintJobChargeDetailController);

    PrintJobChargeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PrintJobCharge', 'PrintJob', 'Invoice'];

    function PrintJobChargeDetailController($scope, $rootScope, $stateParams, entity, PrintJobCharge, PrintJob, Invoice) {
        var vm = this;

        vm.printJobCharge = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:printJobChargeUpdate', function(event, result) {
            vm.printJobCharge = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobChargeDeleteController',PrintJobChargeDeleteController);

    PrintJobChargeDeleteController.$inject = ['$uibModalInstance', 'entity', 'PrintJobCharge'];

    function PrintJobChargeDeleteController($uibModalInstance, entity, PrintJobCharge) {
        var vm = this;

        vm.printJobCharge = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PrintJobCharge.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('print-job-charge', {
            parent: 'entity',
            url: '/print-job-charge',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.printJobCharge.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/print-job-charge/print-job-charges.html',
                    controller: 'PrintJobChargeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printJobCharge');
                    $translatePartialLoader.addPart('chargeStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('print-job-charge-detail', {
            parent: 'entity',
            url: '/print-job-charge/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.printJobCharge.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/print-job-charge/print-job-charge-detail.html',
                    controller: 'PrintJobChargeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printJobCharge');
                    $translatePartialLoader.addPart('chargeStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PrintJobCharge', function($stateParams, PrintJobCharge) {
                    return PrintJobCharge.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('print-job-charge.new', {
            parent: 'print-job-charge',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-job-charge/print-job-charge-dialog.html',
                    controller: 'PrintJobChargeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                reference: null,
                                amountNet: null,
                                tax: null,
                                amountGross: null,
                                currency: null,
                                status: null,
                                errorReason: null,
                                paymentReference: null,
                                paymentDate: null,
                                itemAmountNet: null,
                                quantity: null,
                                country: null,
                                chargeCurrency: null,
                                chargeAmount: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('print-job-charge', null, { reload: true });
                }, function() {
                    $state.go('print-job-charge');
                });
            }]
        })
        .state('print-job-charge.edit', {
            parent: 'print-job-charge',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-job-charge/print-job-charge-dialog.html',
                    controller: 'PrintJobChargeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PrintJobCharge', function(PrintJobCharge) {
                            return PrintJobCharge.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('print-job-charge', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('print-job-charge.delete', {
            parent: 'print-job-charge',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-job-charge/print-job-charge-delete-dialog.html',
                    controller: 'PrintJobChargeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PrintJobCharge', function(PrintJobCharge) {
                            return PrintJobCharge.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('print-job-charge', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('PrintJobCharge', PrintJobCharge);

    PrintJobCharge.$inject = ['$resource', 'DateUtils'];

    function PrintJobCharge ($resource, DateUtils) {
        var resourceUrl =  '/api/print-job-charges/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.paymentDate = DateUtils.convertDateTimeFromServer(data.paymentDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('PrintJobChargeSearch', PrintJobChargeSearch);

    PrintJobChargeSearch.$inject = ['$resource'];

    function PrintJobChargeSearch($resource) {
        var resourceUrl =  '/api/_search/print-job-charges/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobChargeController', PrintJobChargeController);

    PrintJobChargeController.$inject = ['$scope', '$state', 'PrintJobCharge', 'PrintJobChargeSearch'];

    function PrintJobChargeController ($scope, $state, PrintJobCharge, PrintJobChargeSearch) {
        var vm = this;
        
        vm.printJobCharges = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            PrintJobCharge.query(function(result) {
                vm.printJobCharges = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            PrintJobChargeSearch.query({query: vm.searchQuery}, function(result) {
                vm.printJobCharges = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobEditController', PrintJobEditController);

    PrintJobEditController.$inject = ['$location','$state','$timeout', '$scope', '$stateParams', '$http', 'entity', 'PrintJob', 'PrintJobHistory', 'Site', 'VendorJobTicket', 'Template', 'SiteUser', 'SiteDataSource', 'ListCategory', 'SitePrecincts', 'SiteSubUsers', 'Contact', 'Principal', 'Country', 'UserProfile', 'Vendor', 'Account', 'User', 'Stationery'];

    function PrintJobEditController ($location, $state, $timeout, $scope, $stateParams, $http, entity, PrintJob, PrintJobHistory, Site, VendorJobTicket, Template, SiteUser, SiteDataSource, ListCategory, SitePrecincts, SiteSubUsers, Contact, Principal, Country, UserProfile, Vendor, Account, User, Stationery) {

        /*var stripeKeys = {
            'AUD': $scope.ENV === 'dev' ? 'pk_test_NAwIc50T7FTa46UoeswbkTqb' : 'pk_test_NAwIc50T7FTa46UoeswbkTqb' /!*'pk_live_PS4h0U30PcdeIywnhy7yYrj6'*!/,
            'NZD': $scope.ENV === 'dev' ? 'pk_test_JnSwnyjbCChv9q5Zkno9y8RR' : 'pk_test_JnSwnyjbCChv9q5Zkno9y8RR' /!*pk_live_s0xtBDYQ318BWZllsGkd8Hd5*!/
        }*/

        //FIXME check status only allow NEW and PLACED!!!

        Principal.hasAuthority('ROLE_DEMO_MODE').then(function (demoMode) {
            $scope.demoMode = demoMode;
            if(window.Stripe) {//prevent errors during offline debugging
                Stripe.setPublishableKey(demoMode ? 'pk_test_NAwIc50T7FTa46UoeswbkTqb' : 'pk_live_PS4h0U30PcdeIywnhy7yYrj6');
            }
        });

        //TODO replace with country specify check or availability or optional transactional service?

        var vm = this;
        vm.printJob = entity;
        if($stateParams.isTemplate) {
            vm.printJob.isTemplate = Boolean($stateParams.isTemplate);
        }
        if(vm.printJob.id && (vm.printJob.isTemplate || vm.printJob.status === 'NEW')) {
            PrintJob.charges({printJobId: vm.printJob.id}, function (result, headers) {
                vm.processQuote({'items': result}, headers);
            });
        }
        vm.addressValidationServiceEnabled = false;
        vm.addressValidationRequired = false;

        vm.stationeries = Stationery.query();
        vm.apiUploaded = vm.printJob.contactsSource && vm.printJob.contactsSource.match(/\(via API\)/);
        vm.user = Account.get();
        vm.siteMessages = PrintJob.siteMessages();

        var onSaveSync = function (result) {
            vm.printJob.id = result.id;
            vm.printJob.status = result.status;
            vm.printJob.userId = result.userId;
            vm.printJob.created = result.created;
            vm.isSaving = false;
            return result;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.printJob.id !== null) {
                return PrintJob.update(vm.printJob).$promise;
            } else {
                return PrintJob.save(vm.printJob).$promise;
            }
        };

        $scope.range = function(min, max, step) {
            step = step || 1;
            var input = [];
            for (var i = min; i <= max; i += step) {
                input.push(i);
            }
            return input;
        };

        /*if(!vm.printJob.id) {
            //prevent new printjobs getting created
            vm.save().then(function (resp) {
                onSaveSync(resp);
                var off = $scope.$on('$stateChangeStart', function(e) {
                    e.preventDefault();
                });
                off();
                $location.path("print-job/"+vm.printJob.id+"/edit").replace();
            });
        }*/

        // if(vm.printJob.status != 'NEW' && vm.printJob.status != 'QUOTE') {
        // }
        vm.sites = Site.query();
        vm.siteUsersAll = SiteUser.queryActive();
        vm.countries = Country.query(function (resp) {
            vm.countryLookup = {};
            resp.forEach(function (c) {
                vm.countryLookup[c.code3] = c;
            });
            return resp;
        });
        vm.billingAccount = User.billingAccount();
        vm.userProfile = UserProfile.get(function (p) {
            vm.chargeCurrency = p.currency;
            return p;
        });

        vm.contacts = [];
        vm.contactsCountWithAddress = 0;

        vm._firstTimeLoaded = false;
        $scope.$on("editPrintJob:templateLoaded",function () {
            if(vm._firstTimeLoaded) return;
            vm._firstTimeLoaded = true;

            if(!vm.printJob.parameters) {
                vm.printJob.parameters = vm.template.fields.filter(function (e) {
                    return e.mode == 'CUSTOM';
                }).map(function (e) {
                    return {templateField: e.templateField};
                });
            }

            vm.siteUsers = vm.siteUsersAll.filter(function (su) {
                return su.site.id == vm.template.site.id;
            });
            // select the only user to trigger pre-fetching API data, unless this is a template without id
            if(vm.siteUsers.length == 1 && (!vm.printJob.isTemplate || vm.printJob.id)) {
                vm.printJob.siteUserId = vm.siteUsers[0].id;
            }
            if(vm.printJob.siteUserId) {
                vm.siteUserSelected();
            }
            if(vm.printJob.contactsSource && vm.printJob.contactsCount > 0) {
                // debugger;
                vm.loadContacts();
                if(vm.printJob.contactsValidated) {
                    PrintJob.loadQuote({printJobId: vm.printJob.id}, vm.processQuote, vm.quoteError);
                }
            }
            if(vm.isContactsSourceSubscribable() && vm.printJob.contactsSource) {
                vm.getContactsSourceSubscriptionStatus();
                vm.getQuote();
            }
        });

        $scope.$on("editPrintJob:contactsChanged", function (event) {
            vm.getQuote();
        });

        vm.contactSelected = function () {
            $scope.$emit("editPrintJob:contactsChanged");
            vm.contactSelectionDirty = true;
        };

        Principal.identity().then(function(account) {
            vm.account = account;
            vm.templates = Template.query({templateId:vm.printJob.templateId}, function(resp){
                return resp.forEach(function(t){
                    //in order to be able to create template option groups
                    t.category = t.creator.login == account.login ? "My Templates" : "Shared Templates";
                })
            });
        });

        vm.hasExistingSource = function() {
            return !!vm.billingAccount.sources && vm.billingAccount.sources.totalCount >= 1;
        };
        vm.getExistingSource = function() {
            return vm.hasExistingSource() ? vm.billingAccount.sources.data[0] : null;
        };

        $scope.dropzoneConfig = {
            'options': { // passed into the Dropzone constructor
                'url': '/api/assets/templates',
                dictDefaultMessage: 'Upload CSV or MS Excel file.<div class="file-formats"><i class="fa fa-file-excel-o"></i></div>',
                maxFiles: 1,
                parallelUploads: 1,
                maxFilesize : 10,
                uploadMultiple: false,
                acceptedFiles: '.csv,.xlsx,.xls'
            },
            'eventHandlers': {
                'sending': function (file, xhr, formData) {
                    // console.log("sending: "+file);
                },
                'success': function (file, response) {
                    // console.log(response);
                    $scope.dropzoneConfig.dropzone.removeFile(file);
                    vm.doc = response;
                    vm.printJob.contactsSource = vm.doc.originalFilename;
                    vm.loadContacts();
                    $scope.$digest();
                }
            }
        };

        vm.generateUploadedFileThumbnailURL = function(key) {
            return "/api/assets/templates/"+key+"/preview?scaleFactor=0.1&convertOnly=true";
        };

        //http://stackoverflow.com/questions/17582713/programatically-add-existing-file-to-dropzone
        $scope.dropzoneConfigInserts = {
            'options': { // passed into the Dropzone constructor
                'url': '/api/assets/templates?convert-to=pdf',
                dictDefaultMessage: 'Insert Additional Pages <br/><i class="fa fa-file-pdf-o"></i><i class="fa fa-file-word-o"></i>', //
                maxFiles: 2,
                parallelUploads: 1,
                maxFilesize : 3,
                uploadMultiple: true,
                addRemoveLinks: true,
                acceptedFiles: '.pdf,.doc,.docx,.rtf'
            },
            'eventHandlers': {
                'sending': function (file, xhr, formData) {
                    // console.log("sending: "+file);
                },
                'success': function (file, response) {
                    if(vm.printJob.pageCount + response.pageCount > 10) {
                        swal("Maximum Page Count Exceeded!","An envelope cannot hold more than 5 sheets (10 pages). Your last upload has been rejected.","error")
                        $scope.dropzoneConfigInserts.dropzone.removeFile(file);
                        return;
                    }
                    if(!vm.printJob.inserts) vm.printJob.inserts = [];
                    vm.printJob.inserts.push(response);
                    file.doc = response;
                    updatePageCount();
                    $scope.$digest();
                    $scope.dropzoneConfigInserts.dropzone.createThumbnailFromUrl(file, vm.generateUploadedFileThumbnailURL(response.key));
                    if(file.name != response.originalFilename) {
                        swal("Automatic conversion to PDF","Your uploaded document "+file.name+" has automatically been converted to PDF.","success");
                    }
                },
                'error': function (file, errorMessage, xhr) {
                    swal("Failed to upload", xhr.getResponseHeader("x-crm2printapp-error") || errorMessage, "error");
                    $scope.dropzoneConfigInserts.dropzone.removeFile(file);
                },
                'removedfile': function (file) {
                    var idx = vm.printJob.inserts.indexOf(file.doc);
                    if(idx >=0)
                        vm.printJob.inserts.splice(idx,1);
                    updatePageCount();
                    $scope.$digest();
                }
            }
        };

        $timeout(function() {
            if(vm.printJob.inserts) {
                vm.printJob.inserts.forEach(function(insert) {
                    var mockFile = {name: insert.originalFilename, size: insert.size, doc: insert};
                    var dz = $scope.dropzoneConfigInserts.dropzone;
                    dz.options.addedfile.call(dz, mockFile);
                    dz.options.thumbnail.call(dz, mockFile, vm.generateUploadedFileThumbnailURL(insert.key));
                });
            }
        });

        var updatePageCount = function() {
            var count = vm.template ? vm.template.numberOfPages : 0;
            if(vm.printJob.inserts) {
                vm.printJob.inserts.forEach(function (d) {
                    count += d.pageCount;
                });
            }
            vm.printJob.pageCount = count;
            vm.clearQuote();
        };

        vm.clearContacts = function(clearValidation) {
            if(!vm.contactsLoading) {
                delete vm.doc;
            }
            //delete vm.printJob.contactsSource;
            vm.contactsCountWithAddress = 0;
            vm.contactsCountRaw = 0;
            vm.metaLookup = {};
            vm.contacts = [];
            vm.contactLookup = {};
            vm.noContacts = false;
            vm.contactsLoading = false;
            if(clearValidation) {
                delete vm.printJob.contactsValidated;
            }
            if(vm.dtInstance) {
                vm.dtInstance.fnDestroy();
            }
        };

        $scope.handleStripe = function(status, response){
            if(response.error) {
                // there was an error. Fix it.
                swal("Payment Type Verification Error", response.error, "error");
            } else {
                // got stripe token, now checkout as per ususal
                vm.stripeToken = response.id
                vm.checkoutWithExisting()
            }
        };

        vm.checkoutError = function(e) {
            vm.isSaving = false;
            console.log(e);
            swal("Checkout Error", e.data && e.data.error || "Please try again.","error");
        };

        vm.checkoutWithExisting = function() {
            if(vm.isSaving) return;
            vm.save()
                .then(vm.saveContacts)
                .then(function(){
                    return PrintJob.checkout({
                        id: vm.printJob.id,
                        stripeToken: vm.stripeToken
                    }).$promise
                })
                .then(onSaveSuccess, vm.checkoutError)
        };

        vm.saveAsPrintJobTemplate = function(subscribe) {
            vm.save()
                .then(function(){
                    return PrintJob.saveAsPrintJobTemplate({
                        id: vm.printJob.id,
                        stripeToken: vm.stripeToken,
                        subscribe: subscribe
                    }).$promise
                })
                .then(onSaveSuccess, vm.checkoutError)
        };

        vm.unsubscribeFromContactsSource = function () {
            return PrintJob.unsubscribeFromContactsSource(
                angular.extend({}, vm.printJob.contactsFilter, {
                    'printJobId': vm.printJob.id
                })
            , function(resp) {
                vm.listCategories.filter(function (category) {
                    return category.categoryId == vm.printJob.contactsFilter.category;
                }).forEach(function (category) {
                    category.subscriptionStatus = 'Subscribable';
                });
                vm.subscriptionStatus = 'Subscribable';
            })
        };

        vm.updateCountsByCountry = function() {
            vm.countsByCountry = {"NZL":0,"AUS":0,"Other":0};//FIXME generate by supported countries
            vm.contactsCountGood = 0;
            vm.contacts.forEach(function(c){
                if(c.$valid) {
                    vm.countsByCountry[c.$countrycode]++;
                    vm.contactsCountGood++;
                }
            });
        };

        vm.countriesWithContacts = function() {
            return vm.countries.filter(function(country){
                return vm.countsByCountry[country.code3] > 0;
            });
        };

        vm.calculateTotal = function() {
            if(!vm.quote) return 0;
            return vm.printJob.priceGross;
        };


        vm.clearQuote = function() {
            delete vm.quote;
            vm.quoteByCountry = {};
            vm.printJob.priceGross = 0;
            vm.printJob.letterCount = 0;
            vm.printJob.priceGross = 0;
        };

        vm.quoteError = function(resp) {
            vm.isQuoting = false;
        };

        vm.processQuote = function(resp, headers) {
            // debugger;
            if(headers("Pickup-ID")) {
                $timeout(function(){
                    // $http.get(headers("Pickup-Location"),{headers:{"Authorization":"d"}}).then(vm.processQuote, vm.processQuote);
                    PrintJob.pickupQuote({id:headers("Pickup-ID")}, vm.processQuote, vm.quoteError);
                }, 3000);
            } else {
                vm.quote = resp.items;
                vm.quoteByCountry = {};
                vm.printJob.priceGross = 0;
                vm.printJob.letterCount = 0;
                vm.quote.forEach(function (row) {
                    vm.quoteByCountry[row.country] = row;
                    vm.printJob.priceGross += row.chargeAmount;
                    checkVendorAvailabilityForCountry(row);
                });
                vm.isQuoting = false;
            }
        };

        vm.getQuote = function() {
            vm.isQuoting = true;
            vm.clearQuote();
            if(vm.printJob.isTemplate) {
                vm.save().then(function(printJob) {
                    onSaveSync(printJob);
                    PrintJob.quote({printJobId: vm.printJob.id}, vm.processQuote, vm.quoteError);
                });
            } else {
                if (vm.addressValidationRequired && !vm.printJob.contactsValidated) return;
                vm.updateCountsByCountry();
                if (!vm.countsByCountry) return 0;
                vm.save().then(function (printJob) {
                    onSaveSync(printJob);
                    PrintJob.quote({
                        printJobId: vm.printJob.id,
                        contactsMeta: vm.createContactsMeta(),
                        file: vm.doc
                    }, vm.processQuote, vm.quoteError);
                });
            }
        };

        var checkVendorAvailabilityForCountry = function(row) {
            Vendor.checkVendorAvailabilityForPrintJob({countryCode3:row.country,letterCount:row.quantity, printJobId:vm.printJob.id},function (resp) {
                if(resp.length == 0) {
                    row.vendor = "NONE";
                } else {
                    vm.printJob.letterCount = 0;
                    resp.forEach(function(limitation){
                        if(limitation == "") {
                            row.vendor = "OK";
                            vm.printJob.letterCount += row.quantity;
                            delete row.vendorLimitation;
                        } else if(row.vendor != "OK") {
                            row.vendor = "LIMITED";
                            row.vendorLimitation = limitation;
                        }
                    })
                }
                updateVendorAvailabilitySummary();
            });
        };

        var updateVendorAvailabilitySummary = function () {
            vm.vendorsAvailable = true;
            if(vm.quote) {
                vm.quote.forEach(function (row) {
                    vm.vendorsAvailable &= row.vendor == "OK"
                });
            }
        };

        $timeout(function (){

            if(vm.printJob.templateId) {
                vm.loadTemplate();
            }

            jQuery('.print-job-wizard').bootstrapWizard({
                'tabClass': '',
                'firstSelector': '.wizard-first',
                'previousSelector': '.wizard-prev',
                'nextSelector': '.wizard-next',
                'lastSelector': '.wizard-last',
                'onTabShow': function(tab, navigation, index) {
                    var total      = navigation.find('li').length;
                    var current    = index + 1;
                    var percent    = (current/total) * 100;

                    // Get vital wizard elements
                    var wizard     = navigation.parents('.block');
                    var progress   = wizard.find('.wizard-progress > .progress-bar');
                    var btnPrev    = wizard.find('.wizard-prev');
                    var btnNext    = wizard.find('.wizard-next');
                    var btnFinish  = wizard.find('.wizard-finish');

                    // Update progress bar if there is one
                    if (progress) {
                        progress.css({ width: percent + '%' });
                    }

                    // If it's the last tab then hide the last button and show the finish instead
                    if(current >= total) {
                        btnNext.hide();
                        btnFinish.show();
                    } else {
                        btnNext.show();
                        btnFinish.hide();
                    }
                    if(current > 1) {
                        vm.save().then(onSaveSync);
                        btnPrev.show();
                    } else {
                        btnPrev.hide();
                    }
                },
                onTabClick: function(tab, navigation, index) {
                    return false;
                }
            });

            angular.element('.form-group:eq(1)>input').focus();

            // Init Card, for more info and examples you can check out https://github.com/jessepollak/card
            jQuery('.js-card-form').card({
                container: '.js-card-container',
                formSelectors: {
                    numberInput: '#cc_number',
                    expiryInput: '#cc_expiry',
                    cvcInput: '#cc_cvc',
                    nameInput: '#cc_name'
                }
            });
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('crm2PrintApp:printJobUpdate', result);
            vm.isSaving = false;
            if(result.status == 'MERGE_READY') {
                $timeout(function () {
                    $state.go("print-jobs",{status:"in-progress"});
                });
                swal({
                    title: "Success!!!",
                    html: "Your Order has been received." +
                        "<br/>Your letters will be printed &amp; posted by the Mail house within 48 hours.<br/> Your reference for this print job is #"+result.id,
                    type: "success",
                    closeOnConfirm: true
                }).then(function(isConfirm){
                    $state.go('print-job-detail', {id: result.id});
                });
            }
            if(result.status == 'SAVED') {
                $state.go('print-jobs', {status: 'saved'});
            } else if(result.status == 'SUBSCRIBED') {
                swal({
                    title: "Subscribed!!!",
                    html: "Once " + vm.template.site.name+ " has discovered new leads, it will submit a new print job." +
                        "<br/>The letters will then be printed &amp; posted by the Mail house within 48 hours.",
                    type: "success",
                    closeOnConfirm: true
                }).then(function(isConfirm){
                    $state.go('print-jobs', {status: 'saved'});
                })
            }
        };

        vm.fieldName = function(field) {
            if(field.mode == 'CUSTOM') {
                return field.templateField;
            } else {
                return field.mappedField;
            }
        };

        vm.fieldValue = function(field, contact) {
            if(field.mode == 'CUSTOM') {
                //why is this templateField?
                return contact.custom[field.templateField] || contact.custom[field.mappedField];
            } else {
                return contact[field.mappedField];
            }
        };


        vm.visibleFields = function () {
            if(!vm.template) return [];
            else if ($scope.visibleFields) return $scope.visibleFields;
            else {
                return $scope.visibleFields = vm.template.fields.filter(function (f) {
                    return f.display && !f.generated;
                });
            }
        };
        vm.generatedFields = function () {
            if(!vm.template) return [];
            else if ($scope.generatedFields) return $scope.generatedFields;
            else {
                return $scope.generatedFields = vm.template.fields.filter(function (f) {
                    return f.display && f.generated;
                });
            }
        };

        vm.saveContacts = function(printJob, jsonOnly) {
            if (!vm.printJob.contactsFilter)
                vm.printJob.contactsFilter = {};
            return PrintJob.saveContacts({
                printJobId: printJob.id,
                contactsMeta: vm.createContactsMeta(),
                file: vm.doc,
                siteUserId: vm.printJob.siteUserId,
                subUserId: vm.printJob.contactsFilter.user || "",
                precinctId: vm.printJob.contactsFilter.precinct || "",
                categoryId: vm.printJob.contactsFilter.category || "",
                listName: vm.printJob.contactsSource,
                jsonOnly: jsonOnly
            }).$promise;
        };

        vm.clear = function() {
            $state.go('print-jobs',{status:"draft"});
        };
        vm.saveAndClose = function() {
            vm.save().then(function(){
                vm.saveContacts(vm.printJob,true).then(function(){
                    if(vm.printJob.contactsValidated && vm.contactsCountWithAddress > 0 && vm.userProfile.approverEmail) {
                        swal({
                            title: "Your print job is nearly complete.",
                            text: "Would you like to send a notification to your Print Job approver?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: "Yes, send notification to "+vm.userProfile.approverEmail,
                            cancelButtonText: "No, just save.",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        }).then(function(result){
                            if (result.value) {
                                PrintJob.sendApproverNotification({printJobId:vm.printJob.id});
                            }
                        });
                    }
                    vm.clear();
                });
            })
        };

        vm.hasSavedContacts = function() {
            return vm.printJob.contactsSource && vm.printJob.contactsCount > 0;
        };

        vm.clearSavedContacts = function () {
            delete vm.printJob.contactsSource;
            delete vm.printJob.contactsCount;
            PrintJob.deleteContacts({printJobId:vm.printJob.id});
            vm.clearContacts(true);
        };

        vm.siteUserSelected = function() {
            if(vm.printJob.siteUserId) {
                vm.siteUsers.forEach(function (su) {
                    if(su.id == vm.printJob.siteUserId) {
                        vm.siteUser = su;
                    }
                })
            }
            if(vm.template.dataSource.type == 'API') {
                vm.loadListCategories();
                vm.loadSitePrecincts();
                vm.loadSiteSubUsers();
            }
        };

        vm.loadListCategories = function() {
            if(!vm.printJob.siteUserId) {
                delete vm.listCategories;
                return;
            }
            if(!vm.printJob.id) {
                //this function executes on first load ad may not have a printJob id yet
                $timeout(vm.loadListCategories,1000);
                return;
            }
            vm.categoriesLoading = true;
            vm.listCategories = ListCategory.query({
                siteUserId: vm.printJob.siteUserId,
                dataSourceId: vm.template.dataSource.id,
                printJobId: vm.printJob.id
            }, function(resp){
                vm.categoriesLoading = false;
                return resp;
            }, function(resp){
                debugger;
                swal("Error","Failed to load categories","error");
            });
        };

        vm.loadSitePrecincts = function() {
            if(!vm.printJob.siteUserId) {
                delete vm.sitePrecincts;
                return;
            }
            vm.sitePrecinctsLoading = true;
            SitePrecincts.query({siteUserId: vm.printJob.siteUserId, dataSourceId: vm.template.dataSource.id},function(resp){
                vm.sitePrecinctsLoading = false;
                if(resp.length > 0) {
                    resp.forEach(function(prec){
                        if(!vm.sitePrecinct && vm.printJob.contactsFilter && vm.printJob.contactsFilter.precinct ==  prec.precinctId) {
                            vm.sitePrecinct = prec;
                        }
                    });
                    resp.splice(0, 0, {
                        name: "any"
                    });
                    vm.sitePrecincts = resp;
                }
            });
        };

        vm.loadSiteSubUsers = function() {
            if(!vm.printJob.siteUserId) {
                delete vm.siteSubUsers;
                return;
            }
            vm.siteSubUsersLoading = true;
            SiteSubUsers.query({siteUserId: vm.printJob.siteUserId, dataSourceId: vm.template.dataSource.id},function(resp){
                if(resp.length > 0) {
                    resp.forEach(function (su) {
                        su.name = ((su.firstName || "") + " " + (su.lastName || "")).trim();
                        if(!vm.siteSubUser && vm.printJob.contactsFilter && vm.printJob.contactsFilter.user ==  su.userId) {
                            vm.siteSubUser = su;
                        }
                    })
                    vm.siteSubUsersLoading = false;
                    resp.splice(0, 0, {
                        name: "any"
                    });
                    vm.siteSubUsers = resp;
                }
            });
        };

        var templateLoaded = function(resp) {
            if(!resp) {
                delete vm.parameters;
            }
            vm.template = resp;
            updatePageCount();
            delete $scope.visibleFields;
            $scope.$emit("editPrintJob:templateLoaded");
        };

        vm.loadTemplate = function() {
            if(vm.printJob.templateId) {
                Template.get({id: vm.printJob.templateId}, templateLoaded);
            } else {
                templateLoaded(null);
            }
        };

        vm.saveDraftAndPreview = function() {
            vm.save().then(function(printJob) {
                onSaveSync(printJob);//make sure sure we have an id
                PrintJob.generatePreview({
                    printJobId: printJob.id,
                    contactsMeta: vm.createContactsMeta(),
                    file: vm.doc
                }, function (resp) {
                    vm.isSaving = false;
                    vm.previewUrl = resp.url;
                    swal({
                        title: "Preview generated!!",
                        html: "Please <a href='" + vm.previewUrl + "' target='_blank'><strong>click here</strong></a> to download your preview PDF.",
                        type: "success"
                    });
                }, function() {
                    swal("Error", "Failed to generate preview PDF. Please try again.", "error");
                });
            })
        };

        vm.saveDraftAndMailMerge = function() {
            vm.save().then(function(printJob) {
                onSaveSync(printJob);//make sure sure we have an id
                PrintJob.generateMailMerge({
                    printJobId: printJob.id,
                    contactsMeta: vm.createContactsMeta(),
                    file: vm.doc
                }, function () {
                    vm.isSaving = false;
                    vm.downloadUrl = "/api/assets/print-jobs/" + vm.printJob.id + "/mailmerge.pdf";
                    swal({
                        title: "Mail-Merged PDF generated!!",
                        html: "Please <a href='" + vm.downloadUrl + "' target='_blank'><strong>click here</strong></a> to download your PDF.",
                        type: "success"
                    });
                }, function() {
                    swal("Error", "Failed to generate preview PDF. Please try again.", "error");
                });
            })
        };

        vm.onCategorySelect = function($item, $model) {
            vm.printJob.contactsSource = $item.name;

            if(vm.isContactsSourceSubscribable()) {
                vm.getContactsSourceSubscriptionStatus();
                vm.getQuote();
            }
        };

        vm.getContactsSourceSubscriptionStatus = function() {
            SiteDataSource.contactsSourceSubscriptionStatus(
                angular.extend({}, vm.printJob.contactsFilter, {
                    'printJobId': vm.printJob.id,
                    'siteUserId': vm.printJob.siteUserId,
                    'dataSourceId': vm.template.dataSource.id
                }
            ), function(resp){
                vm.subscriptionStatus = resp.status;
            }, function(resp){
                swal({
                    title: "Failed to get subscription status!",
                    text: "Please check your credentials for "+vm.template.site.name+".",
                    type: "error"
                });
            });
        };

        vm.isContactsSourceSubscribable = function() {
            if(!vm.template || !vm.template.dataSource) return;
            return vm.template.dataSource.type == 'API' && (vm.template.site.name == 'AgentInsight' || vm.template.site.name == 'NEXU');
        };

        vm.updateContactsSource = function() {
            if(vm.template.dataSource.type == 'API') {
                vm.printJob.contactsSource = vm.listCategory ? vm.listCategory.name : "";
            } else if(vm.template.dataSource.type == 'CSV') {
                vm.printJob.contactsSource = vm.doc.originalFilename;
            }
        };

        vm.loadContacts = function() {
            vm.contactsLoading = true;
            if(vm.hasSavedContacts()) {
                vm.clearContacts(false);
                PrintJob.loadContacts({
                    printJobId: vm.printJob.id
                }, vm.processContacts, vm.noContactsFound);
            } else if(vm.template.dataSource.type == 'API') {
                vm.clearContacts(true);
                //FIXME
                vm.printJob.contactsSource = vm.listCategory ? vm.listCategory.name : "";
                Contact.query({
                    siteUserId: vm.printJob.siteUserId,
                    subUserId: vm.printJob.contactsFilter.user || "",
                    precinctId: vm.printJob.contactsFilter.precinct || "",
                    categoryId: vm.printJob.contactsFilter.category || "",
                    listName: vm.printJob.contactsSource,
                    printJobId: vm.printJob.id,
                    dataSourceId: vm.template.dataSource.id
                }, vm.processContacts, vm.noContactsFound);

            } else if(vm.template.dataSource.type == 'CSV') {
                vm.clearContacts(true);
                vm.printJob.contactsSource = vm.doc.originalFilename;
                Contact.readFromCSV({
                    siteUserId: vm.printJob.siteUserId,
                    docId: vm.doc.key,
                    listName: vm.printJob.contactsSource,
                    printJobId: vm.printJob.id,
                    templateId: vm.printJob.templateId,
                    dataSourceId: vm.template.dataSource.id
                }, vm.processContacts, vm.noContactsFound);
            }
        };

        vm.noContactsFound = function(resp){
            vm.clearContacts(false);
            vm.noContacts = true;
        };

        vm.processContacts = function(resp){
            vm.doc = resp.file;
            vm.contactsCountRaw = resp.count;
            var generatedFields = vm.generatedFields();
            var addressFields = vm.visibleFields().filter(function(f){
                return f.templateField == "c2p_streetaddress_1" || f.templateField == "c2p_city";
            });
            //should we just check if printJob,contactSource == API?
            var generatedFieldsOnly = generatedFields.length > 0 && addressFields.length == 0;

            var field1, field2, field1Mode, field2Mode;
            if(!generatedFieldsOnly) {
                // field1 = addressFields[0].mappedField.toLowerCase();
                field1 = addressFields[0].mappedField;
                field1Mode = addressFields[0].mode;
                // field2 = addressFields[1].mappedField.toLowerCase();
                field2 = addressFields[1].mappedField;
                field2Mode = addressFields[1].mode;
            }
            vm.contactLookup = {};
            vm.contactsCountWithAddress = 0;
            vm.contacts = resp.contacts.map(function(c){
                if(!generatedFieldsOnly) {
                    var mappedFieldVal1 = field1Mode === 'CUSTOM' ? c.custom[field1] : c[field1];
                    var mappedFieldVal2 = field2Mode === 'CUSTOM' ? c.custom[field2] : c[field2];
                    if (typeof c.$valid == 'undefined') {
                        c.$valid = !!mappedFieldVal1 && mappedFieldVal1.trim().length > 0
                            && !!mappedFieldVal2 && mappedFieldVal2.trim().length > 0
                            && !!vm.countryLookup[c.$countrycode];
                    }
                } else {
                    //assumed to be pre-validated during API upload
                    // c.$valid = c.valid && !!vm.countryLookup[c.$countrycode];
                }

                // if(c.$valid !== undefined)
                if(c.$valid)
                    vm.contactsCountWithAddress++;

                //create lookups by $id for contact and contact meta
                vm.contactLookup[c.$id] = c;
                return c;
            });

            vm.createContactsMeta();
            if(generatedFieldsOnly) {
                vm.syncValidation(resp.contacts);
            }
            vm.updateCountsByCountry();
            $scope.$emit("editPrintJob:contactsChanged");
            $timeout(function () {
                //DOM has finished rendering
                vm.dtInstance = $('table.contacts').dataTable({
                    pageLength: 10,
                    "scrollX": true,
                    "deferRender": true,
                    "language": {
                        "emptyTable": "No contacts",
                        "zeroRecords": "No records to display"
                    }
                });
                //ensure the contacts tabs is active
                if($('.print-job-wizard').bootstrapWizard('currentIndex') != 1) {
                    $('.print-job-wizard').bootstrapWizard('show', 1);
                    $timeout(function () {
                        $('table.contacts').DataTable().draw(false);
                    }, 200);
                }
            });
        };

        vm.createContactsMeta = function() {
            vm.metaLookup = {};
            return vm.contacts.map(function(c){
                return vm.metaLookup[c.$id] = {valid: c.$valid, id: c.$id};
            });
        };

        //this method is copied from the response of validateContacts however adapted for pre-validated API-uploaded contacts
        //FIXME remove duplicate code
        vm.syncValidation = function (resp) {
            // vm.createContactsMeta();
            resp.forEach(function(rec){
                var contact = vm.contactLookup[rec.id];
                if(contact) {
                    contact.$valid = rec.valid;
                    contact.$flag = rec.flag;
                    var flag = vm.flags[rec.flag];
                    if(flag) {
                        contact.$flagAlt = flag.meaning;
                        if(flag.example) {
                            contact.$flagAlt += ", "+flag.example
                        }
                    }
                }
                var meta = vm.metaLookup[rec.id];
                if(meta) {
                    meta.valid = rec.valid;
                } else {
                    debugger;
                }
            });
            vm.getQuote();
        };

        vm.validateContacts = function() {
            PrintJob.validateContacts({
                printJobId: vm.printJob.id,
                contactsMeta: vm.createContactsMeta(),
                file: vm.doc
            }, function (resp) {
                if(resp.length > 0) {
                    vm.printJob.contactsValidated = new Date();
                }
                //FIXME is this right, or do we only accept addresses validated by address washing?
                vm.printJob.letterCount = resp.length;

                resp.forEach(function(rec){
                    var contact = vm.contactLookup[rec.id];
                    if(contact) {
                        contact.$valid = rec.valid;
                        contact.$flag = rec.flag;
                        var flag = vm.flags[rec.flag];
                        if(flag) {
                            contact.$flagAlt = flag.meaning;
                            if(flag.example) {
                                contact.$flagAlt += ", "+flag.example
                            }
                        }
                    }
                    var meta = vm.metaLookup[rec.id];
                    if(meta) {
                        meta.valid = rec.valid;
                    } else {
                        debugger;
                    }
                });
                vm.updateCountsByCountry();
                if(vm.contactsCountGood < vm.contactsCountWithAddress) {
                    swal("Address Validation Complete","The system has identified "+(vm.contactsCountWithAddress - vm.contactsCountGood) +" bad addresses and " +
                        "has automatically removed them from the list. Please review the selection before proceeding.","warning");
                }
                vm.getQuote();
            });
        };

        vm.requireContactsFilter = function() {
            return vm.template && vm.template.dataSource && vm.template.dataSource.type == 'API' && !vm.sitePrecinct && !vm.siteSubUser && !vm.printJob.contactsFilter.category && !vm.contactsCountWithAddress;
        };

        vm.contactValidationAvailable = function() {
            return vm.addressValidationServiceEnabled && !vm.printJob.isTemplate;
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.created = false;
        vm.datePickerOpenStatus.lastModified = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        // DataTables Bootstrap integration
        var bsDataTables = function() {
            var $DataTable = jQuery.fn.dataTable;

            // Set the defaults for DataTables init
            jQuery.extend( true, $DataTable.defaults, {
                dom:
                "<'row'<'col-sm-6'l><'col-sm-6'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-6'i><'col-sm-6'p>>",
                renderer: 'bootstrap',
                oLanguage: {
                    sLengthMenu: "_MENU_",
                    sInfo: "Showing <strong>_START_</strong>-<strong>_END_</strong> of <strong>_TOTAL_</strong>",
                    oPaginate: {
                        sPrevious: '<i class="fa fa-angle-left"></i>',
                        sNext: '<i class="fa fa-angle-right"></i>'
                    }
                }
            });

            // Default class modification
            jQuery.extend($DataTable.ext.classes, {
                sWrapper: "dataTables_wrapper form-inline dt-bootstrap",
                sFilterInput: "form-control",
                sLengthSelect: "form-control"
            });

            // Bootstrap paging button renderer
            $DataTable.ext.renderer.pageButton.bootstrap = function (settings, host, idx, buttons, page, pages) {
                var api     = new $DataTable.Api(settings);
                var classes = settings.oClasses;
                var lang    = settings.oLanguage.oPaginate;
                var btnDisplay, btnClass;

                var attach = function (container, buttons) {
                    var i, ien, node, button;
                    var clickHandler = function (e) {
                        e.preventDefault();
                        if (!jQuery(e.currentTarget).hasClass('disabled')) {
                            api.page(e.data.action).draw(false);
                        }
                    };

                    for (i = 0, ien = buttons.length; i < ien; i++) {
                        button = buttons[i];

                        if (jQuery.isArray(button)) {
                            attach(container, button);
                        }
                        else {
                            btnDisplay = '';
                            btnClass = '';

                            switch (button) {
                                case 'ellipsis':
                                    btnDisplay = '&hellip;';
                                    btnClass = 'disabled';
                                    break;

                                case 'first':
                                    btnDisplay = lang.sFirst;
                                    btnClass = button + (page > 0 ? '' : ' disabled');
                                    break;

                                case 'previous':
                                    btnDisplay = lang.sPrevious;
                                    btnClass = button + (page > 0 ? '' : ' disabled');
                                    break;

                                case 'next':
                                    btnDisplay = lang.sNext;
                                    btnClass = button + (page < pages - 1 ? '' : ' disabled');
                                    break;

                                case 'last':
                                    btnDisplay = lang.sLast;
                                    btnClass = button + (page < pages - 1 ? '' : ' disabled');
                                    break;

                                default:
                                    btnDisplay = button + 1;
                                    btnClass = page === button ?
                                        'active' : '';
                                    break;
                            }

                            if (btnDisplay) {
                                node = jQuery('<li>', {
                                    'class': classes.sPageButton + ' ' + btnClass,
                                    'aria-controls': settings.sTableId,
                                    'tabindex': settings.iTabIndex,
                                    'id': idx === 0 && typeof button === 'string' ?
                                    settings.sTableId + '_' + button :
                                        null
                                    })
                                    .append(jQuery('<a>', {
                                            'href': '#'
                                        })
                                            .html(btnDisplay)
                                    )
                                    .appendTo(container);

                                settings.oApi._fnBindAction(
                                    node, {action: button}, clickHandler
                                );
                            }
                        }
                    }
                };

                attach(
                    jQuery(host).empty().html('<ul class="pagination"/>').children('ul'),
                    buttons
                );
            };

            // TableTools Bootstrap compatibility - Required TableTools 2.1+
            if ($DataTable.TableTools) {
                // Set the classes that TableTools uses to something suitable for Bootstrap
                jQuery.extend(true, $DataTable.TableTools.classes, {
                    "container": "DTTT btn-group",
                    "buttons": {
                        "normal": "btn btn-default",
                        "disabled": "disabled"
                    },
                    "collection": {
                        "container": "DTTT_dropdown dropdown-menu",
                        "buttons": {
                            "normal": "",
                            "disabled": "disabled"
                        }
                    },
                    "print": {
                        "info": "DTTT_print_info"
                    },
                    "select": {
                        "row": "active"
                    }
                });

                // Have the collection use a bootstrap compatible drop down
                jQuery.extend(true, $DataTable.TableTools.DEFAULTS.oTags, {
                    "collection": {
                        "container": "ul",
                        "button": "li",
                        "liner": "a"
                    }
                });
            }
        };
        bsDataTables();
        vm.updateCountsByCountry(); //init to 0

        //FIXME
        vm.flags = {
            "A": {
                "meaning": "Insufficient locality info",
                "example": "e.g. 29 George St, SYDNEY"
            },
            "B": {
                "meaning": "Cannot match locality info",
                "example": "e.g. 29 George St, SYDNEY VIC"
            },
            "E": {
                "meaning": "PAF validation not performed, an error occurred preventing accessing the PAF files."
            },
            "F": {
                "meaning": "No street of that name in this locality",
                "example": "e.g. 2 Mad St, SYDNEY NSW  2000"
            },
            "G": {
                "meaning": "No such postal type in that locality",
                "example": "e.g. Private Bag 1, SYDNEY NSW 2001 (There are only GPO Boxes and Locked Bags in 2001)"
            },
            "I": {
                "meaning": "No street name in address",
                "example": "e.g. Melbourne, VIC 3000"
            },
            "J": {
                "meaning": "Postal prefix or suffix doesn't match",
                "example": "e.g. GPO BOX 1B, MELBOURNE  VIC  3001 (should be GPO Box 1A)"
            },
            "K": {
                "meaning": "Number range invalid (first number greater than second)",
                "example": "e.g. 6-2 Mill St, Perth WA 6000"
            },
            "L": {
                "meaning": "No house number in that street",
                "example": "e.g. 10000 CAMPBELL  ST, HOBART  TAS  7000"
            },
            "M": {
                "meaning": "No such postal number",
                "example": "e.g. GPO BOX 999999, BRISBANE  QLD  4001"
            },
            "N": {
                "meaning": "No such lot number",
                "example": "e.g. Lot 4 CARRINGTON  ST, ADELAIDE  SA  5000"
            },
            "O": {
                "meaning": "No such postal address with no number",
                "example": "e.g. CMB, DARWIN  NT  0801 (CMB in Darwin have numbers)"
            },
            "P": {
                "meaning": "Missing house number in address",
                "example": "e.g. CAVENAGH  ST, DARWIN  NT  0800"
            },
            "Q": {
                "meaning": "Ambiguous street (or NZ Lobby)",
                "example": "e.g. 2 MACQUARIE AVE, SYDNEY  NSW  2000 (there is Macquarie Street and Place, but no Avenue)"
            },
            "R": {
                "meaning": "Ambiguous house number or within range",
                "example": "e.g. 13-17 CONSTITUTION  AVE, CANBERRA  ACT  2600 (there is a 13-15 and a 17) or e.g. 341 BRISBANE  ST, BEAUDESERT  QLD  4285 (the number is 339-347)"
            },
            "S": {
                "meaning": "Matches to more than one address",
                "example": "e.g. 222 Pacific Highway, 2065 NSW (this address appears in several localities Crows Nest, St Leonards and Greenwich) "
            },
            "U": {
                "meaning": "Too many differences. The amendedFlag field will list the differences.",
                "example": "e.g. 29 George, SYDNEY NSW (postcode missing, and street type missing)"
            },
            "V": {
                "meaning": "G/PO Box address with incorrect locality, or changed from GPO to PO Box and postcode incorrect.",
                "example": "e.g. GPO BOX 1, NSW 2001 (missing the locality SYDNEY) or e.g. GPO BOX 1, NORTH SYDNEY  NSW  2060  (there is a PO Box 1, North Sydney NSW 2059)"
            },
            "X": {
                "meaning": "Missing unit or level information. This address is not deliverable without unit/level information (Phantom Primary Point)",
                "example": "e.g. 35 Spring Street BONDI JUNCTION  NSW  2022 (adding “Level 99” for example to the address would make it acceptable)."
            },
            "Z": {
                "meaning": "Unit or level not found, and no corresponding Primary Point in the PAF",
                "example": "e.g. 1/67 Nerang St, NERANG QLD 4211"
            },
            "0": {
                "meaning": "Address correct"
            },
            "1": {
                "meaning": "Address matched to primary point only.",
                "example": "There is secondary address information (such as level, unit number and/or house suffix) that could not be found in the PAF, so the DPID for primary point (the address without any secondary information) was returned."
            },
            "2": {
                "meaning": "Address didn’t exactly match, but was left as is.",
                "example": "AMAS rules allow an incorrect locality to be kept in the address, if it exists within the postcode. Similarly, a border locality, some synonym localities or an alternate street name can be kept. This code can only be returned if the flag in 'DpidGrammar.txt' is set to keep these address elements. The Amended Flag code will indicate which address elements differ from the record in the PAF but weren't corrected. For example, ('The Rocks' is incorrect, but is a locality in the 2000 postcode in 309 Kent St, The Rocks NSW 2000"
            },
            "4": {
                "meaning": "Address amended."
            },
            "8": {
                "meaning": "Address amended on second pass.",
                "example": "Applies only to the Dpid3Pass grammar file, indicating that the address couldn’t be given a DPID according to AMAS matching rules, but after address enhancement, a DPID was found."
            },
            "16": {
                "meaning": "Address matched to street only.",
                "example": "The street number provided doesn’t exist in the PAF, but the PAF does contain a Group Delivery ID for the street. This Group Delivery ID is returned in the DPID field."
            },
            "32": {
                "meaning": "Address matched to locality only.",
                "example": "The street provided doesn’t exist in the PAF, but the PAF does contain a Locality Delivery ID, which is returned in the DPID field."
            },
            "64": {
                "meaning": "Additional sub address information exists. Additional secondary address information (such as level, unit number and/or house suffix) is available for that address."
            },
            "128": {
                "meaning": "Geocode match only.",
                "example": "All matching records had same Geocode, so are returning the found Geocode, even though a unique address cannot be found. "
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobDetailController', PrintJobDetailController);

    PrintJobDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PrintJob', 'PrintJobHistory', 'Site', 'User', 'VendorJobTicket', 'Template', 'Stationery','PrintJobCharge', 'Country', 'Account', 'UserProfile'];

    function PrintJobDetailController($scope, $rootScope, $stateParams, entity, PrintJob, PrintJobHistory, Site, User, VendorJobTicket, Template, Stationery, PrintJobCharge, Country, Account, UserProfile) {
        var vm = this;

        vm.printJob = entity;
        entity.$promise.then(function (printJob) {
            if(printJob.paymentStatus === 'DUE') {
                vm.due = true;
            }
        });
        vm.printJobHistory = [];
        vm.printJobCharges = [];
        vm.countries = Country.query(function (resp) {
            vm.countryLookup = {};
            resp.forEach(function (c) {
                vm.countryLookup[c.code3] = c;
            });
            return resp;
        });
        vm.user = Account.get({userId:vm.printJob.userId});
        vm.userProfile = UserProfile.getByUserId({userId:vm.printJob.userId});
        if(vm.printJob.stationeryId != null) {
            vm.stationery = Stationery.get({id: vm.printJob.stationeryId});
        }

        vm.loadAll = function() {

            PrintJob.history({printJobId:vm.printJob.id}, function(result) {
                vm.printJobHistory = result;
                result.forEach(function(log){
                    if(log.code === 'PLACED') {
                        vm.placed = log;
                    } else if(log.code === 'MERGE_READY' || vm.isMailMerged(log.code)) {
                        vm.inProgress = log;
                    } else if(log.code === 'COMPLETED') {
                        vm.completed = log;
                    };
                });
            });

            PrintJob.charges({printJobId:vm.printJob.id}, function(result){
                vm.printJobCharges = result;
                vm.paid = true;
                vm.due = true;
                result.forEach(function(charge){
                    vm.paid &= charge.invoiceStatus === 'PAID';
                    vm.due &= charge.invoiceStatus === 'ISSUED' || charge.invoiceStatus === 'RAISED';
                });
            });
        };

        vm.isMailMerged = function (status) {
            return status === 'MAIL_MERGE' || status === 'PRINT_READY' || status === 'MAIL_HOUSE' || status === 'PRINTED'
        };


        var unsubscribe = $rootScope.$on('crm2PrintApp:printJobUpdate', function(event, result) {
            vm.printJob = result;
        });


        $scope.$on('$destroy', unsubscribe);
        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobDeleteSelectedController',PrintJobDeleteSelectedController);

    PrintJobDeleteSelectedController.$inject = ['$uibModalInstance', 'ids', 'PrintJob'];

    function PrintJobDeleteSelectedController($uibModalInstance, ids, PrintJob) {
        var vm = this;
        vm.ids = ids;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PrintJob.deletePrintJobs({id: ids},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobDeleteController',PrintJobDeleteController);

    PrintJobDeleteController.$inject = ['$uibModalInstance', 'entity', 'PrintJob'];

    function PrintJobDeleteController($uibModalInstance, entity, PrintJob) {
        var vm = this;

        vm.printJob = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PrintJob.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('print-jobs', {
            parent: 'entity',
            url: '/print-jobs/{status}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.printJob.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/print-job/print-jobs.html',
                    controller: 'PrintJobController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printJob');
                    $translatePartialLoader.addPart('chargeStatus');
                    $translatePartialLoader.addPart('orderStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('print-job', {
            parent: 'entity',
            url: '/print-job',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.printJob.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/print-job/print-jobs.html',
                    controller: 'PrintJobController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printJob');
                    $translatePartialLoader.addPart('orderStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('print-job-detail', {
            parent: 'entity',
            url: '/print-job/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.printJob.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/print-job/print-job-detail.html',
                    controller: 'PrintJobDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printJob');
                    $translatePartialLoader.addPart('orderStatus');
                    $translatePartialLoader.addPart('printJobHistory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PrintJob', function($stateParams, PrintJob) {
                    return PrintJob.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('print-job.new', {
            parent: 'print-job',
            url: '/new/{templateId}?isTemplate',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/print-job/print-job-edit.html',
                    controller: 'PrintJobEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printJob');
                    $translatePartialLoader.addPart('orderStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams','$filter', function($stateParams,$filter) {
                    return {
                        reference: "CRM2Print Print & Mail Order - "+$filter('date')(new Date(),'dd/MM/yyyy HH:mm'),
                        invoiceEmail: null,
                        status: "NEW",
                        created: new Date(),
                        lastModified: null,
                        letterCount: null,
                        pageCount: null,
                        duplex: null,
                        priceNet: null,
                        tax: null,
                        priceGross: null,
                        id: null,
                        templateId: $stateParams.templateId ? parseInt($stateParams.templateId) : null,
                        inserts: null,
                        contactsFilter: {}
                    };
                }]
            }
        })
        .state('print-job.edit', {
            parent: 'print-job',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/print-job/print-job-edit.html',
                    controller: 'PrintJobEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printJob');
                    $translatePartialLoader.addPart('orderStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PrintJob', function($stateParams, PrintJob) {
                    return PrintJob.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('print-job.delete', {
            parent: 'print-job',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-job/print-job-delete-dialog.html',
                    controller: 'PrintJobDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PrintJob', function(PrintJob) {
                            return PrintJob.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('print-job', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('print-job.delete-selected', {
            parent: 'print-job',
            url: '/delete/selected',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-job/print-job-delete-dialog.html',
                    controller: 'PrintJobDeleteSelectedController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        ids: ['$stateParams', function($stateParams) {
                            return {
                                ids: $stateParams.ids
                            };
                        }]
                    }
                }).result.then(function() {
                    $state.go('print-job', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('PrintJob', PrintJob)
        .factory('ListCategory', ListCategory)
        .factory('SitePrecincts', SitePrecincts)
        .factory('SiteSubUsers', SiteSubUsers)
        .factory('Contact', Contact);

    PrintJob.$inject = ['$resource', 'DateUtils'];

    function PrintJob ($resource, DateUtils) {
        var resourceUrl =  '/api/print-jobs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true,params:{'status':'@status'}, url: '/api/print-jobs/:id?status=:status'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                        data.lastModified = DateUtils.convertDateTimeFromServer(data.lastModified);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'deletePrintJobs': {
                method:'DELETE',
                url:'/api/print-jobs/selected'
            },
            'generatePreview': {
                method:'POST',
                url:'/api/print-jobs/:id/generate-preview',
                params: {id:"@printJobId"}
            },
            'generateMailMerge': {
                method:'POST',
                url:'/api/print-jobs/:id/generate-mailmerge',
                params: {id:"@printJobId"}
            },
            'validateContacts': {
                method:'POST',
                isArray: true,
                url:'/api/print-jobs/:id/validate-contacts',
                params: {id:"@printJobId"}
            },
            'saveContacts': {
                method:'PUT',//see loadContacts
                url:'/api/print-jobs/:id/contacts?json-only=:jsonOnly&print-job=:printJobId' +
                    '&site-user=:siteUserId' +
                    '&category=:categoryId' +
                    '&precinct=:precinctId' +
                    '&user=:subUserId' +
                    '&listname=:listName',
                params: {
                    id: "@printJobId", jsonOnly: "@jsonOnly",
                    siteUserId: "@siteUserId",
                    categoryId: "@categoryId",
                    listName: "@listName",
                    subUserId: "@subUserId",
                    precinctId: "@precinctId"
                }
            },
            'deleteContacts': {
                method:'DELETE',
                url:'/api/print-jobs/:printJobId/contacts',
            },
            'loadContacts': {
                method:'POST',//not using GET because params substitution... nfi
                url:'/api/print-jobs/:id/contacts',
                params: {id:"@printJobId"}
            },
            'sendApproverNotification': {
                method:'POST',
                url:'/api/print-jobs/:id/send-approver-notification',
                params: {id:"@printJobId"}
            },
            'checkout': {
                method:'POST',
                url:'/api/print-jobs/:id/checkout?stripe-token=:stripeToken',
                params: {id:"@id",stripeToken:"@stripeToken"}
            },
            'saveAsPrintJobTemplate': {
                method:'POST',
                url:'/api/print-jobs/:id/save-as-template?stripe-token=:stripeToken&subscribe=:subscribe',
                params: {id:"@id",stripeToken:"@stripeToken",subscribe:"@subscribe"}
            },
            'quote': {
                method:'POST',
                url:'/api/print-jobs/:id/quote',
                params: {id:"@printJobId"}
            },
            'loadQuote': {
                method:'GET',
                url:'/api/print-jobs/:printJobId/quote',
            },
            'unsubscribeFromContactsSource': {
                method:'POST',
                url:'/api/print-jobs/:id/unsubscribe',
                params: {id:"@printJobId"}
            },
            'pickupQuote': {
                method:'GET',
                url:'/api/quotes/:id',
                params: {id:"@id"}
            },
            'history': {
                method:'GET',
                url:'/api/print-jobs/:printJobId/history',
                isArray: true,
                params: {printJobId:"@printJobId"}
            },
            'charges': {
                method:'GET',
                url:'/api/print-jobs/:printJobId/charges',
                isArray: true,
                params: {printJobId:"@printJobId"}
            },
            'mailMerge': {
                method:'POST',
                url:'/api/print-jobs/:printJobId/mail-merge',
                params: {printJobId:"@printJobId"}
            },
            'cancel': {
                method:'POST',
                url:'/api/print-jobs/:printJobId/cancel',
                params: {printJobId:"@printJobId"}
            },
            'processMergeReady': {
                method:'POST',
                url:'/api/print-jobs/process-merge-ready?demo=:demo',
                params: {demo:"@demo"}
            },
            'collateMerged': {
                method:'POST',
                isArray: true,
                url:'/api/print-jobs/collate-merged?demo=:demo',
                params: {demo:"@demo"}
            },
            'findApiAbandoned': {
                method:'GET',
                isArray: true,
                url:'/api/print-jobs/abandoned-api-submitted'
            },
            'findApiAbandonedSummary': {
                method:'GET',
                url:'/api/print-jobs/abandoned-api-submitted/summary'
            },
            'deleteApiAbandoned': {
                method:'DELETE',
                url:'/api/print-jobs/abandoned-api-submitted'
            },
            'queueStats': {
                method:'GET',
                isArray: true,
                url:'/api/print-jobs/queue-stats'
            },
            'siteMessages': {
                method:'GET',
                url:'/api/site-messages'
            }
        });
    }

    ListCategory.$inject = ['$resource', 'DateUtils'];

    function ListCategory ($resource, DateUtils) {
        var resourceUrl =  '/api/site-data-sources/:dataSourceId/by-site-user/:siteUserId/list-categories?print-job=:printJobId';

        return $resource(resourceUrl, {siteUserId:"@siteUserId",dataSourceId:"@dataSourceId",printJobId:"@printJobId"}, {
            'query': { method: 'GET', isArray: true}
        });
    }

    SiteSubUsers.$inject = ['$resource', 'DateUtils'];

    function SiteSubUsers ($resource, DateUtils) {
        var resourceUrl =  '/api/site-data-sources/:dataSourceId/by-site-user/:siteUserId/site-sub-users';

        return $resource(resourceUrl, {siteUserId:"@siteUserId",dataSourceId:"@dataSourceId"}, {
            'query': { method: 'GET', isArray: true}
        });
    }

    SitePrecincts.$inject = ['$resource', 'DateUtils'];

    function SitePrecincts ($resource, DateUtils) {
        var resourceUrl =  '/api/site-data-sources/:dataSourceId/by-site-user/:siteUserId/precincts';

        return $resource(resourceUrl, {siteUserId:"@siteUserId",dataSourceId:"@dataSourceId"}, {
            'query': { method: 'GET', isArray: true}
        });
    }

    Contact.$inject = ['$resource', 'DateUtils'];

    function Contact ($resource, DateUtils) {
        var resourceUrl =  '/api/site-data-sources/:dataSourceId/by-site-user/:siteUserId/contacts?category=:categoryId&precinct=:precinctId&user=:subUserId&print-job=:printJobId&listname=:listName';

        return $resource(resourceUrl, {siteUserId:"@siteUserId", categoryId:"@categoryId", printJobId:"@printJobId", listName:"@listName", subUserId:"@subUserId", precinctId:"@precinctId"}, {
            'query': { method: 'GET'},
            'readFromCSV': {
                url: '/api/site-data-sources/:dataSourceId/csv/:docId/contacts?print-job=:printJobId&site-user=:siteUserId&list-name=:listName&template=:templateId',
                method: 'GET'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('PrintJobSearch', PrintJobSearch);

    PrintJobSearch.$inject = ['$resource'];

    function PrintJobSearch($resource) {
        var resourceUrl =  '/api/_search/print-jobs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintJobController', PrintJobController);

    PrintJobController.$inject = ['$scope', '$state', 'PrintJob', 'PrintJobSearch', '$uibModal'];

    var printJobStatusIcon = {
        "null": "",
        "NEW": "si si-plus",
        "PLACED": "si si-basket-loaded",
        "MERGE_READY": "si si-docs text-warning",
        "MAIL_MERGE": "si si-docs text-success",
        "PRINT_READY": "si si-layers",
        "MAIL_HOUSE": "si si-printer",
        "DUE": "fa fa-hourglass-1 text-warning",
        "PAID": "fa fa-tick text-success",
        "PRINTED": "si si-envelope",
        "POSTED": "si si-paper-plane",
        "COMPLETED": "si si-check",
        "ERROR": "si si-ban",
        "CANCELLED": "si si-close",
        "ARCHIVED": "si si-drawer"
    };

    function PrintJobController ($scope, $state, PrintJob, PrintJobSearch, $uibModal) {
        var vm = this;

        vm.printJobs = [];
        vm.search = search;
        vm.status = $state.params.status;

        loadAll();

        function loadAll() {
            PrintJob.query({status:vm.status},function(result) {
                vm.printJobs = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            PrintJobSearch.query({query: vm.searchQuery}, function(result) {
                vm.printJobs = result;
            });
        }

        vm.statusIcon = function(status) {
            return printJobStatusIcon[status];
        }

        vm.selectAll = function() {
            vm.printJobs.forEach(function (pj) {
                pj.selected = vm.selectAllTick;
            });
        }

        vm.deleteSelected = function() {
            var ids = vm.printJobs.filter(function(pj) {
                return pj.selected;
            }).map(function(pj) {
                return pj.id;
            });
            // $state.go('print-job.delete-selected',{ids:ids});
            $uibModal.open({
                templateUrl: 'app/entities/print-job/print-job-delete-dialog.html',
                controller: 'PrintJobDeleteSelectedController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    ids: ['$stateParams', function() {
                        return ids;
                    }]
                }
            }).result.then(function() {
                $state.go('print-job', null, { reload: true });
            }, function() {
                $state.go('^');
            });

        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintAndMailCostDialogController', PrintAndMailCostDialogController);

    PrintAndMailCostDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PrintAndMailCost', 'Envelope', 'Vendor'];

    function PrintAndMailCostDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PrintAndMailCost, Envelope, Vendor) {
        var vm = this;

        vm.printAndMailCost = entity;
        vm.clear = clear;
        vm.save = save;
        vm.envelopes = Envelope.query();
        vm.vendors = Vendor.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.printAndMailCost.id !== null) {
                PrintAndMailCost.update(vm.printAndMailCost, onSaveSuccess, onSaveError);
            } else {
                PrintAndMailCost.save(vm.printAndMailCost, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:printAndMailCostUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintAndMailCostDetailController', PrintAndMailCostDetailController);

    PrintAndMailCostDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PrintAndMailCost', 'Envelope', 'Vendor'];

    function PrintAndMailCostDetailController($scope, $rootScope, $stateParams, entity, PrintAndMailCost, Envelope, Vendor) {
        var vm = this;

        vm.printAndMailCost = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:printAndMailCostUpdate', function(event, result) {
            vm.printAndMailCost = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintAndMailCostDeleteController',PrintAndMailCostDeleteController);

    PrintAndMailCostDeleteController.$inject = ['$uibModalInstance', 'entity', 'PrintAndMailCost'];

    function PrintAndMailCostDeleteController($uibModalInstance, entity, PrintAndMailCost) {
        var vm = this;

        vm.printAndMailCost = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PrintAndMailCost.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('print-and-mail-cost', {
            parent: 'entity',
            url: '/print-and-mail-cost',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.printAndMailCost.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/print-and-mail-cost/print-and-mail-costs.html',
                    controller: 'PrintAndMailCostController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printAndMailCost');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('print-and-mail-cost-detail', {
            parent: 'entity',
            url: '/print-and-mail-cost/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.printAndMailCost.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/print-and-mail-cost/print-and-mail-cost-detail.html',
                    controller: 'PrintAndMailCostDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printAndMailCost');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PrintAndMailCost', function($stateParams, PrintAndMailCost) {
                    return PrintAndMailCost.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('print-and-mail-cost.new', {
            parent: 'print-and-mail-cost',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-and-mail-cost/print-and-mail-cost-dialog.html',
                    controller: 'PrintAndMailCostDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                pageCount: null,
                                duplex: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('print-and-mail-cost', null, { reload: true });
                }, function() {
                    $state.go('print-and-mail-cost');
                });
            }]
        })
        .state('print-and-mail-cost.edit', {
            parent: 'print-and-mail-cost',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-and-mail-cost/print-and-mail-cost-dialog.html',
                    controller: 'PrintAndMailCostDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PrintAndMailCost', function(PrintAndMailCost) {
                            return PrintAndMailCost.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('print-and-mail-cost', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('print-and-mail-cost.delete', {
            parent: 'print-and-mail-cost',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/print-and-mail-cost/print-and-mail-cost-delete-dialog.html',
                    controller: 'PrintAndMailCostDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PrintAndMailCost', function(PrintAndMailCost) {
                            return PrintAndMailCost.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('print-and-mail-cost', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('PrintAndMailCost', PrintAndMailCost);

    PrintAndMailCost.$inject = ['$resource'];

    function PrintAndMailCost ($resource) {
        var resourceUrl =  '/api/print-and-mail-costs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('PrintAndMailCostSearch', PrintAndMailCostSearch);

    PrintAndMailCostSearch.$inject = ['$resource'];

    function PrintAndMailCostSearch($resource) {
        var resourceUrl =  '/api/_search/print-and-mail-costs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PrintAndMailCostController', PrintAndMailCostController);

    PrintAndMailCostController.$inject = ['$scope', '$state', 'PrintAndMailCost', 'PrintAndMailCostSearch'];

    function PrintAndMailCostController ($scope, $state, PrintAndMailCost, PrintAndMailCostSearch) {
        var vm = this;
        
        vm.printAndMailCosts = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            PrintAndMailCost.query(function(result) {
                vm.printAndMailCosts = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            PrintAndMailCostSearch.query({query: vm.searchQuery}, function(result) {
                vm.printAndMailCosts = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PostalAccountDialogController', PostalAccountDialogController);

    PostalAccountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PostalAccount', 'Country'];

    function PostalAccountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PostalAccount, Country) {
        var vm = this;
        vm.postalAccount = entity;
        vm.countries = Country.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('crm2PrintApp:postalAccountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.postalAccount.id !== null) {
                PostalAccount.update(vm.postalAccount, onSaveSuccess, onSaveError);
            } else {
                PostalAccount.save(vm.postalAccount, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.created = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PostalAccountDetailController', PostalAccountDetailController);

    PostalAccountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PostalAccount', 'Country'];

    function PostalAccountDetailController($scope, $rootScope, $stateParams, entity, PostalAccount, Country) {
        var vm = this;
        vm.postalAccount = entity;
        
        var unsubscribe = $rootScope.$on('crm2PrintApp:postalAccountUpdate', function(event, result) {
            vm.postalAccount = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PostalAccountDeleteController',PostalAccountDeleteController);

    PostalAccountDeleteController.$inject = ['$uibModalInstance', 'entity', 'PostalAccount'];

    function PostalAccountDeleteController($uibModalInstance, entity, PostalAccount) {
        var vm = this;

        vm.postalAccount = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PostalAccount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('postal-account', {
            parent: 'entity',
            url: '/postal-account',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.postalAccount.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/postal-account/postal-accounts.html',
                    controller: 'PostalAccountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('postalAccount');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('postal-account-detail', {
            parent: 'entity',
            url: '/postal-account/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.postalAccount.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/postal-account/postal-account-detail.html',
                    controller: 'PostalAccountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('postalAccount');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PostalAccount', function($stateParams, PostalAccount) {
                    return PostalAccount.get({id : $stateParams.id});
                }]
            }
        })
        .state('postal-account.new', {
            parent: 'postal-account',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/postal-account/postal-account-dialog.html',
                    controller: 'PostalAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                created: null,
                                provider: null,
                                accountNumber: null,
                                country: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('postal-account', null, { reload: true });
                }, function() {
                    $state.go('postal-account');
                });
            }]
        })
        .state('postal-account.edit', {
            parent: 'postal-account',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/postal-account/postal-account-dialog.html',
                    controller: 'PostalAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PostalAccount', function(PostalAccount) {
                            return PostalAccount.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('postal-account', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('postal-account.delete', {
            parent: 'postal-account',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/postal-account/postal-account-delete-dialog.html',
                    controller: 'PostalAccountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PostalAccount', function(PostalAccount) {
                            return PostalAccount.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('postal-account', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('PostalAccount', PostalAccount);

    PostalAccount.$inject = ['$resource', 'DateUtils'];

    function PostalAccount ($resource, DateUtils) {
        var resourceUrl =  '/api/postal-accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.created = DateUtils.convertDateTimeFromServer(data.created);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('PostalAccountSearch', PostalAccountSearch);

    PostalAccountSearch.$inject = ['$resource'];

    function PostalAccountSearch($resource) {
        var resourceUrl =  '/api/_search/postal-accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PostalAccountController', PostalAccountController);

    PostalAccountController.$inject = ['$scope', '$state', 'PostalAccount', 'PostalAccountSearch'];

    function PostalAccountController ($scope, $state, PostalAccount, PostalAccountSearch) {
        var vm = this;
        vm.postalAccounts = [];
        vm.loadAll = function() {
            PostalAccount.query(function(result) {
                vm.postalAccounts = result;
            });
        };

        vm.search = function () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            PostalAccountSearch.query({query: vm.searchQuery}, function(result) {
                vm.postalAccounts = result;
            });
        };
        vm.loadAll();
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('ManifestRowDialogController', ManifestRowDialogController);

    ManifestRowDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ManifestRow', 'VendorJobTicket'];

    function ManifestRowDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ManifestRow, VendorJobTicket) {
        var vm = this;

        vm.manifestRow = entity;
        vm.clear = clear;
        vm.save = save;
        vm.vendorjobtickets = VendorJobTicket.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.manifestRow.id !== null) {
                ManifestRow.update(vm.manifestRow, onSaveSuccess, onSaveError);
            } else {
                ManifestRow.save(vm.manifestRow, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:manifestRowUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('ManifestRowDetailController', ManifestRowDetailController);

    ManifestRowDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ManifestRow', 'VendorJobTicket'];

    function ManifestRowDetailController($scope, $rootScope, $stateParams, entity, ManifestRow, VendorJobTicket) {
        var vm = this;

        vm.manifestRow = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:manifestRowUpdate', function(event, result) {
            vm.manifestRow = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('ManifestRowDeleteController',ManifestRowDeleteController);

    ManifestRowDeleteController.$inject = ['$uibModalInstance', 'entity', 'ManifestRow'];

    function ManifestRowDeleteController($uibModalInstance, entity, ManifestRow) {
        var vm = this;

        vm.manifestRow = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ManifestRow.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('manifest-row', {
            parent: 'entity',
            url: '/manifest-row',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_VENDOR'],
                pageTitle: 'crm2PrintApp.manifestRow.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manifest-row/manifest-rows.html',
                    controller: 'ManifestRowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manifestRow');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('manifest-row-detail', {
            parent: 'entity',
            url: '/manifest-row/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_VENDOR'],
                pageTitle: 'crm2PrintApp.manifestRow.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manifest-row/manifest-row-detail.html',
                    controller: 'ManifestRowDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manifestRow');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ManifestRow', function($stateParams, ManifestRow) {
                    return ManifestRow.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('manifest-row.new', {
            parent: 'manifest-row',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_VENDOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manifest-row/manifest-row-dialog.html',
                    controller: 'ManifestRowDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sortPlan: null,
                                letterCount: null,
                                trayCount: null,
                                preSort: null,
                                state: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('manifest-row', null, { reload: true });
                }, function() {
                    $state.go('manifest-row');
                });
            }]
        })
        .state('manifest-row.edit', {
            parent: 'manifest-row',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_VENDOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manifest-row/manifest-row-dialog.html',
                    controller: 'ManifestRowDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ManifestRow', function(ManifestRow) {
                            return ManifestRow.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('manifest-row', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('manifest-row.delete', {
            parent: 'manifest-row',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_VENDOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manifest-row/manifest-row-delete-dialog.html',
                    controller: 'ManifestRowDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ManifestRow', function(ManifestRow) {
                            return ManifestRow.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('manifest-row', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('ManifestRow', ManifestRow);

    ManifestRow.$inject = ['$resource'];

    function ManifestRow ($resource) {
        var resourceUrl =  '/api/manifest-rows/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('ManifestRowSearch', ManifestRowSearch);

    ManifestRowSearch.$inject = ['$resource'];

    function ManifestRowSearch($resource) {
        var resourceUrl =  '/api/_search/manifest-rows/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('ManifestRowController', ManifestRowController);

    ManifestRowController.$inject = ['$scope', '$state', 'ManifestRow', 'ManifestRowSearch'];

    function ManifestRowController ($scope, $state, ManifestRow, ManifestRowSearch) {
        var vm = this;
        
        vm.manifestRows = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            ManifestRow.query(function(result) {
                vm.manifestRows = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ManifestRowSearch.query({query: vm.searchQuery}, function(result) {
                vm.manifestRows = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('InvoiceDetailController', InvoiceDetailController);

    InvoiceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Invoice', 'PrintJobCharge', 'User', 'Country', 'UserProfile', 'Account', 'CostCenter'];

    function InvoiceDetailController($scope, $rootScope, $stateParams, entity, Invoice, PrintJobCharge, User, Country, UserProfile, Account, CostCenter) {
        var vm = this;

        vm.invoice = entity;
        vm.user = Account.get({userId:vm.invoice.userId});
        vm.userProfile = UserProfile.getByUserId({userId:vm.invoice.userId});
        vm.costCenters = CostCenter.withChargeToUser();
        vm.invoiceHistory = [];
        vm.countries = Country.query(function (resp) {
            vm.countryLookup = {};
            resp.forEach(function (c) {
                vm.countryLookup[c.code3] = c;
                vm.countryLookup[c.id] = c;
            });
            return resp;
        });
        vm.allowEditing = vm.invoice.status === 'RAISED' || vm.invoice.status === 'ISSUED';

        function load() {
            vm.invoiceCharges = Invoice.charges({invoiceId:vm.invoice.id});
            vm.invoiceHistory = Invoice.history({invoiceId:vm.invoice.id});
        }

        vm.billingEmail = function() {
            if(vm.userProfile && vm.userProfile.billingEmail) {
                return vm.userProfile.billingEmail;
            }
            return vm.user.email;
        };

        vm.billingPhone = function() {
            if(vm.userProfile && vm.userProfile.billingPhone) {
                return vm.userProfile.billingPhone;
            }
            return vm.userProfile.phone;
        };

        vm.billingContact = function() {
            if(vm.userProfile && vm.userProfile.billingContact) {
                return vm.userProfile.billingContact;
            }
            return (vm.user.firstName || '') + ' ' + (vm.user.lastName || '');
        };

        vm.issueInvoice = function() {
            Invoice.issue({invoiceId: vm.invoice.id}, function (resp) {
                vm.invoice = resp;
                load();
            });
        };

        vm.updateTotals = function() {
            Invoice.updateTotals({invoiceId: vm.invoice.id}, function (resp) {
                vm.invoice = resp;
                load();
            });
        };

        vm.payInvoice = function() {
            Invoice.pay({invoiceId: vm.invoice.id}, function (resp) {
                swal("Submitted.","Your payment request has been received and will be processed shortly.","success");
            });
        };

        vm.assignCostCenter = function() {
            var selected = vm.invoiceCharges.filter(function(e) {
                return e.selected;
            }).map(function(e) {
                return e.id;
            });
            swal({
                title: 'Assign '+selected.length+' charge(s) to Cost Center:',
                input: 'select',
                inputOptions: vm.costCenters.reduce(function(initial,cc) {
                    initial[cc.id] = cc.name;
                    return initial;
                }, {}),
                inputPlaceholder: 'Select cost center',
                showCancelButton: true
            }).then(function(resp){
                if(resp.value) {
                    Invoice.assignChargesToCostCenter({
                        invoiceId: vm.invoice.id,
                        chargeIds: selected,
                        costCenterId: resp.value
                    }).$promise.then(function(resp){
                        vm.invoice = resp;
                        load(); // FIXME use events
                    })
                }
            });
        };

        var unsubscribe = $rootScope.$on('crm2PrintApp:invoiceUpdate', function(event, result) {
            vm.invoice = result;
        });

        load();
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('InvoiceDeleteController',InvoiceDeleteController);

    InvoiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Invoice'];

    function InvoiceDeleteController($uibModalInstance, entity, Invoice) {
        var vm = this;

        vm.invoice = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Invoice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoice', {
            parent: 'entity',
            url: '/invoice?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.invoice.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice/invoices.html',
                    controller: 'InvoiceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invoice');
                    $translatePartialLoader.addPart('invoiceStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('invoice-detail', {
            parent: 'entity',
            url: '/invoice/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.invoice.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice/invoice-detail.html',
                    controller: 'InvoiceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invoice');
                    $translatePartialLoader.addPart('invoiceStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Invoice', function($stateParams, Invoice) {
                    return Invoice.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('invoice.delete', {
            parent: 'invoice',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-delete-dialog.html',
                    controller: 'InvoiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Invoice', function(Invoice) {
                            return Invoice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('Invoice', Invoice);

    Invoice.$inject = ['$resource', 'DateUtils'];

    function Invoice ($resource, DateUtils) {
        var resourceUrl =  'api/invoices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.raised = DateUtils.convertDateTimeFromServer(data.raised);
                        data.issued = DateUtils.convertDateTimeFromServer(data.issued);
                        data.paid = DateUtils.convertDateTimeFromServer(data.paid);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'charges': {
                method:'GET',
                url:'/api/invoices/:invoiceId/charges',
                isArray: true,
                params: {invoiceId:"@invoiceId"}
            },
            'issue': {
                method:'PUT',
                url:'/api/invoices/:invoiceId/issue',
                params: {invoiceId:"@invoiceId"}
            },
            'updateTotals': {
                method:'PUT',
                url:'/api/invoices/:invoiceId/update-totals',
                params: {invoiceId:"@invoiceId"}
            },
            'pay': {
                method:'PUT',
                url:'/api/invoices/:invoiceId/pay',
                params: {invoiceId:"@invoiceId"}
            },
            'assignChargesToCostCenter': {
                method:'POST',
                url:'/api/invoices/:invoiceId/assign-charges-to-cost-center',
                params: {invoiceId:"@invoiceId"}
            },
            'history': {
                method:'GET',
                url:'/api/invoices/:invoiceId/history',
                isArray: true,
                params: {invoiceId:"@invoiceId"}
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('InvoiceSearch', InvoiceSearch);

    InvoiceSearch.$inject = ['$resource'];

    function InvoiceSearch($resource) {
        var resourceUrl =  'api/_search/invoices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('InvoiceController', InvoiceController);

    InvoiceController.$inject = ['$scope', '$state', 'Invoice', 'InvoiceSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function InvoiceController ($scope, $state, Invoice, InvoiceSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                InvoiceSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Invoice.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.invoices = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('IndustryDialogController', IndustryDialogController);

    IndustryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Industry'];

    function IndustryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Industry) {
        var vm = this;

        vm.industry = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.industry.id !== null) {
                Industry.update(vm.industry, onSaveSuccess, onSaveError);
            } else {
                Industry.save(vm.industry, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:industryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('IndustryDetailController', IndustryDetailController);

    IndustryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Industry'];

    function IndustryDetailController($scope, $rootScope, $stateParams, entity, Industry) {
        var vm = this;

        vm.industry = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:industryUpdate', function(event, result) {
            vm.industry = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('IndustryDeleteController',IndustryDeleteController);

    IndustryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Industry'];

    function IndustryDeleteController($uibModalInstance, entity, Industry) {
        var vm = this;

        vm.industry = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Industry.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('industry', {
            parent: 'entity',
            url: '/industry',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.industry.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/industry/industries.html',
                    controller: 'IndustryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('industry');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('industry-detail', {
            parent: 'entity',
            url: '/industry/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.industry.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/industry/industry-detail.html',
                    controller: 'IndustryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('industry');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Industry', function($stateParams, Industry) {
                    return Industry.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('industry.new', {
            parent: 'industry',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/industry/industry-dialog.html',
                    controller: 'IndustryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                icon: null,
                                subTitle: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('industry', null, { reload: true });
                }, function() {
                    $state.go('industry');
                });
            }]
        })
        .state('industry.edit', {
            parent: 'industry',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/industry/industry-dialog.html',
                    controller: 'IndustryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Industry', function(Industry) {
                            return Industry.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('industry', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('industry.delete', {
            parent: 'industry',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/industry/industry-delete-dialog.html',
                    controller: 'IndustryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Industry', function(Industry) {
                            return Industry.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('industry', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('Industry', Industry);

    Industry.$inject = ['$resource'];

    function Industry ($resource) {
        var resourceUrl =  '/api/industries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('IndustrySearch', IndustrySearch);

    IndustrySearch.$inject = ['$resource'];

    function IndustrySearch($resource) {
        var resourceUrl =  '/api/_search/industries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('IndustryController', IndustryController);

    IndustryController.$inject = ['$scope', '$state', 'Industry', 'IndustrySearch'];

    function IndustryController ($scope, $state, Industry, IndustrySearch) {
        var vm = this;
        
        vm.industries = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            Industry.query(function(result) {
                vm.industries = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            IndustrySearch.query({query: vm.searchQuery}, function(result) {
                vm.industries = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('FAQDialogController', FAQDialogController);

    FAQDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FAQ', 'User'];

    function FAQDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FAQ, User) {
        var vm = this;

        vm.faq = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.faq.id !== null) {
                FAQ.update(vm.faq, onSaveSuccess, onSaveError);
            } else {
                FAQ.save(vm.faq, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:faqUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastModified = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('FAQDetailController', FAQDetailController);

    FAQDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'FAQ', 'User'];

    function FAQDetailController($scope, $rootScope, $stateParams, entity, FAQ, User) {
        var vm = this;

        vm.faq = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:faqUpdate', function(event, result) {
            vm.faq = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('FAQDeleteController',FAQDeleteController);

    FAQDeleteController.$inject = ['$uibModalInstance', 'entity', 'FAQ'];

    function FAQDeleteController($uibModalInstance, entity, FAQ) {
        var vm = this;

        vm.faq = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FAQ.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('faq', {
            parent: 'entity',
            url: '/faq',
            data: {
                authorities: [],
                pageTitle: 'crm2PrintApp.faq.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/faq/faqs.html',
                    controller: 'FAQController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('faq');
                    $translatePartialLoader.addPart('faqCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('faq-detail', {
            parent: 'entity',
            url: '/faq/{id}',
            data: {
                authorities: [''],
                pageTitle: 'crm2PrintApp.faq.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/faq/faq-detail.html',
                    controller: 'FAQDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('faq');
                    $translatePartialLoader.addPart('faqCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FAQ', function($stateParams, FAQ) {
                    return FAQ.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('faq.new', {
            parent: 'faq',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/faq/faq-dialog.html',
                    controller: 'FAQDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                question: null,
                                answer: null,
                                category: null,
                                lastModified: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('faq', null, { reload: true });
                }, function() {
                    $state.go('faq');
                });
            }]
        })
        .state('faq.edit', {
            parent: 'faq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/faq/faq-dialog.html',
                    controller: 'FAQDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FAQ', function(FAQ) {
                            return FAQ.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('faq', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('faq.delete', {
            parent: 'faq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/faq/faq-delete-dialog.html',
                    controller: 'FAQDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FAQ', function(FAQ) {
                            return FAQ.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('faq', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('FAQ', FAQ);

    FAQ.$inject = ['$resource', 'DateUtils'];

    function FAQ ($resource, DateUtils) {
        var resourceUrl =  '/api/faqs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastModified = DateUtils.convertDateTimeFromServer(data.lastModified);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('FAQSearch', FAQSearch);

    FAQSearch.$inject = ['$resource'];

    function FAQSearch($resource) {
        var resourceUrl =  '/api/_search/faqs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('FAQController', FAQController);

    FAQController.$inject = ['$scope', '$state', 'FAQ', 'FAQSearch'];

    function FAQController ($scope, $state, FAQ, FAQSearch) {
        var vm = this;

        vm.faqs = [];
        vm.categories = {};
        vm.search = search;

        loadAll();

        function loadAll() {
            FAQ.query(processResult);
        }

        function processResult(result) {
            if(result.length > 0) {
                vm.categories = {};
                for (var i = 0; i < result.length; i++) {
                    var c = vm.categories[result[i].category];
                    if(!c) {
                        c = vm.categories[result[i].category] = { count:0, faqs:[] };
                    }
                    c.faqs.push(result[i]);
                    c.count++;
                }
            }
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            FAQSearch.query({query: vm.searchQuery}, processResult);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('EnvelopeDialogController', EnvelopeDialogController);

    EnvelopeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Envelope', 'Vendor'];

    function EnvelopeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Envelope, Vendor) {
        var vm = this;

        vm.envelope = entity;
        vm.clear = clear;
        vm.save = save;
        vm.vendors = Vendor.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.envelope.id !== null) {
                Envelope.update(vm.envelope, onSaveSuccess, onSaveError);
            } else {
                Envelope.save(vm.envelope, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:envelopeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('EnvelopeDetailController', EnvelopeDetailController);

    EnvelopeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Envelope', 'Vendor'];

    function EnvelopeDetailController($scope, $rootScope, $stateParams, entity, Envelope, Vendor) {
        var vm = this;

        vm.envelope = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:envelopeUpdate', function(event, result) {
            vm.envelope = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('EnvelopeDeleteController',EnvelopeDeleteController);

    EnvelopeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Envelope'];

    function EnvelopeDeleteController($uibModalInstance, entity, Envelope) {
        var vm = this;

        vm.envelope = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Envelope.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('envelope', {
            parent: 'entity',
            url: '/envelope',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.envelope.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/envelope/envelopes.html',
                    controller: 'EnvelopeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('envelope');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('envelope-detail', {
            parent: 'entity',
            url: '/envelope/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.envelope.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/envelope/envelope-detail.html',
                    controller: 'EnvelopeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('envelope');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Envelope', function($stateParams, Envelope) {
                    return Envelope.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('envelope.new', {
            parent: 'envelope',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/envelope/envelope-dialog.html',
                    controller: 'EnvelopeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                size: null,
                                width: null,
                                height: null,
                                windowLeft: null,
                                windowTop: null,
                                windowRight: null,
                                windowBottom: null,
                                windowWidth: null,
                                windowHeight: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('envelope', null, { reload: true });
                }, function() {
                    $state.go('envelope');
                });
            }]
        })
        .state('envelope.edit', {
            parent: 'envelope',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/envelope/envelope-dialog.html',
                    controller: 'EnvelopeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Envelope', function(Envelope) {
                            return Envelope.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('envelope', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('envelope.delete', {
            parent: 'envelope',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/envelope/envelope-delete-dialog.html',
                    controller: 'EnvelopeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Envelope', function(Envelope) {
                            return Envelope.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('envelope', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('Envelope', Envelope);

    Envelope.$inject = ['$resource'];

    function Envelope ($resource) {
        var resourceUrl =  '/api/envelopes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('EnvelopeSearch', EnvelopeSearch);

    EnvelopeSearch.$inject = ['$resource'];

    function EnvelopeSearch($resource) {
        var resourceUrl =  '/api/_search/envelopes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('EnvelopeController', EnvelopeController);

    EnvelopeController.$inject = ['$scope', '$state', 'Envelope', 'EnvelopeSearch'];

    function EnvelopeController ($scope, $state, Envelope, EnvelopeSearch) {
        var vm = this;
        
        vm.envelopes = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            Envelope.query(function(result) {
                vm.envelopes = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            EnvelopeSearch.query({query: vm.searchQuery}, function(result) {
                vm.envelopes = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('CountryDialogController', CountryDialogController);

    CountryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Country'];

    function CountryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.country.id !== null) {
                Country.update(vm.country, onSaveSuccess, onSaveError);
            } else {
                Country.save(vm.country, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:countryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.supportedSince = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('CountryDetailController', CountryDetailController);

    CountryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Country'];

    function CountryDetailController($scope, $rootScope, $stateParams, entity, Country) {
        var vm = this;

        vm.country = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:countryUpdate', function(event, result) {
            vm.country = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('CountryDeleteController',CountryDeleteController);

    CountryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Country'];

    function CountryDeleteController($uibModalInstance, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Country.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('country', {
            parent: 'entity',
            url: '/country',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.country.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/countries.html',
                    controller: 'CountryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('country-detail', {
            parent: 'entity',
            url: '/country/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'crm2PrintApp.country.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/country-detail.html',
                    controller: 'CountryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Country', function($stateParams, Country) {
                    return Country.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('country.new', {
            parent: 'country',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                supportedSince: null,
                                code2: null,
                                code3: null,
                                currency: null,
                                taxRate: null,
                                taxName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: true });
                }, function() {
                    $state.go('country');
                });
            }]
        })
        .state('country.edit', {
            parent: 'country',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country.delete', {
            parent: 'country',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-delete-dialog.html',
                    controller: 'CountryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('Country', Country);

    Country.$inject = ['$resource', 'DateUtils'];

    function Country ($resource, DateUtils) {
        var resourceUrl =  '/api/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.supportedSince = DateUtils.convertDateTimeFromServer(data.supportedSince);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('CountrySearch', CountrySearch);

    CountrySearch.$inject = ['$resource'];

    function CountrySearch($resource) {
        var resourceUrl =  '/api/_search/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('CountryController', CountryController);

    CountryController.$inject = ['$scope', '$state', 'Country', 'CountrySearch'];

    function CountryController ($scope, $state, Country, CountrySearch) {
        var vm = this;
        
        vm.countries = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            Country.query(function(result) {
                vm.countries = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            CountrySearch.query({query: vm.searchQuery}, function(result) {
                vm.countries = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('CostCenterSendInviteDialogController', CostCenterSendInviteDialogController);

    CostCenterSendInviteDialogController.$inject = ['$uibModalInstance', 'entity', 'CostCenter'];

    function CostCenterSendInviteDialogController($uibModalInstance, entity, CostCenter) {
        var vm = this;

        vm.costCenter = entity;
        vm.clear = clear;
        vm.sendInvite = sendInvite;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function sendInvite (id) {
            CostCenter.sendInvite({id: id, email: vm.email},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('CostCenterDialogController', CostCenterDialogController);

    CostCenterDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CostCenter', 'User'];

    function CostCenterDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CostCenter, User) {
        var vm = this;

        vm.costCenter = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.costCenter.id !== null) {
                CostCenter.update(vm.costCenter, onSaveSuccess, onSaveError);
            } else {
                CostCenter.save(vm.costCenter, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:costCenterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('CostCenterDetailController', CostCenterDetailController);

    CostCenterDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CostCenter', 'User'];

    function CostCenterDetailController($scope, $rootScope, $stateParams, entity, CostCenter, User) {
        var vm = this;

        vm.costCenter = entity;

        var unsubscribe = $rootScope.$on('crm2PrintApp:costCenterUpdate', function(event, result) {
            vm.costCenter = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('CostCenterDeleteController',CostCenterDeleteController);

    CostCenterDeleteController.$inject = ['$uibModalInstance', 'entity', 'CostCenter'];

    function CostCenterDeleteController($uibModalInstance, entity, CostCenter) {
        var vm = this;

        vm.costCenter = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CostCenter.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('CostCenterConfirmInviteDialogController', CostCenterConfirmInviteDialogController);

    CostCenterConfirmInviteDialogController.$inject = ['$uibModalInstance', 'entity', 'CostCenter'];

    function CostCenterConfirmInviteDialogController($uibModalInstance, entity, CostCenter) {
        var vm = this;

        vm.costCenter = entity;
        vm.clear = clear;
        vm.confirmInvite = confirmInvite;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmInvite (id) {
            CostCenter.confirmInvite({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cost-center', {
            parent: 'entity',
            url: '/cost-center?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.costCenter.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cost-center/cost-centers.html',
                    controller: 'CostCenterController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('costCenter');
                    $translatePartialLoader.addPart('costCenterStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cost-center-detail', {
            parent: 'entity',
            url: '/cost-center/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.costCenter.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cost-center/cost-center-detail.html',
                    controller: 'CostCenterDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('costCenter');
                    $translatePartialLoader.addPart('costCenterStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CostCenter', function($stateParams, CostCenter) {
                    return CostCenter.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('cost-center.confirm-invite', {
            parent: 'cost-center',
            url: '/{id}/confirm-invite',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cost-center/cost-center-confirm-invite-dialog.html',
                    controller: 'CostCenterConfirmInviteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CostCenter', function(CostCenter) {
                            return CostCenter.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-profile', null, { reload: true });
                }, function() {
                    $state.go('cost-center');
                });
            }]
        })
        .state('cost-center.send-invite', {
            parent: 'cost-center',
            url: '/{id}/send-invite',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cost-center/cost-center-send-invite-dialog.html',
                    controller: 'CostCenterSendInviteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CostCenter', function(CostCenter) {
                            return CostCenter.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cost-center', null, { reload: true });
                }, function() {
                    $state.go('cost-center');
                });
            }]
        })
        .state('cost-center.new', {
            parent: 'cost-center',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cost-center/cost-center-dialog.html',
                    controller: 'CostCenterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                status: null,
                                created: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cost-center', null, { reload: true });
                }, function() {
                    $state.go('cost-center');
                });
            }]
        })
        .state('cost-center.edit', {
            parent: 'cost-center',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cost-center/cost-center-dialog.html',
                    controller: 'CostCenterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CostCenter', function(CostCenter) {
                            return CostCenter.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cost-center', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cost-center.delete', {
            parent: 'cost-center',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cost-center/cost-center-delete-dialog.html',
                    controller: 'CostCenterDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CostCenter', function(CostCenter) {
                            return CostCenter.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cost-center', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('CostCenter', CostCenter);

    CostCenter.$inject = ['$resource', 'DateUtils'];

    function CostCenter ($resource, DateUtils) {
        var resourceUrl =  '/api/cost-centers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'confirmInvite': {
                method:'POST',
                url:'/api/cost-centers/:id/confirm-invite',
                params: {id:"@id"}
            },
            'sendInvite': {
                method:'POST',
                url:'/api/cost-centers/:id/send-invite',
                params: {id:"@id"}
            },
            'withChargeToUser': {
                method:'GET', isArray: true,
                url:'/api/cost-centers/with-charge-to-user'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('CostCenterSearch', CostCenterSearch);

    CostCenterSearch.$inject = ['$resource'];

    function CostCenterSearch($resource) {
        var resourceUrl =  '/api/_search/cost-centers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('CostCenterController', CostCenterController);

    CostCenterController.$inject = ['$scope', '$state', 'CostCenter', 'CostCenterSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CostCenterController ($scope, $state, CostCenter, CostCenterSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CostCenterSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CostCenter.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.costCenters = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('CartDialogController', CartDialogController);

    CartDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Cart', 'User'];

    function CartDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Cart, User) {
        var vm = this;

        vm.cart = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.cart.id !== null) {
                Cart.update(vm.cart, onSaveSuccess, onSaveError);
            } else {
                Cart.save(vm.cart, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('crm2PrintApp:cartUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('CartDetailController', CartDetailController);

    CartDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Cart', 'User'];

    function CartDetailController($scope, $rootScope, $stateParams, previousState, entity, Cart, User) {
        var vm = this;

        vm.cart = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('crm2PrintApp:cartUpdate', function(event, result) {
            vm.cart = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('CartDeleteController',CartDeleteController);

    CartDeleteController.$inject = ['$uibModalInstance', 'entity', 'Cart'];

    function CartDeleteController($uibModalInstance, entity, Cart) {
        var vm = this;

        vm.cart = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Cart.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cart', {
            parent: 'entity',
            url: '/cart',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.cart.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cart/carts.html',
                    controller: 'CartController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cart');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cart-detail', {
            parent: 'entity',
            url: '/cart/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'crm2PrintApp.cart.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cart/cart-detail.html',
                    controller: 'CartDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cart');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Cart', function($stateParams, Cart) {
                    return Cart.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cart',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cart-detail.edit', {
            parent: 'cart-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cart/cart-dialog.html',
                    controller: 'CartDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cart', function(Cart) {
                            return Cart.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cart.new', {
            parent: 'cart',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cart/cart-dialog.html',
                    controller: 'CartDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                created: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cart', null, { reload: true });
                }, function() {
                    $state.go('cart');
                });
            }]
        })
        .state('cart.edit', {
            parent: 'cart',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cart/cart-dialog.html',
                    controller: 'CartDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cart', function(Cart) {
                            return Cart.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cart', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cart.delete', {
            parent: 'cart',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cart/cart-delete-dialog.html',
                    controller: 'CartDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Cart', function(Cart) {
                            return Cart.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cart', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('Cart', Cart);

    Cart.$inject = ['$resource', 'DateUtils'];

    function Cart ($resource, DateUtils) {
        var resourceUrl =  'api/carts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('CartSearch', CartSearch);

    CartSearch.$inject = ['$resource'];

    function CartSearch($resource) {
        var resourceUrl =  'api/_search/carts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('CartController', CartController);

    CartController.$inject = ['$scope', '$state', 'Cart', 'CartSearch'];

    function CartController ($scope, $state, Cart, CartSearch) {
        var vm = this;
        
        vm.carts = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            Cart.query(function(result) {
                vm.carts = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            CartSearch.query({query: vm.searchQuery}, function(result) {
                vm.carts = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
(function(){
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse (header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if( angular.isString(page) ) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page-1) * 20)==0 ? 1:(($ctrl.page-1) * 20 + 1)}} - ' +
                    '{{($ctrl.page * 20) < $ctrl.queryCount ? ($ctrl.page * 20) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total'
        }
    };

    angular
        .module('crm2PrintApp')
        .component('jhiItemCount', jhiItemCount);
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('crm2PrintApp')
        .factory('ContactService', ContactService);

    ContactService.$inject = ['$resource'];

    function ContactService ($resource) {
        var resourceUrl =  '/api/contact/contact-us';

        return $resource(resourceUrl, {}, {
            'contactUs': { method:'POST' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('SplashScreenService', SplashScreenService);

    SplashScreenService.$inject = ['$uibModal'];

    function SplashScreenService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open (userProfile) {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/splash-screen/splash-screen.html',
                controller: 'SplashScreenController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('splashScreen');
                        return $translate.refresh();
                    }],
                    userProfile: function() {
                        return userProfile;
                    }
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SplashScreenController', SplashScreenController);

    SplashScreenController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', '$sce', 'User', 'userProfile', 'UserProfile'];

    function SplashScreenController ($rootScope, $state, $timeout, Auth, $uibModalInstance, $sce, User, userProfile, UserProfile) {
        var vm = this;

        vm.cancel = cancel;
        vm.doStuff = doStuff;
        vm.showVideo = showVideo;
        vm.closeVideo = closeVideo;
        vm.markGuideAsSeen = markGuideAsSeen;
        vm.credentials = {};
        vm.userProfile = userProfile;
        User.updateLastViewedWelcome();

        $timeout(function (){
            angular.element('#username').focus();
            $('a[title]').tooltip();
        });

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function doStuff () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }


        function showVideo(video) {
            vm.videoUrl = $sce.trustAsResourceUrl('https://s3-ap-southeast-2.amazonaws.com/crm2print-static/media/videos/'+video+'.mp4');
            vm.videoTitle = video;
            $('#splash-content').removeClass("flipInX").addClass("flipOutX");
            setTimeout(function(){
                $('#splash-video').show();
            }, 750)
        }

        function closeVideo() {
            $('#splash-video').hide();
            $('#splash-content').removeClass("flipOutX").show();
        }


        function markGuideAsSeen() {
            UserProfile.markGuideAsSeen();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                } else {
                    $state.go('template');
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('crm2PrintApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(paginationConfig);
    
    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];
    
    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
(function() {
    'use strict';

    var jhiAlertError = {
        /*template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',*/
        template: '',
        controller: jhiAlertErrorController
    };

    angular
        .module('crm2PrintApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('crm2PrintApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-crm2PrintApp-error');
                var params = httpResponse.headers('X-crm2PrintApp-params');
                var paramsType = httpResponse.headers('X-crm2PrintApp-params-type');
                if (errorHeader && paramsType === 'entityKey') {
                    var entityName = $translate.instant('global.menu.entities.' + params);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (errorHeader) {
                    addErrorAlert(errorHeader, errorHeader, params);
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('crm2PrintApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    icon: 'fa fa-check',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    icon: 'fa fa-times',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    icon: 'fa fa-warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    icon: 'fa fa-info-circle',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type ? alertOptions.type : 'info',
                    //msg: $sce.trustAsHtml(alertOptions.msg),
                    message: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    url: alertOptions.url ? alertOptions.url : '',
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                // if(!alert.scoped) {
                //     alerts.push(alert);
                // }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                // if (alertOptions.timeout && alertOptions.timeout > 0) {
                //     $timeout(function () {
                //         that.closeAlert(alertOptions.alertId, extAlerts);
                //     }, alertOptions.timeout);
                // }
                jQuery.notify(alert, {
                    element: 'body',
                    type: alert.type ? alert.type : 'info',
                    allow_dismiss: true,
                    newest_on_top: true,
                    showProgressbar: false,
                    placement: {
                        from: alert.from ? alert.from : 'top',
                        align: alert.align ? alert.align : 'right'
                    },
                    offset: 20,
                    spacing: 10,
                    z_index: 1100,
                    delay: 5000,
                    timer: 1000,
                    animate: {
                        enter: 'animated fadeIn',
                        exit: 'animated fadeOutDown'
                    }
                });
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('crm2PrintApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-crm2PrintApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-crm2PrintApp-params')});
            }
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('crm2PrintApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            
            if (token && token.expires_at && token.expires_at > new Date().getTime()) {
                config.headers.Authorization = 'Bearer ' + token.access_token;
            }
            
            return config;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider'];

    function localStorageConfig($localStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('crm2PrintApp')
        .constant('VERSION', "0.1.0-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_APIUSER', 'ROLE_VENDOR', 'ROLE_DEMO_MODE'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User', 'AuthServerProvider', '$http', '$localStorage'];

    function UserManagementDetailController ($stateParams, User, AuthServerProvider, $http, $localStorage) {
        var vm = this;

        vm.load = load;
        vm.impersonate = impersonate;
        vm.sendActivationEmail = sendActivationEmail;
        vm.user = {};
        vm.token = AuthServerProvider.getToken().access_token;

        vm.load($stateParams.id);

        function load (id) {
            User.get({id: id}, function(result) {
                vm.user = result;
            });
        }


        function impersonate() {
            return $http.post("/login/impersonate?username="+vm.user.login+"&access_token="+vm.token).success(authSuccess);

            function authSuccess (response) {
                var expiredAt = new Date();
                expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
                response.expires_at = expiredAt.getTime();
                $localStorage.authenticationToken = response;
                location.href = "/";
                return response;
            }
        }

        function sendActivationEmail() {
            User.sendActivationEmail({id: vm.user.id}, function(result) {
                //vm.user = result;
                swal("Sent", "Activate Email has been sent to "+result.email, "info");
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            User.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:id',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'paginationConstants', 'JhiLanguageService', 'AuthServerProvider', '$http' ,'$localStorage'];

    function UserManagementController(Principal, User, ParseLinks, paginationConstants, JhiLanguageService, AuthServerProvider, $http, $localStorage) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_APIUSER', 'ROLE_VENDOR', 'ROLE_DEMO_MODE'];
        vm.clear = clear;
        vm.currentAccount = null;
        vm.languages = null;
        vm.links = null;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.loadPage = loadPage;
        vm.page = 1;
        vm.setActive = setActive;
        vm.totalItems = null;
        vm.users = [];
        vm.token = AuthServerProvider.getToken().access_token;
        vm.impersonate = impersonate;

        vm.loadAll();


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });


        function loadAll () {
            User.query({page: vm.page - 1, size: paginationConstants.itemsPerPage}, function (result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');

                //hide anonymous user from user management: it's a required user for Spring Security
                for(var i in result) {
                    if(result[i]['login'] === 'anonymoususer') {
                        result.splice(i,1);
                    }
                }
                vm.users = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            User.search({query: vm.searchQuery}, function(result) {
                //hide anonymous user from user management: it's a required user for Spring Security
                for(var i in result) {
                    if(result[i]['login'] === 'anonymoususer') {
                        result.splice(i,1);
                    }
                }
                vm.users = result;
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();
        }


        function impersonate(user) {
            return $http.post("/login/impersonate?username="+user.login+"&access_token="+vm.token).success(authSuccess);

            function authSuccess (response) {
                var expiredAt = new Date();
                expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
                response.expires_at = expiredAt.getTime();
                $localStorage.authenticationToken = response;
                location.href = "/";
                return response;
            }
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();
;
(function() {
    'use strict';

    angular.module('crm2PrintApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_APIUSER'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin-dashboard', {
            parent: 'admin',
            url: '/admin-dashboard',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Dashboard'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/dashboard/admin-dashboard.html',
                    controller: 'AdminDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('printJob');
                    $translatePartialLoader.addPart('orderStatus');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('adminDashboard');
                    $translatePartialLoader.addPart('invoiceStatus');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('AdminDashboard', AdminDashboard);

    AdminDashboard.$inject = ['$rootScope', '$http'];

    function AdminDashboard ($rootScope, $http) {
        var service = {
            getOpenInvoices: function(demo) {
                return $http.get('api/admin/invoices/open?demo='+demo).then(function (response) {
                    return response.data;
                });
            },
            getPaidInvoices: function(days, demo) {
                return $http.get('api/admin/invoices/paid?days='+days+'&demo='+demo).then(function (response) {
                    return response.data;
                });
            },
            getInvoiceSummary: function (status, days, demo) {
                return $http.get('api/admin/invoices/summary/'+days+'?status='+status+'&demo='+demo).then(function (response) {
                    return response.data;
                });
            },
            getPrintJobSummary: function (days, demo) {
                return $http.get('api/admin/print-jobs/summary/'+days+'?demo'+demo).then(function (response) {
                    return response.data;
                });
            },
            getPrintJobStats: function (demo) {
                return $http.get('api/admin/print-jobs/stats?demo'+demo).then(function (response) {
                    return response.data;
                });
            },
            getPrintJobs: function (demo) {
                return $http.get('api/admin/print-jobs?demo='+demo).then(function (response) {
                    return response.data;
                });
            },
            clearHibernateCache: function (demo) {
                return $http.delete('api/admin/hibernate/cache').then(function (response) {
                    return response.data;
                });
            }
        };

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('AdminDashboardModalController', AdminDashboardModalController);

    AdminDashboardModalController.$inject = ['$uibModalInstance'];

    function AdminDashboardModalController ($uibModalInstance) {
        var vm = this;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('AdminDashboardController', AdminDashboardController);

    AdminDashboardController.$inject = ['$timeout','$scope', '$uibModal', 'PrintJob', 'AdminDashboard', 'User', 'VendorJobTicket'];

    function AdminDashboardController ($timeout, $scope, $uibModal, PrintJob, AdminDashboard, User, VendorJobTicket) {
        var vm = this;
        vm.demo = false;
        vm.due = true;
        vm.refresh = refresh;
        vm.processMergeReadyPrintJobs = processMergeReadyPrintJobs;
        vm.processMergeReadyPrintJob = processMergeReadyPrintJob;
        vm.processPrintJobPrintStreams = processPrintJobPrintStreams;
        vm.deleteApiAbandoned = deleteApiAbandoned;
        vm.clearHibernateCache = AdminDashboard.clearHibernateCache;
        vm.reIndexAllUsers = User.reIndexAllUsers;
        vm.syncMailchimp = User.syncMailchimp;
        vm.markJobTicketsComplete = VendorJobTicket.markJobTicketsComplete;
        vm.cancelPrintJob = cancelPrintJob;

        vm.refresh();

        vm.merged = [];
        vm.collated = [];

        $scope.$watch('vm.metrics', function (newValue) {
        });

        function refresh () {
            vm.updatingMetrics = true;

            if(vm.due) {
                AdminDashboard.getOpenInvoices(vm.demo).then(function (resp) {
                    vm.invoices = resp;
                });
            } else {
                AdminDashboard.getPaidInvoices(1, vm.demo).then(function (resp) {
                    vm.invoices = resp;
                });
            }
            AdminDashboard.getInvoiceSummary('',7,vm.demo).then(function (resp) {
                vm.raised7days = resp;
            });
            AdminDashboard.getInvoiceSummary('',0,vm.demo).then(function (resp) {
                vm.raised24hours = resp;
            });
            /*AdminDashboard.getPrintJobSummary(7,vm.demo).then(function (resp) {
                vm.placed7days = resp;
            });
            AdminDashboard.getPrintJobSummary(0,vm.demo).then(function (resp) {
                vm.placed24hours = resp;
            });*/
            AdminDashboard.getPrintJobStats(vm.demo).then(function (resp) {
                vm.placedStats = resp;
                vm.placedStatsLookup = resp['by-period'].reduce(function(i,e){
                    i[e.period] = e;
                    return i;
                },{});
            });
            AdminDashboard.getPrintJobs(vm.demo).then(function (resp) {
                vm.printJobs = resp;
                vm.printJobCountByStatus = resp.reduce(function(stats,pj){
                   stats[pj.status] = (stats[pj.status] || 0) + 1;
                   return stats;
                },{});
            });
            PrintJob.findApiAbandonedSummary(function(resp) {
                vm.apiAbandonedCount = resp.count;
            });
            refreshQueueStats();
        }

        //this function will refresh the queue stats until the queues are idle
        function refreshQueueStats() {
            PrintJob.queueStats(function(resp){
                vm.queueStats = resp.reduce(function(initial,e) {
                    initial[e.name]=e;
                    initial.waiting+=e.waiting;
                    initial.active+=e.active;
                    return initial;
                },{waiting:0,active:0});
                if(vm.queueStats.active > 0 || vm.queueStats.waiting > 0) {
                    vm.queueProcessing = true;
                    $timeout(refreshQueueStats,3000);
                }
                if(vm.queueProcessing && vm.queueStats.active == 0 && vm.queueStats.waiting == 0) {
                    vm.queueProcessing = false;
                    $timeout(refresh,5);
                }
            });
        }


        function cancelPrintJob(id) {
            swal({
                title: "Cancel Printjob.",
                text: "Are you sure you want to cancel print job #"+id+"?\n Ensure to refund any payments.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "No.",
                closeOnConfirm: true,
                closeOnCancel: true
            }).then(function(result){
                if (result.value) {
                    PrintJob.cancel({printJobId:id});
                }
            });
        }

        function processMergeReadyPrintJobs(demo) {
            PrintJob.processMergeReady({demo:demo}, refreshQueueStats);
        }

        function processMergeReadyPrintJob(id) {
            PrintJob.mailMerge({printJobId:id}, refreshQueueStats);
        }

        function processPrintJobPrintStreams(demo) {
            PrintJob.collateMerged({demo:demo}, refreshQueueStats);
        }

        function deleteApiAbandoned() {
            PrintJob.deleteApiAbandoned(function(resp) {
                swal("Done.","Delete all API Abandoned Print Jobs","success");
                vm.deletingApiAbandoned = false;
                PrintJob.findApiAbandonedSummary(function(resp) {
                    vm.apiAbandonedCount = resp.count;
                });
            });
            vm.deletingApiAbandoned = true;
        }

        function refreshThreadDumpData () {
            //JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/dashboard/admin-dashboard.modal.html',
                    controller: 'AdminDashboardModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }
                    }
                });
            //});
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sso', {
            parent: 'account',
            url: '/sso?token',
            data: {
                authorities: [],
                pageTitle: 'sso.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sso/sso.html',
                    controller: 'SSOController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sso');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SSOController', SSOController);

    SSOController.$inject = ['$rootScope', '$state', '$stateParams', 'Auth', 'LoginService', '$localStorage'];

    function SSOController ($rootScope, $state, $stateParams, Auth, LoginService, $localStorage) {
        var vm = this;
        Auth.ssoLogin($stateParams.token).then(function(){
            $state.go("template");
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('letterheadBehaviour');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login,
                billingFrequency: account.billingFrequency
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                    swal("Almost there!",
                        "Please check your email and click the Activation Link to complete your registration.",
                        "success");
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();
;
/* globals $ */
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('crm2PrintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;(function(){angular.module("crm2PrintApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/home/about-us.html","<style type=\"text/css\">.header-navbar-fixed #main-container {\n        padding-top: 0;\n    }\n    .nav-users a {\n        padding-left: 30px;\n    }</style><main id=\"main-container\" style=\"min-height: 294px\"><div class=\"bg-primary-dark\"><section class=\"content content-full content-boxed\"><div class=\"push-100-t push-50 text-center\"><h1 class=\"h2 text-white push-10 animated fadeInDown\" data-toggle=\"appear\" data-class=\"animated fadeInDown\">We are passionate people.</h1><h2 class=\"h5 text-white-op animated fadeInDown\" data-toggle=\"appear\" data-class=\"animated fadeInDown\">We are creating products that you\'ll love to use. Let us introduce ourselves.</h2></div></section></div><div class=\"bg-white\"><section class=\"content content-boxed\"><div class=\"row items-push push-20-t nice-copy\"><div class=\"col-md-6\"><h3 class=\"h5 font-w600 text-uppercase push-10\">Who is CRM2Print?</h3><p>In 2016, a crack commando unit was sentenced with fixing direct mail across the globe. These men promptly devised a strategy to fix the problem from the Brisbane underground.</p><!--<h3 class=\"h5 font-w600 text-uppercase push-10\">What can you do for me?</h3>--><p>Today, still wanted by printers and paper suppliers across the globe, they survive as soldiers of fortune, creating a quiet network with CRMs to deploy direct mail right from the desktop.</p><!--<h3 class=\"h5 font-w600 text-uppercase push-10\">What are you currently working on?</h3>--><p>If you have a mail out, if noone wants to stuff envelopes, maybe you can use CRM2Print.com</p></div><div class=\"col-md-6\"><div class=\"block block-transparent\"><div class=\"block-content\"><ul class=\"list list-timeline pull-t\"><li class=\"animated fadeInRight\" data-toggle=\"appear\" data-class=\"animated fadeInRight\"><div class=\"list-timeline-time\">2010</div><i class=\"si si-bulb list-timeline-icon bg-warning\"></i><div class=\"list-timeline-content\"><p class=\"font-w600\">Alphamail</p></div></li><li class=\"animated fadeInRight\" data-toggle=\"appear\" data-timeout=\"100\" data-class=\"animated fadeInRight\"><div class=\"list-timeline-time\">2013</div><i class=\"si si-speedometer list-timeline-icon bg-city\"></i><div class=\"list-timeline-content\"><p class=\"font-w600\">Things are getting busy!</p><p class=\"font-s13\"></p></div></li><li class=\"animated fadeInRight\" data-toggle=\"appear\" data-timeout=\"200\" data-class=\"animated fadeInRight\"><div class=\"list-timeline-time\">2015</div><i class=\"si si-briefcase list-timeline-icon bg-smooth\"></i><div class=\"list-timeline-content\"><p class=\"font-w600\">AlphaMail <a href=\"http://carlquested.com/book-launch/\" target=\"_blank\">book launch</a></p><p class=\"font-s13\">On Stage with Tom Panos</p></div></li><li class=\"animated fadeInRight\" data-toggle=\"appear\" data-timeout=\"300\" data-class=\"animated fadeInRight\"><div class=\"list-timeline-time\">2015</div><i class=\"fa fa-user-plus list-timeline-icon bg-success\"></i><div class=\"list-timeline-content\"><p class=\"font-w600\">Carl, Brett and Daniel meet!</p><ul class=\"nav-users push-10-t push\"><li><a href=\"http://carlquested.com/\" target=\"_blank\">Carl<div class=\"font-w400 text-muted\"><i class=\"fa fa-print text-success\"></i> <small>Printer &amp; Direct Mail Enthusiast</small></div></a></li><li><a href=\"http://www.nexu.com.au\" target=\"_blank\">Brett<div class=\"font-w400 text-muted\"><i class=\"fa fa-facebook text-success\"></i> <i class=\"fa fa-linkedin text-success\"></i> <small>Online Entrepreneur</small></div></a></li><li><a href=\"http://www.nexu.com.au\" target=\"_blank\">Daniel<div class=\"font-w400 text-muted\"><i class=\"fa fa-linux text-success\"></i> <small>Software Developer</small></div></a></li></ul></div></li><li class=\"animated fadeInRight\" data-toggle=\"appear\" data-timeout=\"400\" data-class=\"animated fadeInRight\"><div class=\"list-timeline-time\">2016</div><i class=\"si si-like list-timeline-icon bg-primary\"></i><div class=\"list-timeline-content\"><p class=\"font-w600\">The idea was born for CRM2Print!</p><p class=\"font-s13\">Super excited!</p></div></li><li class=\"animated fadeInRight\" data-toggle=\"appear\" data-timeout=\"400\" data-class=\"animated fadeInRight\"><div class=\"list-timeline-time\">2016</div><i class=\"si si-like list-timeline-icon bg-primary\"></i><div class=\"list-timeline-content\"><p class=\"font-w600\">API gets released</p><p class=\"font-s13\">Transactional and bulk mail integration with <a href=\"https://www.rexsoftware.com/\" target=\"_blank\">REX</a></p></div></li></ul></div></div></div></div></section></div><div class=\"bg-gray-lighter\"><section class=\"content content-full content-boxed\"><div class=\"push-20-t push-20 text-center\"><h3 class=\"h4 push-20 animated fadeIn\" data-toggle=\"appear\">We would love to work together!</h3><a class=\"btn btn-rounded btn-noborder btn-lg btn-success animated bounceIn\" data-toggle=\"appear\" data-class=\"animated bounceIn\" href=\"mailto:support@crm2print.com\">Get In Touch Today</a></div></section></div><div class=\"bg-image\" style=\"background-image: url(\'assets/img/photos/photo6@2x.jpg\')\"><div class=\"bg-primary-dark-op\" style=\"height:100px\"><!--<section class=\"content content-full content-boxed\">\n                <div class=\"row items-push-2x push-50-t text-center\">\n                    <div class=\"col-sm-4 visibility-hidden\" data-toggle=\"appear\" data-offset=\"-150\">\n                        <img class=\"img-avatar img-avatar-thumb\" src=\"assets/img/avatars/avatar5.jpg\" alt=\"\">\n                        <div class=\"h4 text-white-op push-10-t push-5\">Julia Cole</div>\n                        <div class=\"h6 text-gray\">Photographer</div>\n                    </div>\n                    <div class=\"col-sm-4 visibility-hidden\" data-toggle=\"appear\" data-offset=\"-150\" data-timeout=\"150\">\n                        <img class=\"img-avatar img-avatar-thumb\" src=\"assets/img/avatars/avatar13.jpg\" alt=\"\">\n                        <div class=\"h4 text-white-op push-10-t push-5\">Joshua Munoz</div>\n                        <div class=\"h6 text-gray\">Web Designer</div>\n                    </div>\n                </div>\n            </section>--></div></div></main>");
$templateCache.put("app/home/contact-us.html","<style type=\"text/css\">.header-navbar-fixed #main-container {\n        padding-top: 0;\n    }\n    .nav-users a {\n        padding-left: 30px;\n    }</style><main id=\"main-container\" style=\"min-height: 451px\"><div class=\"bg-primary-dark\"><section class=\"content content-full content-boxed\"><div class=\"push-100-t push-50 text-center\"><h1 class=\"h2 text-white push-10 animated fadeInDown\" data-toggle=\"appear\" data-class=\"animated fadeInDown\">Contact Us.</h1><h2 class=\"h5 text-white-op animated fadeInDown\" data-toggle=\"appear\" data-class=\"animated fadeInDown\">Need some advice creating an effective direct mail campaign or just need some help uploading a template? Get in touch today.</h2></div></section></div><div class=\"bg-white\"><section class=\"content content-boxed\"><div class=\"row items-push push-50-t push-30\"><div class=\"col-md-6 col-md-offset-3\"><form class=\"form-horizontal\" ng-submit=\"vm.contactUs()\" method=\"post\"><div class=\"form-group\"><div class=\"col-xs-6\"><div class=\"form-material form-material-primary\"><input class=\"form-control\" type=\"text\" id=\"frontend-contact-firstname\" ng-model=\"vm.message.firstName\" name=\"frontend-contact-firstname\" placeholder=\"Enter your firstname..\"><label for=\"frontend-contact-firstname\">Firstname</label></div></div><div class=\"col-xs-6\"><div class=\"form-material form-material-primary\"><input class=\"form-control\" type=\"text\" id=\"frontend-contact-lastname\" ng-model=\"vm.message.lastName\" name=\"frontend-contact-lastname\" placeholder=\"Enter your lastname..\"><label for=\"frontend-contact-lastname\">Lastname</label></div></div></div><div class=\"form-group\"><div class=\"col-xs-12\"><div class=\"form-material form-material-primary\"><input class=\"form-control\" type=\"email\" id=\"frontend-contact-email\" ng-model=\"vm.message.email\" name=\"frontend-contact-email\" placeholder=\"Enter your email..\"><label for=\"frontend-contact-email\">Email</label></div></div></div><div class=\"form-group\"><div class=\"col-xs-12\"><div class=\"form-material form-material-primary\"><input class=\"form-control\" type=\"tel\" id=\"frontend-contact-phone\" ng-model=\"vm.message.phone\" name=\"frontend-contact-phone\" placeholder=\"Enter your phone..\"><label for=\"frontend-contact-phone\">Phone</label></div></div></div><div class=\"form-group\"><div class=\"col-xs-12\"><div class=\"form-material form-material-primary\"><select class=\"form-control\" id=\"frontend-contact-subject\" ng-model=\"vm.message.subject\" name=\"frontend-contact-subject\" size=\"1\"><option value=\"Support\">Support</option><option value=\"Billing\">Billing</option><option value=\"Integration\">Integration</option><option value=\"Feature Request\">Feature Request</option><option value=\"Other\">Other</option></select><label for=\"frontend-contact-subject\">Subject</label></div></div></div><div class=\"form-group\"><div class=\"col-xs-12\"><div class=\"form-material form-material-primary\"><textarea class=\"form-control\" id=\"frontend-contact-msg\" name=\"frontend-contact-msg\" rows=\"7\" ng-model=\"vm.message.text\" placeholder=\"Enter your message..\"></textarea><label for=\"frontend-contact-msg\">Message</label></div></div></div><div class=\"form-group\"><div class=\"col-xs-12 col-sm-6\"><button class=\"btn btn-block btn-primary\" type=\"submit\"><i class=\"fa fa-send pull-left\"></i> Send Message</button></div><div class=\"col-xs-10 col-sm-6\"><a class=\"btn btn-block btn-success\" href=\"https://calendly.com/crm2print/15min\" target=\"_blank\"><i class=\"fa fa-phone pull-left\"></i> or, book a time to call you</a></div></div></form></div></div></section></div><div class=\"bg-white\" id=\"js-map-contact\" style=\"height: 350px; position: relative; overflow: hidden; transform: translateZ(0px); background-color: rgb(229, 227, 223)\"></div></main>");
$templateCache.put("app/home/home.html","<style type=\"text/css\">.header-navbar-fixed #main-container {padding-left: 0; padding-right: 0; padding-top: 0}\n    .authenticated #main-container {padding-top: 60px}\n    section.content-boxed {\n        position: relative;\n    }\n    #signup-offer { margin-bottom: -60px;}\n    #signup-offer .row {margin:0}\n    #signup-offer .col {padding:0}\n    @media (min-width: 865px) {\n        #signup-offer {\n            width: 235px;\n            position: absolute;\n            right: 0;\n        }\n    }\n    @media (min-width: 990px) {\n        #signup-offer {\n            width: 285px;\n        }\n    }</style><!-- Hero Content --><div class=\"bg-image\" style=\"background-image: url(\'content/images/various/hero1.jpg\')\"><div class=\"bg-primary-dark-op\"><section class=\"content content-full content-boxed overflow-hidden\"><div id=\"signup-offer\"><div class=\"row\"><div class=\"col col-xs-9 text-white\"><b>Download a FREE Copy of Alpha Mail</b><br>Discover how top agents list and sell more property, using direct mail. Signup for free to receive your copy.</div><div class=\"col col-xs-3\"><a href=\"http://carlquested.com/?ref=crm2print\" target=\"_blank\"><img height=\"100\" width=\"76\" src=\"https://storage.googleapis.com/crm2print/public/images/cquested-alpha-mail-cover-web-promo-3dbook100.png\"></a></div></div></div><!-- Section Content --><div class=\"push-100-t push-50 text-center\"><h2 class=\"text-white push-10 visibility-hidden\" data-js-appear data-toggle=\"appear\" data-class=\"animated fadeInDown\"><span translate=\"home.title\">Welcome to <b>CRM2</b>Print!</span> <img src=\"content/images/logos/logo-white-on-transparent-64.png\" width=\"64\" height=\"66\"></h2><h5 class=\"text-white-op push-50 visibility-hidden\" data-js-appear data-toggle=\"appear\" data-class=\"animated fadeInDown\"><span translate=\"home.subtitle\"></span></h5><h3 ng-if=\"utm.source==\'rexsoftware\'\" class=\"text-white-op push-50 visibility-hidden\" data-js-appear data-toggle=\"appear\" data-class=\"animated fadeInDown\">Hello REX User, start sending letters from REX now!</h3><div ng-switch=\"vm.isAuthenticated()\" class=\"visibility-hidden\" data-js-appear><div class=\"alert alert-success\" ng-switch-when=\"true\" translate=\"home.logged.message\" translate-values=\"{username: \'{{vm.account.login}}\'}\">You are logged in as user \"{{vm.account.login}}\".</div><span ng-switch-when=\"false\"><a class=\"btn btn-rounded btn-noborder btn-lg btn-primary\" data-class=\"animated bounceIn\" data-timeout=\"800\" ng-click=\"vm.login()\"><span translate=\"home.login.button\" translate-compile></a></span> <span ng-switch-when=\"false\"><a class=\"btn btn-rounded btn-noborder btn-lg btn-primary push-10-l\" data-class=\"animated bounceIn\" data-timeout=\"800\" ui-sref=\"register\"><span translate=\"home.register.button\" translate-compile></a></span></div></div><div class=\"row visibility-hidden\" data-js-appear data-toggle=\"appear\" data-class=\"animated fadeInUp\"><div class=\"col-sm-8 col-sm-offset-2\"><img class=\"img-responsive pull-b\" src=\"content/images/various/promo-templates.jpg\" alt=\"\"></div></div><!-- END Section Content --></section></div></div><!-- END Hero Content --><!-- Classic Features #1 --><div class=\"bg-white\"><section class=\"content content-boxed\"><!-- Section Content --><div class=\"row\"><div class=\"col-sm-4\"><div class=\"block\"><div class=\"block-content block-content-full ribbon ribbon-modern ribbon-success bg-primary-lighter\"><div class=\"ribbon-box font-w600\">1</div><div class=\"text-center push-20-t push\"><h3 class=\"h4\">Upload Your Direct Mail Template</h3></div></div></div></div><div class=\"col-sm-4\"><div class=\"block\"><div class=\"block-content block-content-full ribbon ribbon-modern ribbon-primary bg-primary-lighter\"><div class=\"ribbon-box font-w600\">2</div><div class=\"text-center push-20-t push\"><h3 class=\"h4\">Select contacts from your CRM</h3></div></div></div></div><div class=\"col-sm-4\"><div class=\"block\"><div class=\"block-content block-content-full ribbon ribbon-modern ribbon-danger bg-primary-lighter\"><div class=\"ribbon-box font-w600\">3</div><div class=\"text-center push-20-t push\"><h3 class=\"h4\">Merge contacts &amp; send to mailhouse</h3></div></div></div></div></div><div class=\"row\"><div class=\"col col-lg-1\"></div><div class=\"col col-xs-6 col-sm-4 col-lg-2 animated fadeInUp\" data-toggle=\"appear\" data-offset=\"50\" data-timeout=\"400\" data-class=\"animated fadeInUp\" ng-repeat=\"userPricing in vm.userPricings\"><a class=\"block block-bordered block-link-hover3 text-center\" ui-sref=\"register\"><div class=\"block-header\"><h3 class=\"block-title\"><span ng-class=\"[{\'text-primary\':userPricing.pageCount == 1}]\">{{::userPricing.pageCount}} {{::userPricing.pageCount > 1 ? \'Pages\' : \'Page\'}}<span style=\"font-size:smaller\">*</span></span></h3></div><div class=\"block-content block-content-full bg-gray-lighter\"><div class=\"h1 font-w700 push-10\"><span ng-class=\"[{\'text-primary\':userPricing.pageCount == 1}]\">{{::userPricing.amount | currency:\"$\":2}}</span></div><div class=\"h5 font-w300 text-muted\">(ex GST)</div></div><div class=\"block-content\" style=\"padding: 15px 0 0px\"><table class=\"table table-borderless table-condensed\"><tbody><!--<tr>\n                                <td><strong>CRM</strong> Integration</td>\n                            </tr>\n                            <tr>\n                                <td><strong>Merge</strong>, Print &amp; Post</td>\n                            </tr>\n                            <tr>\n                                <td><strong>Address</strong> Validation</td>\n                            </tr>\n                            <tr>\n                                <td><strong>Delivery</strong> Notification</td>\n                            </tr>\n                            <tr>\n                                <td><strong>Return to Sender</strong> Service</td>\n                            </tr>--><!--<tr ng-show=\"userPricing.duplexPrice\">\n                                <td><strong>{{::userPricing.duplexPrice | currency:\"$\":2}}</strong> Double sided*</td>\n                            </tr>--><tr ng-show=\"userPricing.pageCount > 5\"><td>Duplex only</td></tr></tbody></table></div><!--<div class=\"block-content block-content-mini block-content-full bg-gray-lighter\">\n                        <span class=\"btn btn-default\">Sign Up</span>\n                    </div>--></a></div></div><div class=\"row\"><div class=\"col col-xs-12 text-center\">*Prices shown are for mail printed &amp; posted in Australia. Please <a ui-sref=\"contact-us\">contact us</a> for direct mail prices in New Zealand.<br>All include: CRM Integration, Merge, Print &amp; Post<!--, Address Validation-->, Delivery Notification, and Return to Sender Service<br>Prices may vary for transactional mail (single letters) submitted through partner CRMs. Please check the pricing provided by the CRM.</div></div><div class=\"row items-push-3x push-50-t nice-copy text-center\"><iframe src=\"https://player.vimeo.com/video/173006162?title=0&byline=0&portrait=0\" width=\"640\" height=\"360\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div><div class=\"row items-push-3x push-50-t nice-copy\"><div class=\"col-sm-4\"><div class=\"text-center push-30\"><span class=\"item item-2x item-circle border\"><i class=\"si si-link\"></i></span></div><h3 class=\"h5 font-w600 text-uppercase text-center push-10\">CRM Integrated</h3><p>CRM2PRINT provides users of various CRM (customer relationship management) systems the ability to fully automate their direct communication with their customers.</p></div><div class=\"col-sm-4\"><div class=\"text-center push\"><span class=\"item item-2x item-circle border\"><i class=\"si si-printer\"></i> <i class=\"si si-envelope\"></i></span></div><h3 class=\"h5 font-w600 text-uppercase text-center push-10\">Mail House</h3><p>Many CRMs have provided the ability to communicate via email and SMS, but until now, the task of actually sending one client, or many, a physical letter was a laborious process.</p></div><div class=\"col-sm-4\"><div class=\"text-center push\"><span class=\"item item-2x item-circle border\"><i class=\"si si-clock\"></i></span></div><h3 class=\"h5 font-w600 text-uppercase text-center push-10\">Save time</h3><p>It usually involves downloading a template, perhaps exporting your database or segment, then the time consuming task of printing, folding, enveloping and getting the letters in the mail.</p></div></div><div class=\"row items-push-3x nice-copy\"><div class=\"col-sm-4\"><div class=\"text-center push\"><span class=\"item item-2x item-circle border\"><i class=\"si si-envelope-letter\"></i></span></div><h3 class=\"h5 font-w600 text-uppercase text-center push-10\">Higher Open Rates</h3><p>With more and more SPAM filters affecting the delivery and open rates of email, direct mail provides a way to cut through all of the noise, and allow the recipient to digest the information in their own time. Plus direct mail is kept around longer.</p></div><div class=\"col-sm-4\"><div class=\"text-center push\"><span class=\"item item-2x item-circle border\"><i class=\"si si-rocket\"></i></span></div><h3 class=\"h5 font-w600 text-uppercase text-center push-10\">Powerful</h3><p>And now, thanks to CRM2PRINT, you can automate your letters just like you do your emails. Our simple 3 step process, which is fully integrated in the CRM, gives you the power to send 1 or 10,000 letters with the click of a button.</p></div><div class=\"col-sm-4\"><div class=\"text-center push\"><span class=\"item item-2x item-circle border\"><a href=\"http://carlquested.com/?ref=crm2print\" target=\"_blank\"><img height=\"100\" width=\"76\" src=\"https://storage.googleapis.com/crm2print/public/images/cquested-alpha-mail-cover-web-promo-3dbook100.png\"></a></span></div><h3 class=\"h5 font-w600 text-uppercase text-center push-10\">FREE* Copy of Alpha Mail</h3><p>Discover how top agents list and sell more property, using direct mail. Signup for free to receive your copy.</p></div></div><!-- END Section Content --></section></div><!-- END Classic Features #1 --><!-- Mini Stats --><div class=\"bg-gray-lighter\"><section class=\"content content-boxed\"><!-- Section Content --><div class=\"row items-push push-20-t push-20 text-center\"><div class=\"col-sm-4\"><div class=\"h1 push-5\" data-toggle=\"countTo\" data-js-count-to data-to=\"15760\" data-after=\"+\"></div><div class=\"font-w600 text-uppercase text-muted\">Letters Today</div></div><div class=\"col-sm-4\"><div class=\"h1 push-5\" data-toggle=\"countTo\" data-js-count-to data-to=\"3890\" data-after=\"+\"></div><div class=\"font-w600 text-uppercase text-muted\">Templates</div></div><div class=\"col-sm-4\"><div class=\"h1 push-5\" data-toggle=\"countTo\" data-js-count-to data-to=\"205\" data-after=\"+\"></div><div class=\"font-w600 text-uppercase text-muted\">Users</div></div></div><!-- END Section Content --></section></div><!-- END Mini Stats --><!-- Classic Features #2 --><div class=\"bg-white\"><section class=\"content content-boxed\"><!-- Section Content --><div class=\"row items-push-3x push-50-t nice-copy\"><div class=\"col-sm-4\"><div class=\"text-center push-30\"><span class=\"item item-2x item-circle border\"><i class=\"si si-printer\"></i></span></div><h3 class=\"h5 font-w600 text-uppercase text-center push-10\">Dispatch</h3><p>Your letters are then dispatched to our facility, where they will be printed on production quality printers and in the post within 2 business days.</p></div><div class=\"col-sm-4\"><div class=\"text-center push\"><span class=\"item item-2x item-circle border\">$</span></div><h3 class=\"h5 font-w600 text-uppercase text-center push-10\">Cost</h3><p>And the cost? About the same, if not cheaper than you doing it yourself - just without all the hassle and wasted time.</p></div><div class=\"col-sm-4\"><div class=\"text-center push\"><span class=\"item item-2x item-circle border\"><i class=\"si si-call-out\"></i></span></div><h3 class=\"h5 font-w600 text-uppercase text-center push-10\">Call Us Today</h3><p>So if you value your time, and you value the relationship with your clients, give CRM2PRINT a call today.</p></div></div><!-- END Section Content --></section></div><!-- END Classic Features #2 --><!-- Ratings --><div class=\"bg-image\" style=\"background-image: url(\'content/images/photos/photo3@2x.jpg\')\"><div class=\"bg-primary-dark-op\"><section class=\"content content-full content-boxed\"><!-- Section Content --><div class=\"row items-push-2x push-50-t text-center\"><div class=\"col-sm-4 visibility-hidden\" data-js-appear data-toggle=\"appear\" data-offset=\"-150\"><img class=\"img-avatar img-avatar-thumb\" src=\"content/images/avatars/avatar10.jpg\" alt=\"\"><div class=\"text-warning push-10-t push-15\"><i class=\"fa fa-fw fa-star\"></i> <i class=\"fa fa-fw fa-star\"></i> <i class=\"fa fa-fw fa-star\"></i> <i class=\"fa fa-fw fa-star\"></i> <i class=\"fa fa-fw fa-star\"></i></div><div class=\"h4 text-white-op push-5\">Finally! Someone who knows what they are talking about has finally written a direct mail book [alphamail] SPECIFICALLY for real estate agents! A fabulous idea filled read and very inspirational Well Done!</div><div class=\"h6 text-gray\">- <a href=\"http://www.topagentsplaybook.com/\" target=\"_blank\">Ray Wood</a></div></div><div class=\"col-sm-4 visibility-hidden\" data-js-appear data-toggle=\"appear\" data-offset=\"-150\" data-timeout=\"150\"><img class=\"img-avatar img-avatar-thumb\" src=\"content/images/avatars/avatar10.jpg\" alt=\"\"><div class=\"text-warning push-10-t push-15\"><i class=\"fa fa-fw fa-star\"></i> <i class=\"fa fa-fw fa-star\"></i> <i class=\"fa fa-fw fa-star\"></i> <i class=\"fa fa-fw fa-star\"></i> <i class=\"fa fa-fw fa-star\"></i></div><div class=\"h4 text-white-op push-5\">Great insights into Direct Mail - What a great book not just for real estate agents but for anyone who wants to consider the power of traditional mail in their business. Great title too!</div><div class=\"h6 text-gray\">- <a href=\"https://www.amazon.com.au/gp/aw/cr/B00PF3KO6C\" target=\"_blank\">Amazon.com Reviewer</a></div></div><div class=\"col-sm-4 visibility-hidden\" data-js-appear data-toggle=\"appear\" data-offset=\"-150\" data-timeout=\"300\"><img class=\"img-avatar img-avatar-thumb\" src=\"content/images/avatars/avatar10.jpg\" alt=\"\"><div class=\"text-warning push-10-t push-15\"><i class=\"fa fa-fw fa-star\"></i> <i class=\"fa fa-fw fa-star\"></i> <i class=\"fa fa-fw fa-star\"></i> <i class=\"fa fa-fw fa-star\"></i> <i class=\"fa fa-fw fa-star\"></i></div><div class=\"h4 text-white-op push-5\">Simple, smart, and actionable</div><div class=\"h6 text-gray\">- <a href=\"https://www.amazon.com.au/gp/aw/cr/B00PF3KO6C\" target=\"_blank\">Amazon.com Reviewer</a></div></div></div><!-- END Section Content --></section></div></div><!-- END Ratings --><!-- END Get Started --><div class=\"bg-gray-lighter\"><section class=\"content content-full content-boxed\"><div class=\"push-20-t push-20 text-center\"><h3 class=\"h4 push-20 animated fadeIn\" data-toggle=\"appear\">Your letters printed, folded and mailed without leaving your chair.</h3><a class=\"btn btn-rounded btn-noborder btn-lg btn-success animated bounceIn\" data-toggle=\"appear\" data-class=\"animated bounceIn\" ui-sref=\"register\">Get Started Today</a></div></section></div><footer id=\"page-footer\" class=\"bg-white\"><div class=\"content content-boxed\"><div class=\"row push-30-t items-push-2x\"><div class=\"col-sm-4\"><h3 class=\"h5 font-w600 text-uppercase push-20\">Company</h3><ul class=\"list list-simple-mini font-s13\"><li><a class=\"font-w600\" href=\"/\">Home</a></li><!--<li>\n                        <a class=\"font-w600\" href=\"frontend_features.php\">Features</a>\n                    </li>\n                    <li>\n                        <a class=\"font-w600\" href=\"frontend_pricing.php\">Pricing</a>\n                    </li>--><li><a class=\"font-w600\" ui-sref=\"about-us\">About Us</a></li><li><a class=\"font-w600\" ui-sref=\"contact-us\">Contact Us</a></li></ul></div><div class=\"col-sm-4\"><h3 class=\"h5 font-w600 text-uppercase push-20\">Support</h3><ul class=\"list list-simple-mini font-s13\"><li ng-hide=\"vm.isAuthenticated()\"><a class=\"font-w600\" href=\"#\" ng-click=\"vm.login()\">Log In</a></li><li ng-hide=\"vm.isAuthenticated()\"><a class=\"font-w600\" ui-sref=\"register\">Sign Up</a></li><li><a class=\"font-w600\" data-ui-sref=\"faq\">Support Center</a></li><li><a class=\"font-w600\" ui-sref=\"privacy\">Privacy Policy</a></li><li><a class=\"font-w600\" ui-sref=\"terms\">Terms &amp; Conditions</a></li></ul></div><div class=\"col-sm-4\"><h3 class=\"h5 font-w600 text-uppercase push-20\">Get In Touch</h3><div class=\"font-s13 push\"><strong>CRM2Print Pty. Ltd.</strong><br><!--8/349 Macdonnell Road<br>\n                    CLONTARF QLD 4019<br>--> <abbr title=\"Phone\">P:</abbr> <a href=\"tel:0720004455\">(07) 2000 4455</a></div><div class=\"font-s13\"><i class=\"si si-envelope-open\"></i> <a href=\"mailto:sales@crm2print.com\">sales@crm2print.com</a></div></div></div></div></footer>");
$templateCache.put("app/home/privacy.html","<style type=\"text/css\">.header-navbar-fixed #main-container {\n        padding-top: 0;\n    }</style><div class=\"bg-primary-dark\"><section class=\"content content-full content-boxed\"><div class=\"push-100-t push-50 text-center\"><h1 class=\"h2 text-white push-10 animated fadeInDown\" data-toggle=\"appear\" data-class=\"animated fadeInDown\">Privacy Policy</h1></div></section></div><div class=\"bg-white\"><section class=\"content content-full content-boxed\"><div class=\"row push-20-t push-20\"><p style=\"margin-bottom: 0in\">This privacy policy outlines how CRM2Print Pty Ltd&nbsp;(‘CRM2Print’,’us’, ‘we’, ‘Company’) collect, hold, use, disclose and otherwise manage your personal information and comply with our obligations under the Privacy Act 1988 (Cth). It applies to all of your dealings with us.</p><p><b>How We Collect Your Personal Information</b></p><p>All personal data is collected for CRM2Print and only shared with CRM2Print group of companies.</p><p>CRM2Print collect your personal information for the following main purposes:</p><p>to keep clients and contacts informed of current products and services we offer;<br>to maintain contact with clients;<br>to notify contacts and clients of events, products and services;<br>to manage and administer the products and services we offer;<br>to improve our websites to provide you with a personalised experience; and<br>to provide you with information about other products and services we offer that may be relevant to you.</p><p>We may collect your personal information via a number of methods. These include in person at a meeting or seminar, when you register for e-newsletters, fill out a form, or correspond with us via our website, email or by telephone.</p><p>On occasion it may be necessary for us to collect your personal information from a publicly available source. We will only do so where you have consented, you would reasonably expect us to do so, or if it is necessary for us to perform a specific</p><p><b>Personal Information Collected</b></p><p>Generally the personal information we collect consists of your full name and contact details. This may include postal and email address, phone and mobile number and business contact details. Where relevant we may ask you for other information. To deliver our more complex services, it may be necessary to collect information including employment status, income, dependencies and asset and liability information.</p><p>We may collect personal information such as your IP address and web activity through third party companies such as Pardot, Facebook Google Analytics and Google Analytics if you interact with us over the internet.</p><p>Usually we will not collect sensitive information (e.g. data relating to professional memberships, race or ethnic origin, religious beliefs, political opinions, criminal record, physical or mental health, or sexual orientation) from you. We may do so only if it is reasonably necessary for one or more of our functions and you explicitly consent beforehand.</p><p><b>How We Use Your Personal Information</b></p><p>We use your personal information to perform our services, respond to your requests and provide you with information about the Company.</p><p>We may disclose your personal information to third parties who assist us to provide the products and services you request. With your verbal or written consent, we may use or disclose your personal information to the following third parties:</p><p>those that provide, manage or administer our product or service to you;</p><p>those involved in developments;</p><p>your referral introducer; and/or</p><p>those required or authorised by law, for example, government or regulatory bodies for purposes related to public health or safety, the prevention or detection of unlawful activities or to protect public revenue.</p><p>We require third parties to protect your information in a manner consistent with this policy and the Privacy Act 1988 (Cth). We will never sell your personal information.</p><p>We will take reasonable steps to ensure that the information remains secure and is used in a manner consistent with this policy and our obligations under the Privacy Act 1988 (Cth).</p><p>If personal information is not able to be collected, this may impact the level of service The Company is able to provide.</p><p>We may use your personal information to market our services, including by phone, email or SMS. If at any stage you no longer wish to receive this marketing, please send an email to admin@agentinsight.com.au with your full name, postcode, mobile number and the communication mediums you wish to unsubscribe from. We will endeavour to process your request within 21 days.</p><p>We will hold your personal information for such time as required to fulfil the purposes for which it was collected, or as required by law.</p><p><b>Security of Your Personal Information</b></p><p>We take the security of your personal information very seriously. We will take reasonable commercial measures to protect your personal information from misuse, interference, loss, unauthorised access, modification or disclosure. Your information may be kept in electronic form or hard copy.</p><p>We implement a number of processes to ensure your personal information is safeguarded. Our processes include the following:</p><p>information storage security policies;<br>security measures for systems access;<br>providing discreet meeting areas for confidential discussions;<br>accessed control for our Customer Relationship Management systems; and<br>secure web forms when collecting sensitive information.</p><p>We take reasonable care to ensure any personal information you provide us via our website is protected. For example, if we require your sensitive information our websites have electronic security systems in place which include data encryption.</p><p>Depending on your involvement with our Company and the type of information collected, user identifiers, passwords or other access codes may also be used to control access to your personal information.</p><p><b>Data Usage</b></p><p>Users of our data in Australia should be aware that residential/private individuals who have signed up to the “Do Not Call Register” cannot be called for telemarketing purposes only under special circumstances – for more information see https://www.donotcall.gov.au/</p><p>In additions Under the Spam Act 2003 it is illegal to send, or cause to be sent, unsolicited commercial electronic messages. The Act covers email, instant messaging, SMS and MMS (text and image-based mobile phone messaging) of a commercial nature. It does not cover faxes, internet pop-ups or voice telemarketing. https://www.comlaw.gov.au/Series/C2004A01214</p><p><b>Use of Cookies</b></p><p>You are not required to provide us with any personal information as a visitor to our website. You may choose to remain anonymous or to provide us with a pseudonym if you do not wish to reveal your identity. However, please be aware that if this is impractical we may be unable to provide you with proper services.</p><p>We use cookies on our website. These are small text files that are placed on your computer when you visit our website that provide us with information such as internet provider, date and time, search phrases, or referring websites. This information is not initially personally identifiable. However it is likely to be once you provide us with your personal information. Cookies assist us to monitor traffic to the various pages on our website. This enables us to create a customised user experience.</p><p>Most browsers are programmed to accept cookies. If you wish to erase or block Cookies, you may be able to do this by changing the settings of your browser.</p><p><b>Sharing Your Content and Information</b></p><p>CRM2Print communicates with clients by social media, forums and other interactive platforms. Any personal information you disclose on these sites may be read, collected and used by other users over whom we have no control.</p><p>CRM2Print are not responsible for any use, misuse or misappropriation by other users of any personal information that you contribute in this manner. Our website may include links to third party websites. If you access those websites you will be subject to their privacy policy, the terms and conditions of which may differ from our own. You will need to contact or examine those websites or companies directly to determine their privacy standards, policies and procedures.</p><p>Any information you disclose on the CRM2Print App may be read, collected and used by other users of the App over whom we have no control. For content that is covered by intellectual property rights, like your business data, company logo, photos and videos (IP), you specifically give us the following permission: you grant us a non-exclusive, transferable, sub-licensable, royalty-free, worldwide license to use any IP that you post on or in connection with the CRM2Print Software (Content License). This Content License will apply at all times both during and after the termination of your subscription licence.</p><p><b>Access to Your Personal Information</b></p><p>To request access to your personal information, please email CRM2Print. In certain circumstances we may be able to deal with your request over the telephone or in person. Otherwise we will endeavour to process your request within 21 days. In some circumstances we may refuse to give you access. We will explain why if that is the case (e.g. it may unreasonably affect the privacy of others).</p><p>We take reasonable steps to ensure that the personal information we collect and store is accurate, up-to-date and complete. Should you wish to access your personal information to ensure it is accurate, up-to-date, complete, relevant and not misleading, and if not, to correct it, please email CRM2Print.</p><p><b>Opting Out</b></p><p>If you wish to Opt Out from receiving communications from CRM2Print send your request to our Privacy Officer by emailing admin@agentinsight.com.au or in writing.<br>If you prefer to be removed from the CRM2Print database, send your request to our Privacy Officer by email admin@agentinsight.com.au or in writing.<br>You will be removed from our database in 20 working days from receiving the removal request.<br>No fee applies to any of the above requests.</p><p><b>Complaints</b></p><p>If you believe we have breached an Australian Privacy Principle or registered Australian Privacy Principle code and would like to make a complaint, you can do so in writing by emailing or writing to CRM2Print. We will endeavour to respond to your complaint within 30 days.</p><p>You may direct any subsequent complaints to the Office of the Australian Information Commissioner (OAIC) at http://www.oaic.gov.au/privacy/making-a-privacy-complaint.</p><p><b>How to Contact Us</b></p><p>We are committed to respecting your right to privacy and protecting your personal information. You may request further information about the way we manage your personal information by contacting CRM2Print.</p><p style=\"margin-bottom: 0in; background: #ffffff\"><span style=\"color: #646464\"><b>CRM2Print Pty. Ltd.</b></span><!--<span style=\"color: #646464\"><BR>8/349 Macdonnell Road<BR>CLONTARF QLD 4019<BR></span>--> P:&nbsp;<a href=\"tel:0720004455\" style=\"color:#5c90d2\"><u>(07) 2000 4455</u></a></p><p style=\"margin-bottom: 0in; background: #ffffff\"><a href=\"mailto:support@crm2print.com\" style=\"color:#5c90d2\"><u>support@crm2print.com</u></a></p><p lang=\"en-AU\"><br><br></p><p><a name=\"_GoBack\"></a>You will always be able to access a current version of our privacy policy on our website. Occasionally it will be necessary for us to update our privacy policy.</p></div></section></div><div class=\"bg-gray-lighter\"><section class=\"content content-full content-boxed\"><div class=\"push-20-t push-20 text-center\"><a class=\"btn btn-rounded btn-noborder btn-lg btn-success animated bounceIn\" data-toggle=\"appear\" data-class=\"animated bounceIn\" href=\"mailto:support@crm2print.com\">Contact Us</a></div></section></div>");
$templateCache.put("app/home/terms.html","<style type=\"text/css\">.header-navbar-fixed #main-container {\n        padding-top: 0;\n    }</style><div class=\"bg-primary-dark\"><section class=\"content content-full content-boxed\"><div class=\"push-100-t push-50 text-center\"><h1 class=\"h2 text-white push-10 animated fadeInDown\" data-toggle=\"appear\" data-class=\"animated fadeInDown\">Terms &amp; Conditions</h1></div></section></div><div class=\"bg-white\"><section class=\"content content-full content-boxed\"><div class=\"row push-20-t push-20\"><h5 class=\"western\" style=\"margin-top: 0.13in; margin-bottom: 0.13in; background: #ffffff; line-height: 0.2in\"><font color=\"#000000\"><b>1. BINDING TERMS</b></font></h5><p>1.1 This Website is operated by CRM2Print Pty Ltd trading as CRM2Print Pty Ltd (“CRM2Print”, “C2P”, “Our”, “Us” or “We”).</p><p>1.2 By using this Website you agree to be bound by an agreement created between you and Us under these Website Terms of Use. If you do not agree to these Website Terms of Use, please do not use this Website or any information derived as a result of the use of this Website.</p><p>1.3 In this Agreement the following terms shall have the meanings respectively ascribed to them:</p><p>a) The ‘Customer’; shall mean the person whose name and address appears on the web form;</p><p>b) ‘CRM2Print’ shall mean the Australian based business CRM2Print PTY LTD</p><p>d) ‘Services’ means the provision of customer data and delivery of mail</p><h3><span style=\"font-weight: normal\">2. Purpose of the Agreement</span></h3><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\">The Customer hereby requests CRM2Print to make the various Services specified, available to the Customer. Payment by the Customer to access the Service(s) specified are subject to these Terms and Conditions and subject further to all Conditions which CRM2Print may publish from time to time and provide to the Customer respecting CRM2Print, Services.</p><h3><span style=\"font-weight: normal\">3. Terms of Services</span></h3><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\">All information, whether printed, written or oral, incorporated in the publications or<br>a) in any other document delivered to the customer pursuant to the service(s) or submitted in answer to a regular or special enquiry or voluntarily furnished to the customer by CRM2Print is for the exclusive use of the customer as one factor in the customer’s marketing and other business decisions and for no other purpose. Such information shall be held in strict confidence. It is expressly agreed that the customer shall neither request information for the use of others nor permit requests to be made under this service agreement by others.<br>b) The service(s) comes into effect immediately upon the customer making the first payment for the Services and remains in effect until termi&shy;nated as specified herein.<br>c) By agreeing to these Terms &amp; Conditions, you hereby acknowledge that you will be utilizing CRM2Print for business purposes.<br><br><br></p><h3><span style=\"font-weight: normal\">4. Payments &amp; Charges</span></h3><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\">a) The Customer will pay the company for the Services on the order date.<br>b) Claims for credit must be made in writing to CRM2Print within 14 days from the date upon which the cause of the claim first arises.</p><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\">a) The Customer will pay the company for the Services on the order date.<br>b) No claims for credit are available, for printing and postage charges incurred by CRM2Print</p><h3><span style=\"font-weight: normal\">5. Services</span></h3><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\">CRM2Print reserves the right to add or withdraw any of its Services, and modify or otherwise improve CRM2Print, Services without notice. CRM2Print reserves the right to change any and all Service rates, documentation prices, fees and any other prices or other conditions of supply respecting CRM2Print, Services at any time and all such changes shall be effective immediately. However CRM2Print will use its best efforts to provide thirty (30) days notice in advance of the effective date of such changes.</p><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\"><br>5.1 Delivery of Services<br>The Services are provided immediately after a Customer makes a purchase</p><h3><span style=\"font-weight: normal\">6. Copyright</span></h3><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\">a) It is recognised that all data and information provided through CRM2Print and the formats thereof, will be subject to the copyright and other property rights of CRM2Print and/or the respective Database Providers. The Customer shall not commit or permit any act of omission or commission by its agents, employees or any third party which will impair the copyright or other proprietary rights to the data, information and formats.<br>b) The Customer shall not disclose, transfer, duplicate, reproduce, retain for a purpose other than that for which it was first acquired, sell or reuse any information supplied by CRM2Print regardless of the form in which that information was supplied and, in particular, without limiting the generality of the foregoing, shall not do any of those acts with respect to information contained in hardcopy or any storage media, of whatever type, nature and description.<br>c) Without limiting the generality of the sub-clause 6 (b), no information supplied by CRM2Print will be copied or transferred to another file; where access to CRM2Print, Services permits the Customer to print data in machine readable form (using commands designated for this purpose) the Customer agrees:<br>i)Not to transfer, retransmit, duplicate or resell any items from the database to any third party without prior written approval of CRM2Print.<br>ii)Not to use these items from CRM2Print, Services to combine with any other information with the object of offering it on-line or in any other way to third par&shy;ties without prior written approval of CRM2Print.</p><h3><span style=\"font-weight: normal\">7. Warranty</span></h3><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\">All terms, conditions, representations, warranties, guarantees and indemnities (hereinafter “State&shy;ments”), not expressly contained herein, whether arising by operation of law or otherwise, are hereby expressly excluded to the maximum extent permitted by law and, in particular, but in no way limiting the generality of the foregoing, CRM2Print makes no Statement as to the completeness or accuracy of the data comprised in CRM2Print, Services or as to its fitness for use for any unknown purpose.<br>Any links on this website to other websites are for your convenience only. The links do not indicate that CRM2Print endorses the material on, or is associated with, those websites.</p><h3><span style=\"font-weight: normal\">8. Liability</span></h3><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\">a) CRM2Print shall not be liable to the Customer for any loss of profit, or earning, any damage or goodwill suffered by any person arising directly or indirectly out of its provision of CRM2Print, Services whether in accordance with these terms or otherwise and whether caused by negligence of CRM2Print its servants or agents or from any other cause.<br>b) CRM2Print liability of any nature or kind (including, without limitation, negligence) with respect to the subject of this agreement, or for non-compliance with or breach of any Statement which cannot be excluded by agreement, is limited to providing the service in respect of which the breach or non-compliance arose, or, at CRM2Print option, to the cost of having that service provided.</p><h3><span style=\"font-weight: normal\">9. Indemnity</span></h3><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\">The Customer shall indemnify and hold CRM2Print and its officers and employees harmless from and against any loss, claim, demand, expense (including legal fees) arising out of the Customer’s use of CRM2Print. The obligations imposed by this clause are owned jointly and severally to CRM2Print and to its employees.</p><h3><span style=\"font-weight: normal\">10. Default</span></h3><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\">If there is a breach of any of these terms then:<br>a) All monies payable by the Customer to CRM2Print will at CRM2Print’ election become immediately due and payable notwithstanding that the specified period for payment may not yet have expired;<br>b) Any credit facilities may be withdrawn by CRM2Print;<br>c) Claims for credit must be made in writing to CRM2Print within 14 days from the date upon which the cause of the claim first arises.<br>d) CRM2Print may withhold the delivery of Services already ordered by the Customer and is at liberty to suspend the Services to be provided to the Customer pursuant to this Agreement should the Customer default on any term of this agreement;<br>e) In the event of a suspension of a Customer’s account CRM2Print is not liable to refund any monies or credit the Customer’s account with respect to the time the Customer remains in breach of the Agreement for the Services that ought to have been provided had the Customer not been in breach of the Agreement;<br>f) That CRM2Print may list the Customer with any credit rating authority it so chooses and will only remove such a listing when the Customer remedies its breach of the Agreement pursuant to the terms of the same.<br>g) CRM2Print may charge interest on the overdue amount at 20% per annum rate calculated daily on the amount overdue until payment in full; and<br>h) CRM2Print may charge to the Customer all monies, costs, charges and expenses (including legal costs on an indemnity basis) of any attempt made by or on behalf of CRM2Print to recover payment of any monies owing by the Customer to CRM2Print or to secure any indebtedness or liability by the Customer to CRM2Print notwithstanding that no demand has been made by CRM2Print for payment by the Customer.</p><h3><span style=\"font-weight: normal\">11. Acceptance of Terms</span></h3><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\">These terms are not binding upon CRM2Print until the payment for Services is completed by the Customer. CRM2Print hereby reserves the right to terminate Service(s) upon fourteen (14) days written notice, with or without reason, in which event it shall be obliged to refund at any time, the unearned portion of any consideration paid by the customer.</p><h3><span style=\"font-weight: normal\">12. Customer Warranty and Indemnity</span></h3><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\">The Customer warrants with respect to the information supplied that all requirements of the Privacy Act as to content security, access, disclosure and use, have or will be complied with in full.</p><h3><span style=\"font-weight: normal\">13. CRM2Print Privacy Statement</span></h3><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\">CRM2Print is bound by the National Privacy Principles under the Privacy Act 1988 (Cth) and the Privacy and Personal Information Protection Act 1998 (NSW). CRM2Print has the following policies in relation to Privacy Principles:<br>Collection – We will not store personal information unless it is necessary for one or more of our functions or activities. The information will be collected lawfully and fairly, and not in an unreasonably intrusive way.<br>Data Security – We use industry standard security and encryption to protect all data including the personal information we hold from misuse and loss, and from unauthorised access, modification or disclosure.</p><h3><span style=\"font-weight: normal\">14. Laws to Govern</span></h3><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\">Unless varied by notice by CRM2Print that these terms and all matters arising from the relationship of CRM2Print and the Customer will be interpreted and governed in accordance with the laws of the State of Queensland notwithstanding that the goods and services may be delivered outside the state of Queensland. The Customer submits to the exclusive jurisdiction of the Brisbane District Court or such other capital city in any other state that CRM2Print may from time to time notify the Customer in writing of.</p><h3><span style=\"font-weight: normal\">15. Refund Policy</span></h3><p lang=\"en-AU\" style=\"margin-top: 0.19in; margin-bottom: 0.19in\"><a name=\"_GoBack\"></a> The Customer has 14 days to dispute an order if they believe the Services promoted on this website are different to Services provided. The Customer may contact CRM2Print by phone to dispute the Service and claim a refund. No claims for credit are available, for printing and postage charges incurred by CRM2Print. In the event a refund is approved by CRM2Print, the credit card used by the Customer for the Service, will be credited for the same amount as the original amount charged.</p></div></section></div><div class=\"bg-gray-lighter\"><section class=\"content content-full content-boxed\"><div class=\"push-20-t push-20 text-center\"><a class=\"btn btn-rounded btn-noborder btn-lg btn-success animated bounceIn\" data-toggle=\"appear\" data-class=\"animated bounceIn\" href=\"mailto:support@crm2print.com\">Contact Us</a></div></section></div>");
$templateCache.put("app/swagger-ui/index.html","<!DOCTYPE html><html><head><meta charset=\"UTF-8\"><title>Swagger UI</title><link rel=\"icon\" type=\"image/png\" href=\"images/favicon-32x32.png\" sizes=\"32x32\"><link rel=\"icon\" type=\"image/png\" href=\"images/favicon-16x16.png\" sizes=\"16x16\"><link href=\"../../bower_components/swagger-ui/dist/css/typography.css\" media=\"screen\" rel=\"stylesheet\" type=\"text/css\"><link href=\"../../bower_components/swagger-ui/dist/css/reset.css\" media=\"screen\" rel=\"stylesheet\" type=\"text/css\"><link href=\"../../bower_components/swagger-ui/dist/css/screen.css\" media=\"screen\" rel=\"stylesheet\" type=\"text/css\"><link href=\"../../bower_components/swagger-ui/dist/css/reset.css\" media=\"print\" rel=\"stylesheet\" type=\"text/css\"><link href=\"../../bower_components/swagger-ui/dist/css/print.css\" media=\"print\" rel=\"stylesheet\" type=\"text/css\"><script src=\"../../bower_components/swagger-ui/dist/lib/jquery-1.8.0.min.js\" type=\"text/javascript\"></script><script src=\"../../bower_components/swagger-ui/dist/lib/jquery.slideto.min.js\" type=\"text/javascript\"></script><script src=\"../../bower_components/swagger-ui/dist/lib/jquery.wiggle.min.js\" type=\"text/javascript\"></script><script src=\"../../bower_components/swagger-ui/dist/lib/jquery.ba-bbq.min.js\" type=\"text/javascript\"></script><script src=\"../../bower_components/swagger-ui/dist/lib/handlebars-2.0.0.js\" type=\"text/javascript\"></script><script src=\"../../bower_components/swagger-ui/dist/lib/underscore-min.js\" type=\"text/javascript\"></script><script src=\"../../bower_components/swagger-ui/dist/lib/backbone-min.js\" type=\"text/javascript\"></script><script src=\"../../bower_components/swagger-ui/dist/swagger-ui.js\" type=\"text/javascript\"></script><script src=\"../../bower_components/swagger-ui/dist/lib/highlight.7.3.pack.js\" type=\"text/javascript\"></script><script src=\"../../bower_components/swagger-ui/dist/lib/jsoneditor.min.js\" type=\"text/javascript\"></script><script src=\"../../bower_components/swagger-ui/dist/lib/marked.js\" type=\"text/javascript\"></script><script src=\"../../bower_components/swagger-ui/dist/lib/swagger-oauth.js\" type=\"text/javascript\"></script><!-- Some basic translations --><!-- <script src=\'lang/translator.js\' type=\'text/javascript\'></script> --><!-- <script src=\'lang/ru.js\' type=\'text/javascript\'></script> --><!-- <script src=\'lang/en.js\' type=\'text/javascript\'></script> --><script type=\"text/javascript\">$(function() {\n            var springfox = {\n                \"baseUrl\": function() {\n                    var urlMatches = /(.*)\\/swagger-ui\\/index.html.*/.exec(window.location.href);\n                    return urlMatches[1]+\"/..\";\n                },\n                \"securityConfig\": function(cb) {\n                    $.getJSON(this.baseUrl() + \"/configuration/security\", function(data) {\n                        cb(data);\n                    });\n                },\n                \"uiConfig\": function(cb) {\n                    $.getJSON(this.baseUrl() + \"/configuration/ui\", function(data) {\n                        cb(data);\n                    });\n                }\n            };\n            window.springfox = springfox;\n            window.oAuthRedirectUrl = springfox.baseUrl() + \'../bower_components/swagger-ui/dist/o2c.html\'\n\n            window.springfox.uiConfig(function(data) {\n                window.swaggerUi = new SwaggerUi({\n                    dom_id: \"swagger-ui-container\",\n                    validatorUrl: data.validatorUrl,\n                    supportedSubmitMethods: [\'get\', \'post\', \'put\', \'delete\', \'patch\'],\n                    onComplete: function(swaggerApi, swaggerUi) {\n                        initializeSpringfox();\n                        if (window.SwaggerTranslator) {\n                            window.SwaggerTranslator.translate();\n                        }\n                        $(\'pre code\').each(function(i, e) {\n                            hljs.highlightBlock(e)\n                        });\n                    },\n                    onFailure: function(data) {\n                        log(\"Unable to Load SwaggerUI\");\n                    },\n                    docExpansion: \"none\",\n                    apisSorter: \"alpha\",\n                    showRequestHeaders: false\n                });\n\n                initializeBaseUrl();\n\n                $(\'#select_baseUrl\').change(function() {\n                    window.swaggerUi.headerView.trigger(\'update-swagger-ui\', {\n                        url: $(\'#select_baseUrl\').val()\n                    });\n                    addApiKeyAuthorization();\n                });\n\n                function addApiKeyAuthorization(){\n\n\n                    var authToken = JSON.parse(localStorage.getItem(\"jhi-authenticationToken\")).access_token;\n                    var apiKeyAuth = new SwaggerClient.ApiKeyAuthorization(\"Authorization\",\n                            \"Bearer \" + authToken, \"header\");\n                    window.swaggerUi.api.clientAuthorizations.add(\"key\", apiKeyAuth);\n\n\n\n                }\n\n                function getCSRF() {\n                    var name = \"CSRF-TOKEN=\";\n                    var ca = document.cookie.split(\';\');\n                    for(var i=0; i<ca.length; i++) {\n                        var c = ca[i];\n                        while (c.charAt(0)==\' \') c = c.substring(1);\n                        if (c.indexOf(name) != -1) return c.substring(name.length,c.length);\n                    }\n                    return \"\";\n                }\n\n                function log() {\n                    if (\'console\' in window) {\n                        console.log.apply(console, arguments);\n                    }\n                }\n\n                function oAuthIsDefined(security) {\n                    return security.clientId\n                    && security.clientSecret\n                    && security.appName\n                    && security.realm;\n                }\n\n                function initializeSpringfox() {\n                    var security = {};\n                    window.springfox.securityConfig(function(data) {\n                        security = data;\n                        if (typeof initOAuth == \"function\" && oAuthIsDefined(security)) {\n                            initOAuth(security);\n                        }\n                    });\n                }\n            });\n\n            function maybePrefix(location, withRelativePath) {\n                var pat = /^https?:\\/\\//i;\n                if (pat.test(location)) {\n                    return location;\n                }\n                return withRelativePath + location;\n            }\n\n            function initializeBaseUrl() {\n                var relativeLocation = springfox.baseUrl();\n\n                $(\'#input_baseUrl\').hide();\n\n                $.getJSON(relativeLocation + \"/swagger-resources\", function(data) {\n                    var $urlDropdown = $(\'#select_baseUrl\');\n                    $urlDropdown.empty();\n                    $.each(data, function(i, resource) {\n                        var option = $(\'<option></option>\')\n                        .attr(\"value\", maybePrefix(resource.location, relativeLocation))\n                        .text(resource.name + \" (\" + resource.location + \")\");\n                        $urlDropdown.append(option);\n                    });\n                    $urlDropdown.change();\n                });\n\n            }\n\n        });</script></head><body class=\"swagger-section\"><div id=\"header\"><div class=\"swagger-ui-wrap\"><a id=\"logo\" href=\"http://swagger.io\">swagger</a><form id=\"api_selector\"><div class=\"input\"><select id=\"select_baseUrl\" name=\"select_baseUrl\"></select></div><div class=\"input\"><input placeholder=\"http://example.com/api\" id=\"input_baseUrl\" name=\"baseUrl\" type=\"text\"></div></form></div></div><div id=\"message-bar\" class=\"swagger-ui-wrap\" data-sw-translate>&nbsp;</div><div id=\"swagger-ui-container\" class=\"swagger-ui-wrap\"></div></body></html>");
$templateCache.put("app/widget/widget-preview.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\">Widget Demo</h3></div><div class=\"block-content\"><hr><div class=\"block\"><div class=\"block-header\"><h2 class=\"block-title\">Authentication</h2></div><div class=\"block-content\">Please note that this form is for development purposes only. In production the user\'s access_token should have been requested using a refresh_token.<form class=\"form-horizontal\" ng-submit=\"vm.getToken()\"><div class=\"row\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Client ID</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.clientId\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Client Secret</label><div class=\"col-sm-10\"><input type=\"password\" class=\"form-control\" ng-model=\"vm.clientSecret\"></div></div></div><div class=\"row\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">CRM2Print Username</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.credentials.username\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">CRM2Print Password</label><div class=\"col-sm-10\"><input type=\"password\" class=\"form-control\" ng-model=\"vm.credentials.password\"></div></div><div class=\"form-group\"><div class=\"col-sm-4 col-sm-offset-2\"><button class=\"btn btn-primary\" type=\"submit\">Get Token</button></div></div></div></form>Request:<pre>\nPOST https://www.crm2print.com/oauth/token\n\nHeaders:\n{{ vm.header() | json }}\n\n{\n    \"grant_type\": \"password\",\n    \"username\":\"{{vm.credentials.username}}\",\n    \"password\":\"{{vm.credentials.password | blankout}}\"\n}\n</pre></div></div><div class=\"block\" ng-show=\"vm.token\"><div class=\"block-header\"><h2 class=\"block-title\">Single Sign On (SSO)</h2></div><div class=\"block-content\"><pre>\nGET https://www.crm2print.com/api/users/sso?access_token={{vm.token.access_token}}\n</pre></div></div><div class=\"block\" ng-show=\"vm.token\"><div class=\"block-header\"><h2 class=\"block-title\">Widget Demo</h2></div><div class=\"block-content\"><pre>&lt;iframe src=\"https://www.crm2print.com/api/widget?access_token={{vm.token.access_token}}\" width=\"400\" height=\"80\" style=\"border:none; overflow: hidden\" scrolling=\"no\"/&gt;</pre><iframe ng-src=\"{{vm.previewUrl}}\" width=\"400\" height=\"80\" style=\"border:none; overflow: hidden; margin-top: 20px\" scrolling=\"no\"></div><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info push-30-t\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div></div>");
$templateCache.put("app/account/activate/activate.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"activate.title\">Activation</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"activate.messages.success\" translate-compile><strong>Your user has been activated.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"activate.messages.error\"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>");
$templateCache.put("app/account/password/password.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"password.title\" translate-values=\"{username: \'{{vm.account.login}}\'}\">Password for [<b>{{vm.account.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"password.messages.success\"><strong>Password changed!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"password.messages.error\"><strong>An error has occurred!</strong> The password could not be changed.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.changePassword()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"password.form.button\">Save</button></form></div></div></div>");
$templateCache.put("app/account/register/register.html","<style type=\"text/css\">.header-navbar-fixed #main-container {\n        padding-top: 0px;\n    }</style><!-- Main Container --><main id=\"main-container\"><!-- Hero Content --><div class=\"bg-success\"><section class=\"content content-full content-boxed overflow-hidden\"><!-- Section Content --><div class=\"push-100-t push-50 text-center\"><!--translate=\"register.title\"--><h1 class=\"h2 text-white push-10 visibility-hidden\" data-js-appear data-toggle=\"appear\" data-class=\"animated fadeInDown\">Sign up for a new account.</h1><h2 class=\"h5 text-white-op visibility-hidden\" data-js-appear data-toggle=\"appear\" data-class=\"animated fadeInDown\">Stop folding letters and stuffing envelopes. Today.</h2></div><div class=\"row visibility-hidden\" data-js-appear data-toggle=\"appear\" data-class=\"animated fadeInUp\"><div class=\"col-sm-8 col-sm-offset-2\"><img class=\"img-responsive pull-b\" src=\"content/images/various/promo-templates.jpg\" alt=\"\"></div></div><!-- END Section Content --></section></div><!-- END Hero Content --><!-- Content --><div class=\"bg-white\"><section class=\"content content-boxed\"><div><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"register.messages.success\"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"register.messages.error.fail\"><strong>Registration failed!</strong> Please try again later.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorUserExists\" translate=\"register.messages.error.userexists\"><strong>Login name already registered!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorEmailExists\" translate=\"register.messages.error.emailexists\"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div></div><!-- Section Content --><div class=\"row items-push push-50-t push-30\"><div class=\"col-md-6 col-md-offset-3\"><form class=\"form-horizontal\" ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.register()\" show-validation><div class=\"form-group\"><div class=\"col-xs-12\"><div class=\"form-material form-material-success\"><input type=\"text\" class=\"form-control\" id=\"login\" name=\"login\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.login\" ng-minlength=\"1\" ng-maxlength=\"50\" ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\" required><label class=\"control-label\" for=\"login\" translate=\"global.form.username\">Username</label><div ng-show=\"form.login.$dirty && form.login.$invalid\"><p class=\"help-block\" ng-show=\"form.login.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-show=\"form.login.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.login.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-show=\"form.login.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div></div></div><div class=\"form-group\"><div class=\"col-xs-12\"><div class=\"form-material form-material-success\"><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div></div></div><div class=\"form-group\"><div class=\"col-xs-12\"><div class=\"form-material form-material-success\"><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.registerAccount.password\"></password-strength-bar></div></div></div><div class=\"form-group\"><div class=\"col-xs-12\"><div class=\"form-material form-material-success\"><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div></div></div><div class=\"form-group\"><div class=\"col-xs-12 text-center\"><label class=\"css-input switch switch-sm switch-success\"><input type=\"checkbox\" ng-model=\"form.agreeTerms\" name=\"frontend-signup-terms\" required><span></span> I agree with <a ui-sref=\"terms\" target=\"_blank\">terms &amp; conditions</a></label></div></div><div class=\"form-group\"><div class=\"col-sm-6 col-sm-offset-3\"><button class=\"btn btn-block btn-success\" ng-disabled=\"form.$invalid || !form.agreeTerms\" class=\"btn btn-primary\" translate=\"register.form.button\"><i class=\"fa fa-plus pull-right\"></i> Sign Up</button></div></div></form></div></div><!-- END Section Content --></section></div><!-- END Content --><!-- Login --><div class=\"bg-gray-lighter\"><section class=\"content content-full content-boxed\"><!-- Section Content --><div class=\"push-20-t push-20 text-center\"><h3 class=\"h4 push-20 visibility-hidden\" data-js-appear data-toggle=\"appear\">Do you already have an account?</h3><a class=\"btn btn-rounded btn-noborder btn-lg btn-success visibility-hidden\" data-js-appear data-toggle=\"appear\" data-class=\"animated bounceIn\" ng-click=\"vm.login()\">Log In</a></div><!-- END Section Content --></section></div><!-- END Login --></main><!-- END Main Container --><!-- Footer --><footer id=\"page-footer\" class=\"bg-white\"><div class=\"content content-boxed\"><div class=\"row push-30-t items-push-2x\"><div class=\"col-sm-4\"><h3 class=\"h5 font-w600 text-uppercase push-20\">Company</h3><ul class=\"list list-simple-mini font-s13\"><li><a class=\"font-w600\" href=\"/\">Home</a></li><!--<li>\n                        <a class=\"font-w600\" href=\"frontend_features.php\">Features</a>\n                    </li>\n                    <li>\n                        <a class=\"font-w600\" href=\"frontend_pricing.php\">Pricing</a>\n                    </li>--><li><a class=\"font-w600\" ui-sref=\"about-us\">About Us</a></li><li><a class=\"font-w600\" ui-sref=\"contact-us\">Contact Us</a></li></ul></div><div class=\"col-sm-4\"><h3 class=\"h5 font-w600 text-uppercase push-20\">Support</h3><ul class=\"list list-simple-mini font-s13\"><li ng-hide=\"vm.isAuthenticated()\"><a class=\"font-w600\" href=\"#\" ng-click=\"vm.login()\">Log In</a></li><li ng-hide=\"vm.isAuthenticated()\"><a class=\"font-w600\" ui-sref=\"register\">Sign Up</a></li><li><a class=\"font-w600\" data-ui-sref=\"faq\">Support Center</a></li><li><a class=\"font-w600\" ui-sref=\"privacy\">Privacy Policy</a></li><li><a class=\"font-w600\" ui-sref=\"terms\">Terms &amp; Conditions</a></li></ul></div><div class=\"col-sm-4\"><h3 class=\"h5 font-w600 text-uppercase push-20\">Get In Touch</h3><div class=\"font-s13 push\"><strong>CRM2Print Pty. Ltd.</strong><br><!--8/349 Macdonnell Road<br>\n                    CLONTARF QLD 4019<br>--> <abbr title=\"Phone\">P:</abbr> <a href=\"tel:0720004455\">(07) 2000 4455</a></div><div class=\"font-s13\"><i class=\"si si-envelope-open\"></i> <a href=\"mailto:sales@crm2print.com\">sales@crm2print.com</a></div></div></div></div></footer><!-- END Footer --><!-- Page JS Code --> <!--\n<script>\n    jQuery(function () {\n        // Init page helpers (Appear plugin)\n        App.initHelpers(\'appear\');\n    });\n</script>\n-->");
$templateCache.put("app/account/settings/settings.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"settings.title\" translate-values=\"{username: \'{{vm.settingsAccount.login}}\'}\">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"settings.messages.success\"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"row\"><div class=\"form-group col-xs-6\"><label class=\"control-label\" for=\"firstName\" translate=\"settings.form.firstname\">First Name</label><input type=\"text\" class=\"form-control\" id=\"firstName\" name=\"firstName\" placeholder=\"{{\'settings.form.firstname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.firstName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.firstName.$dirty && form.firstName.$invalid\"><p class=\"help-block\" ng-show=\"form.firstName.$error.required\" translate=\"settings.messages.validate.firstname.required\">Your first name is required.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.minlength\" translate=\"settings.messages.validate.firstname.minlength\">Your first name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.maxlength\" translate=\"settings.messages.validate.firstname.maxlength\">Your first name cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-xs-6\"><label class=\"control-label\" for=\"lastName\" translate=\"settings.form.lastname\">Last Name</label><input type=\"text\" class=\"form-control\" id=\"lastName\" name=\"lastName\" placeholder=\"{{\'settings.form.lastname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.lastName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-show=\"form.lastName.$error.required\" translate=\"settings.messages.validate.lastname.required\">Your last name is required.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.minlength\" translate=\"settings.messages.validate.lastname.minlength\">Your last name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.maxlength\" translate=\"settings.messages.validate.lastname.maxlength\">Your last name cannot be longer than 50 characters.</p></div></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required maxlength=\"100\"><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label for=\"langKey\" translate=\"settings.form.language\">Language</label><select id=\"langKey\" name=\"langKey\" class=\"form-control\" ng-model=\"vm.settingsAccount.langKey\" ng-controller=\"JhiLanguageController as languageVm\" ng-options=\"code as (code | findLanguageFromKey) for code in languageVm.languages\"></select></div><div class=\"form-group\" ng-show=\"vm.settingsAccount.billingFrequency\"><label translate=\"settings.form.billingFrequency\">Billing Frequency</label><div>{{vm.settingsAccount.billingFrequency}} Days</div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"settings.form.button\">Save</button></form></div></div></div>");
$templateCache.put("app/account/sso/sso.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"sso.title\">SSO</h1>Please wait while we log you in.</div></div></div>");
$templateCache.put("app/admin/audits/audits.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"audits.title\">Audits</h3></div><div class=\"block-content\"><div class=\"row\"><div class=\"col-md-5\"><h4 translate=\"audits.filter.title\">Filter by date</h4><p class=\"input-group\"><span class=\"input-group-addon\" translate=\"audits.filter.from\">from</span> <input type=\"date\" class=\"input-sm form-control\" name=\"start\" ng-model=\"vm.fromDate\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-addon\" translate=\"audits.filter.to\">to</span> <input type=\"date\" class=\"input-sm form-control\" name=\"end\" ng-model=\"vm.toDate\" ng-change=\"vm.onChangeDate()\" required></p></div></div><table class=\"table table-condensed table-striped table-bordered table-responsive\"><thead><tr><th ng-click=\"predicate = \'timestamp\'; reverse=!reverse\"><span translate=\"audits.table.header.date\">Date</span></th><th ng-click=\"predicate = \'principal\'; reverse=!reverse\"><span translate=\"audits.table.header.principal\">User</span></th><th ng-click=\"predicate = \'type\'; reverse=!reverse\"><span translate=\"audits.table.header.status\">State</span></th><th ng-click=\"predicate = \'data.message\'; reverse=!reverse\"><span translate=\"audits.table.header.data\">Extra data</span></th></tr></thead><tr ng-repeat=\"audit in vm.audits | filter:filter | orderBy:predicate:reverse\" ng-hide=\"audit.filtered\"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show=\"audit.data.message\">{{audit.data.message}}</span> <span ng-show=\"audit.data.remoteAddress\"><span translate=\"audits.table.data.remoteAddress\">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadPage(vm.page)\"></uib-pagination></div></div></div>");
$templateCache.put("app/admin/configuration/configuration.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"configuration.title\">Configuration</h3></div><div class=\"block-content\"><span translate=\"configuration.filter\">Filter (by prefix)</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><label ng-hide=\"filteredConfig.length == 0\">Spring configuration</label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filteredConfig.length == 0\"><thead><tr><th ng-click=\"predicate = \'prefix\'; reverse=!reverse\" class=\"col-sm-4\"><span translate=\"configuration.table.prefix\">Prefix</span></th><th translate=\"configuration.table.properties\" class=\"col-sm-8\">Properties</th></tr></thead><tr ng-repeat=\"entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)\"><td><span>{{entry.prefix}}</span></td><td><div class=\"row\" ng-repeat=\"(key, value) in entry.properties\"><div class=\"col-md-4\">{{key}}</div><div class=\"col-md-8\"><span class=\"pull-right label label-default break\">{{value}}</span></div></div></td></tr></table><div ng-repeat=\"(key, value) in vm.allConfiguration\"><label ng-hide=\"filtered.length == 0\"><span>{{key}}</span></label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filtered.length == 0\"><thead><tr><th class=\"col-sm-4\">Property</th><th class=\"col-sm-8\">Value</th></tr></thead><tbody><tr ng-repeat=\"item in filtered = (value | filter:filter)\"><td class=\"break\">{{item.key}}</td><td class=\"break\"><span class=\"pull-right label label-default break\">{{item.val}}</span></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/admin/dashboard/admin-dashboard.html","<!-- Page Header --><div class=\"content bg-image overflow-hidden\" style=\"background-image: url(\'content/images/photos/photo3@2x.jpg\')\"><div class=\"push-50-t push-15\"><h1 class=\"h2 text-white animated zoomIn\">Dashboard</h1><h2 class=\"h5 text-white-op animated zoomIn\">Welcome Administrator</h2></div></div><!-- END Page Header --><!-- Stats --><div class=\"content bg-white border-b\"><div class=\"row items-push text-uppercase\"><div class=\"col-xs-6 col-sm-1\"><div class=\"h3 font-w700\">Print Jobs</div></div><div class=\"col-xs-6 col-sm-1\" ng-repeat=\"s in vm.placedStats[\'by-period\']\"><div class=\"text-muted animated fadeIn\"><small><i class=\"si si-calendar\"></i> {{s.period}}</small></div><span class=\"h2 font-w300 text-primary\">{{s.count}}</span><!--<span class=\"label label-default push-5\" ng-show=\"s.count\"><i class=\"si si-envelope\"></i> {{s.letter_count}}</span>--> <span class=\"h5 font-w300 text-muted\" ng-show=\"s.count\"><i class=\"si si-envelope\"></i> {{s.letter_count}}</span></div></div></div><!-- END Stats --><!-- Page Content --><div class=\"content\"><div class=\"row\"><div class=\"col-lg-7\"><div class=\"row\"><!-- Main Dashboard Chart --><div class=\"block\"><div class=\"block-header\"><ul class=\"block-options\"><li><button type=\"button\" data-js-block-option data-action=\"refresh_toggle\" data-action-mode=\"demo\"><i class=\"si si-refresh\"></i></button></li></ul><h3 class=\"block-title\">Print Job Management</h3></div><div class=\"block-content block-content-full text-center\"><div class=\"row\"><div class=\"col-xs-3 col-sm-3 col-lg-2\"><a class=\"block block-link-hover2 text-center\" ng-click=\"vm.processMergeReadyPrintJobs(vm.demo)\"><div class=\"block-content block-content-full bg-primary\"><i class=\"si si-size-actual job-management-icon text-white\"></i><div class=\"font-w600 text-white-op push-15-t\">Merge</div></div><div class=\"block-content block-content-full block-content-mini bg-gray-lighter\"><strong>{{vm.queueStats.mergeReady.active}}</strong> / {{vm.queueStats.mergeReady.waiting}} <i class=\"fa fa-cog fa-spin text-warning\" ng-show=\"vm.queueStats.mergeReady.active\"></i></div></a></div><div class=\"col-xs-3 col-sm-3 col-lg-2\"><a class=\"block block-link-hover2 text-center\" ui-sref=\"print-stream({type:\'PRINTJOB\'})\"><div class=\"block-content block-content-full bg-primary-light\"><i class=\"si si-docs job-management-icon text-white\"></i><div class=\"font-w600 text-white-op push-15-t\">View</div></div><div class=\"block-content block-content-full block-content-mini bg-gray-lighter\" style=\"padding-left: 0;padding-right: 0\"><strong>Job Streams</strong></div></a></div><div class=\"col-xs-3 col-sm-3 col-lg-2\"><a class=\"block block-link-hover2 text-center\" ng-disabled=\"vm.queueStats.mergeReady.active\" ng-click=\"vm.processPrintJobPrintStreams(vm.demo)\"><div class=\"block-content block-content-full bg-success\"><i class=\"si si-shuffle job-management-icon text-white\"></i><div class=\"font-w600 text-white-op push-15-t\">Collate</div></div><div class=\"block-content block-content-full block-content-mini bg-gray-lighter\"><strong>{{vm.queueStats.collateReady.active}}</strong> / {{vm.queueStats.collateReady.waiting}} <i class=\"fa fa-cog fa-spin text-warning\" ng-show=\"vm.queueStats.collateReady.active\"></i></div></a></div><div class=\"col-xs-3 col-sm-3 col-lg-2\"><a class=\"block block-link-hover2 text-center\" ui-sref=\"print-stream({type:\'FINAL\'})\"><div class=\"block-content block-content-full bg-success-light\"><i class=\"si si-printer job-management-icon text-white\"></i><div class=\"font-w600 text-white-op push-15-t\">View</div></div><div class=\"block-content block-content-full block-content-mini bg-gray-lighter\" style=\"padding-left: 0;padding-right: 0\"><strong>Print Streams</strong></div></a></div><div class=\"col-xs-3 col-sm-3 col-lg-2\"><a class=\"block block-link-hover2 text-center\" ng-click=\"vm.deleteApiAbandoned()\"><div class=\"block-content block-content-full bg-warning\"><i class=\"si si-basket job-management-icon text-white\"></i><div class=\"font-w600 text-white-op push-15-t\">Delete</div></div><div class=\"block-content block-content-full block-content-mini bg-gray-lighter\" style=\"padding-left: 0;padding-right: 0\"><strong title=\"TODO\">{{vm.apiAbandonedCount}}</strong> Abandoned <i class=\"fa fa-cog fa-spin text-warning\" ng-show=\"vm.deletingApiAbandoned\"></i></div></a></div></div></div></div><!-- END Main Dashboard Chart --></div><div class=\"row\"><div class=\"block\"><div class=\"block-header bg-gray-lighter\"><ul class=\"block-options\"><li class=\"dropdown\"><button type=\"button\" data-toggle=\"dropdown\" aria-expanded=\"false\">Filter <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-repeat=\"(status,count) in vm.printJobCountByStatus\"><a tabindex=\"-1\" href=\"javascript:void(0)\"><span class=\"badge pull-right\" translate=\"{{\'crm2PrintApp.OrderStatus.\' + status}}\">{{status}}</span>{{count}}</a></li></ul></li><li><button type=\"button\" data-js-block-option data-action=\"refresh_toggle\" ng-click=\"vm.refresh()\"><i class=\"si si-refresh\"></i></button></li><li><button type=\"button\" data-js-block-option data-action=\"refresh_toggle\" data-action-mode=\"demo\" ng-click=\"vm.demo=!vm.demo;vm.refresh()\">{{vm.demo?\'DEMO\':\'LIVE\'}}</button></li></ul><h3 class=\"block-title\">Active Print Jobs</h3></div><div class=\"block-content\"><table class=\"table table-borderless table-striped table-vcenter\"><thead><tr><th class=\"text-center\" style=\"width: 100px\"><span translate=\"global.field.id\">ID</span></th><th class=\"text-center\"><span translate=\"crm2PrintApp.printJob.status\">Status</span></th><th class=\"hidden-xs text-center\"><span translate=\"crm2PrintApp.printJob.placed\">Placed</span></th><th class=\"text-right\"># Letter</th><th class=\"hidden-xs text-right\"># Page</th><th class=\"hidden-xs hidden-sm text-right\"># Contacts</th><th class=\"hidden-xs\"><span translate=\"crm2PrintApp.printJob.user\">User</span></th><th class=\"hidden-xs text-center\">Action</th></tr></thead><tbody><tr ng-repeat=\"printJob in vm.printJobs track by printJob.id\"><td class=\"text-center\"><a ui-sref=\"print-job-detail({id:printJob.id})\"><strong>PJ-{{printJob.id}}</strong></a></td><td><i ng-class=\"vm.statusIcon(printJob.status)\"></i> <span translate=\"{{\'crm2PrintApp.OrderStatus.\' + printJob.status}}\">{{printJob.status}}</span></td><td class=\"hidden-xs text-center\">{{printJob.placed | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"text-right\">{{printJob.letterCount}} <span ng-show=\"printJob.duplex\" title=\"Duplex\">D</span></td><td class=\"hidden-xs text-right\">{{printJob.pageCount}}</td><td class=\"hidden-xs hidden-sm text-right\">{{printJob.contactsCount}}</td><td class=\"hidden-xs\"><a ui-sref=\"user-management-detail({id:printJob.userId})\">{{printJob.userLogin}}</a></td><td class=\"hidden-xs text-center\"><div class=\"btn-group btn-group-xs\"><a ui-sref=\"print-job-detail({id:printJob.id})\" data-toggle=\"tooltip\" title=\"\" class=\"btn btn-default\" data-original-title=\"View\"><i class=\"fa fa-eye\"></i></a> <a ng-show=\"printJob.status == \'MERGE_READY\'\" ng-click=\"vm.processMergeReadyPrintJob(printJob.id)\" data-toggle=\"tooltip\" title=\"\" class=\"btn btn-default\" data-original-title=\"Mail Merge\"><i class=\"si si-size-actual\"></i></a> <a ng-show=\"(printJob.status == \'MERGE_READY\' || printJob.status == \'MAIL_MERGE\') && printJob.apiClientId == \'c2p$api_stashproperty\'\" ng-click=\"vm.cancelPrintJob(printJob.id)\" data-toggle=\"tooltip\" title=\"\" class=\"btn btn-default\" data-original-title=\"Cancel\"><i class=\"fa fa-times text-danger\"></i></a></div></td></tr></tbody></table><!--<nav class=\"text-right\">\n                            <ul class=\"pagination pagination-sm\">\n                                <li class=\"active\">\n                                    <a href=\"javascript:void(0)\">1</a>\n                                </li>\n                                <li>\n                                    <a href=\"javascript:void(0)\">2</a>\n                                </li>\n                                <li>\n                                    <a href=\"javascript:void(0)\">3</a>\n                                </li>\n                                <li>\n                                    <a href=\"javascript:void(0)\">4</a>\n                                </li>\n                                <li>\n                                    <a href=\"javascript:void(0)\">5</a>\n                                </li>\n                                <li>\n                                    <a href=\"javascript:void(0)\"><i class=\"fa fa-angle-right\"></i></a>\n                                </li>\n                            </ul>\n                        </nav>--></div></div></div><div class=\"row\"><!-- Admin Options --><div class=\"block\"><div class=\"block-header bg-warning\"><h3 class=\"block-title\">Maintenance</h3></div><div class=\"block-content block-content-full text-center\"><div class=\"row\"><div class=\"col-lg-4\"><a class=\"block block-link-hover3 block-bordered\" ng-click=\"vm.clearHibernateCache()\"><div class=\"block-content block-content-full clearfix\"><i class=\"si si-trash fa-2x text-muted pull-right\"></i> <span class=\"h4 text-muted\">clear hibernate cache</span></div></a></div><div class=\"col-lg-4\"><a class=\"block block-link-hover3 block-bordered\" ng-click=\"vm.reIndexAllUsers()\"><div class=\"block-content block-content-full clearfix\"><i class=\"si si-refresh fa-2x text-muted pull-right\"></i> <span class=\"h4 text-muted\">re-index users</span></div></a></div><div class=\"col-lg-4\"><a class=\"block block-link-hover3 block-bordered\" ng-click=\"vm.syncMailchimp()\"><div class=\"block-content block-content-full clearfix\"><i class=\"si si-cloud-upload fa-2x text-muted pull-right\"></i> <span class=\"h4 text-muted\">sync Mailchimp</span></div></a></div></div><div class=\"row\"><div class=\"col-lg-4\"><a class=\"block block-link-hover3 block-bordered\" ng-click=\"vm.markJobTicketsComplete()\"><div class=\"block-content block-content-full clearfix\"><i class=\"si si-envelope fa-2x text-muted pull-right\"></i> <span class=\"h4 text-muted\">mark tickets complete</span></div></a></div></div></div></div><!-- END Admin Options --></div></div><div class=\"col-lg-5\"><!-- Latest Invoices Widget --><div class=\"block\"><div class=\"block-header\"><ul class=\"block-options\"><li><button type=\"button\" data-js-block-option data-action=\"refresh_toggle\" ng-click=\"vm.refresh()\"><i class=\"si si-refresh\"></i></button></li><li><button type=\"button\" data-js-block-option data-action=\"refresh_toggle\" data-action-mode=\"demo\" ng-click=\"vm.demo=!vm.demo;vm.refresh()\">{{vm.demo?\'DEMO\':\'LIVE\'}}</button></li><li><button type=\"button\" data-js-block-option data-action=\"refresh_toggle\" data-action-mode=\"demo\" ng-click=\"vm.due=!vm.due;vm.refresh()\">{{vm.due?\'Due\':\'Paid\'}}</button></li></ul><h3 class=\"block-title\">Latest Invoices</h3></div><div class=\"block-content bg-gray-lighter\"><div class=\"row items-push\"><div class=\"col-xs-3\"><div class=\"text-muted\"><small><i class=\"si si-calendar\"></i> today</small></div><div class=\"font-w600\">{{vm.raised24hours.count || \'na\'}}</div></div><div class=\"col-xs-3 h1 font-w300 metric-number-lg text-right\">{{vm.raised24hours.amountGross | currency:\'$\':2}}</div><div class=\"col-xs-3\"><div class=\"text-muted\"><small><i class=\"si si-calendar\"></i> 7 days</small></div><div class=\"font-w600\">{{vm.raised7days.count || \'na\'}}</div></div><div class=\"col-xs-3 h1 font-w300 metric-number-lg text-right\">{{vm.raised7days.amountGross | currency:\'$\':2}}</div></div></div><div class=\"block-content\"><div class=\"pull-t pull-r-l\"><div class=\"remove-margin-b\"><div><table class=\"table remove-margin-b table-borderless table-striped table-vcenter\"><thead><tr><th>ID</th><th class=\"hidden-xs\">Status</th><th>Date</th><th class=\"hidden-xs\">User</th><th class=\"text-right\">Amount</th></tr></thead><tbody><tr ng-repeat=\"invoice in vm.invoices track by invoice.id\"><td style=\"white-space: nowrap\"><a ui-sref=\"invoice-detail({id:invoice.id})\"><strong>I-{{invoice.id}}</strong></a></td><td><span ng-class=\"[\'label\',{\'label-info\':invoice.status==\'RAISED\',\'label-success\':invoice.status==\'PAID\',\'label-warning\':invoice.status==\'ISSUED\'}]\" translate=\"{{\'crm2PrintApp.InvoiceStatus.\' + invoice.status}}\">{{invoice.status}}</span> <span ng-show=\"invoice.demo\" class=\"text-primary\">DEMO</span> <i class=\"fa fa-exclamation-triangle text-danger\" ng-show=\"invoice.errorReason\" title=\"Error: {{invoice.errorReason}}\"></td><td class=\"hidden-xs\" ng-switch=\"invoice.status\"><span ng-switch-when=\"PAID\">{{invoice.paid | date:\'dd/MM/yyyy HH:mm\'}}</span> <span ng-switch-when=\"RAISED\">{{invoice.raised | date:\'dd/MM/yyyy HH:mm\'}}</span> <span ng-switch-default>{{invoice.issued | date:\'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"hidden-xs\"><a ui-sref=\"user-management-detail({id:invoice.userId})\">{{invoice.userLogin}}</a></td><td class=\"text-right\"><strong>{{invoice.amountGross | currency:invoice.currency:2}}</strong></td></tr></tbody></table></div></div><!-- END Slick slider --></div></div></div><!-- END Latest Sales Widget --></div></div></div><!-- END Page Content -->");
$templateCache.put("app/admin/dashboard/admin-dashboard.modal.html","<!-- Modal used to display the threads dump --><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"metrics.jvm.threads.dump.title\">Threads dump</h4></div><div class=\"modal-body pad\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/docs/docs.html","<iframe src=\"app/swagger-ui/index.html\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/admin/health/health.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"health.title\">Health Checks</h3></div><div class=\"block-content\"><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"health.refresh.button\">Refresh</span></button></p><table id=\"healthCheck\" class=\"table table-striped\"><thead><tr><th class=\"col-md-7\" translate=\"health.table.service\">Service Name</th><th class=\"col-md-2 text-center\" translate=\"health.table.status\">Status</th><th class=\"col-md-2 text-center\" translate=\"health.details.details\">Details</th></tr></thead><tbody><tr ng-repeat=\"health in vm.healthData\"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class=\"text-center\"><span class=\"label\" ng-class=\"vm.getLabelClass(health.status)\">{{\'health.status.\' + health.status | translate}}</span></td><td class=\"text-center\"><a class=\"hand\" ng-click=\"vm.showHealth(health)\" ng-show=\"health.details || health.error\"><i class=\"glyphicon glyphicon-eye-open\"></i></a></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/health/health.modal.html","<div class=\"modal-header\"><button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"showHealthLabel\">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class=\"modal-body pad\"><div ng-show=\"vm.currentHealth.details\"><h4 translate=\"health.details.properties\">Properties</h4><table class=\"table table-striped\"><thead><tr><th class=\"col-md-6 text-left\" translate=\"health.details.name\">Name</th><th class=\"col-md-6 text-left\" translate=\"health.details.value\">Value</th></tr></thead><tbody><tr ng-repeat=\"(k,v) in vm.currentHealth.details\"><td class=\"col-md-6 text-left\">{{k}}</td><td class=\"col-md-6 text-left\">{{v}}</td></tr></tbody></table></div><div ng-show=\"vm.currentHealth.error\"><h4 translate=\"health.details.error\">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class=\"modal-footer\"><button data-dismiss=\"modal\" class=\"btn btn-default pull-left\" type=\"button\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/logs/logs.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"logs.title\">Logs</h3></div><div class=\"block-content table-responsive\"><p translate=\"logs.nbloggers\" translate-values=\"{total: \'{{ vm.loggers.length }}\'}\">There are {{ vm.loggers.length }} loggers.</p><span translate=\"logs.filter\">Filter</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><table class=\"table table-condensed table-striped table-bordered\"><thead><tr title=\"click to order\"><th ng-click=\"predicate = \'name\'; reverse=!reverse\"><span translate=\"logs.table.name\">Name</span></th><th ng-click=\"predicate = \'level\'; reverse=!reverse\"><span translate=\"logs.table.level\">Level</span></th></tr></thead><tr ng-repeat=\"logger in vm.loggers | filter:filter | orderBy:predicate:reverse\"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click=\"vm.changeLevel(logger.name, \'TRACE\')\" ng-class=\"(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">TRACE</button> <button ng-click=\"vm.changeLevel(logger.name, \'DEBUG\')\" ng-class=\"(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">DEBUG</button> <button ng-click=\"vm.changeLevel(logger.name, \'INFO\')\" ng-class=\"(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">INFO</button> <button ng-click=\"vm.changeLevel(logger.name, \'WARN\')\" ng-class=\"(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">WARN</button> <button ng-click=\"vm.changeLevel(logger.name, \'ERROR\')\" ng-class=\"(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">ERROR</button></td></tr></table></div></div>");
$templateCache.put("app/admin/metrics/metrics.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"metrics.title\">Application Metrics</h3></div><div class=\"block-content\"><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"metrics.refresh.button\">Refresh</span></button></p><h3 translate=\"metrics.jvm.title\">JVM Metrics</h3><div class=\"row\" ng-hide=\"vm.updatingMetrics\"><div class=\"col-md-4\"><b translate=\"metrics.jvm.memory.title\">Memory</b><p><span translate=\"metrics.jvm.memory.total\">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.total.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.total.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.heap\">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.heap.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.nonheap\">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.threads.title\">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class=\"hand\" ng-click=\"vm.refreshThreadDumpData()\" data-toggle=\"modal\" data-target=\"#threadDump\"><i class=\"glyphicon glyphicon-eye-open\"></i></a><p><span translate=\"metrics.jvm.threads.runnable\">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.runnable.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.timedwaiting\">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.waiting\">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.blocked\">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.blocked.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.gc.title\">Garbage collections</b><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweepcount\">Mark Sweep count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweeptime\">Mark Sweep time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengecount\">Scavenge count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengetime\">Scavenge time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class=\"well well-lg\" ng-show=\"vm.updatingMetrics\" translate=\"metrics.updating\">Updating...</div><h3 translate=\"metrics.jvm.http.title\">HTTP requests (events per second)</h3><p><span translate=\"metrics.jvm.http.active\">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate=\"metrics.jvm.http.total\">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.jvm.http.table.code\">Code</th><th translate=\"metrics.jvm.http.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.jvm.http.table.mean\">Mean</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (1 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (5 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate=\"metrics.jvm.http.code.ok\">OK</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.notfound\">Not Found</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.servererror\">Server error</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.servicesstats.title\">Services statistics (time in millisecond)</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.servicesstats.table.name\">Service name</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.min\">Min</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p50\">p50</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p75\">p75</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p95\">p95</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p99\">p99</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.max\">Max</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.servicesStats\"><td>{{k}}</td><td class=\"text-right\">{{v.count}}</td><td class=\"text-right\">{{v.mean * 1000 | number:0}}</td><td class=\"text-right\">{{v.min * 1000 | number:0}}</td><td class=\"text-right\">{{v.p50 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p75 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p95 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p99 * 1000 | number:0}}</td><td class=\"text-right\">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate=\"metrics.datasource.title\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\">DataSource statistics (time in millisecond)</h3><div class=\"table-responsive\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\"><table class=\"table table-striped\"><thead><tr><th><span translate=\"metrics.datasource.usage\">Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class=\"text-right\" translate=\"metrics.datasource.count\">Count</th><th class=\"text-right\" translate=\"metrics.datasource.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.datasource.min\">Min</th><th class=\"text-right\" translate=\"metrics.datasource.p50\">p50</th><th class=\"text-right\" translate=\"metrics.datasource.p75\">p75</th><th class=\"text-right\" translate=\"metrics.datasource.p95\">p95</th><th class=\"text-right\" translate=\"metrics.datasource.p99\">p99</th><th class=\"text-right\" translate=\"metrics.datasource.max\">Max</th></tr></thead><tbody><tr><td><div class=\"progress progress-striped\"><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value\" value=\"vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/admin/metrics/metrics.modal.html","<!-- Modal used to display the threads dump --><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"metrics.jvm.threads.dump.title\">Threads dump</h4></div><div class=\"modal-body pad\"><span class=\"label label-primary\" ng-click=\"threadDumpFilter = {}\">All&nbsp;<span class=\"badge\">{{vm.threadDumpAll}}</span></span>&nbsp; <span class=\"label label-success\" ng-click=\"threadDumpFilter = {threadState: \'RUNNABLE\'}\">Runnable&nbsp;<span class=\"badge\">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class=\"label label-info\" ng-click=\"threadDumpFilter = {threadState: \'WAITING\'}\">Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class=\"label label-warning\" ng-click=\"threadDumpFilter = {threadState: \'TIMED_WAITING\'}\">Timed Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class=\"label label-danger\" ng-click=\"threadDumpFilter = {threadState: \'BLOCKED\'}\">Blocked&nbsp;<span class=\"badge\">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class=\"voffset2\">&nbsp;</div>Filter <input type=\"text\" ng-model=\"threadDumpFilter\" class=\"form-control\"><div class=\"row pad\" ng-repeat=\"(k, v) in vm.threadDump | filter:threadDumpFilter\"><h5><span class=\"label\" ng-class=\"vm.getLabelClass(v.threadState)\">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click=\"show = !show\"><span ng-show=\"!show\" translate=\"metrics.jvm.threads.dump.show\">Show StackTrace</span> <span ng-show=\"show\" translate=\"metrics.jvm.threads.dump.hide\">Hide StackTrace</span></a></h5><div class=\"well\" ng-show=\"show\"><div ng-repeat=\"(stK, stV) in v.stackTrace\">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class=\"voffset1\"></span></div></div><table class=\"table table-condensed\"><thead><tr><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedtime\">Blocked Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedcount\">Blocked Count</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedtime\">Waited Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedcount\">Waited Count</th><th translate=\"metrics.jvm.threads.dump.lockname\">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/user-management/user-management-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.user.login)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"userManagement.delete.question\" translate-values=\"{login: \'{{vm.user.login}}\'}\">Are you sure you want to delete this User?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/admin/user-management/user-management-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"userManagement.detail.title\">User {{vm.user.login}}</h3></div><div class=\"block-content\"><dl class=\"dl-horizontal\"><dt><span translate=\"userManagement.login\">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span translate=\"userManagement.firstName\">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span translate=\"userManagement.lastName\">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span translate=\"userManagement.email\">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate=\"userManagement.activated\">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span translate=\"userManagement.langKey\">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span translate=\"userManagement.createdBy\">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span translate=\"userManagement.createdDate\">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span translate=\"userManagement.lastModifiedBy\">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span translate=\"userManagement.lastModifiedDate\">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span translate=\"userManagement.profiles\">Profiles</span></dt><dd><ul class=\"list-unstyled\"><li ng-repeat=\"authority in user.authorities\"><span>{{authority}}</span></li></ul></dd></dl><button type=\"submit\" ui-sref=\"user-management\" class=\"btn btn-info push-10\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\">Back</span></button> <button type=\"submit\" has-authority=\"ROLE_ADMIN\" ui-sref=\"user-management.edit({id:vm.user.id})\" class=\"btn btn-primary push-10\"><span class=\"glyphicon glyphicon-pencil\" title=\"Edit\"></span>&nbsp;<span>Edit</span></button> <button ng-click=\"vm.sendActivationEmail()\" has-authority=\"ROLE_ADMIN\" ng-show=\"!vm.user.activated\" class=\"btn btn-warning push-10\"><span class=\"glyphicon glyphicon-envelope\" title=\"Re-send Activation Email\"></span>&nbsp;<span>Re-send Activation Email</span></button> <button ng-click=\"vm.impersonate()\" has-authority=\"ROLE_ADMIN\" class=\"btn btn-success push-10\"><span class=\"glyphicon glyphicon-lock\" title=\"Impersonate\"></span>&nbsp;<span>Impersonate</span></button></div></div>");
$templateCache.put("app/admin/user-management/user-management-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myUserLabel\" translate=\"userManagement.home.createOrEditLabel\">Create or edit a User</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" name=\"id\" ng-model=\"vm.user.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.login\">Login</label><input type=\"text\" class=\"form-control\" name=\"login\" ng-model=\"vm.user.login\" ng-required=\"vm.user.id == null\" ng-minlength=\"1\" ng-maxlength=\"50\" ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\"><div ng-show=\"editForm.login.$invalid\"><p class=\"help-block\" ng-show=\"editForm.login.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.login.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"75\">This field cannot be longer than 75 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.firstName\">First Name</label><input type=\"text\" class=\"form-control\" name=\"firstName\" ng-model=\"vm.user.firstName\" ng-maxlength=\"50\"><div ng-show=\"editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"userManagement.lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" ng-model=\"vm.user.lastName\" ng-maxlength=\"50\"><div ng-show=\"editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.email\">Email</label><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.user.email\" required ng-maxlength=\"100\"><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.billingFrequency\">Billing Frequency</label><input type=\"number\" class=\"form-control\" name=\"billingFrequency\" ng-model=\"vm.user.billingFrequency\" required ng-pattern=\"(0|1|7|30)\"></div><div class=\"form-group\"><label for=\"activated\"><input ng-disabled=\"vm.user.id === null\" type=\"checkbox\" id=\"activated\" ng-model=\"vm.user.activated\"> <span translate=\"userManagement.activated\">Activated</span></label></div><div class=\"form-group\"><label translate=\"userManagement.langKey\">Lang Key</label><select class=\"form-control\" name=\"langKey\" ng-model=\"vm.user.langKey\" ng-options=\"language as language for language in vm.languages track by language\"></select></div><div class=\"form-group\"><label translate=\"userManagement.profiles\">Profiles</label><select class=\"form-control\" multiple=\"multiple\" name=\"authority\" ng-model=\"vm.user.authorities\" ng-options=\"authority for authority in vm.authorities\"></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/admin/user-management/user-management.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"userManagement.home.title\">Users</h3></div><div class=\"block-content\"><div class=\"row\"><div class=\"col-md-4\"><button class=\"btn btn-primary\" ui-sref=\"user-management.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"userManagement.home.createLabel\">Create a new User</span></button></div><div class=\"col-xs-8\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"Search for User\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"global.field.id\">ID</th><th translate=\"userManagement.login\">Login</th><th translate=\"userManagement.email\">Email</th><th></th><!--<th translate=\"userManagement.langKey\" class=\"hidden-xs hidden-sm\">Lang Key</th>--><th>Terms</th><th translate=\"userManagement.profiles\">Profiles</th><th translate=\"userManagement.createdDate\" class=\"hidden-xs hidden-sm\">Created Date</th><th translate=\"userManagement.lastModifiedDate\" class=\"hidden-xs hidden-sm\">Last Modified Date</th><th></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users track by user.id\"><td><a ui-sref=\"user-management-detail({id:user.id})\">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}<div ng-show=\"user.agileCrmContactId\" class=\"text-muted\">AgileCRM: <a ng-href=\"https://crm2print.agilecrm.com/#contact/{{user.agileCrmContactId}}\" target=\"_blank\">{{user.agileCrmContactId}}</a></div></td><td><span class=\"label label-danger\" ng-click=\"vm.setActive(user, true)\" ng-show=\"!user.activated\" translate=\"userManagement.deactivated\" style=\"cursor: pointer\">Desactivated</span> <span class=\"label label-success\" ng-click=\"vm.setActive(user, false)\" ng-show=\"user.activated\" translate=\"userManagement.activated\" style=\"cursor: pointer\">Activated</span></td><!--<td class=\"hidden-xs hidden-sm\">{{user.langKey}}</td>--><td><span ng-if=\"user.billingFrequency > 0\">{{user.billingFrequency }} Days</span></td><td><div ng-repeat=\"authority in user.authorities\"><span class=\"label label-info\">{{ authority }}</span></div></td><td class=\"hidden-xs hidden-sm\">{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td class=\"hidden-xs hidden-sm\"><span title=\"Modified by {{user.lastModifiedBy}}\">{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</span></td><td class=\"text-right\"><!--<div class=\"btn-group\">\n                            <div class=\"btn-group\">\n                                <button class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-expanded=\"false\">\n                                    <span class=\"caret\"></span>\n                                </button>\n                                <ul class=\"dropdown-menu dropdown-menu-right\">\n                                    <li class=\"dropdown-header\">Actions</li>\n                                    <li>\n                                        <button type=\"submit\"\n                                                ui-sref=\"user-management-detail({id:user.login})\"\n                                                class=\"btn btn-info btn-sm btn-block\">\n                                            <span class=\"glyphicon glyphicon-eye-open pull-left\"></span>\n                                            <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span>\n                                        </button>\n                                    </li>\n                                    <li>\n                                        <button type=\"submit\"\n                                                ui-sref=\"user-management.edit({login:user.login})\"\n                                                class=\"btn btn-primary btn-sm btn-block\">\n                                            <span class=\"glyphicon glyphicon-pencil pull-left\"></span>\n                                            <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>\n                                        </button>\n                                    </li>\n                                    <li>\n                                        <button type=\"submit\"\n                                                ui-sref=\"user-management.delete({login:user.login})\"\n                                                class=\"btn btn-danger btn-sm btn-block\" ng-disabled=\"vm.currentAccount.login==user.login\">\n                                            <span class=\"glyphicon glyphicon-remove-circle pull-left\"></span>\n                                            <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>\n                                        </button>\n                                    </li>\n                                    <li>\n                                        <button ng-click=\"vm.impersonate(user)\"\n                                                class=\"btn btn-success btn-sm btn-block\" ng-disabled=\"vm.currentAccount.login==user.login\">\n                                            <span class=\"glyphicon glyphicon-lock pull-left\"></span>\n                                            <span class=\"hidden-xs hidden-sm\">Impersonate</span>\n                                        </button>\n                                    </li>\n                                </ul>\n                            </div>\n                        </div>--><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"user-management-detail({id:user.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\" title=\"View\"></span></button> <button type=\"submit\" ui-sref=\"user-management.edit({id:user.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\" title=\"Edit\"></span></button><!--<button type=\"submit\"\n                                    ui-sref=\"user-management.delete({login:user.login})\"\n                                    class=\"btn btn-danger btn-sm\" ng-disabled=\"vm.currentAccount.login==user.login\">\n                                <span class=\"glyphicon glyphicon-remove-circle\" title=\"Delete\"></span>\n                            </button>--> <button ng-click=\"vm.impersonate(user)\" class=\"btn btn-success btn-sm\" ng-disabled=\"vm.currentAccount.id==user.id\"><span class=\"glyphicon glyphicon-lock\" title=\"Impersonate\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div></div>");
$templateCache.put("app/components/login/login.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"login.title\">Sign in</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 translate=\"login.title\">Sign in</h1></div><div class=\"col-md-8 col-md-offset-2\"><div class=\"alert alert-danger\" ng-show=\"vm.authenticationError\" translate=\"login.messages.error.authentication\"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class=\"col-md-8 col-md-offset-2\"><form class=\"form\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"form-group\"><label for=\"username\" translate=\"global.form.username\">Login</label><input type=\"text\" class=\"form-control\" id=\"username\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.username\"></div><div class=\"form-group\"><label for=\"password\" translate=\"login.form.password\">Password</label><input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"{{\'login.form.password.placeholder\' | translate}}\" ng-model=\"vm.password\"></div><button type=\"submit\" class=\"btn btn-primary\" translate=\"login.form.button\">Sign in</button></form><p></p><div class=\"alert alert-warning\"><a class=\"alert-link\" href=\"\" ng-click=\"vm.requestResetPassword()\" translate=\"login.password.forgot\">Did you forget your password?</a></div><div class=\"alert alert-warning\" translate=\"global.messages.info.register\" translate-compile>You don\'t have an account yet? <a class=\"alert-link\" href=\"\" ng-click=\"vm.register()\">Register a new account</a></div></div></div></div>");
$templateCache.put("app/components/splash-screen/splash-screen.html","<style type=\"text/css\">@import url(https://fonts.googleapis.com/css?family=Roboto+Condensed:400,700);\n/* written by riliwan balogun http://www.facebook.com/riliwan.rabo*/\n.board{\n    /*width: 75%;*/\n    /*margin: 60px auto;*/\n    height: 520px;\n    background: #fff;\n    /*box-shadow: 10px 10px #ccc,-10px 20px #ddd;*/\n}\n.board .nav-tabs {\n    position: relative;\n    /* border-bottom: 0; */\n    /* width: 80%; */\n    /*margin: 40px auto;*/\n    margin-bottom: 0;\n    box-sizing: border-box;\n\n}\n\n.board > div.board-inner{\n    background: #fafafa url(/content/images/geometry2.png);\n    background-size: 30%;\n}\n\np.narrow{\n    width: 60%;\n    margin: 10px auto;\n}\n\np.wide{\n    width: 80%;\n    margin: 10px auto;\n}\n\n.liner{\n    height: 2px;\n    background: #ddd;\n    position: absolute;\n    width: 80%;\n    margin: 0 auto;\n    left: 0;\n    right: 0;\n    top: 50%;\n    z-index: 1;\n}\n\n.nav-tabs > li.active > a, .nav-tabs > li.active > a:hover, .nav-tabs > li.active > a:focus {\n    color: #555555;\n    cursor: default;\n    /* background-color: #ffffff; */\n    border: 0;\n    border-bottom-color: transparent;\n}\n\nspan.round-tabs{\n    width: 70px;\n    height: 70px;\n    line-height: 70px;\n    display: inline-block;\n    border-radius: 100px;\n    background: white;\n    z-index: 2;\n    position: absolute;\n    left: 0;\n    text-align: center;\n    font-size: 25px;\n}\n\nspan.round-tabs.one{\n    color: rgb(34, 194, 34);border: 2px solid rgb(34, 194, 34);\n}\n\nli.active span.round-tabs.one{\n    background: #fff !important;\n    border: 2px solid #ddd;\n    color: rgb(34, 194, 34);\n}\n\nspan.round-tabs.two{\n    color: #febe29;border: 2px solid #febe29;\n}\n\nli.active span.round-tabs.two{\n    background: #fff !important;\n    border: 2px solid #ddd;\n    color: #febe29;\n}\n\nspan.round-tabs.three{\n    color: #3e5e9a;border: 2px solid #3e5e9a;\n}\n\nli.active span.round-tabs.three{\n    background: #fff !important;\n    border: 2px solid #ddd;\n    color: #3e5e9a;\n}\n\nspan.round-tabs.four{\n    color: #f1685e;border: 2px solid #f1685e;\n}\n\nli.active span.round-tabs.four{\n    background: #fff !important;\n    border: 2px solid #ddd;\n    color: #f1685e;\n}\n\nspan.round-tabs.five{\n    color: #999;border: 2px solid #999;\n}\n\nli.active span.round-tabs.five{\n    background: #fff !important;\n    border: 2px solid #ddd;\n    color: #999;\n}\n\n.nav-tabs > li.active > a span.round-tabs{\n    background: #fafafa;\n}\n.nav-tabs > li {\n    width: 20%;\n}\n/*li.active:before {\n    content: \" \";\n    position: absolute;\n    left: 45%;\n    opacity:0;\n    margin: 0 auto;\n    bottom: -2px;\n    border: 10px solid transparent;\n    border-bottom-color: #fff;\n    z-index: 1;\n    transition:0.2s ease-in-out;\n}*/\n.nav-tabs > li:after {\n    content: \" \";\n    position: absolute;\n    left: 45%;\n    opacity:0;\n    margin: 0 auto;\n    bottom: 0px;\n    border: 5px solid transparent;\n    border-bottom-color: #ddd;\n    transition:0.1s ease-in-out;\n\n}\n.nav-tabs > li.active:after {\n    content: \" \";\n    position: absolute;\n    left: 45%;\n    opacity:1;\n    margin: 0 auto;\n    bottom: 0px;\n    border: 10px solid transparent;\n    border-bottom-color: #ddd;\n\n}\n.nav-tabs > li a{\n    width: 70px;\n    height: 70px;\n    margin: 20px auto;\n    border-radius: 100%;\n    padding: 0;\n}\n\n.nav-tabs > li a:hover{\n    background: transparent;\n}\n\n.tab-content{\n}\n.tab-pane{\n    position: relative;\n    padding-top: 50px;\n}\n.tab-content .head{\n    font-family: \'Roboto Condensed\', sans-serif;\n    font-size: 25px;\n    text-transform: uppercase;\n    padding-bottom: 10px;\n}\n.btn-outline-rounded{\n    padding: 10px 40px;\n    margin: 20px 0;\n    border: 2px solid transparent;\n    border-radius: 25px;\n}\n\n.btn.green{\n    background-color:#5cb85c;\n    /*border: 2px solid #5cb85c;*/\n    color: #ffffff;\n}\n\n.tab-content .badge {\n    font-weight: normal;\n    vertical-align: top;\n}\n\n\n\n@media( max-width : 585px ){\n\n    .board {\n        width: 90%;\n        height:auto !important;\n    }\n    span.round-tabs {\n        font-size:16px;\n        width: 50px;\n        height: 50px;\n        line-height: 50px;\n    }\n    .tab-content .head{\n        font-size:20px;\n    }\n    .nav-tabs > li a {\n        width: 50px;\n        height: 50px;\n        line-height:50px;\n    }\n\n    .nav-tabs > li.active:after {\n        content: \" \";\n        position: absolute;\n        left: 35%;\n    }\n\n    .btn-outline-rounded {\n        padding:12px 20px;\n    }\n}\n    .modal-dialog {\n        width: 800px\n    }\n    .modal-body {\n        background:#efefe9;\n    }</style><div class=\"modal-body\"><!-- http://bootsnipp.com/snippets/featured/content-in-bootstrap-tabs --><div class=\"board wizard-splash\"><div class=\"board-inner\"><ul class=\"nav nav-tabs\" data-js-tabs><div class=\"liner\"></div><li class=\"active\"><a href=\"#home\" data-toggle=\"tab\" title=\"Welcome\"><span class=\"round-tabs one\"><i class=\"glyphicon glyphicon-home\"></i> </span></a></li><li><a href=\"#connect-crm\" data-toggle=\"tab\" title=\"Setup your Profile\" id=\"connect-crm-link\"><span class=\"round-tabs two\"><i class=\"si si-user-follow\"></i></span></a></li><li><a href=\"#template\" data-toggle=\"tab\" title=\"Upload a Template\" id=\"template-link\"><span class=\"round-tabs three\"><i class=\"si si-doc\"></i></span></a></li><li><a href=\"#printjob\" data-toggle=\"tab\" title=\"Start a Print Job\" id=\"printjob-link\"><span class=\"round-tabs four\"><i class=\"si si-printer\"></i> </span></a></li><li><a href=\"#done\" data-toggle=\"tab\" title=\"completed\" id=\"done-link\"><span class=\"round-tabs five\"><i class=\"glyphicon glyphicon-ok\"></i></span></a></li></ul></div><div id=\"splash-video\" class=\"tab-content animated\" style=\"display:none\"><div class=\"tab-pane active\" style=\"padding-top: 0\"><div align=\"center\"><iframe width=\"760\" height=\"350\" ng-src=\"{{vm.videoUrl}}\" frameborder=\"0\" allowfullscreen></iframe></div><div class=\"text-center\"><button class=\"btn btn-sm btn-minw btn-rounded btn-default\" type=\"button\" ng-click=\"vm.closeVideo()\"><i class=\"fa fa-times\"></i> Close</button></div></div></div><div id=\"splash-content\" class=\"tab-content animated\"><div class=\"tab-pane fade in active\" id=\"home\"><h3 class=\"head text-center\">Welcome to CRM2Print <i class=\"si si-animated-envelope\"></i></h3><p class=\"narrow text-center\"><!--<div class=\"crm2print-logo\"/>--><object width=\"75\" height=\"75\" data=\"/content/images/logos/crm2print.svg\"></object></p><p class=\"narrow text-center\">We\'re excited to have you as a new member and want to provide you with the resources you need to get the most out of outsourcing your direct mail printing.</p><p class=\"text-center\"><a onclick=\"$(\'#connect-crm-link\').trigger(\'click\')\" class=\"btn btn-success btn-outline-rounded green\">Next: Setup your profile & link your CRM <span style=\"margin-left:10px\" class=\"glyphicon glyphicon-chevron-right\"></span></a></p></div><div class=\"tab-pane fade\" id=\"connect-crm\"><h3 class=\"head text-center\">Setup your profile</h3><p class=\"narrow text-center\"><ul class=\"push-150-l fa-ul\"><li><i class=\"fa fa-check fa-li\"></i>Connect your CRM / List Provider<ul class=\"fa-ul\"><li><i class=\"fa fa-angle-right fa-li\"></i>Rex, VaultRE/MyDesktop, LockedOn, Property Tree, <a href=\"https://www.stashproperty.com.au\" target=\"_blank\" title=\"Stash helps property professionals find deals faster\">Stash</a>, <a href=\"https://www.nexu.com.au\" target=\"_blank\" title=\"Targeted Leads - Connect with Home Sellers, Buyers & Tenants\">NEXU</a>, ... <span class=\"badge badge-info\" ng-click=\"vm.showVideo(\'setup-link-crm\')\"><i class=\"fa fa-youtube-play\"></i> show me</span></li><li><i class=\"fa fa-angle-right fa-li\"></i>Configure Rex page margins and templates to ensure the address block gets printed in the correct position. <span class=\"badge badge-info\" ng-click=\"vm.showVideo(\'rex-margins\')\"><i class=\"fa fa-youtube-play\"></i> show me</span></li></ul></li><li><i class=\"fa fa-check fa-li\"></i>Update Profile and Settings<ul class=\"fa-ul\"><li><i class=\"fa fa-angle-right fa-li\"></i>Postcode and Country <span class=\"text-warning\">(required)</span> <span class=\"badge badge-info\" ng-click=\"vm.showVideo(\'setup-postcode\')\"><i class=\"fa fa-youtube-play\"></i> show me</span></li><li><i class=\"fa fa-angle-right fa-li\"></i>Update Contact details (for technical enquires)</li><li><i class=\"fa fa-angle-right fa-li\"></i>Appoint Print Job approver. <span class=\"badge badge-info\" ng-click=\"vm.showVideo(\'setup-approver\')\"><i class=\"fa fa-youtube-play\"></i> show me</span></li></ul></li><li><i class=\"fa fa-check fa-li\"></i>Update Billing Details<ul class=\"fa-ul\"><li><i class=\"fa fa-angle-right fa-li\"></i>Credit Card Details <span ng-show=\"utm.source==\'rexsoftware\'\" class=\"text-warning\">(required)</span> <span class=\"badge badge-info\" ng-click=\"vm.showVideo(\'setup-add-credit-card\')\"><i class=\"fa fa-youtube-play\"></i> show me</span></li><li><i class=\"fa fa-angle-right fa-li\"></i>Update Billing Contact Details (billing enquires)</li></ul></li></ul></p><p class=\"text-center\"><a onclick=\"$(\'#template-link\').trigger(\'click\')\" class=\"btn btn-success btn-outline-rounded green\">Next: Upload your template <span style=\"margin-left:10px\" class=\"glyphicon glyphicon-chevron-right\"></span></a></p></div><div class=\"tab-pane fade\" id=\"template\"><h3 class=\"head text-center\">Upload a Template</h3><p class=\"wide text-center\">Create and upload a Word Document with mail merge fields (e.g. <span style=\"font-family: monospace\">$$greeting$$</span>).</p><ul class=\"push-150-l fa-ul\"><li><i class=\"fa fa-check fa-li\"></i>Create a mail merge template <span class=\"badge badge-info\" ng-click=\"vm.showVideo(\'create-merge-template\')\"><i class=\"fa fa-youtube-play\"></i> show me</span></li><li><i class=\"fa fa-check fa-li\"></i>Upload your Word or RTF Mail Merge templates and letterheads. <span class=\"badge badge-info\" ng-click=\"vm.showVideo(\'upload-template\')\"><i class=\"fa fa-youtube-play\"></i> show me</span></li></ul><p class=\"text-center\"><a onclick=\"$(\'#printjob-link\').trigger(\'click\')\" class=\"btn btn-success btn-outline-rounded green\">Next: Start a print job <span style=\"margin-left:10px\" class=\"glyphicon glyphicon-chevron-right\"></span></a></p></div><div class=\"tab-pane fade\" id=\"printjob\"><h3 class=\"head text-center\">Create a Print Job!</h3><p class=\"wide text-center\">Upload &amp; validate your address database, preview &amp; submit your mail-out. <span class=\"badge badge-info\" ng-click=\"vm.showVideo(\'submit-printjob\')\"><i class=\"fa fa-youtube-play\"></i> show me</span></p><p class=\"text-center\"><a onclick=\"$(\'#done-link\').trigger(\'click\')\" class=\"btn btn-success btn-outline-rounded green\">Next: Where can I find help? <span style=\"margin-left:10px\" class=\"glyphicon glyphicon-chevron-right\"></span></a></p></div><div class=\"tab-pane fade\" id=\"done\"><div class=\"text-center\"><i class=\"img-intro icon-checkmark-circle\"></i></div><h3 class=\"head text-center\">thanks for staying tuned! <span style=\"color:#f48260\">♥</span> CRM2Print</h3><p class=\"wide\">Also checkout our <a ui-sref=\"faq\" ng-click=\"vm.cancel()\">Frequently Asked Question</a>, including how to:</p><ul class=\"alternate\" type=\"square\" style=\"margin: 5px 10%\"><li>Import you leads directly from your CRM</li><li>Upload your existing Word templates</li><li>Create your first Print Job to start saving time sending letters manually</li></ul><p class=\"wide\">Prefer to talk to a human?</p><ul class=\"alternate\" type=\"square\" style=\"margin: 5px 10%\"><li>Chat to us online... <a onclick=\"window.fcWidget.open()\">right now</a>.</li><li>Send us a <a ui-sref=\"contact-us\" ng-click=\"vm.cancel()\">message</a></li><li>Send an email to <a href=\"mailto:support@crm2print.com?subject=Website Enquiry\">support@crm2print.com</a></li></ul><p class=\"text-center\"><a ng-click=\"vm.cancel()\" class=\"btn btn-success btn-outline-rounded green\">Start using CRM2Print <span style=\"margin-left:10px\" class=\"glyphicon glyphicon-send\"></span></a></p></div><div class=\"clearfix\"></div></div></div><div style=\"position: absolute; right:10px; bottom: 3px\"><label class=\"checkbox-inline\" for=\"showWelcomeGuide-checkbox\" style=\"font-size: 12px\"><input type=\"checkbox\" id=\"showWelcomeGuide-checkbox\" name=\"showWelcomeGuide-checkbox\" ng-model=\"vm.userProfile.showWelcomeGuide\" ng-change=\"vm.markGuideAsSeen()\"> show on startup</label></div></div>");
$templateCache.put("app/entities/cart/cart-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.cart.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.cart.delete.question\" translate-values=\"{id: \'{{vm.cart.id}}\'}\">Are you sure you want to delete this Cart?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/cart/cart-detail.html","<div><h2><span translate=\"crm2PrintApp.cart.detail.title\">Cart</span> {{vm.cart.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.cart.created\">Created</span></dt><dd><span>{{vm.cart.created | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.cart.user\">User</span></dt><dd>{{vm.cart.userLogin}}</dd></dl><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button> <button type=\"button\" ui-sref=\"cart-detail.edit({id:vm.cart.id})\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\">Edit</span></button></div>");
$templateCache.put("app/entities/cart/cart-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCartLabel\" translate=\"crm2PrintApp.cart.home.createOrEditLabel\">Create or edit a Cart</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.cart.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.cart.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.cart.created\" for=\"field_created\">Created</label><div class=\"input-group\"><input id=\"field_created\" type=\"text\" class=\"form-control\" name=\"created\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.cart.created\" is-open=\"vm.datePickerOpenStatus.created\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'created\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.created.$invalid\"><p class=\"help-block\" ng-show=\"editForm.created.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.created.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label translate=\"crm2PrintApp.cart.user\" for=\"field_user\">User</label><select class=\"form-control\" id=\"field_user\" name=\"user\" ng-model=\"vm.cart.userId\" ng-options=\"user.id as user.login for user in vm.users\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.user.$invalid\"><p class=\"help-block\" ng-show=\"editForm.user.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/cart/carts.html","<div><h2 translate=\"crm2PrintApp.cart.home.title\">Carts</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"cart.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.cart.home.createLabel\">Create new Cart</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.cart.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"crm2PrintApp.cart.created\">Created</span></th><th><span translate=\"crm2PrintApp.cart.user\">User</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"cart in vm.carts track by cart.id\"><td><a ui-sref=\"cart-detail({id:cart.id})\">{{cart.id}}</a></td><td>{{cart.created | date:\'medium\'}}</td><td>{{cart.userLogin}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"cart-detail({id:cart.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"cart.edit({id:cart.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"cart.delete({id:cart.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/cost-center/cost-center-confirm-invite-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmInvite(vm.costCenter.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\">Accept invitation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.costCenter.confirmInvite.question\" translate-values=\"{id: \'{{vm.costCenter.name}}\', account: \'{{vm.costCenter.user.login}}\'}\">Will you accept the invitation to pay for the charges against this Cost Center?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-thumbs-up\"></span>&nbsp;<span translate=\"crm2PrintApp.costCenter.action.accept\">Accept</span></button></div></form>");
$templateCache.put("app/entities/cost-center/cost-center-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.costCenter.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.costCenter.delete.question\" translate-values=\"{id: \'{{vm.costCenter.id}}\'}\">Are you sure you want to delete this Cost Center?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/cost-center/cost-center-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\"><span translate=\"crm2PrintApp.costCenter.detail.title\">Cost Center</span> #{{vm.costCenter.id}}</h3></div><div class=\"block-content\"><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.costCenter.name\">Name</span></dt><dd><span>{{vm.costCenter.name}}</span></dd><dt><span translate=\"crm2PrintApp.costCenter.status\">Status</span></dt><dd><span translate=\"{{\'crm2PrintApp.CostCenterStatus.\' + vm.costCenter.status}}\">{{vm.costCenter.status}}</span></dd><dt><span translate=\"crm2PrintApp.costCenter.createdTimestamp\">Created</span></dt><dd><span>{{vm.costCenter.created | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.costCenter.user\">User</span></dt><dd>{{vm.costCenter.user.login}}</dd><dt><span translate=\"crm2PrintApp.costCenter.chargeToUser\">Charge To</span></dt><dd>{{vm.costCenter.chargeToUser.login}}</dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info push-10\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div>");
$templateCache.put("app/entities/cost-center/cost-center-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCostCenterLabel\" translate=\"crm2PrintApp.costCenter.home.createOrEditLabel\">Create or edit a Cost Center</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.costCenter.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.costCenter.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.costCenter.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.costCenter.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.costCenter.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.costCenter.status\" id=\"field_status\"><option value=\"OPEN\" translate=\"crm2PrintApp.CostCenterStatus.OPEN\">OPEN</option><option value=\"CLOSED\" translate=\"crm2PrintApp.CostCenterStatus.CLOSED\">CLOSED</option><option value=\"ARCHIVED\" translate=\"crm2PrintApp.CostCenterStatus.ARCHIVED\">ARCHIVED</option><option value=\"PENDING\" translate=\"crm2PrintApp.CostCenterStatus.PENDING\">PENDING</option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/cost-center/cost-center-send-invite-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.sendInvite(vm.costCenter.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\">Send invitation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.costCenter.sendInvite.question\" translate-values=\"{id: \'{{vm.costCenter.name}}\'}\">Send invitation to the person responsible for the charges against this Cost Center?</p><p><input type=\"text\" ng-model=\"vm.email\"></p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-send\"></span>&nbsp;<span translate=\"crm2PrintApp.costCenter.action.send\">Send</span></button></div></form>");
$templateCache.put("app/entities/cost-center/cost-centers.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.costCenter.home.title\">Cost Centers</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"cost-center.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.costCenter.home.createLabel\">Create new Cost Center</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.costCenter.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"crm2PrintApp.costCenter.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"crm2PrintApp.costCenter.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"created\"><span translate=\"crm2PrintApp.costCenter.createdTimestamp\">Created</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"chargeToUserLogin\"><span translate=\"crm2PrintApp.costCenter.chargeToUser\">Charge To User</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"costCenter in vm.costCenters track by costCenter.id\"><td><a ui-sref=\"cost-center-detail({id:costCenter.id})\">{{costCenter.id}}</a></td><td>{{costCenter.name}}</td><td translate=\"{{\'crm2PrintApp.CostCenterStatus.\' + costCenter.status}}\">{{costCenter.status}}</td><td>{{costCenter.created | date:\'medium\'}}</td><td>{{costCenter.chargeToUserLogin}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"cost-center-detail({id:costCenter.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"cost-center.edit({id:costCenter.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"cost-center.delete({id:costCenter.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button> <button type=\"submit\" ui-sref=\"cost-center.send-invite({id:costCenter.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-send\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"crm2PrintApp.costCenter.action.send\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div></div>");
$templateCache.put("app/entities/country/countries.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.country.home.title\">Countries</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"country.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.country.home.createLabel\">Create new Country</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.country.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"crm2PrintApp.country.name\">Name</span></th><th><span translate=\"crm2PrintApp.country.supportedSince\">Supported Since</span></th><th><span translate=\"crm2PrintApp.country.code2\">Code 2</span></th><th><span translate=\"crm2PrintApp.country.code3\">Code 3</span></th><th><span translate=\"crm2PrintApp.country.currency\">Currency</span></th><th><span translate=\"crm2PrintApp.country.taxRate\">Tax Rate</span></th><th><span translate=\"crm2PrintApp.country.taxName\">Tax Name</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"country in vm.countries track by country.id\"><td><a ui-sref=\"country-detail({id:country.id})\">{{country.id}}</a></td><td>{{country.name}}</td><td>{{country.supportedSince | date:\'medium\'}}</td><td>{{country.code2}}</td><td>{{country.code3}}</td><td>{{country.currency}}</td><td>{{country.taxRate}}</td><td>{{country.taxName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"country-detail({id:country.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"country.edit({id:country.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"country.delete({id:country.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/entities/country/country-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.country.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.country.delete.question\" translate-values=\"{id: \'{{vm.country.id}}\'}\">Are you sure you want to delete this Country?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/country/country-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.country.detail.title\">Country {{vm.country.id}}</h3></div><div class=\"block-content\"><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.country.name\">Name</span></dt><dd><span>{{vm.country.name}}</span></dd><dt><span translate=\"crm2PrintApp.country.supportedSince\">Supported Since</span></dt><dd><span>{{vm.country.supportedSince | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.country.code2\">Code 2</span></dt><dd><span>{{vm.country.code2}}</span></dd><dt><span translate=\"crm2PrintApp.country.code3\">Code 3</span></dt><dd><span>{{vm.country.code3}}</span></dd><dt><span translate=\"crm2PrintApp.country.currency\">Currency</span></dt><dd><span>{{vm.country.currency}}</span></dd><dt><span translate=\"crm2PrintApp.country.taxRate\">Tax Rate</span></dt><dd><span>{{vm.country.taxRate}}</span></dd><dt><span translate=\"crm2PrintApp.country.taxName\">Tax Name</span></dt><dd><span>{{vm.country.taxName}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div>");
$templateCache.put("app/entities/country/country-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCountryLabel\" translate=\"crm2PrintApp.country.home.createOrEditLabel\">Create or edit a Country</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.country.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.country.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.country.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.country.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.country.supportedSince\" for=\"field_supportedSince\">Supported Since</label><div class=\"input-group\"><input id=\"field_supportedSince\" type=\"text\" class=\"form-control\" name=\"supportedSince\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.country.supportedSince\" is-open=\"vm.datePickerOpenStatus.supportedSince\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'supportedSince\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.country.code2\" for=\"field_code2\">Code 2</label><input type=\"text\" class=\"form-control\" name=\"code2\" id=\"field_code2\" ng-model=\"vm.country.code2\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.country.code3\" for=\"field_code3\">Code 3</label><input type=\"text\" class=\"form-control\" name=\"code3\" id=\"field_code3\" ng-model=\"vm.country.code3\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.country.currency\" for=\"field_currency\">Currency</label><input type=\"text\" class=\"form-control\" name=\"currency\" id=\"field_currency\" ng-model=\"vm.country.currency\" required ng-minlength=\"3\" ng-maxlength=\"3\"><div ng-show=\"editForm.currency.$invalid\"><p class=\"help-block\" ng-show=\"editForm.currency.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.currency.$error.minlength\" translate=\"entity.validation.minlength\" translate-value-min=\"3\">This field is required to be at least 3 characters.</p><p class=\"help-block\" ng-show=\"editForm.currency.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"3\">This field cannot be longer than 3 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.country.taxRate\" for=\"field_taxRate\">Tax Rate</label><input type=\"number\" class=\"form-control\" name=\"taxRate\" id=\"field_taxRate\" ng-model=\"vm.country.taxRate\" required><div ng-show=\"editForm.taxRate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.taxRate.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.taxRate.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.country.taxName\" for=\"field_taxName\">Tax Name</label><input type=\"text\" class=\"form-control\" name=\"taxName\" id=\"field_taxName\" ng-model=\"vm.country.taxName\" required><div ng-show=\"editForm.taxName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.taxName.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/envelope/envelope-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.envelope.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.envelope.delete.question\" translate-values=\"{id: \'{{vm.envelope.id}}\'}\">Are you sure you want to delete this Envelope?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/envelope/envelope-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.envelope.detail.title\">Envelope {{vm.envelope.id}}</h3></div><div class=\"block-content\"><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.envelope.code\">Code</span></dt><dd><span>{{vm.envelope.code}}</span></dd><dt><span translate=\"crm2PrintApp.envelope.label\">Label</span></dt><dd><span>{{vm.envelope.label}}</span></dd><dt><span translate=\"crm2PrintApp.envelope.size\">Size</span></dt><dd><span>{{vm.envelope.size}}</span></dd><dt><span translate=\"crm2PrintApp.envelope.width\">Width</span></dt><dd><span>{{vm.envelope.width}}</span></dd><dt><span translate=\"crm2PrintApp.envelope.height\">Height</span></dt><dd><span>{{vm.envelope.height}}</span></dd><dt><span translate=\"crm2PrintApp.envelope.windowLeft\">Window Left</span></dt><dd><span>{{vm.envelope.windowLeft}}</span></dd><dt><span translate=\"crm2PrintApp.envelope.windowTop\">Window Top</span></dt><dd><span>{{vm.envelope.windowTop}}</span></dd><dt><span translate=\"crm2PrintApp.envelope.windowRight\">Window Right</span></dt><dd><span>{{vm.envelope.windowRight}}</span></dd><dt><span translate=\"crm2PrintApp.envelope.windowBottom\">Window Bottom</span></dt><dd><span>{{vm.envelope.windowBottom}}</span></dd><dt><span translate=\"crm2PrintApp.envelope.windowWidth\">Window Width</span></dt><dd><span>{{vm.envelope.windowWidth}}</span></dd><dt><span translate=\"crm2PrintApp.envelope.windowHeight\">Window Height</span></dt><dd><span>{{vm.envelope.windowHeight}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info push-10\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div>");
$templateCache.put("app/entities/envelope/envelope-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myEnvelopeLabel\" translate=\"crm2PrintApp.envelope.home.createOrEditLabel\">Create or edit a Envelope</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.envelope.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.envelope.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.envelope.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.envelope.code\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.envelope.label\" for=\"field_label\">Label</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.envelope.label\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.envelope.size\" for=\"field_size\">Size</label><select class=\"form-control\" name=\"size\" ng-model=\"vm.envelope.size\" id=\"field_size\"><option value=\"DLX\">DLX</option><option value=\"DL\">DL</option><option value=\"C6\">C6</option><option value=\"NA_10_DG1\">NA_10_DG1</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.envelope.width\" for=\"field_width\">Width</label><input type=\"number\" class=\"form-control\" name=\"width\" id=\"field_width\" ng-model=\"vm.envelope.width\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.envelope.height\" for=\"field_height\">Height</label><input type=\"number\" class=\"form-control\" name=\"height\" id=\"field_height\" ng-model=\"vm.envelope.height\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.envelope.windowLeft\" for=\"field_windowLeft\">Window Left</label><input type=\"number\" class=\"form-control\" name=\"windowLeft\" id=\"field_windowLeft\" ng-model=\"vm.envelope.windowLeft\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.envelope.windowTop\" for=\"field_windowTop\">Window Top</label><input type=\"number\" class=\"form-control\" name=\"windowTop\" id=\"field_windowTop\" ng-model=\"vm.envelope.windowTop\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.envelope.windowRight\" for=\"field_windowRight\">Window Right</label><input type=\"number\" class=\"form-control\" name=\"windowRight\" id=\"field_windowRight\" ng-model=\"vm.envelope.windowRight\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.envelope.windowBottom\" for=\"field_windowBottom\">Window Bottom</label><input type=\"number\" class=\"form-control\" name=\"windowBottom\" id=\"field_windowBottom\" ng-model=\"vm.envelope.windowBottom\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.envelope.windowWidth\" for=\"field_windowWidth\">Window Width</label><input type=\"number\" class=\"form-control\" name=\"windowWidth\" id=\"field_windowWidth\" ng-model=\"vm.envelope.windowWidth\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.envelope.windowHeight\" for=\"field_windowHeight\">Window Height</label><input type=\"number\" class=\"form-control\" name=\"windowHeight\" id=\"field_windowHeight\" ng-model=\"vm.envelope.windowHeight\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/envelope/envelopes.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.envelope.home.title\">Envelopes</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"envelope.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.envelope.home.createLabel\">Create new Envelope</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.envelope.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"crm2PrintApp.envelope.code\">Code</span></th><th><span translate=\"crm2PrintApp.envelope.size\">Size</span></th><th><span translate=\"crm2PrintApp.envelope.width\">Width</span></th><th><span translate=\"crm2PrintApp.envelope.height\">Height</span></th><th><span translate=\"crm2PrintApp.envelope.windowLeft\">Window Left</span></th><th><span translate=\"crm2PrintApp.envelope.windowTop\">Window Top</span></th><th><span translate=\"crm2PrintApp.envelope.windowRight\">Window Right</span></th><th><span translate=\"crm2PrintApp.envelope.windowBottom\">Window Bottom</span></th><th><span translate=\"crm2PrintApp.envelope.windowWidth\">Window Width</span></th><th><span translate=\"crm2PrintApp.envelope.windowHeight\">Window Height</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"envelope in vm.envelopes track by envelope.id\"><td><a ui-sref=\"envelope-detail({id:envelope.id})\">{{envelope.id}}</a></td><td>{{envelope.code}}</td><td>{{envelope.size}}</td><td>{{envelope.width}}</td><td>{{envelope.height}}</td><td>{{envelope.windowLeft}}</td><td>{{envelope.windowTop}}</td><td>{{envelope.windowRight}}</td><td>{{envelope.windowBottom}}</td><td>{{envelope.windowWidth}}</td><td>{{envelope.windowHeight}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"envelope-detail({id:envelope.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"envelope.edit({id:envelope.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"envelope.delete({id:envelope.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/entities/faq/faq-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.faq.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.faq.delete.question\" translate-values=\"{id: \'{{vm.faq.id}}\'}\">Are you sure you want to delete this FAQ?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/faq/faq-detail.html","<div><h2><span translate=\"crm2PrintApp.faq.detail.title\">FAQ</span> {{vm.faq.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.faq.question\">Question</span></dt><dd><span>{{vm.faq.question}}</span></dd><dt><span translate=\"crm2PrintApp.faq.answer\">Answer</span></dt><dd><span>{{vm.faq.answer}}</span></dd><dt><span translate=\"crm2PrintApp.faq.category\">Category</span></dt><dd><span translate=\"{{\'crm2PrintApp.FAQCategory.\' + vm.faq.category}}\">{{vm.faq.category}}</span></dd><dt><span translate=\"crm2PrintApp.faq.lastModified\">Last Modified</span></dt><dd><span>{{vm.faq.lastModified | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.faq.lastModifiedBy\">Last Modified By</span></dt><dd>{{vm.faq.lastModifiedByLogin}}</dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/faq/faq-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myFAQLabel\" translate=\"crm2PrintApp.faq.home.createOrEditLabel\">Create or edit a FAQ</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.faq.category\" for=\"field_category\">Category</label><select class=\"form-control\" name=\"category\" ng-model=\"vm.faq.category\" id=\"field_category\" required><option value=\"ACCOUNT\" translate=\"crm2PrintApp.FAQCategory.ACCOUNT\">ACCOUNT</option><option value=\"PAYMENT\" translate=\"crm2PrintApp.FAQCategory.PAYMENT\">PAYMENT</option><option value=\"FEATURES\" translate=\"crm2PrintApp.FAQCategory.FEATURES\">FEATURES</option><option value=\"TIPS\" translate=\"crm2PrintApp.FAQCategory.TIPS\">TIPS</option></select><div ng-show=\"editForm.category.$invalid\"><p class=\"help-block\" ng-show=\"editForm.category.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.faq.question\" for=\"field_question\">Question</label><input type=\"text\" class=\"form-control\" name=\"question\" id=\"field_question\" ng-model=\"vm.faq.question\" required><div ng-show=\"editForm.question.$invalid\"><p class=\"help-block\" ng-show=\"editForm.question.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.faq.answer\">Answer</label><input ng-model=\"vm.faq.answer\" type=\"hidden\" name=\"answer\" id=\"field_answer\" required><summernote ng-model=\"vm.faq.answer\" height=\"150\"></summernote><div ng-show=\"editForm.answer.$invalid\"><p class=\"help-block\" ng-show=\"editForm.answer.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/faq/faqs.html","<style type=\"text/css\">.block.block-faq {\n        margin-bottom: 10px;\n    }</style><jhi-alert></jhi-alert><div class=\"bg-primary-dark\"><section class=\"content content-full content-boxed\"><div class=\"push-100-t push-50 text-center\"><h1 class=\"h2 text-white push-10 animated fadeInDown\" data-toggle=\"appear\" data-class=\"animated fadeInDown\">Support Center.</h1><h2 class=\"h5 text-white-op animated fadeInDown\" data-toggle=\"appear\" data-class=\"animated fadeInDown\">Making direct mail as simple and efficient is not our only job. We care about our clients.</h2></div></section></div><div class=\"bg-white\"><section class=\"content content-boxed overflow-hidden\"><div class=\"content-grid\"><div class=\"row\"><div ng-repeat=\"(key, value) in vm.categories\" class=\"col-xs-6 col-sm-3 animated fadeInDown\" data-toggle=\"appear\" data-class=\"animated fadeInDown\"><a class=\"block block-bordered block-rounded block-link-hover3\" href=\"javascript:void(0)\"><div class=\"block-content block-content-full border-b text-center\"><div class=\"item\" ng-switch=\"key\"><i class=\"si si-user text-amethyst\" ng-switch-when=\"ACCOUNT\"></i> <i class=\"si si-settings text-city\" ng-switch-when=\"FEATURES\"></i> <i class=\"si si-wallet text-smooth\" ng-switch-when=\"PAYMENT\"></i> <i class=\"si si-target text-flat\" ng-switch-when=\"TIPS\"></i></div></div><div class=\"block-content block-content-full block-content-mini\"><span class=\"font-w600 text-uppercase\"><span class=\"badge badge-default pull-right\">{{value.count}}</span> <span translate=\"crm2PrintApp.FAQCategory.{{key}}\">{{key}}</span></span></div></a></div></div></div></section></div><div class=\"bg-gray-lighter\"><section class=\"content content-full content-boxed\"><div class=\"row\"><div class=\"col-sm-8 col-sm-offset-2\"><form name=\"searchForm\" ng-submit=\"vm.search(vm.searchQuery)\"><div class=\"input-group input-group-lg\"><div class=\"input-group-btn\" ui-sref=\"faq.new\" has-authority=\"ROLE_ADMIN\"><button type=\"button\" class=\"btn btn-primary\"><i class=\"fa fa-plus\"></i></button></div><input class=\"form-control\" type=\"text\" placeholder=\"Search for answers..\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.faq.home.search\' | translate }}\"><div class=\"input-group-btn\" ng-click=\"vm.search(vm.searchQuery)\"><button class=\"btn btn-default\"><i class=\"fa fa-search\"></i></button></div><div class=\"input-group-btn\" ng-if=\"vm.currentSearch\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clear()\"><i class=\"fa fa-trash\"></i></button></div></div></form></div></div></section></div><div class=\"bg-white\"><section class=\"content content-full content-boxed\"><div class=\"row push-20-t push-20\"><div class=\"col-sm-8 col-sm-offset-2\" ng-repeat=\"(key, value) in vm.categories\"><h2 class=\"h3 font-w600 push-30-t push\"><span translate=\"crm2PrintApp.FAQCategory.{{key}}\">{{key}}</span></h2><div class=\"block block-opt-hidden block-rounded block-bordered block-faq\" ng-repeat=\"faq in value.faqs\"><div id=\"faq-{{faq.id}}\" class=\"block-header bg-gray-lighter\"><ul class=\"block-options\" has-authority=\"ROLE_ADMIN\"><li><button type=\"submit\" ui-sref=\"faq.edit({id:faq.id})\"><i class=\"si si-pencil\"></i></button></li><li><button type=\"submit\" ui-sref=\"faq.delete({id:faq.id})\"><i class=\"si si-trash\"></i></button></li></ul><a href=\"\" data-js-block-action data-action=\"content_toggle\"><h3 class=\"block-title text-normal\">{{faq.question}}</h3></a></div><div class=\"block-content\"><p ng-bind-html=\"faq.answer | html\"></p><small class=\"text-muted\">Last Updated: {{faq.lastModified | date:\'medium\'}} by {{faq.lastModifiedByLogin}}</small></div></div></div></div></section></div><div class=\"bg-gray-lighter\"><section class=\"content content-full content-boxed\"><div class=\"push-20-t push-20 text-center\"><h3 class=\"h4 push-20 animated fadeIn\" data-toggle=\"appear\">Can\'t find what you were looking for?</h3><a class=\"btn btn-rounded btn-noborder btn-lg btn-success animated bounceIn\" data-toggle=\"appear\" data-class=\"animated bounceIn\" ui-sref=\"contact-us\">Contact Us</a></div></section></div>");
$templateCache.put("app/entities/industry/industries.html","<div><h2 translate=\"crm2PrintApp.industry.home.title\">Industries</h2><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"industry.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.industry.home.createLabel\">Create new Industry</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.industry.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"crm2PrintApp.industry.name\">Name</span></th><th><span translate=\"crm2PrintApp.industry.icon\">Icon</span></th><th><span translate=\"crm2PrintApp.industry.subTitle\">Sub Title</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"industry in vm.industries track by industry.id\"><td><a ui-sref=\"industry-detail({id:industry.id})\">{{industry.id}}</a></td><td>{{industry.name}}</td><td>{{industry.icon}}</td><td>{{industry.subTitle}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"industry-detail({id:industry.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"industry.edit({id:industry.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"industry.delete({id:industry.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/industry/industry-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.industry.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.industry.delete.question\" translate-values=\"{id: \'{{vm.industry.id}}\'}\">Are you sure you want to delete this Industry?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/industry/industry-detail.html","<div><h2><span translate=\"crm2PrintApp.industry.detail.title\">Industry</span> {{vm.industry.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.industry.name\">Name</span></dt><dd><span>{{vm.industry.name}}</span></dd><dt><span translate=\"crm2PrintApp.industry.icon\">Icon</span></dt><dd><span>{{vm.industry.icon}}</span></dd><dt><span translate=\"crm2PrintApp.industry.subTitle\">Sub Title</span></dt><dd><span>{{vm.industry.subTitle}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/industry/industry-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myIndustryLabel\" translate=\"crm2PrintApp.industry.home.createOrEditLabel\">Create or edit a Industry</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.industry.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.industry.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.industry.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.industry.name\" required><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.industry.icon\" for=\"field_icon\">Icon</label><input type=\"text\" class=\"form-control\" name=\"icon\" id=\"field_icon\" ng-model=\"vm.industry.icon\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.industry.subTitle\" for=\"field_subTitle\">Sub Title</label><input type=\"text\" class=\"form-control\" name=\"subTitle\" id=\"field_subTitle\" ng-model=\"vm.industry.subTitle\" required><div ng-show=\"editForm.subTitle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.subTitle.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/invoice/invoice-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.invoice.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.invoice.delete.question\" translate-values=\"{id: \'{{vm.invoice.id}}\'}\">Are you sure you want to delete this Invoice?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/invoice/invoice-detail.html","<div class=\"content content-boxed\"><style type=\"text/css\">.chargeCancelled {\n            text-decoration: line-through;\n        }</style><div class=\"block\"><div class=\"block-header\"><ul class=\"block-options\"><li><button type=\"button\" onclick=\"window.print()\"><i class=\"si si-printer\"></i> Print Invoice</button></li></ul><h3 class=\"block-title\"># {{vm.invoice.id}}</h3></div><div class=\"block-content block-content-narrow\"><div class=\"h1 text-center push-30-t push-20\">INVOICE <span ng-show=\"vm.invoice.demo\" class=\"text-primary\">DEMO</span></div><div class=\"h4 text-center push-20\" ng-show=\"vm.invoice.reference\"><i>{{vm.invoice.reference}}</i></div><hr class=\"hidden-print\"><div class=\"row items-push-2x\"><div class=\"col-xs-6\"><p class=\"h2 font-w400 push-5\">To:</p><address><div ng-show=\"vm.userProfile.companyName\">{{vm.userProfile.companyName}}</div><div ng-show=\"vm.billingContact()\">{{vm.billingContact()}}</div><div ng-show=\"vm.userProfile.address1\">{{vm.userProfile.address1}}</div><div ng-show=\"vm.userProfile.address2\">{{vm.userProfile.address2}}</div><div>{{vm.userProfile.city}} {{vm.userProfile.state}} {{vm.userProfile.postcode}}</div><i class=\"si si-call-end\" ng-show=\"vm.billingPhone()\"></i> {{vm.billingPhone()}}<br><i class=\"si si-envelope\"></i> {{vm.billingEmail()}}</address></div><div class=\"col-xs-6 text-right\"><p class=\"h2 font-w400 push-5\">CRM2Print Pty. Ltd.</p><address><!--8/349 Macdonnell Road<br/>\n                        CLONTARF QLD 4019<br/>--> <i class=\"si si-call-end\"></i> (07) 2000 4455<br><i class=\"si si-envelope\"></i> support@crm2print.com<br>ABN 18 613 449 755</address></div></div><div class=\"h4 font-w400 push-10\"><span translate=\"crm2PrintApp.invoice.status\">Status</span>: <span class=\"label label-default\" translate=\"{{\'crm2PrintApp.InvoiceStatus.\' + vm.invoice.status}}\">{{vm.invoice.status}}</span></div><div class=\"table-responsive push-50\"><table class=\"table table-bordered table-hover\"><thead><tr><th ng-if=\"vm.allowEditing\">&nbsp;</th><th>Reference</th><th class=\"text-center\">Quantity</th><th class=\"text-right\">Unit</th><th class=\"text-right\">Amount</th></tr></thead><tbody><tr ng-repeat=\"charge in vm.invoiceCharges\" ng-class=\"{chargeCancelled: charge.printJobStatus == \'ERROR\' || charge.printJobStatus == \'CANCELLED\'}\"><td ng-if=\"vm.allowEditing\"><input type=\"checkbox\" ng-model=\"charge.selected\"></td><td><strong>[<a ui-sref=\"print-job-detail({id:charge.printJobId})\">PJ-{{charge.printJobId}}</a>]</strong> {{charge.printJobReference}}<br><i class=\"si si-star text-warning\" ng-show=\"charge.reference.startsWith(\'Voucher\')\"></i> <i>{{charge.reference}}</i><div ng-show=\"charge.costCenterName\">Cost Center: {{ charge.costCenterName }} <span ng-show=\"charge.costCenterAccount\">@ {{ charge.costCenterAccount }}</span></div></td><td class=\"text-center\"><span class=\"badge badge-primary\">{{charge.quantity}}</span></td><td class=\"text-right\">{{charge.itemAmountNet | currency:charge.currency:2}}</td><td class=\"text-right\">{{charge.amountNet | currency:charge.currency:2}}</td></tr></tbody><tr class=\"active\"><td colspan=\"{{ vm.allowEditing ? 4 : 3 }}\" class=\"font-w700 text-uppercase text-right\">Sub Total</td><td class=\"text-right\">{{vm.invoice.amountNet | currency:vm.invoice.currency:2}}</td></tr><tr><td colspan=\"{{ vm.allowEditing ? 4 : 3 }}\" class=\"font-w600 text-right\">{{vm.countryLookup[vm.invoice.countryId].taxName}}</td><td class=\"text-right\">{{vm.invoice.tax | currency:vm.invoice.currency:2}}</td></tr><tr class=\"active\"><td colspan=\"{{ vm.allowEditing ? 4 : 3 }}\" class=\"font-w700 text-uppercase text-right\">Total</td><td class=\"text-right\">{{vm.invoice.amountGross | currency:vm.invoice.currency:2}}</td></tr><tr><td colspan=\"{{ vm.allowEditing ? 2 : 1 }}\"><span ng-show=\"vm.invoice.paid\"><span translate=\"crm2PrintApp.invoice.paymentReference\" class=\"font-w600\">Payment Reference</span> <span>{{vm.invoice.paymentReference}} ({{vm.invoice.paid | date:\'dd/MM/yyyy HH:mm\'}})</span> </span><span ng-show=\"vm.invoice.errorReason\"><i class=\"fa fa-exclamation-triangle text-danger\">{{vm.invoice.errorReason}}</span></td><td colspan=\"2\" class=\"font-w700 text-uppercase text-right\">Paid <i class=\"fa fa-check text-success\" ng-show=\"vm.invoice.status == \'PAID\'\"><i class=\"fa fa-times text-danger\" ng-show=\"vm.invoice.status == \'ISSUED\'\"></td><td class=\"text-right\">{{vm.invoice.chargeAmount | currency:vm.invoice.chargeCurrency:2}}</td></tr></table><div class=\"pull-right\"><button type=\"submit\" ng-if=\"vm.allowEditing\" ng-click=\"vm.assignCostCenter()\" class=\"btn btn-info hidden-print\"><span class=\"si si-action-redo\"></span>&nbsp;Assign Cost Center</button> <button type=\"submit\" ng-click=\"vm.issueInvoice()\" class=\"btn btn-info hidden-print\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.invoice.status == \'RAISED\'\"><span class=\"si si-paper-plane\"></span>&nbsp;Issue Invoice</button> <button type=\"submit\" ng-click=\"vm.updateTotals()\" class=\"btn btn-info hidden-print\" has-authority=\"ROLE_ADMIN\" ng-if=\"vm.invoice.status != \'PAID\'\"><span class=\"si si-refresh\"></span>&nbsp;Update Totals</button> <button type=\"submit\" ng-click=\"vm.payInvoice()\" class=\"btn btn-info hidden-print\" ng-if=\"vm.invoice.status == \'ISSUED\'\"><span class=\"fa fa-dollar\"></span>&nbsp;Pay Invoice</button></div></div><hr class=\"hidden-print\"><p class=\"text-muted text-center\"><small>Thank you very much for doing business with us. We look forward to working with you again!</small></p></div></div><div class=\"block hidden-print\"><div class=\"block-header bg-gray-lighter\"><h3 class=\"block-title\">Log Messages</h3></div><div class=\"block-content\"><div class=\"table-responsive\"><table class=\"table table-borderless table-striped table-vcenter\"><tbody><tr ng-repeat=\"log in vm.invoiceHistory\"><td style=\"width: 80px\"><span class=\"label label-primary\"><span>{{log.code}}</span></span></td><td style=\"width: 220px\"><span class=\"font-w600\">{{log.created | date:\"dd/MM/yyyy HH:mm:ss\"}}</span></td><!--<td>\n                            <a href=\"javascript:void(0)\"></a>\n                        </td>--><td class=\"text-success\">{{log.comment}}</td></tr></tbody></table></div></div></div><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info hidden-print\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/invoice/invoices.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.invoice.home.title\">Invoices</h3></div><div class=\"block-content\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"crm2PrintApp.invoice.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"reference\"><span translate=\"crm2PrintApp.invoice.reference\">Reference</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"raised\"><span translate=\"crm2PrintApp.invoice.raised\">Raised</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"issued\"><span translate=\"crm2PrintApp.invoice.issued\">Issued</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"paid\"><span translate=\"crm2PrintApp.invoice.paid\">Paid</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"amountGross\" class=\"text-right\"><span translate=\"crm2PrintApp.invoice.amountGross\">Amount Gross</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"invoice in vm.invoices track by invoice.id\"><td><a ui-sref=\"invoice-detail({id:invoice.id})\">{{invoice.id}}</a></td><td><span ng-class=\"[\'label\',{\'label-info\':invoice.status==\'RAISED\',\'label-success\':invoice.status==\'PAID\',\'label-warning\':invoice.status==\'ISSUED\',\'label-danger\':invoice.status==\'ERROR\',\'label-default\':invoice.status==\'REFUNDED\'}]\" translate=\"{{\'crm2PrintApp.InvoiceStatus.\' + invoice.status}}\">{{invoice.status}}</span> <span ng-show=\"invoice.demo\" class=\"text-primary\">DEMO</span></td><td>{{invoice.reference || \'n/a\'}}</td><td>{{invoice.raised | date:\'dd/MM/yyyy\'}}</td><td>{{invoice.issued | date:\'dd/MM/yyyy\'}}</td><td>{{invoice.paid | date:\'dd/MM/yyyy\'}}</td><td class=\"text-right\">{{invoice.amountGross | currency:invoice.currency:2}} <span ng-if=\"(invoice.chargeAmount && invoice.chargeAmount != invoice.amountGross) || (invoice.chargeCurrency && invoice.chargeCurrency != invoice.currency)\">(Charged: {{invoice.chargeAmount | currency:invoice.chargeCurrency:2}})</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"invoice-detail({id:invoice.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div></div>");
$templateCache.put("app/entities/manifest-row/manifest-row-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.manifestRow.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.manifestRow.delete.question\" translate-values=\"{id: \'{{vm.manifestRow.id}}\'}\">Are you sure you want to delete this Manifest Row?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/manifest-row/manifest-row-detail.html","<div><h2><span translate=\"crm2PrintApp.manifestRow.detail.title\">Manifest Row</span> {{vm.manifestRow.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.manifestRow.sortPlan\">Sort Plan</span></dt><dd><span>{{vm.manifestRow.sortPlan}}</span></dd><dt><span translate=\"crm2PrintApp.manifestRow.letterCount\">Letter Count</span></dt><dd><span>{{vm.manifestRow.letterCount}}</span></dd><dt><span translate=\"crm2PrintApp.manifestRow.trayCount\">Tray Count</span></dt><dd><span>{{vm.manifestRow.trayCount}}</span></dd><dt><span translate=\"crm2PrintApp.manifestRow.preSort\">Pre Sort</span></dt><dd><span>{{vm.manifestRow.preSort}}</span></dd><dt><span translate=\"crm2PrintApp.manifestRow.state\">State</span></dt><dd><span>{{vm.manifestRow.state}}</span></dd><dt><span translate=\"crm2PrintApp.manifestRow.ticket\">Ticket</span></dt><dd><a ui-sref=\"vendor-job-ticket-detail({id:vm.manifestRow.ticket.id})\">{{vm.manifestRow.ticket.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/manifest-row/manifest-row-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myManifestRowLabel\" translate=\"crm2PrintApp.manifestRow.home.createOrEditLabel\">Create or edit a Manifest Row</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.manifestRow.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.manifestRow.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.manifestRow.sortPlan\" for=\"field_sortPlan\">Sort Plan</label><input type=\"text\" class=\"form-control\" name=\"sortPlan\" id=\"field_sortPlan\" ng-model=\"vm.manifestRow.sortPlan\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.manifestRow.letterCount\" for=\"field_letterCount\">Letter Count</label><input type=\"number\" class=\"form-control\" name=\"letterCount\" id=\"field_letterCount\" ng-model=\"vm.manifestRow.letterCount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.manifestRow.trayCount\" for=\"field_trayCount\">Tray Count</label><input type=\"number\" class=\"form-control\" name=\"trayCount\" id=\"field_trayCount\" ng-model=\"vm.manifestRow.trayCount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.manifestRow.preSort\" for=\"field_preSort\">Pre Sort</label><input type=\"text\" class=\"form-control\" name=\"preSort\" id=\"field_preSort\" ng-model=\"vm.manifestRow.preSort\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.manifestRow.state\" for=\"field_state\">State</label><input type=\"text\" class=\"form-control\" name=\"state\" id=\"field_state\" ng-model=\"vm.manifestRow.state\"></div><div class=\"form-group\"><label translate=\"crm2PrintApp.manifestRow.ticket\" for=\"field_ticket\">Ticket</label><select class=\"form-control\" id=\"field_ticket\" name=\"ticket\" ng-model=\"vm.manifestRow.ticket\" ng-options=\"vendorJobTicket as vendorJobTicket.id for vendorJobTicket in vm.vendorjobtickets track by vendorJobTicket.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/manifest-row/manifest-rows.html","<div><h2 translate=\"crm2PrintApp.manifestRow.home.title\">Manifest Rows</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"manifest-row.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.manifestRow.home.createLabel\">Create new Manifest Row</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.manifestRow.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"crm2PrintApp.manifestRow.sortPlan\">Sort Plan</span></th><th><span translate=\"crm2PrintApp.manifestRow.letterCount\">Letter Count</span></th><th><span translate=\"crm2PrintApp.manifestRow.trayCount\">Tray Count</span></th><th><span translate=\"crm2PrintApp.manifestRow.preSort\">Pre Sort</span></th><th><span translate=\"crm2PrintApp.manifestRow.state\">State</span></th><th><span translate=\"crm2PrintApp.manifestRow.ticket\">Ticket</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"manifestRow in vm.manifestRows track by manifestRow.id\"><td><a ui-sref=\"manifest-row-detail({id:manifestRow.id})\">{{manifestRow.id}}</a></td><td>{{manifestRow.sortPlan}}</td><td>{{manifestRow.letterCount}}</td><td>{{manifestRow.trayCount}}</td><td>{{manifestRow.preSort}}</td><td>{{manifestRow.state}}</td><td><a ui-sref=\"vendor-job-ticket-detail({id:manifestRow.ticket.id})\">{{manifestRow.ticket.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"manifest-row-detail({id:manifestRow.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"manifest-row.edit({id:manifestRow.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"manifest-row.delete({id:manifestRow.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/postal-account/postal-account-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.postalAccount.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.postalAccount.delete.question\" translate-values=\"{id: \'{{vm.postalAccount.id}}\'}\">Are you sure you want to delete this Postal Account?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/postal-account/postal-account-detail.html","<div><h2><span translate=\"crm2PrintApp.postalAccount.detail.title\">Postal Account</span> {{vm.postalAccount.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"crm2PrintApp.postalAccount.created\">Created</span></dt><dd><span>{{vm.postalAccount.created | date:\'medium\'}}</span></dd><hr><dt><span translate=\"crm2PrintApp.postalAccount.provider\">Provider</span></dt><dd><span>{{vm.postalAccount.provider}}</span></dd><hr><dt><span translate=\"crm2PrintApp.postalAccount.accountNumber\">Account Number</span></dt><dd><span>{{vm.postalAccount.accountNumber}}</span></dd><hr><dt><span translate=\"crm2PrintApp.postalAccount.country\">Country</span></dt><dd><span>{{vm.postalAccount.country}}</span></dd><hr><dt><span translate=\"crm2PrintApp.postalAccount.country\">Country</span></dt><dd><a ui-sref=\"country-detail({id:vm.postalAccount.country.id})\">{{vm.postalAccount.country.id}}</a></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/postal-account/postal-account-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPostalAccountLabel\" translate=\"crm2PrintApp.postalAccount.home.createOrEditLabel\">Create or edit a Postal Account</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.postalAccount.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.postalAccount.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.postalAccount.created\" for=\"field_created\">Created</label><div class=\"input-group\"><input id=\"field_created\" type=\"text\" class=\"form-control\" name=\"created\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.postalAccount.created\" is-open=\"vm.datePickerOpenStatus.created\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'created\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.postalAccount.provider\" for=\"field_provider\">Provider</label><input type=\"text\" class=\"form-control\" name=\"provider\" id=\"field_provider\" ng-model=\"vm.postalAccount.provider\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.postalAccount.accountNumber\" for=\"field_accountNumber\">Account Number</label><input type=\"text\" class=\"form-control\" name=\"accountNumber\" id=\"field_accountNumber\" ng-model=\"vm.postalAccount.accountNumber\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.postalAccount.country\" for=\"field_country\">Country</label><input type=\"text\" class=\"form-control\" name=\"country\" id=\"field_country\" ng-model=\"vm.postalAccount.country\"></div><div class=\"form-group\"><label translate=\"crm2PrintApp.postalAccount.country\" for=\"field_country\">Country</label><select class=\"form-control\" id=\"field_country\" name=\"country\" ng-model=\"vm.postalAccount.country\" ng-options=\"country as country.id for country in vm.countries track by country.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/postal-account/postal-accounts.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.postalAccount.home.title\">Postal Accounts</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"postal-account.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.postalAccount.home.createLabel\">Create new Postal Account</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.postalAccount.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"crm2PrintApp.postalAccount.created\">Created</span></th><th><span translate=\"crm2PrintApp.postalAccount.provider\">Provider</span></th><th><span translate=\"crm2PrintApp.postalAccount.accountNumber\">Account Number</span></th><th><span translate=\"crm2PrintApp.postalAccount.country\">Country</span></th><th><span translate=\"crm2PrintApp.postalAccount.country\">Country</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"postalAccount in vm.postalAccounts track by postalAccount.id\"><td><a ui-sref=\"postal-account-detail({id:postalAccount.id})\">{{postalAccount.id}}</a></td><td>{{postalAccount.created | date:\'medium\'}}</td><td>{{postalAccount.provider}}</td><td>{{postalAccount.accountNumber}}</td><td>{{postalAccount.country}}</td><td><a ui-sref=\"country-detail({id:postalAccount.country.id})\">{{postalAccount.country.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"postal-account-detail({id:postalAccount.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"postal-account.edit({id:postalAccount.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"postal-account.delete({id:postalAccount.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/entities/print-and-mail-cost/print-and-mail-cost-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.printAndMailCost.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.printAndMailCost.delete.question\" translate-values=\"{id: \'{{vm.printAndMailCost.id}}\'}\">Are you sure you want to delete this Print And Mail Cost?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/print-and-mail-cost/print-and-mail-cost-detail.html","<div><h2><span translate=\"crm2PrintApp.printAndMailCost.detail.title\">Print And Mail Cost</span> {{vm.printAndMailCost.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.printAndMailCost.pageCount\">Page Count</span></dt><dd><span>{{vm.printAndMailCost.pageCount}}</span></dd><dt><span translate=\"crm2PrintApp.printAndMailCost.duplex\">Duplex</span></dt><dd><span>{{vm.printAndMailCost.duplex}}</span></dd><dt><span translate=\"crm2PrintApp.printAndMailCost.envelope\">Envelope</span></dt><dd><a ui-sref=\"envelope-detail({id:vm.printAndMailCost.envelope.id})\">{{vm.printAndMailCost.envelope.id}}</a></dd><dt><span translate=\"crm2PrintApp.printAndMailCost.vendor\">Vendor</span></dt><dd><a ui-sref=\"vendor-detail({id:vm.printAndMailCost.vendor.id})\">{{vm.printAndMailCost.vendor.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/print-and-mail-cost/print-and-mail-cost-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPrintAndMailCostLabel\" translate=\"crm2PrintApp.printAndMailCost.home.createOrEditLabel\">Create or edit a Print And Mail Cost</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.printAndMailCost.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.printAndMailCost.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printAndMailCost.pageCount\" for=\"field_pageCount\">Page Count</label><input type=\"number\" class=\"form-control\" name=\"pageCount\" id=\"field_pageCount\" ng-model=\"vm.printAndMailCost.pageCount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printAndMailCost.duplex\" for=\"field_duplex\">Duplex</label><input type=\"checkbox\" class=\"form-control\" name=\"duplex\" id=\"field_duplex\" ng-model=\"vm.printAndMailCost.duplex\"></div><div class=\"form-group\"><label translate=\"crm2PrintApp.printAndMailCost.envelope\" for=\"field_envelope\">Envelope</label><select class=\"form-control\" id=\"field_envelope\" name=\"envelope\" ng-model=\"vm.printAndMailCost.envelope\" ng-options=\"envelope as envelope.id for envelope in vm.envelopes track by envelope.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"crm2PrintApp.printAndMailCost.vendor\" for=\"field_vendor\">Vendor</label><select class=\"form-control\" id=\"field_vendor\" name=\"vendor\" ng-model=\"vm.printAndMailCost.vendor\" ng-options=\"vendor as vendor.id for vendor in vm.vendors track by vendor.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/print-and-mail-cost/print-and-mail-costs.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.printAndMailCost.home.title\">Print And Mail Costs</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"print-and-mail-cost.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.printAndMailCost.home.createLabel\">Create new Print And Mail Cost</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.printAndMailCost.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"crm2PrintApp.printAndMailCost.pageCount\">Page Count</span></th><th><span translate=\"crm2PrintApp.printAndMailCost.duplex\">Duplex</span></th><th><span translate=\"crm2PrintApp.printAndMailCost.envelope\">Envelope</span></th><th><span translate=\"crm2PrintApp.printAndMailCost.vendor\">Vendor</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"printAndMailCost in vm.printAndMailCosts track by printAndMailCost.id\"><td><a ui-sref=\"print-and-mail-cost-detail({id:printAndMailCost.id})\">{{printAndMailCost.id}}</a></td><td>{{printAndMailCost.pageCount}}</td><td>{{printAndMailCost.duplex}}</td><td><a ui-sref=\"envelope-detail({id:printAndMailCost.envelope.id})\">{{printAndMailCost.envelope.id}}</a></td><td><a ui-sref=\"vendor-detail({id:printAndMailCost.vendor.id})\">{{printAndMailCost.vendor.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"print-and-mail-cost-detail({id:printAndMailCost.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"print-and-mail-cost.edit({id:printAndMailCost.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"print-and-mail-cost.delete({id:printAndMailCost.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/entities/print-job/print-job-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.printJob.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><span ng-show=\"vm.ids\">Are you sure you want to delete {{vm.ids.length}} Print Job(s)?</span><p ng-show=\"vm.printJob\" translate=\"crm2PrintApp.printJob.delete.question\" translate-values=\"{id: \'{{vm.printJob.id}}\'}\">Are you sure you want to delete this Print Job?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/print-job/print-job-detail.html","<div class=\"content content-boxed\"><div class=\"row no-print\" ng-hide=\"vm.printJob.isTemplate\"><div class=\"col-sm-6 col-md-3\"><a class=\"block block-link-hover3 text-center\" href=\"javascript:void(0)\"><div class=\"block-content block-content-full\"><span class=\"item item-circle bg-success-light\"><i class=\"fa fa-check text-success\" ng-show=\"vm.placed\"></i> <i class=\"fa fa-times text-muted\" ng-hide=\"vm.placed\"></i></span></div><div class=\"block-content block-content-full block-content-mini bg-gray-lighter text-muted font-w600\"><span translate=\"crm2PrintApp.printJob.detail.title\">Print Job</span> {{vm.printJob.id}} <span ng-show=\"vm.printJob.demo\" class=\"text-primary\">DEMO</span></div></a></div><div class=\"col-sm-6 col-md-3\"><a class=\"block block-link-hover3 text-center\" href=\"javascript:void(0)\"><div class=\"block-content block-content-full\"><span ng-class=\"[\'item\',\'item-circle\',vm.paid ? \'bg-success-light\' : \'bg-warning-light\']\"><i class=\"fa fa-check text-success\" ng-show=\"vm.paid\"></i> <i class=\"fa fa-hourglass-1 text-warning\" ng-show=\"vm.due\"></i> <i class=\"fa fa-times text-muted\" ng-hide=\"vm.paid || vm.due\"></i></span></div><div class=\"block-content block-content-full block-content-mini bg-gray-lighter text-muted font-w600\">Payment <span ng-show=\"vm.user.billingFrequency > 0\">(Terms: {{vm.user.billingFrequency}} Days)</span></div></a></div><div class=\"col-sm-6 col-md-3\"><a class=\"block block-link-hover3 text-center\" href=\"javascript:void(0)\"><div class=\"block-content block-content-full\"><span ng-class=\"[\'item\',\'item-circle\',vm.completed ? \'bg-success-light\' : \'bg-warning-light\']\"><i class=\"fa fa-check text-success\" ng-show=\"vm.completed\"></i> <i class=\"fa fa-times text-muted\" ng-show=\"!vm.inProgress && !vm.completed\"></i> <i class=\"si si-settings fa fa-spin text-warning\" ng-show=\"vm.inProgress && !vm.completed\"></i></span></div><div class=\"block-content block-content-full block-content-mini bg-gray-lighter text-muted font-w600\">Processing</div></a></div><div class=\"col-sm-6 col-md-3\"><a class=\"block block-link-hover3 text-center\" href=\"javascript:void(0)\"><div class=\"block-content block-content-full\"><span ng-class=\"[\'item\',\'item-circle\',vm.completed ? \'bg-success-light\' : \'bg-warning-light\']\"><i class=\"fa fa-check text-success\" ng-show=\"vm.completed\"></i> <i class=\"fa fa-times text-muted\" ng-hide=\"vm.completed\"></i></span></div><div class=\"block-content block-content-full block-content-mini bg-gray-lighter text-muted font-w600\">Mailed</div></a></div></div><div class=\"block\"><div class=\"block-header bg-gray-lighter\"><h3 class=\"block-title\">Reference: {{vm.printJob.reference}}</h3></div><div class=\"block-content\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"block block-bordered\"><div class=\"block-header\"><h3 class=\"block-title\">Client</h3></div><div class=\"block-content block-content-full\"><div class=\"h4 push-5\">{{vm.user.firstName}} {{vm.user.lastName}}</div><!--AgileCRM: {{vm.user.agileCrmContactId}}--><address><span ng-show=\"vm.userProfile.companyName\">{{vm.userProfile.companyName}}<br></span><span ng-show=\"vm.userProfile.address1\">{{vm.userProfile.address1}}<br></span><span ng-show=\"vm.userProfile.address2\">{{vm.userProfile.address2}}<br></span>{{vm.userProfile.city}} {{vm.userProfile.state}} {{vm.userProfile.postcode}}<br><span ng-show=\"vm.userProfile.phone\"><i class=\"fa fa-phone\"></i> {{vm.userProfile.phone}}<br></span><i class=\"fa fa-envelope-o\"></i> <a href=\"javascript:void(0)\">{{vm.user.email}}</a> <span ng-show=\"vm.user.approverEmail\"><i class=\"fa fa-envelope-o\"></i> <a href=\"javascript:void(0)\">{{vm.user.approverEmail}} </a>(Approver)</span></address></div></div></div><div class=\"col-lg-6\"><div class=\"block block-bordered\"><div class=\"block-header\"><h3 class=\"block-title\">Job Details</h3></div><div class=\"block-content block-content-full\"><div class=\"h5 push-5\">Status: <span class=\"label label-default\" translate=\"{{\'crm2PrintApp.OrderStatus.\' + vm.printJob.status}}\">{{vm.printJob.status}}</span></div><div class=\"h5 push-5\">UUID: {{vm.printJob.uuid}}</div><div class=\"h5 push-5\" has-authority=\"ROLE_ADMIN\">API Client ID: {{vm.printJob.apiClientId}}</div><div class=\"h5 push-5\" ng-show=\"vm.printJob.stream\">Stream: <a class=\"block block-link-hover1\" ng-href=\"/api/assets/print-jobs/{{vm.printJob.id}}/stream-uploaded.pdf\" target=\"_blank\">Download</a></div><div class=\"h5 push-5\">External User: {{vm.printJob.externalUserReference}}</div><div class=\"h5 push-5\">Client Reference: {{vm.printJob.clientReference}}</div><div class=\"h5 push-5\">Cost Centre: {{vm.printJob.costCentre}}</div><div class=\"h5 push-5\">Last modified: {{vm.printJob.lastModified | date:\'dd/MM/yyyy HH:mm\'}}</div><address><span ng-show=\"vm.userProfile.billingContact\">{{vm.userProfile.billingContact}}<br></span><span ng-show=\"vm.userProfile.billingPhone\"><i class=\"fa fa-phone\"></i> {{vm.userProfile.billingPhone}}<br></span><span ng-show=\"vm.userProfile.billingEmail\"><i class=\"fa fa-envelope-o\"></i> <a href=\"javascript:void(0)\">{{vm.userProfile.billingEmail}}</a></span></address></div></div></div></div></div></div><div class=\"block\"><div class=\"block-header bg-gray-lighter\"><h3 class=\"block-title\">Print Job Items</h3></div><div class=\"block-content\"><div class=\"table-responsive\"><table class=\"table table-borderless table-striped table-vcenter\"><thead><tr><th class=\"text-center\" style=\"width: 100px\">ID</th><th class=\"text-center\">Invoice #</th><th>Reference</th><th class=\"text-center\">QTY</th><th class=\"text-right\" style=\"width: 10%\">NET PRICE</th></tr></thead><tbody ng-repeat=\"charge in vm.printJobCharges\"><tr><td class=\"text-center\"><a ui-sref=\"print-job-charge-detail({id:charge.id})\"><strong>C-{{charge.id}}</strong></a></td><td class=\"text-center\"><a ui-sref=\"invoice-detail({id:charge.invoiceId})\" ng-show=\"charge.invoiceId\"><strong>I-{{charge.invoiceId}}</strong></a> <span ng-show=\"charge.invoiceId\">({{charge.invoiceStatus}})</span></td><td>{{charge.reference}}</td><td class=\"text-center\"><strong>{{charge.quantity}}</strong></td><td class=\"text-right\">{{charge.amountNet | currency:charge.currency:2}}</td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-lg-4\"><a class=\"block block-link-hover1\" ui-sref=\"template-detail({id:vm.printJob.templateId})\"><div class=\"block-content block-content-full bg-gray-lighter border-b clearfix\"><i class=\"si si-doc fa-2x text-warning pull-right\"></i> <span class=\"h4 text-muted\">Template</span> <em></em></div><div class=\"block-content block-content-full block-content-mini\"><strong>Name</strong> {{vm.printJob.templateName}}</div></a></div><div class=\"col-lg-4\" ng-if=\"vm.printJob.stationeryId\"><a class=\"block block-link-hover1\" ui-sref=\"stationery-detail({id:vm.printJob.stationeryId})\"><div class=\"block-content block-content-full bg-gray-lighter border-b clearfix\"><i class=\"si si-doc fa-2x text-warning pull-right\"></i> <span class=\"h4 text-muted\">Stationery/Letterhead</span> <em></em></div><div class=\"block-content block-content-full block-content-mini\"><strong>Name</strong> {{vm.stationery.name}}</div></a></div><div class=\"col-lg-4\"><a class=\"block block-link-hover1\" ui-sref=\"print-job-record({printjobid:vm.printJob.id})\"><div class=\"block-content block-content-full bg-gray-lighter border-b clearfix\"><i class=\"si si-users fa-2x text-danger pull-right\"></i> <span class=\"h4 font-w700\">{{vm.printJob.letterCount}}</span> <span class=\"h4 text-muted\">Letters</span></div><div class=\"block-content block-content-full block-content-mini\"><strong>Source</strong> {{vm.printJob.contactsSource}}</div></a></div><div class=\"col-lg-4\" ng-show=\"vm.isMailMerged(vm.printJob.status)\" has-authority=\"ROLE_ADMIN\"><a class=\"block block-link-hover1\" ui-sref=\"print-stream({printjobid:vm.printJob.id})\"><div class=\"block-content block-content-full bg-gray-lighter border-b clearfix\"><i class=\"si si-docs fa-2x text-primary pull-right\"></i> <span class=\"h4 text-muted\"><span class=\"hidden-xs\">Download</span> Job Stream(s)</span></div><div class=\"block-content block-content-full block-content-mini\"><strong>{{vm.printJob.pageCount}}</strong> pages <strong ng-show=\"vm.printJob.duplex\">Duplex</strong></div></a></div></div><div class=\"block\"><div class=\"block-header bg-gray-lighter\"><h3 class=\"block-title\">Log Messages</h3></div><div class=\"block-content\"><div class=\"table-responsive\"><table class=\"table table-borderless table-striped table-vcenter\"><tbody><tr ng-repeat=\"log in vm.printJobHistory\"><td style=\"width: 80px\"><span class=\"label label-primary\"><span translate=\"{{\'crm2PrintApp.printJobHistory.code.\' + log.code}}\">{{log.code}}</span></span></td><td style=\"width: 220px\"><span class=\"font-w600\">{{log.created | date:\"dd/MM/yyyy HH:mm:ss\"}}</span></td><td class=\"text-success\">{{log.comment}}</td></tr></tbody></table></div></div></div><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info push-10-t no-print\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button> <button type=\"submit\" ng-show=\"vm.printJob.isTemplate || vm.printJob.status == \'NEW\' || vm.printJob.status == \'PLACED\'\" ui-sref=\"print-job.edit({id:vm.printJob.id})\" class=\"btn btn-primary push-10-t no-print\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\">{{vm.printJob.isTemplate ? \'Edit\' : \'Continue\'}}</span></button></div>");
$templateCache.put("app/entities/print-job/print-job-edit.html","<!-- Page Content --><div class=\"content content-boxed\"><form name=\"editForm\" role=\"form\" stripe-form=\"handleStripe\" novalidate class=\"js-card-form form-horizontal\"><style type=\"text/css\">.print-job-wizard .nav-tabs span.si {\n            font-size: large;\n            vertical-align: text-top;\n            margin-left: 0.5ex;\n            color: orange;\n        }\n        .dataTables_wrapper .dataTables_paginate .paginate_button {\n            padding: 0;\n        }\n        .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n            border: 0;\n            background: none;\n        }\n        table.contacts th {\n            text-transform: none !important;\n        }\n        table.contacts td.contact-valid {\n            font-weight: bold;\n            color: darkgreen;\n        }\n        table.contacts td.contact-invalid {\n            font-weight: bold;\n            color: red;\n        }</style><div class=\"block\"><div class=\"block-header\"><!--<h4 class=\"modal-title\" id=\"myPrintJobLabel\" translate=\"crm2PrintApp.printJob.home.createOrEditLabel\">Create or edit a Print Job</h4>--><p class=\"content-mini content-mini-full bg-warning-light text-danger\" ng-show=\"vm.siteMessages.warning\">{{vm.siteMessages.warning}}</p><h4 class=\"modal-title\" id=\"myPrintJobLabel\">Start a new Print &amp; Mail Job <strong has-authority=\"ROLE_DEMO_MODE\" title=\"Demo Mode is active for this user. No actual money will be transferred upon checkout.\">[DEMO MODE]</strong></h4></div><div class=\"block-content\"><jhi-alert-error></jhi-alert-error><div class=\"print-job-wizard block\"><div class=\"block-content block-content-mini block-content-full border-b\"><!--<div class=\"wizard-progress progress active remove-margin-b\">\n                    <div class=\"progress-bar progress-bar-primary progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 33.3333%;\"></div>\n                </div>--></div><ul class=\"nav nav-tabs nav-tabs-alt nav-justified\"><li class=\"active\"><a class=\"inactive\" href=\"#print-job-step1\" data-toggle=\"tab\">1. Choose Template <span class=\"si si-doc\"></a></li><li><a class=\"inactive\" href=\"#print-job-step2\" data-toggle=\"tab\">2. Choose Mailing List <span class=\"si si-list\"></a></li><li><a class=\"inactive\" href=\"#print-job-step3\" data-toggle=\"tab\">3. Review &amp; Submit <span class=\"si si-basket\"></a></li></ul><div class=\"block-content block-content-mini tab-content\"><div class=\"tab-pane fade fade-right in push-10-t push-20 active\" id=\"print-job-step1\"><!--<div class=\"form-group\" ng-show=\"vm.printJob.id\">\n                        <label for=\"id\" translate=\"global.field.id\">ID</label>\n                        <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\n                               ng-model=\"vm.printJob.id\" readonly />\n                    </div>--><div class=\"form-group\"><label class=\"control-label\" for=\"field_reference\">Print Job Name</label><input type=\"text\" class=\"form-control\" name=\"reference\" id=\"field_reference\" ng-required ng-model=\"vm.printJob.reference\"><div class=\"help-block\">Enter an order reference, e.g. client number, for your own records</div></div><div class=\"form-group\"><label translate=\"crm2PrintApp.printJob.template\" for=\"field_template\">Template</label><select class=\"form-control\" ng-required id=\"field_template\" name=\"template\" ng-model=\"vm.printJob.templateId\" ng-options=\"template.id as template.name group by template.category for template in vm.templates\" ng-change=\"vm.loadTemplate()\"><option value=\"\"></option></select></div><div class=\"row\"><div class=\"col-lg-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJob.status\" for=\"field_status\">Status</label><select class=\"form-control\" disabled=\"disabled\" name=\"status\" ng-model=\"vm.printJob.status\" id=\"field_status\"><option value=\"NEW\" translate=\"crm2PrintApp.OrderStatus.NEW\">NEW</option><option value=\"PLACED\" translate=\"crm2PrintApp.OrderStatus.PLACED\">PLACED</option><option value=\"DUE\" translate=\"crm2PrintApp.OrderStatus.DUE\">DUE</option><option value=\"SHIPPED\" translate=\"crm2PrintApp.OrderStatus.SHIPPED\">SHIPPED</option><option value=\"PAID\" translate=\"crm2PrintApp.OrderStatus.PAID\">PAID</option><option value=\"PRINTED\" translate=\"crm2PrintApp.OrderStatus.PRINTED\">PRINTED</option><option value=\"POSTED\" translate=\"crm2PrintApp.OrderStatus.POSTED\">POSTED</option><option value=\"COMPLETED\" translate=\"crm2PrintApp.OrderStatus.COMPLETED\">COMPLETED</option><option value=\"ERROR\" translate=\"crm2PrintApp.OrderStatus.ERROR\">ERROR</option><option value=\"CANCELLED\" translate=\"crm2PrintApp.OrderStatus.CANCELLED\">CANCELLED</option><option value=\"ARCHIVED\" translate=\"crm2PrintApp.OrderStatus.ARCHIVED\">ARCHIVED</option></select></div><div class=\"form-group\"><label class=\"control-label\">Data Source ({{vm.template.dataSource.type}})</label><div class=\"form-control-static\">{{vm.template.site.name}}</div><div class=\"form-control-static\"><i>{{vm.template.dataSource.name}}</i></div></div><div class=\"form-group\" ng-show=\"vm.printJob.stream\"><label class=\"control-label text-info\">Pre-generated PDF Stream (via API)</label><div class=\"form-control-static\">{{vm.printJob.stream.originalFilename}}</div></div><!--<div class=\"form-group\">\n                                <label class=\"control-label\" translate=\"crm2PrintApp.printJob.created\">Created</label>\n                                <div class=\"form-control-static\">{{vm.printJob.created | date:\'dd/MM/yyyy HH:mm:ss\'}}</div>\n                            </div>--><div class=\"form-group\" ng-show=\"vm.printJob.lastModified\"><label class=\"control-label\" translate=\"crm2PrintApp.printJob.lastModified\">Last Modified</label><div class=\"form-control-static\">{{vm.printJob.lastModified | date:\'dd/MM/yyyy HH:mm:ss\'}}</div></div><div class=\"form-group\" ng-show=\"vm.template && vm.template.addressBoxSpace == false\"><label class=\"control-label\">Address Block</label><div class=\"form-control-static\">Print on envelope. Surcharges will apply.</div></div><div class=\"form-group\" ng-show=\"vm.template\"><label class=\"control-label\">Template Page Count</label><div class=\"form-control-static\">{{vm.template.numberOfPages}}</div></div><div class=\"form-group\" ng-show=\"vm.template\"><label class=\"control-label\">Total Page Count</label><div class=\"row form-control-static\"><div class=\"col-xs-5\" style=\"padding-right: 0\">{{vm.printJob.pageCount}} (max: {{vm.printJob.duplex ? 10 : 5}})</div><div class=\"col-xs-7\"><label class=\"css-input css-checkbox css-checkbox-info\" style=\"margin:0\"><input type=\"checkbox\" ng-model=\"vm.printJob.duplex\"><span></span> Double Sided</label></div></div></div><div class=\"form-group\" ng-show=\"vm.template && vm.template.visibility == \'PRIVATE\'\"><label class=\"control-label\">Archive Template</label><div class=\"form-control-static\"><label class=\"css-input css-checkbox css-checkbox-info\" style=\"margin:0\"><input type=\"checkbox\" ng-model=\"vm.printJob.archiveTemplate\"><span></span> Hide template after checkout</label></div></div><div class=\"form-group\" ng-show=\"vm.template\"><label class=\"control-label\" translate=\"crm2PrintApp.printJob.stationery\">Stationery / Letterhead</label><div class=\"form-control-static\">{{vm.template.stationery.name || \'N/A\'}}</div><label class=\"control-label\" style=\"font-weight: 100;font-style: italic\" for=\"stationery_id\">override:</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.printJob.stationeryId\" id=\"stationery_id\" ng-options=\"stationery.id as stationery.name for stationery in vm.stationeries\"><option value=\"\"></option></select></div><div class=\"form-group\" ng-show=\"vm.printJob.stationeryId\"><label class=\"css-input switch switch-success\"><span translate=\"crm2PrintApp.printJob.stationeryFirstPageOnly\" class=\"font-w600\">Stationery First Page Only</span> <input type=\"checkbox\" name=\"stationeryFirstPageOnly\" id=\"field_stationeryFirstPageOnly\" ng-init=\"vm.printJob.stationeryFirstPageOnly=true\" ng-model=\"vm.printJob.stationeryFirstPageOnly\"><span></span></label></div></div><div class=\"col-lg-6\"><div style=\"width:393px;height:556px;border:darkgrey 1px solid; text-align: center; padding-top: 50%\" ng-hide=\"vm.printJob.templateId\">Please select a Template</div><img ng-if=\"vm.printJob.templateId\" class=\"img-responsive\" ng-src=\"/api/assets/templates/{{vm.printJob.templateId}}/detail.png\" alt=\"\" style=\"border:black 1px solid\"></div><div class=\"col-xs-3\"><div data-js-dropzone=\"\" dropzone=\"dropzoneConfigInserts\" class=\"dropzone\"></div><div class=\"form-group\" ng-show=\"vm.printJob.inserts.length > 0\"><label class=\"control-label\" translate=\"crm2PrintApp.printJob.insertsOffset\" for=\"field_inserts_offset\">Insert Location</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.printJob.insertsOffset\" id=\"field_inserts_offset\"><option value=\"-1\">After Last Page</option><option ng-repeat=\"n in range(1,vm.template.numberOfPages,1)\" value=\"{{n}}\">After Page {{n}}</option><option value=\"0\" ng-if=\"vm.template.numberOfPages == 1\">On First Page</option></select></div></div></div></div><!-- END Step 1 --><div class=\"tab-pane fade fade-right push-10-t push-20\" id=\"print-job-step2\"><p ng-show=\"vm.printJob.isTemplate && vm.isContactsSourceSubscribable()\" class=\"content-mini content-mini-full bg-info\">Your are editing a print job template for future/automated Print Jobs. If you planning on using this template to automate direct mail campaigns for your daily NEXU or AgentInsight leads, please ensure to select the correct campaign/list.</p><div ng-show=\"vm.hasSavedContacts()\"><label class=\"control-label\" for=\"field_crm\">Saved Contacts <button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"vm.clearSavedContacts()\">Clear</button></label><div class=\"form-control-static\">Data Source: {{vm.template.dataSource.name}} - {{vm.printJob.contactsSource}} <strong>({{vm.printJob.contactsCount}} Contacts)</strong></div></div><div ng-hide=\"vm.hasSavedContacts()\"><div class=\"form-group\" ng-hide=\"!vm.template.dataSource.requiresUser && (!vm.siteUsers || vm.siteUsers.length == 0)\"><label class=\"control-label\" for=\"field_crm\"><i class=\"fa fa-plug\"></i> Choose your {{vm.template.site.name}} connection</label><select class=\"form-control\" id=\"field_crm\" name=\"field_crm\" ng-model=\"vm.printJob.siteUserId\" ng-required=\"vm.template.dataSource.requiresUser\" ng-disabled=\"!vm.template.dataSource.requiresUser && (!vm.siteUsers || vm.siteUsers.length == 0)\" ng-change=\"vm.siteUserSelected()\" ng-options=\"siteUser.id as siteUser.username for siteUser in vm.siteUsers\"><option value=\"\"></option></select><div ng-show=\"editForm.field_crm.$invalid\"><p class=\"help-block\" ng-show=\"editForm.field_crm.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\" ng-show=\"vm.template.dataSource.type == \'API\' && vm.printJob.siteUserId\"><label class=\"control-label\" for=\"field_listcategory\"><i class=\"fa fa-th-list\"></i> Choose your mailing list <i class=\"fa fa-refresh fa-spin text-warning\" ng-show=\"vm.categoriesLoading\"></i><!--<span ng-show=\"vm.subscriptionStatus\">\n                                    <span class=\"label label-success\" ng-show=\"vm.subscriptionStatus == \'Subscribed\'\"><i class=\"fa fa-link\"></i> Subscribed</span>\n                                    <span class=\"label label-primary\" ng-show=\"vm.subscriptionStatus == \'Subscribable\'\"> Subscription available</span>\n                                    <span class=\"label label-danger\" ng-show=\"vm.subscriptionStatus == \'NotSubscribable\'\"><i class=\"fa fa-exclamation\"></i>Subscription not available. Already subscribed.</span>\n                                </span>--></label><ui-select id=\"field_listcategory\" name=\"field_listcategory\" ng-model=\"vm.printJob.contactsFilter.category\" theme=\"bootstrap\" ng-show=\"vm.listCategories\" ng-required=\"vm.requireContactsFilter()\" ng-disabled=\"!vm.printJob.siteUserId\" on-select=\"vm.onCategorySelect($item, $model)\"><ui-select-match>{{$select.selected.name}} <span ng-show=\"$select.selected.subscriptionStatus\"><span class=\"label label-success\" ng-show=\"$select.selected.subscriptionStatus == \'Subscribed\'\"><i class=\"fa fa-link\"></i> Subscribed</span> <span class=\"label label-primary\" ng-show=\"$select.selected.subscriptionStatus == \'Subscribable\'\">Subscription available</span> <span class=\"label label-danger\" ng-show=\"$select.selected.subscriptionStatus == \'NotSubscribable\'\"><i class=\"fa fa-exclamation\"></i>Subscription not available. Already subscribed.</span></span></ui-select-match><ui-select-choices repeat=\"listCategory.categoryId as listCategory in vm.listCategories | propsFilter: {name: $select.search}\"><span ng-bind-html=\"listCategory.name | highlight: $select.search\"></span> <span ng-show=\"listCategory.subscriptionStatus\"><span class=\"label label-success\" ng-show=\"listCategory.subscriptionStatus == \'Subscribed\'\"><i class=\"fa fa-link\"></i> Subscribed</span> <span class=\"label label-primary\" ng-show=\"listCategory.subscriptionStatus == \'Subscribable\'\">Subscription available</span> <span class=\"label label-danger\" ng-show=\"listCategory.subscriptionStatus == \'NotSubscribable\'\"><i class=\"fa fa-exclamation\"></i>Subscription not available. Already subscribed.</span></span></ui-select-choices></ui-select><div class=\"row\"><div class=\"col-xs-6\" ng-show=\"vm.siteSubUsers\"><label class=\"control-label\" for=\"field_siteSubUser\">... FPOC <i class=\"fa fa-refresh fa-spin text-warning\" ng-show=\"vm.siteSubUsersLoading\"></i></label><ui-select id=\"field_siteSubUser\" name=\"field_siteSubUser\" ng-model=\"vm.printJob.contactsFilter.user\" theme=\"bootstrap\" ng-required=\"vm.requireContactsFilter()\" ng-disabled=\"!vm.printJob.siteUserId\"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"siteSubUser.userId as siteSubUser in vm.siteSubUsers | propsFilter: {name: $select.search}\"><span ng-bind-html=\"siteSubUser.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div class=\"col-xs-6\" ng-show=\"vm.sitePrecincts\"><label class=\"control-label\" for=\"field_siteprecinct\">... Precinct <i class=\"fa fa-refresh fa-spin text-warning\" ng-show=\"vm.sitePrecinctsLoading\"></i></label><ui-select id=\"field_siteprecinct\" name=\"field_siteprecinct\" ng-model=\"vm.printJob.contactsFilter.precinct\" theme=\"bootstrap\" ng-required=\"vm.requireContactsFilter()\" ng-disabled=\"!vm.printJob.siteUserId\"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"sitePrecinct.precinctId as sitePrecinct in vm.sitePrecincts | propsFilter: {name: $select.search}\"><span ng-bind-html=\"sitePrecinct.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"row\"><div class=\"col-xs-12 push-10-t\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"vm.loadContacts()\"><i ng-class=\"[\'fa\',vm.contactsLoading ? \'fa-cog fa-spin\' : \'fa-search\']\"></i> Search</button> <button class=\"btn btn-danger\" type=\"button\" ng-show=\"vm.isContactsSourceSubscribable() && vm.subscriptionStatus == \'Subscribed\'\" ng-click=\"vm.unsubscribeFromContactsSource()\"><i ng-class=\"[\'fa\',vm.unsubscribing ? \'fa-cog fa-spin\' : \'fa-unlink\']\"></i> Unsubscribe</button></div></div><div ng-show=\"editForm.field_listcategory.$invalid\"><p class=\"help-block\" ng-show=\"editForm.field_listcategory.$error.required\">At least one of these filters is required.</p></div></div><div ng-show=\"!vm.printJob.isTemplate && vm.template.dataSource.type == \'CSV\'\"><div class=\"form-group\"><label class=\"control-label\"><i class=\"fa fa-file-o\"></i> Upload your {{vm.template.site.name}} {{vm.template.dataSource.name}} File</label><div ng-hide=\"vm.printJob.siteUserId || !vm.template.dataSource.requiresUser\">Please select a CRM User to dynamically enhance your CSV File</div><div data-js-dropzone=\"\" dropzone=\"dropzoneConfig\" class=\"dropzone\" ng-hide=\"vm.doc || (!vm.printJob.siteUserId && vm.template.dataSource.requiresUser)\"></div><div ng-show=\"vm.doc\"><button class=\"btn btn-xs\" type=\"reset\" ng-click=\"vm.clearContacts(true)\"><i class=\"fa fa-trash\"></i></button> {{vm.printJob.contactsSource}} <i class=\"fa fa-check font-s48 text-success\"></i></div></div></div></div><div class=\"row push-10\"><span class=\"label label-primary\">{{vm.contactsCountRaw || 0}} Contacts Found</span> <span class=\"label label-primary\">{{vm.contactsCountWithAddress || 0}} Contacts With Address</span> <span class=\"label label-success\" ng-hide=\"vm.printJob.isTemplate\">{{vm.contactsCountGood || \"?\"}} Good</span> <span class=\"label label-danger\" ng-hide=\"vm.printJob.isTemplate\">{{(vm.contactsCountRaw - vm.contactsCountGood) || \"?\"}} Bad</span></div><div class=\"row\" ng-show=\"vm.contactsCountRaw && !vm.printJob.isTemplate\"><span class=\"text-warning\" ng-show=\"vm.noContacts\">No contacts found.</span> <span class=\"text-warning\" ng-show=\"vm.apiUploaded\">Contacts uploaded from 3rd Parties via API cannot be edited. Please generate a Preview.</span><table class=\"table table-header-bg js-table-checkable table-condensed table-hover contacts\" ng-hide=\"vm.apiUploaded\" width=\"100%\"><thead><tr><th>&nbsp;</th><th>valid?</th><th ng-repeat=\"field in vm.visibleFields()\">{{::vm.fieldName(field)}}</th></tr></thead><tbody><tr ng-repeat=\"contact in vm.contacts\"><td><input type=\"checkbox\" ng-model=\"contact.$valid\" ng-change=\"vm.contactSelected()\"></td><td ng-class=\"contact.$valid ? \'contact-valid\' : \'contact-invalid\'\"><span title=\"{{::contact.$flagAlt}}\">{{::contact.$flag}}</span></td><td ng-repeat=\"field in vm.visibleFields()\">{{::vm.fieldValue(field, contact)}}</td></tr><!--<tr ng-hide=\"vm.contacts && vm.contacts.length > 0\">\n                                <td colspan=\"{{vm.visibleFields().length}}\">No Contacts</td>\n                            </tr>--></tbody></table></div><div class=\"row push-20-t\" ng-show=\"vm.printJob.parameters\"><div class=\"col-xs-6\"><div class=\"block block-rounded block-bordered\"><div class=\"block-header bg-primary-light\"><!--<div class=\"block-options-simple\">\n                                        <button class=\"btn btn-xs btn-primary\" type=\"submit\"><i class=\"fa fa-check\"></i> Save</button>\n                                    </div>--><h3 class=\"block-title\">Custom Fields</h3></div><div class=\"block-content block-content-mini\"><table class=\"table table-hover table-condensed\"><thead><tr><th>Field</th><th>Value</th></tr></thead><tbody><tr ng-repeat=\"param in vm.printJob.parameters\"><td><label class=\"control-label\">{{param.templateField}}</label></td><td><input type=\"text\" ng-model=\"param.expression\" class=\"form-control\" placeholder=\"Field Value\"></td></tr></tbody></table></div></div></div><div class=\"col-xs-4 col-xs-offset-2\"><div><button type=\"button\" ng-hide=\"!vm.contactValidationAvailable()\" ng-disabled=\"vm.printJob.contactsValidated || vm.contactsCountWithAddress == 0 || vm.isSaving\" ng-click=\"vm.validateContacts()\" class=\"btn btn-success btn-block\"><span class=\"glyphicon glyphicon-ok-circle pull-right\" ng-show=\"vm.printJob.contactsValidated\"></span> <span class=\"glyphicon glyphicon-filter pull-left\"></span> &nbsp;Validate Addresses &amp; Barcode</button> <button type=\"button\" ng-hide=\"vm.contactValidationAvailable()\" ng-disabled=\"vm.contactsCountWithAddress == 0 || vm.isSaving || vm.isQuoting\" ng-click=\"vm.getQuote()\" class=\"btn btn-success btn-block\"><span class=\"glyphicon glyphicon-cog pull-left fa-spin\" ng-show=\"vm.isQuoting\"></span> <span class=\"glyphicon glyphicon-usd pull-left\" ng-hide=\"vm.isQuoting\"></span> &nbsp;Get Quote</button> <button type=\"button\" ng-disabled=\"vm.contactsCountWithAddress == 0 || vm.isSaving\" ng-click=\"vm.saveDraftAndPreview()\" class=\"btn btn-default btn-block\"><span class=\"glyphicon glyphicon-save pull-left\"></span>&nbsp;Generate Preview</button> <button type=\"button\" ng-hide=\"vm.printJob.isTemplate || vm.contactsCountWithAddress == 0 || vm.contactsCountWithAddress > 100 || vm.isSaving\" ng-click=\"vm.saveDraftAndMailMerge()\" class=\"btn btn-default btn-block\"><span class=\"glyphicon glyphicon-cloud-download pull-left\"></span>&nbsp;Download Mail-Merged PDF</button></div></div></div></div><div class=\"tab-pane fade fade-right push-10-t push-20\" id=\"print-job-step3\"><div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\">Review your Print Job</h3></div><div class=\"block-content\"><table class=\"table table-borderless table-vcenter\"><tbody><tr class=\"error\" ng-hide=\"!vm.contactValidationAvailable() || (vm.printJob.contactsValidated && vm.contactsCountWithAddress > 0)\"><td class=\"text-center\" colspan=\"4\">You need to validate your addresses before you can proceed with the order.</td></tr><tr class=\"error\" ng-show=\"vm.vendorsAvailable === false\"><td class=\"text-center\" colspan=\"4\">This print job cannot be finalised as a suitable print vendor could not be found.</td></tr><tr ng-hide=\"vm.printJob.isTemplate\"><td style=\"max-width: 55px\" class=\"text-center\"><a class=\"text-danger\" href=\"javascript:void(0)\"><i class=\"fa fa-check\"></i></a></td><td><a class=\"h5\" style=\"font-weight: bold\">{{vm.printJob.letterCount}} valid Contacts (total {{vm.contactsCountRaw}}) via {{vm.template.dataSource.type}}</a><div class=\"font-s12 text-muted\"><span class=\"hidden-xs\">{{vm.template.site.name}} -</span> {{vm.printJob.contactsSource}}</div></td><td class=\"text-right\" colspan=\"2\"><div class=\"font-w600 text-success\">Free</div></td></tr><tr ng-repeat=\"row in vm.quote\"><td class=\"text-center\"><a class=\"text-danger\" href=\"javascript:void(0)\"><i class=\"fa fa-check\"></i></a></td><td><h5>Print &amp; Mail</h5><div class=\"font-s12 text-muted\">Printed by {{row.country}} Mailhouse &amp; distributed to sorting centre within 2 business days</div><div ng-show=\"row.vendor == \'NONE\'\">No suitable vendor was found for print &amp; mail for this country.</div><div ng-show=\"row.vendor == \'LIMITED\'\">A Mailhouse is available for {{row.country}}, but it has some limitations: {{row.vendorLimitation}}</div></td><td class=\"text-right\"><div class=\"font-w600 text-success text-center\" style=\"white-space: nowrap\">{{row.quantity}}x<br>{{row.itemAmountNet | currency:row.currency:2}} ea</div></td><td class=\"text-right\"><div class=\"font-w600 text-success\">{{row.amountNet | currency:row.currency }}</div><div class=\"text-muted text-nowrap\">+ {{row.tax | currency:row.currency:2}} {{vm.countryLookup[row.country].taxName}}</div><div class=\"text-muted text-nowrap\" ng-show=\"row.currency != row.chargeCurrency\">(~{{row.chargeAmount | currency:row.chargeCurrency:4}})</div></td></tr><tr ng-show=\"vm.addressValidationServiceEnabled\"><td class=\"text-center\"><a class=\"text-danger\" href=\"javascript:void(0)\"><i class=\"fa fa-check\"></i></a></td><td colspan=\"2\"><h5>Address Validation</h5><div class=\"font-s12 text-muted hidden-xs\">Addresses are checked against the Postal Address File and validated, where possible</div></td><td class=\"text-right\"><div class=\"font-w600 text-success\">Free</div></td></tr><tr><td class=\"text-center\"><a class=\"text-danger\" href=\"javascript:void(0)\"><i class=\"fa fa-check\"></i></a></td><td colspan=\"2\"><h5>Return To Sender (RTS) Management</h5><div class=\"font-s12 text-muted hidden-xs\">Undelivered letters are processed and a note added to the record advising of incorrect address</div></td><td class=\"text-right\"><div class=\"font-w600 text-success\">Free</div></td></tr><tr class=\"success\"><td class=\"text-right\" colspan=\"3\"><span class=\"h4 font-w600\">Total</span></td><td class=\"text-right\"><div class=\"h4 font-w600 text-success\">{{vm.printJob.priceGross | currency:vm.chargeCurrency }}</div></td></tr></tbody></table><div ng-show=\"editForm.$invalid\" class=\"text-danger\">Please complete all required field.</div><div class=\"form-group\" ng-show=\"!vm.printJob.isTemplate && !editForm.$invalid && vm.quote && vm.vendorsAvailable && (vm.printJob.status == \'NEW\' || vm.printJob.status == \'PLACED\')\"><div class=\"col-xs-12 text-center\"><button class=\"btn btn-primary\" ng-show=\"vm.hasExistingSource()\" type=\"button\" ng-disabled=\"vm.isSaving\" ng-click=\"vm.checkoutWithExisting()\"><i class=\"fa fa-check push-5-r\"></i> Complete Order with existing account *</button> <button type=\"button\" ng-hide=\"vm.checkout\" class=\"btn btn-success\" ng-click=\"vm.checkout = true\">Checkout with new account</button></div></div><div class=\"form-group\" ng-show=\"vm.printJob.isTemplate\"><div class=\"col-xs-12 text-center\"><button class=\"btn btn-primary\" ng-disabled=\"editForm.$invalid\" ng-show=\"vm.hasExistingSource()\" type=\"button\" ng-click=\"vm.saveAsPrintJobTemplate()\"><i class=\"fa fa-save push-5-r\"></i> Save as Print Job Template</button> <button class=\"btn btn-success\" ng-disabled=\"editForm.$invalid\" type=\"button\" ng-show=\"vm.isContactsSourceSubscribable() && vm.subscriptionStatus == \'Subscribable\'\" ng-click=\"vm.saveAsPrintJobTemplate(true)\"><i class=\"fa fa-link push-5-r\"></i> Subscribe to <u>{{vm.template.site.name}} - {{vm.printJob.contactsSource}}</u>*</button><div>* {{vm.template.site.name}} will automatically submit new print jobs (based on this template) for new leads.</div></div></div><div class=\"row text-center\" style=\"clear: both\" ng-show=\"!editForm.$invalid && vm.hasExistingSource() && vm.vendorsAvailable\"><small>* {{vm.getExistingSource().brand}} with card number ending in {{vm.getExistingSource().last4}}</small></div></div></div><!-- Credit Card --><div class=\"block\" ng-show=\"vm.checkout\"><div class=\"block-header\"><h3 class=\"block-title\">Credit Card</h3></div><div class=\"block-content\"><!-- Card Container --><div class=\"js-card-container hidden-xs push-50\"></div><div class=\"row credit-card\"><div class=\"col-sm-6 col-sm-offset-3\"><div class=\"row text-danger\" has-authority=\"ROLE_DEMO_MODE\"><strong>Demo Mode is active for this user.</strong><p>No actual money will be transferred upon checkout<br>Use Card number 4242 4242 4242 4242</p></div><div class=\"form-group\"><div class=\"col-xs-12\"><div class=\"form-material\"><input class=\"form-control\" id=\"cc_number\" name=\"cc_number\" type=\"text\" placeholder=\"**** **** **** ****\" ng-model=\"number\" payments-validate=\"card\" payments-format=\"card\" payments-type-model=\"type\" ng-class=\"editForm.cc_number.$card.type\"><label for=\"cc_number\">Number</label></div></div></div><div class=\"form-group\"><div class=\"col-xs-12\"><div class=\"form-material\"><input class=\"form-control\" id=\"cc_name\" name=\"cc_name\" type=\"text\" placeholder=\"JOHN DOE\"><label for=\"cc_name\">Full Name</label></div></div></div><div class=\"form-group\"><div class=\"col-xs-6\"><div class=\"form-material\"><input class=\"form-control\" id=\"cc_expiry\" name=\"cc_expiry\" type=\"text\" placeholder=\"01/19\" ng-model=\"expiry\" payments-validate=\"expiry\" payments-format=\"expiry\"><label for=\"cc_expiry\">MM/YY</label></div></div><div class=\"col-xs-6\"><div class=\"form-material\"><input class=\"form-control\" id=\"cc_cvc\" name=\"cc_cvc\" type=\"text\" placeholder=\"***\" ng-model=\"cvc\" payments-validate=\"cvc\" payments-format=\"cvc\" payments-type-model=\"type\"><label for=\"cc_cvc\">CVC</label></div></div></div><div class=\"form-group\"><div class=\"col-xs-12 text-center\"><button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || !vm.quote || !vm.vendorsAvailable || !(vm.printJob.status == \'NEW\' || vm.printJob.status == \'PLACED\')\"><i class=\"fa fa-check push-5-r\"></i> Complete Order</button></div></div></div></div></div></div><!-- END Credit Card --></div></div><div class=\"block-content block-content-mini block-content-full border-t\"><div class=\"row\"><div class=\"col-xs-8\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.saveAndClose()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span>Save &amp; Close</span></button> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button></div><div class=\"col-xs-2\"><button class=\"wizard-prev btn btn-warning disabled\" type=\"button\"><i class=\"fa fa-arrow-circle-o-left\"></i> Previous</button></div><div class=\"col-xs-2 text-right\"><button class=\"wizard-next btn btn-success\" type=\"button\">Next <i class=\"fa fa-arrow-circle-o-right\"></i></button></div></div></div></div></div></div></form></div>");
$templateCache.put("app/entities/print-job/print-jobs.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.printJob.home.title\">Print Jobs</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"print-job.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.printJob.home.createLabel\">Create new Print Job</span></button><!--<button class=\"btn btn-success\" ui-sref=\"print-job.new({isTemplate:true})\" >\n                        <span class=\"glyphicon glyphicon-plus\"></span>\n                        <span class=\"hidden-xs\">\n                            Create Print Job Template\n                        </span>\n                    </button>--> <button class=\"btn btn-danger\" ng-click=\"vm.deleteSelected()\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs\">Delete</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.printJob.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><input type=\"checkbox\" ng-model=\"vm.selectAllTick\" ng-change=\"vm.selectAll()\"></th><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"crm2PrintApp.printJob.reference\">Reference</span></th><th><span translate=\"crm2PrintApp.printJob.status\">Status</span></th><th><span translate=\"crm2PrintApp.printJob.contactsSource\">Contacts Source</span></th><th><span translate=\"crm2PrintApp.printJob.letterCount\">Letter Count</span></th><th><span translate=\"crm2PrintApp.printJob.template\">Template</span></th><th has-authority=\"ROLE_ADMIN\"><span translate=\"crm2PrintApp.printJob.user\">User</span></th><th><span translate=\"crm2PrintApp.printJob.cart\">Cart</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"printJob in vm.printJobs track by printJob.id\"><td><input type=\"checkbox\" ng-model=\"printJob.selected\"></td><td><a ui-sref=\"print-job-detail({id:printJob.id})\">{{printJob.id}}</a></td><td><span ng-show=\"printJob.isTemplate && printJob.status != \'SUBSCRIBED\'\" class=\"label label-success\">Template</span> <span ng-show=\"printJob.isTemplate && printJob.status == \'SUBSCRIBED\'\" class=\"label label-primary\">Automatic</span> <span ng-show=\"printJob.apiClientId\" class=\"label label-primary\" title=\"{{printJob.externalUserReference}}\">API</span> {{printJob.reference}}</td><td><i ng-class=\"vm.statusIcon(printJob.status)\"></i> <span translate=\"{{\'crm2PrintApp.OrderStatus.\' + printJob.status}}\">{{printJob.status}}</span> <span ng-show=\"printJob.approvalRequested && printJob.status==\'NEW\'\" class=\"text-warning\" style=\"white-space: nowrap\" title=\"{{printJob.approvalRequested}}\">(Approval requested)</span> <span ng-show=\"printJob.demo\" class=\"text-primary\">DEMO</span></td><td>{{printJob.contactsSource}}</td><td>{{printJob.letterCount}} <span ng-show=\"printJob.duplex\" title=\"Duplex\">D</span></td><td><a ui-sref=\"template-detail({id:printJob.templateId})\">{{printJob.templateName}}</a></td><td has-authority=\"ROLE_ADMIN\"><a ui-sref=\"user-management-detail({id:printJob.userId})\">{{printJob.userLogin}}</a></td><td><a ui-sref=\"cart-detail({id:printJob.cartId})\">{{printJob.cartId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"print-job-detail({id:printJob.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ng-show=\"printJob.isTemplate || printJob.status == \'NEW\' || printJob.status == \'PLACED\'\" ui-sref=\"print-job.edit({id:printJob.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\">{{printJob.isTemplate ? \'Edit\' : \'Continue\'}}</span></button> <button type=\"submit\" ng-show=\"printJob.isTemplate || printJob.status == \'NEW\' || printJob.demo\" ui-sref=\"print-job.delete({id:printJob.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/entities/print-job-charge/print-job-charge-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.printJobCharge.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.printJobCharge.delete.question\" translate-values=\"{id: \'{{vm.printJobCharge.id}}\'}\">Are you sure you want to delete this Print Job Charge?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/print-job-charge/print-job-charge-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\"><span translate=\"crm2PrintApp.printJobCharge.detail.title\">Print Job Charge</span> {{vm.printJobCharge.id}}</h3></div><div class=\"block-content\"><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.printJobCharge.status\">Status</span></dt><dd><span translate=\"{{\'crm2PrintApp.ChargeStatus.\' + vm.printJobCharge.status}}\">{{vm.printJobCharge.status}}</span> <span class=\"text-danger\">{{vm.printJobCharge.errorReason}}</span></dd><dt><span translate=\"crm2PrintApp.printJobCharge.paymentDate\">Payment Date</span></dt><dd><span>{{vm.printJobCharge.paymentDate | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.printJobCharge.reference\">Reference</span></dt><dd><span>{{vm.printJobCharge.reference}}</span></dd><dt><span translate=\"crm2PrintApp.printJobCharge.itemAmountNet\">Item Amount Net</span></dt><dd><span>{{vm.printJobCharge.itemAmountNet | currency:currency:2}}</span></dd><dt><span translate=\"crm2PrintApp.printJobCharge.quantity\">Quantity</span></dt><dd><span>{{vm.printJobCharge.quantity}}</span></dd><dt><span translate=\"crm2PrintApp.printJobCharge.country\">Country</span></dt><dd><span>{{vm.printJobCharge.country}}</span></dd><dt><span translate=\"crm2PrintApp.printJobCharge.amountNet\">Amount Net</span></dt><dd><span>{{vm.printJobCharge.amountNet | currency:currency:2}}</span></dd><dt><span translate=\"crm2PrintApp.printJobCharge.tax\">Tax</span></dt><dd><span>{{vm.printJobCharge.tax | currency:currency:2}}</span></dd><dt><span translate=\"crm2PrintApp.printJobCharge.amountGross\">Amount Gross</span></dt><dd><span>{{vm.printJobCharge.amountGross | currency:currency:2}}</span></dd><dt><span translate=\"crm2PrintApp.printJobCharge.paymentReference\">Payment Reference</span></dt><dd><span>{{vm.printJobCharge.paymentReference}}</span></dd><dt><span translate=\"crm2PrintApp.printJobCharge.chargeAmount\">Charge Amount</span></dt><dd><span>{{vm.printJobCharge.chargeAmount | currency:chargeCurrency:2}}</span></dd><dt><span translate=\"crm2PrintApp.printJobCharge.printJob\">Print Job</span></dt><dd><a ui-sref=\"print-job-detail({id:vm.printJobCharge.printJobId})\">{{vm.printJobCharge.printJobId}}</a></dd><dt><span translate=\"crm2PrintApp.printJobCharge.invoice\">Invoice</span></dt><dd><a ui-sref=\"invoice-detail({id:vm.printJobCharge.invoiceId})\">{{vm.printJobCharge.invoiceId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info push-10-t\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div>");
$templateCache.put("app/entities/print-job-charge/print-job-charge-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPrintJobChargeLabel\" translate=\"crm2PrintApp.printJobCharge.home.createOrEditLabel\">Create or edit a Print Job Charge</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.printJobCharge.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.printJobCharge.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobCharge.reference\" for=\"field_reference\">Reference</label><input type=\"text\" class=\"form-control\" name=\"reference\" id=\"field_reference\" ng-model=\"vm.printJobCharge.reference\" required><div ng-show=\"editForm.reference.$invalid\"><p class=\"help-block\" ng-show=\"editForm.reference.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobCharge.amountNet\" for=\"field_amountNet\">Amount Net</label><input type=\"number\" class=\"form-control\" name=\"amountNet\" id=\"field_amountNet\" ng-model=\"vm.printJobCharge.amountNet\" required><div ng-show=\"editForm.amountNet.$invalid\"><p class=\"help-block\" ng-show=\"editForm.amountNet.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.amountNet.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobCharge.tax\" for=\"field_tax\">Tax</label><input type=\"number\" class=\"form-control\" name=\"tax\" id=\"field_tax\" ng-model=\"vm.printJobCharge.tax\" required><div ng-show=\"editForm.tax.$invalid\"><p class=\"help-block\" ng-show=\"editForm.tax.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.tax.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobCharge.amountGross\" for=\"field_amountGross\">Amount Gross</label><input type=\"number\" class=\"form-control\" name=\"amountGross\" id=\"field_amountGross\" ng-model=\"vm.printJobCharge.amountGross\" required><div ng-show=\"editForm.amountGross.$invalid\"><p class=\"help-block\" ng-show=\"editForm.amountGross.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.amountGross.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobCharge.currency\" for=\"field_currency\">Currency</label><input type=\"text\" class=\"form-control\" name=\"currency\" id=\"field_currency\" ng-model=\"vm.printJobCharge.currency\" required><div ng-show=\"editForm.currency.$invalid\"><p class=\"help-block\" ng-show=\"editForm.currency.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobCharge.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.printJobCharge.status\" id=\"field_status\" required><option value=\"QUOTE\" translate=\"crm2PrintApp.ChargeStatus.QUOTE\">QUOTE</option><option value=\"PAID\" translate=\"crm2PrintApp.ChargeStatus.PAID\">PAID</option><option value=\"REFUNDED\" translate=\"crm2PrintApp.ChargeStatus.REFUNDED\">REFUNDED</option><option value=\"DUE\" translate=\"crm2PrintApp.ChargeStatus.DUE\">DUE</option><option value=\"ERROR\" translate=\"crm2PrintApp.ChargeStatus.ERROR\">ERROR</option></select><div ng-show=\"editForm.status.$invalid\"><p class=\"help-block\" ng-show=\"editForm.status.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobCharge.errorReason\" for=\"field_errorReason\">Error Reason</label><input type=\"text\" class=\"form-control\" name=\"errorReason\" id=\"field_errorReason\" ng-model=\"vm.printJobCharge.errorReason\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobCharge.paymentReference\" for=\"field_paymentReference\">Payment Reference</label><input type=\"text\" class=\"form-control\" name=\"paymentReference\" id=\"field_paymentReference\" ng-model=\"vm.printJobCharge.paymentReference\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobCharge.paymentDate\" for=\"field_paymentDate\">Payment Date</label><div class=\"input-group\"><input id=\"field_paymentDate\" type=\"text\" class=\"form-control\" name=\"paymentDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.printJobCharge.paymentDate\" is-open=\"vm.datePickerOpenStatus.paymentDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'paymentDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobCharge.itemAmountNet\" for=\"field_itemAmountNet\">Item Amount Net</label><input type=\"number\" class=\"form-control\" name=\"itemAmountNet\" id=\"field_itemAmountNet\" ng-model=\"vm.printJobCharge.itemAmountNet\" required><div ng-show=\"editForm.itemAmountNet.$invalid\"><p class=\"help-block\" ng-show=\"editForm.itemAmountNet.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.itemAmountNet.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobCharge.quantity\" for=\"field_quantity\">Quantity</label><input type=\"number\" class=\"form-control\" name=\"quantity\" id=\"field_quantity\" ng-model=\"vm.printJobCharge.quantity\" required><div ng-show=\"editForm.quantity.$invalid\"><p class=\"help-block\" ng-show=\"editForm.quantity.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.quantity.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobCharge.country\" for=\"field_country\">Country</label><input type=\"text\" class=\"form-control\" name=\"country\" id=\"field_country\" ng-model=\"vm.printJobCharge.country\" required><div ng-show=\"editForm.country.$invalid\"><p class=\"help-block\" ng-show=\"editForm.country.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobCharge.chargeCurrency\" for=\"field_chargeCurrency\">Charge Currency</label><input type=\"text\" class=\"form-control\" name=\"chargeCurrency\" id=\"field_chargeCurrency\" ng-model=\"vm.printJobCharge.chargeCurrency\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobCharge.chargeAmount\" for=\"field_chargeAmount\">Charge Amount</label><input type=\"number\" class=\"form-control\" name=\"chargeAmount\" id=\"field_chargeAmount\" ng-model=\"vm.printJobCharge.chargeAmount\"></div><div class=\"form-group\"><label translate=\"crm2PrintApp.printJobCharge.printJob\" for=\"field_printJob\">Print Job</label><select class=\"form-control\" id=\"field_printJob\" name=\"printJob\" ng-model=\"vm.printJobCharge.printJob\" ng-options=\"printJob as printJob.id for printJob in vm.printjobs track by printJob.id\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.printJob.$invalid\"><p class=\"help-block\" ng-show=\"editForm.printJob.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><label translate=\"crm2PrintApp.printJobCharge.invoice\" for=\"field_invoice\">Invoice</label><select class=\"form-control\" id=\"field_invoice\" name=\"invoice\" ng-model=\"vm.printJobCharge.invoice\" ng-options=\"invoice as invoice.id for invoice in vm.invoices track by invoice.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/print-job-charge/print-job-charges.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.printJobCharge.home.title\">Print Job Charges</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.printJobCharge.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"crm2PrintApp.printJobCharge.paymentDate\">Payment Date</span></th><th><span translate=\"crm2PrintApp.printJobCharge.status\">Status</span></th><th><span translate=\"crm2PrintApp.printJobCharge.reference\">Reference</span></th><!--<th><span translate=\"crm2PrintApp.printJobCharge.amountNet\">Amount Net</span></th>--><!--<th><span translate=\"crm2PrintApp.printJobCharge.tax\">Tax</span></th>--><th><span translate=\"crm2PrintApp.printJobCharge.amountGross\">Amount Gross</span></th><!--<th><span translate=\"crm2PrintApp.printJobCharge.itemAmountNet\">Item Amount Net</span></th>--><!--<th><span translate=\"crm2PrintApp.printJobCharge.quantity\">Quantity</span></th>\n                        <th><span translate=\"crm2PrintApp.printJobCharge.country\">Country</span></th>--><th><span translate=\"crm2PrintApp.printJobCharge.chargeAmount\">Charge Amount</span></th><th><span translate=\"crm2PrintApp.printJobCharge.paymentReference\">Payment Reference</span></th><th><span translate=\"crm2PrintApp.printJobCharge.printJob\">Print Job</span></th><th><span translate=\"crm2PrintApp.printJobCharge.invoice\">Invoice</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"printJobCharge in vm.printJobCharges track by printJobCharge.id\"><td><a ui-sref=\"print-job-charge-detail({id:printJobCharge.id})\">{{printJobCharge.id}}</a></td><td>{{printJobCharge.paymentDate | date:\'dd/MM/yy HH:mm\'}}</td><td><span ng-class=\"[\'label\',{\'label-info\':printJobCharge.status==\'DUE\',\'label-success\':printJobCharge.status==\'PAID\',\'label-warning\':invoice.status==\'REFUNDED\',\'label-danger\':invoice.status==\'ERROR\'}]\" translate=\"{{\'crm2PrintApp.ChargeStatus.\' + printJobCharge.status}}\" ng-title=\"printJobCharge.errorReason\">{{printJobCharge.status}}</span></td><td>{{printJobCharge.reference}}</td><!--<td>{{printJobCharge.amountNet}}</td>--><!--<td>{{printJobCharge.tax}}</td>--><td>{{printJobCharge.amountGross | currency:printJobCharge.currency:2}}</td><!--<td>{{printJobCharge.itemAmountNet | currency:printJobCharge.currency:2}}</td>--><!--<td>{{printJobCharge.quantity}}</td>\n                        <td>{{printJobCharge.country}}</td>--><td>{{printJobCharge.chargeAmount | currency:printJobCharge.chargeCurrency:2}}</td><td>{{printJobCharge.paymentReference}}</td><td><a ui-sref=\"print-job-detail({id:printJobCharge.printJobId})\">{{printJobCharge.printJobId}}</a></td><td><a ui-sref=\"invoice-detail({id:printJobCharge.invoiceId})\">{{printJobCharge.invoiceId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"print-job-charge-detail({id:printJobCharge.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/entities/print-job-history/print-job-histories.html","<div><h2 translate=\"crm2PrintApp.printJobHistory.home.title\">Print Job Histories</h2><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"print-job-history.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.printJobHistory.home.createLabel\">Create new Print Job History</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.printJobHistory.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"crm2PrintApp.printJobHistory.code\">Code</span></th><th><span translate=\"crm2PrintApp.printJobHistory.comment\">Comment</span></th><th><span translate=\"crm2PrintApp.printJobHistory.created\">Created</span></th><th><span translate=\"crm2PrintApp.printJobHistory.printJob\">Print Job</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"printJobHistory in vm.printJobHistories track by printJobHistory.id\"><td><a ui-sref=\"print-job-history-detail({id:printJobHistory.id})\">{{printJobHistory.id}}</a></td><td>{{printJobHistory.code}}</td><td>{{printJobHistory.comment}}</td><td>{{printJobHistory.created | date:\'medium\'}}</td><td><a ui-sref=\"print-job-detail({id:printJobHistory.printJob.id})\">{{printJobHistory.printJob.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"print-job-history-detail({id:printJobHistory.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"print-job-history.edit({id:printJobHistory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"print-job-history.delete({id:printJobHistory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/print-job-history/print-job-history-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.printJobHistory.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.printJobHistory.delete.question\" translate-values=\"{id: \'{{vm.printJobHistory.id}}\'}\">Are you sure you want to delete this Print Job History?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/print-job-history/print-job-history-detail.html","<div><h2><span translate=\"crm2PrintApp.printJobHistory.detail.title\">Print Job History</span> {{vm.printJobHistory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.printJobHistory.code\">Code</span></dt><dd><span>{{vm.printJobHistory.code}}</span></dd><dt><span translate=\"crm2PrintApp.printJobHistory.comment\">Comment</span></dt><dd><span>{{vm.printJobHistory.comment}}</span></dd><dt><span translate=\"crm2PrintApp.printJobHistory.created\">Created</span></dt><dd><span>{{vm.printJobHistory.created | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.printJobHistory.printJob\">Print Job</span></dt><dd><a ui-sref=\"print-job-detail({id:vm.printJobHistory.printJob.id})\">{{vm.printJobHistory.printJob.id}}</a></dd><dt><span translate=\"crm2PrintApp.printJobHistory.invoice\">Invoice</span></dt><dd><a ui-sref=\"invoice-detail({id:vm.printJobHistory.invoice.id})\">{{vm.printJobHistory.invoice.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/print-job-history/print-job-history-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPrintJobHistoryLabel\" translate=\"crm2PrintApp.printJobHistory.home.createOrEditLabel\">Create or edit a Print Job History</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.printJobHistory.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.printJobHistory.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobHistory.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.printJobHistory.code\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobHistory.comment\" for=\"field_comment\">Comment</label><input type=\"text\" class=\"form-control\" name=\"comment\" id=\"field_comment\" ng-model=\"vm.printJobHistory.comment\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobHistory.created\" for=\"field_created\">Created</label><div class=\"input-group\"><input id=\"field_created\" type=\"text\" class=\"form-control\" name=\"created\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.printJobHistory.created\" is-open=\"vm.datePickerOpenStatus.created\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'created\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label translate=\"crm2PrintApp.printJobHistory.printJob\" for=\"field_printJob\">Print Job</label><select class=\"form-control\" id=\"field_printJob\" name=\"printJob\" ng-model=\"vm.printJobHistory.printJob\" ng-options=\"printJob as printJob.id for printJob in vm.printjobs track by printJob.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"crm2PrintApp.printJobHistory.invoice\" for=\"field_invoice\">Invoice</label><select class=\"form-control\" id=\"field_invoice\" name=\"invoice\" ng-model=\"vm.printJobHistory.invoice\" ng-options=\"invoice as invoice.id for invoice in vm.invoices track by invoice.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/print-job-record/print-job-record-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.printJobRecord.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.printJobRecord.delete.question\" translate-values=\"{id: \'{{vm.printJobRecord.id}}\'}\">Are you sure you want to delete this Print Job Record?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/print-job-record/print-job-record-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\"><span translate=\"crm2PrintApp.printJobRecord.detail.title\">Print Job Record</span> {{vm.printJobRecord.id}}</h3></div><div class=\"block-content\"><div><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.printJobRecord.barcode\">Barcode</span></dt><dd><span>{{vm.printJobRecord.c2p_address_barcode}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.sortPlan\">Sort Plan</span></dt><dd><span>{{vm.printJobRecord.c2p_sort_plan}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.dpid\">Dpid</span></dt><dd><span>{{vm.printJobRecord.c2p_dpid}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.bsp\">Bsp</span></dt><dd><span>{{vm.printJobRecord.c2p_bsp}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.recipient1\">Recipient 1</span></dt><dd><span>{{vm.printJobRecord.c2p_recipient_1}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.recipient2\">Recipient 2</span></dt><dd><span>{{vm.printJobRecord.c2p_receipient_2}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.address1\">Address 1</span></dt><dd><span>{{vm.printJobRecord.c2p_streetaddress_1}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.address2\">Address 2</span></dt><dd><span>{{vm.printJobRecord.c2p_streetaddress_2}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.city\">City</span></dt><dd><span>{{vm.printJobRecord.c2p_city}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.state\">State</span></dt><dd><span>{{vm.printJobRecord.c2p_state}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.postcode\">Postcode</span></dt><dd><span>{{vm.printJobRecord.c2p_postcode}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.country\">Country</span></dt><dd><span>{{vm.printJobRecord.c2p_country}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.pageCount\">Page Count</span></dt><dd><span>{{vm.printJobRecord.pageCount}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.receivedReturnMail\">Received Return Mail</span></dt><dd><span>{{vm.printJobRecord.receivedReturnMail | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.flag\">Flag</span></dt><dd><span>{{vm.printJobRecord.flag}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.countryCode\">Country Code</span></dt><dd><span>{{vm.printJobRecord.countryCode}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.addressId\">Address Id</span></dt><dd><span>{{vm.printJobRecord.addressId}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.printStreamPage\">Print Stream Page</span></dt><dd><span>{{vm.printJobRecord.printStreamPage}}</span></dd><dt><span translate=\"crm2PrintApp.printJobRecord.job\">Job</span></dt><dd><a ui-sref=\"print-job-detail({id:vm.printJobRecord.job.id})\">{{vm.printJobRecord.job.id}}</a></dd><dt><span translate=\"crm2PrintApp.printJobRecord.jobStream\">Print Stream</span></dt><dd><a ui-sref=\"print-stream-detail({id:vm.printJobRecord.jobStream.id})\">{{vm.printJobRecord.jobStream.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info push-10\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div></div>");
$templateCache.put("app/entities/print-job-record/print-job-record-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPrintJobRecordLabel\" translate=\"crm2PrintApp.printJobRecord.home.createOrEditLabel\">Create or edit a Print Job Record</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.printJobRecord.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.printJobRecord.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.barcode\" for=\"field_barcode\">Barcode</label><input type=\"text\" class=\"form-control\" name=\"barcode\" id=\"field_barcode\" ng-model=\"vm.printJobRecord.barcode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.sortPlan\" for=\"field_sortPlan\">Sort Plan</label><input type=\"text\" class=\"form-control\" name=\"sortPlan\" id=\"field_sortPlan\" ng-model=\"vm.printJobRecord.sortPlan\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.dpid\" for=\"field_dpid\">Dpid</label><input type=\"number\" class=\"form-control\" name=\"dpid\" id=\"field_dpid\" ng-model=\"vm.printJobRecord.dpid\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.bsp\" for=\"field_bsp\">Bsp</label><input type=\"number\" class=\"form-control\" name=\"bsp\" id=\"field_bsp\" ng-model=\"vm.printJobRecord.bsp\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.recipient1\" for=\"field_recipient1\">Recipient 1</label><input type=\"text\" class=\"form-control\" name=\"recipient1\" id=\"field_recipient1\" ng-model=\"vm.printJobRecord.recipient1\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.recipient2\" for=\"field_recipient2\">Recipient 2</label><input type=\"text\" class=\"form-control\" name=\"recipient2\" id=\"field_recipient2\" ng-model=\"vm.printJobRecord.recipient2\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.address1\" for=\"field_address1\">Address 1</label><input type=\"text\" class=\"form-control\" name=\"address1\" id=\"field_address1\" ng-model=\"vm.printJobRecord.address1\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.address2\" for=\"field_address2\">Address 2</label><input type=\"text\" class=\"form-control\" name=\"address2\" id=\"field_address2\" ng-model=\"vm.printJobRecord.address2\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.city\" for=\"field_city\">City</label><input type=\"text\" class=\"form-control\" name=\"city\" id=\"field_city\" ng-model=\"vm.printJobRecord.city\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.state\" for=\"field_state\">State</label><input type=\"text\" class=\"form-control\" name=\"state\" id=\"field_state\" ng-model=\"vm.printJobRecord.state\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.postcode\" for=\"field_postcode\">Postcode</label><input type=\"text\" class=\"form-control\" name=\"postcode\" id=\"field_postcode\" ng-model=\"vm.printJobRecord.postcode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.country\" for=\"field_country\">Country</label><input type=\"text\" class=\"form-control\" name=\"country\" id=\"field_country\" ng-model=\"vm.printJobRecord.country\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.pageCount\" for=\"field_pageCount\">Page Count</label><input type=\"number\" class=\"form-control\" name=\"pageCount\" id=\"field_pageCount\" ng-model=\"vm.printJobRecord.pageCount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.receivedReturnMail\" for=\"field_receivedReturnMail\">Received Return Mail</label><div class=\"input-group\"><input id=\"field_receivedReturnMail\" type=\"text\" class=\"form-control\" name=\"receivedReturnMail\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.printJobRecord.receivedReturnMail\" is-open=\"vm.datePickerOpenStatus.receivedReturnMail\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'receivedReturnMail\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.flag\" for=\"field_flag\">Flag</label><input type=\"text\" class=\"form-control\" name=\"flag\" id=\"field_flag\" ng-model=\"vm.printJobRecord.flag\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.countryCode\" for=\"field_countryCode\">Country Code</label><input type=\"text\" class=\"form-control\" name=\"countryCode\" id=\"field_countryCode\" ng-model=\"vm.printJobRecord.countryCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.addressId\" for=\"field_addressId\">Address Id</label><input type=\"text\" class=\"form-control\" name=\"addressId\" id=\"field_addressId\" ng-model=\"vm.printJobRecord.addressId\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printJobRecord.printStreamPage\" for=\"field_printStreamPage\">Print Stream Page</label><input type=\"number\" class=\"form-control\" name=\"printStreamPage\" id=\"field_printStreamPage\" ng-model=\"vm.printJobRecord.printStreamPage\"></div><div class=\"form-group\"><label translate=\"crm2PrintApp.printJobRecord.job\" for=\"field_job\">Job</label><select class=\"form-control\" id=\"field_job\" name=\"job\" ng-model=\"vm.printJobRecord.job\" ng-options=\"printJob as printJob.id for printJob in vm.printjobs track by printJob.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"crm2PrintApp.printJobRecord.jobStream\" for=\"field_printStream\">Print Stream</label><select class=\"form-control\" id=\"field_printStream\" name=\"jobStream\" ng-model=\"vm.printJobRecord.jobStream\" ng-options=\"jobStream as jobStream.id for jobStream in vm.printstreams track by jobStream.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/print-job-record/print-job-records.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.printJobRecord.home.title\">Print Job Records</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQueryRecipient\" id=\"searchQueryRecipient\" placeholder=\"Recipient\"> <input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQueryAddress1\" id=\"searchQueryAddress1\" placeholder=\"Address Line 1\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQueryRecipient, vm.searchQueryAddress1)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><!--<th><span translate=\"crm2PrintApp.printJobRecord.barcode\">Barcode</span></th>--><th><span translate=\"crm2PrintApp.printJobRecord.sortPlan\">Sort Plan</span></th><!--<th><span translate=\"crm2PrintApp.printJobRecord.dpid\">Dpid</span></th>--><th><span translate=\"crm2PrintApp.printJobRecord.bsp\">Bsp</span></th><th><span translate=\"crm2PrintApp.printJobRecord.recipient1\">Recipient 1</span></th><th><span translate=\"crm2PrintApp.printJobRecord.recipient2\">Recipient 2</span></th><th><span translate=\"crm2PrintApp.printJobRecord.address1\">Address 1</span></th><th><span translate=\"crm2PrintApp.printJobRecord.address2\">Address 2</span></th><th><span translate=\"crm2PrintApp.printJobRecord.city\">City</span></th><th><span translate=\"crm2PrintApp.printJobRecord.state\">State</span></th><th><span translate=\"crm2PrintApp.printJobRecord.postcode\">Postcode</span></th><th><span translate=\"crm2PrintApp.printJobRecord.country\">Country</span></th><th><span translate=\"crm2PrintApp.printJobRecord.pageCount\">Page Count</span></th><th><span translate=\"crm2PrintApp.printJobRecord.receivedReturnMail\">Received Return Mail</span></th><th><span translate=\"crm2PrintApp.printJobRecord.flag\">Flag</span></th><th><span translate=\"crm2PrintApp.printJobRecord.countryCode\">Country Code</span></th><!--<th><span translate=\"crm2PrintApp.printJobRecord.addressId\">Address Id</span></th>--><th><span translate=\"crm2PrintApp.printJobRecord.printStreamPage\" has-authority=\"ROLE_ADMIN\">Print Stream Page</span></th><th><span translate=\"crm2PrintApp.printJobRecord.job\" has-authority=\"ROLE_ADMIN\">Job</span></th><th><span translate=\"crm2PrintApp.printJobRecord.jobStream\" has-authority=\"ROLE_ADMIN\">Job Stream</span></th><th><span translate=\"crm2PrintApp.printJobRecord.printStream\" has-authority=\"ROLE_ADMIN\">Print Stream</span></th><!--<th></th>--></tr></thead><tbody><tr ng-repeat=\"printJobRecord in vm.printJobRecords track by printJobRecord.id\"><td><a ui-sref=\"print-job-record-detail({id:printJobRecord.id})\">{{printJobRecord.id}}</a></td><!--<td>{{printJobRecord.barcode}}</td>--><td>{{printJobRecord.c2p_sort_plan}}</td><!--<td>{{printJobRecord.dpid}}</td>--><td>{{printJobRecord.c2p_bsp}}</td><td>{{printJobRecord.c2p_recipient_1}}</td><td>{{printJobRecord.c2p_recipient_2}}</td><td>{{printJobRecord.c2p_streetaddress_1}}</td><td>{{printJobRecord.c2p_streetaddress_2}}</td><td>{{printJobRecord.c2p_city}}</td><td>{{printJobRecord.c2p_state}}</td><td>{{printJobRecord.c2p_postcode}}</td><td>{{printJobRecord.c2p_country}}</td><td>{{printJobRecord.pageCount}}</td><td>{{printJobRecord.receivedReturnMail | date:\'medium\'}}</td><td>{{printJobRecord.flag}}</td><td>{{printJobRecord.countryCode}}</td><!--<td>{{printJobRecord.addressId}}</td>--><td has-authority=\"ROLE_ADMIN\">{{printJobRecord.printStreamPage}}</td><td has-authority=\"ROLE_ADMIN\"><a ui-sref=\"print-job-detail({id:printJobRecord.job.id})\">{{printJobRecord.job.id}}</a></td><td has-authority=\"ROLE_ADMIN\"><a ui-sref=\"print-stream-detail({id:printJobRecord.jobStream.id})\">{{printJobRecord.jobStream.id}}</a></td><td has-authority=\"ROLE_ADMIN\"><a ui-sref=\"print-stream-detail({id:printJobRecord.printStream.id})\">{{printJobRecord.printStream.id}}</a></td><!-- <td class=\"text-right\">\n                        <div class=\"btn-group flex-btn-group-container\">\n                            <button type=\"submit\"\n                                    ui-sref=\"print-job-record-detail({id:printJobRecord.id})\"\n                                    class=\"btn btn-info btn-sm\">\n                                <span class=\"glyphicon glyphicon-eye-open\"></span>\n                                <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span>\n                            </button>\n                            <button type=\"submit\"\n                                    ui-sref=\"print-job-record.edit({id:printJobRecord.id})\"\n                                    class=\"btn btn-primary btn-sm\">\n                                <span class=\"glyphicon glyphicon-pencil\"></span>\n                                <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>\n                            </button>\n                            <button type=\"submit\"\n                                    ui-sref=\"print-job-record.delete({id:printJobRecord.id})\"\n                                    class=\"btn btn-danger btn-sm\">\n                                <span class=\"glyphicon glyphicon-remove-circle\"></span>\n                                <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>\n                            </button>\n                        </div>\n                    </td>--></tr></tbody></table></div></div></div>");
$templateCache.put("app/entities/print-stream/print-stream-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.printStream.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.printStream.delete.question\" translate-values=\"{id: \'{{vm.printStream.id}}\'}\">Are you sure you want to delete this Print Stream?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/print-stream/print-stream-detail.html","<div><h2><span translate=\"crm2PrintApp.printStream.detail.title\">Print Stream</span> {{vm.printStream.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.printStream.type\">Type</span></dt><dd><span translate=\"{{\'crm2PrintApp.PrintStreamType.\' + vm.printStream.type}}\">{{vm.printStream.type}}</span></dd><dt><span translate=\"crm2PrintApp.printStream.created\">Created</span></dt><dd><span>{{vm.printStream.created | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.printStream.letterCount\">Letter Count</span></dt><dd><span>{{vm.printStream.letterCount}}</span></dd><dt><span translate=\"crm2PrintApp.printStream.pageCount\">Page Count</span></dt><dd><span>{{vm.printStream.pageCount}}</span></dd><dt><span translate=\"crm2PrintApp.printStream.paperSize\">Paper Size</span></dt><dd><span>{{vm.printStream.paperSize}}</span></dd><dt><span translate=\"crm2PrintApp.printStream.sortPlanCounts\">Sort Plan Counts</span></dt><dd><span>{{vm.printStream.sortPlanCounts}}</span></dd><dt><span translate=\"crm2PrintApp.printStream.addressBarcodeCount\">Address Barcode Count</span></dt><dd><span>{{vm.printStream.addressBarcodeCount}}</span></dd><dt><span translate=\"crm2PrintApp.printStream.duplex\">Duplex</span></dt><dd><span>{{vm.printStream.duplex}}</span></dd><dt><span translate=\"crm2PrintApp.printStream.notes\">Notes</span></dt><dd><span>{{vm.printStream.notes}}</span></dd><dt><span translate=\"crm2PrintApp.printStream.archived\">Archived</span></dt><dd><span>{{vm.printStream.archived | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.printStream.vendor\">Vendor</span></dt><dd><a ui-sref=\"vendor-detail({id:vm.printStream.vendor.id})\">{{vm.printStream.vendor.name}}</a></dd><dt><span translate=\"crm2PrintApp.printStream.printJob\">Print Job</span></dt><dd><a ui-sref=\"print-job-detail({id:vm.printStream.printJob.id})\">{{vm.printStream.printJob.id}}</a></dd><dt><span translate=\"crm2PrintApp.printStream.jobTicket\">Job Ticket</span></dt><dd><a ui-sref=\"vendor-job-ticket-detail({id:vm.printStream.jobTicket.id})\">{{vm.printStream.jobTicket.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/print-stream/print-stream-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPrintStreamLabel\" translate=\"crm2PrintApp.printStream.home.createOrEditLabel\">Create or edit a Print Stream</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.printStream.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.printStream.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printStream.type\" for=\"field_type\">Type</label><select class=\"form-control\" name=\"type\" ng-model=\"vm.printStream.type\" id=\"field_type\" required><option value=\"PRINTJOB\" translate=\"crm2PrintApp.PrintStreamType.PRINTJOB\">PRINTJOB</option><option value=\"FINAL\" translate=\"crm2PrintApp.PrintStreamType.FINAL\">FINAL</option></select><div ng-show=\"editForm.type.$invalid\"><p class=\"help-block\" ng-show=\"editForm.type.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printStream.created\" for=\"field_created\">Created</label><div class=\"input-group\"><input id=\"field_created\" type=\"text\" class=\"form-control\" name=\"created\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.printStream.created\" is-open=\"vm.datePickerOpenStatus.created\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'created\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.created.$invalid\"><p class=\"help-block\" ng-show=\"editForm.created.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.created.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printStream.letterCount\" for=\"field_letterCount\">Letter Count</label><input type=\"number\" class=\"form-control\" name=\"letterCount\" id=\"field_letterCount\" ng-model=\"vm.printStream.letterCount\" required><div ng-show=\"editForm.letterCount.$invalid\"><p class=\"help-block\" ng-show=\"editForm.letterCount.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.letterCount.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printStream.pageCount\" for=\"field_pageCount\">Page Count</label><input type=\"number\" class=\"form-control\" name=\"pageCount\" id=\"field_pageCount\" ng-model=\"vm.printStream.pageCount\" required><div ng-show=\"editForm.pageCount.$invalid\"><p class=\"help-block\" ng-show=\"editForm.pageCount.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.pageCount.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printStream.paperSize\" for=\"field_paperSize\">Paper Size</label><input type=\"text\" class=\"form-control\" name=\"paperSize\" id=\"field_paperSize\" ng-model=\"vm.printStream.paperSize\" ng-pattern=\"/((?:SR)?(A[0-4])|Letter|Legal|8x4)/\"><div ng-show=\"editForm.paperSize.$invalid\"><p class=\"help-block\" ng-show=\"editForm.paperSize.$error.pattern\" translate=\"entity.validation.pattern\" translate-value-pattern=\"((?:SR)?(A[0-4])|Letter|Legal|8x4)\">This field should follow pattern \"((?:SR)?(A[0-4])|Letter|Legal|8x4)\".</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.printStream.sortPlanCounts\" for=\"field_sortPlanCounts\">Sort Plan Counts</label><textarea class=\"form-control\" name=\"sortPlanCounts\" id=\"field_sortPlanCounts\" ng-model=\"vm.printStream.sortPlanCounts\">\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"crm2PrintApp.printStream.addressBarcodeCount\" for=\"field_addressBarcodeCount\">Address Barcode Count</label>\n            <input type=\"number\" class=\"form-control\" name=\"addressBarcodeCount\" id=\"field_addressBarcodeCount\" ng-model=\"vm.printStream.addressBarcodeCount\">\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"crm2PrintApp.printStream.duplex\" for=\"field_duplex\">Duplex</label>\n            <input type=\"checkbox\" class=\"form-control\" name=\"duplex\" id=\"field_duplex\" ng-model=\"vm.printStream.duplex\">\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"crm2PrintApp.printStream.notes\" for=\"field_notes\">Notes</label>\n            <input type=\"text\" class=\"form-control\" name=\"notes\" id=\"field_notes\" ng-model=\"vm.printStream.notes\">\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"crm2PrintApp.printStream.archived\" for=\"field_archived\">Archived</label>\n                <div class=\"input-group\">\n                    <input id=\"field_archived\" type=\"text\" class=\"form-control\" name=\"archived\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.printStream.archived\" is-open=\"vm.datePickerOpenStatus.archived\">\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'archived\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label translate=\"crm2PrintApp.printStream.vendor\" for=\"field_vendor\">Vendor</label>\n            <select class=\"form-control\" id=\"field_vendor\" name=\"vendor\" ng-model=\"vm.printStream.vendor\" ng-options=\"vendor as vendor.name for vendor in vm.vendors track by vendor.id\" required>\n                <option value=\"\"></option>\n            </select>\n        </div>\n        <div ng-show=\"editForm.vendor.$invalid\">\n            <p class=\"help-block\" ng-show=\"editForm.vendor.$error.required\" translate=\"entity.validation.required\">\n                This field is required.\n            </p>\n        </div>\n        <div class=\"form-group\">\n            <label translate=\"crm2PrintApp.printStream.printJob\" for=\"field_printJob\">Print Job</label>\n            <select class=\"form-control\" id=\"field_printJob\" name=\"printJob\" ng-model=\"vm.printStream.printJob\" ng-options=\"printJob as printJob.id for printJob in vm.printjobs track by printJob.id\">\n                <option value=\"\"></option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label translate=\"crm2PrintApp.printStream.jobTicket\" for=\"field_jobTicket\">Job Ticket</label>\n            <select class=\"form-control\" id=\"field_jobTicket\" name=\"jobTicket\" ng-model=\"vm.printStream.jobTicket\" ng-options=\"vendorJobTicket as vendorJobTicket.id for vendorJobTicket in vm.vendorjobtickets track by vendorJobTicket.id\">\n                <option value=\"\"></option>\n            </select>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\">\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\">\n            <span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>");
$templateCache.put("app/entities/print-stream/print-streams.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.printStream.home.title\">Print Streams</h3></div><div class=\"block-content\"><jhi-alert></jhi-alert><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"type\"><span translate=\"crm2PrintApp.printStream.type\">Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><i class=\"fa fa-cloud-download\"></i></th><th jh-sort-by=\"letterCount\"><!--<span translate=\"crm2PrintApp.printStream.letterCount\">Letter Count</span>--><i class=\"fa fa-envelope-o\" title=\"Stream Letter Count\"></i> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"pageCount\"><!--<span translate=\"crm2PrintApp.printStream.pageCount\">Page Count</span>--> <i class=\"si si-docs\" title=\"Stream Page Count\"></i> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sortPlanCounts\"><!--<span translate=\"crm2PrintApp.printStream.sortPlanCounts\">Sort Plan Counts</span>--><i class=\"fa fa-sort-numeric-asc\" title=\"Number of Sort Plan\"></i> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"addressBarcodeCount\"><!--<span translate=\"crm2PrintApp.printStream.addressBarcodeCount\">Address Barcode Count</span>--><i class=\"fa fa-barcode\" title=\"Number of barcoded addresses\"></i> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"paperSize\"><!--<span translate=\"crm2PrintApp.printStream.paperSize\">Paper Size</span>--> <i class=\"si si-frame\" title=\"Page Size\"></i> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"duplex\"><span translate=\"crm2PrintApp.printStream.duplex\">Duplex</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"notes\"><span translate=\"crm2PrintApp.printStream.notes\">Notes</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"created\"><span translate=\"crm2PrintApp.printStream.created\">Created</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vendor.name\"><span translate=\"crm2PrintApp.printStream.vendor\">Vendor</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"printJob.id\"><span translate=\"crm2PrintApp.printStream.printJob\">Print Job</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"jobTicket.id\"><span translate=\"crm2PrintApp.printStream.jobTicket\">Job Ticket</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"printStream in vm.printStreams track by printStream.id\"><td><a ui-sref=\"print-stream-detail({id:printStream.id})\">{{printStream.id}}</a></td><td><span translate=\"{{\'crm2PrintApp.PrintStreamType.\' + printStream.type}}\">{{printStream.type}}</span></td><td><a ng-show=\"printStream.type==\'PRINTJOB\'\" ng-href=\"/api/assets/print-jobs/{{printStream.printJob.id}}/print-streams/{{printStream.id}}/stream.pdf\" target=\"_blank\"><i class=\"fa fa-file-pdf-o\"></i></a> <a ng-show=\"printStream.type==\'FINAL\'\" ng-href=\"/api/assets/print-streams/{{printStream.id}}/stream.pdf\" target=\"_blank\"><i class=\"fa fa-file-pdf-o\"></i></a></td><td>{{printStream.letterCount}}</td><td>{{printStream.pageCount}}</td><td>{{printStream.sortPlanCount}}</td><td>{{printStream.addressBarcodeCount}}</td><td>{{printStream.paperSize}}</td><td><i ng-class=\"[\'fa\',printStream.duplex?\'fa-check\':\'fa-times\']\"></i></td><td>{{printStream.notes}}</td><td>{{printStream.created | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td><a ui-sref=\"vendor-detail({id:printStream.vendor.id})\">{{printStream.vendor.name}}</a></td><td><a ui-sref=\"print-job-detail({id:printStream.printJob.id})\">{{printStream.printJob.id}}</a></td><td><a ui-sref=\"vendor-job-ticket-detail({id:printStream.jobTicket.id})\">{{printStream.jobTicket.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"print-stream-detail({id:printStream.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"print-stream.edit({id:printStream.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"print-stream.delete({id:printStream.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div></div>");
$templateCache.put("app/entities/return-to-sender/return-to-sender-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.returnToSender.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.returnToSender.delete.question\" translate-values=\"{id: \'{{vm.returnToSender.id}}\'}\">Are you sure you want to delete this Return To Sender?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/return-to-sender/return-to-sender-detail.html","<div><h2><span translate=\"crm2PrintApp.returnToSender.detail.title\">Return To Sender</span> {{vm.returnToSender.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.returnToSender.created\">Created</span></dt><dd><span>{{vm.returnToSender.created | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.returnToSender.notifiedUser\">Notified User</span></dt><dd><span>{{vm.returnToSender.notifiedUser | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.returnToSender.vendor\">Vendor</span></dt><dd><a ui-sref=\"vendor-detail({id:vm.returnToSender.vendor.id})\">{{vm.returnToSender.vendor.name}}</a></dd><dt><span translate=\"crm2PrintApp.returnToSender.printJobRecord\">Print Job Record</span></dt><dd><a ui-sref=\"print-job-record-detail({id:vm.returnToSender.printJobRecord.id})\">{{vm.returnToSender.printJobRecord.address1}}</a></dd><dt><span translate=\"crm2PrintApp.returnToSender.vendorStaff\">Vendor Staff</span></dt><dd><a ui-sref=\"vendor-staff-detail({id:vm.returnToSender.vendorStaff.id})\">{{vm.returnToSender.vendorStaff.userLogin}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/return-to-sender/return-to-sender-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myReturnToSenderLabel\" translate=\"crm2PrintApp.returnToSender.home.createOrEditLabel\">Create or edit a Return To Sender</h4></div><div class=\"modal-body\"><div class=\"form-group\" ng-show=\"vm.returnToSender.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.returnToSender.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label translate=\"crm2PrintApp.returnToSender.vendor\">Vendor</label><div class=\"form-control-static\">{{vm.returnToSender.vendor.name}}</div></div><div class=\"form-group\"><label translate=\"crm2PrintApp.returnToSender.vendorStaff\">Vendor Staff</label><div class=\"form-control-static\">{{vm.returnToSender.vendorStaff.userLogin}}</div></div><div class=\"form-group\"><label for=\"field_barcode\">Barcode</label><div class=\"row\"><div class=\"col-xs-9\"><div class=\"input-group\"><input class=\"form-control\" type=\"text\" pattern=\"^([0-3]{52}|[0-3]{67})$\" id=\"field_barcode\" name=\"field_barcode\" ng-model=\"vm.barcode\"> <span class=\"input-group-addon\"><i ng-class=\"[\'fa\',editForm.field_barcode.$invalid ? \'fa-times\' : \'fa-check\']\"></i></span></div></div><div class=\"col-xs-3\"><button type=\"button\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\" ng-click=\"vm.validateBarcode()\"><span class=\"glyphicon glyphicon-barcode\"></span>&nbsp;<span>Validate Barcode</span></button></div></div></div><div class=\"form-group\"><label for=\"field_barcode\">ID</label><div class=\"row\"><div class=\"col-xs-9\"><div class=\"input-group\"><input class=\"form-control\" type=\"text\" pattern=\"^[0-9]+$\" id=\"field_printjobrecordid\" name=\"field_printjobrecordid\" ng-model=\"vm.printJobRecordId\"> <span class=\"input-group-addon\"><i ng-class=\"[\'fa\',editForm.field_printjobrecordid.$invalid ? \'fa-times\' : \'fa-check\']\"></i></span></div></div><div class=\"col-xs-3\"><button type=\"button\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\" ng-click=\"vm.validatePrintJobRecordId()\"><span class=\"glyphicon glyphicon-barcode\"></span>&nbsp;<span>Validate ID</span></button> <a ui-sref=\"print-job-record\" target=\"_blank\"><button type=\"button\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-search\"></span></button></a></div></div></div><div class=\"form-group\"><label translate=\"crm2PrintApp.returnToSender.printJobRecord\">Print Job Record</label><div class=\"form-control-static\" ng-show=\"vm.returnToSender.printJobRecord\"><img ng-src=\"{{vm.barcodePreviewUrl}}\" style=\"display: block\"> {{vm.returnToSender.printJobRecord.c2p_recipient_1}}<br>{{vm.returnToSender.printJobRecord.c2p_streetaddress_1}}<div ng-show=\"vm.returnToSender.printJobRecord.c2p_streetaddress_2\">{{vm.returnToSender.printJobRecord.c2p_streetaddress_2}}</div><br>{{vm.returnToSender.printJobRecord.c2p_city}}, {{vm.returnToSender.printJobRecord.c2p_state}} {{vm.returnToSender.printJobRecord.c2p_postcode}}<br>{{vm.returnToSender.printJobRecord.c2p_country}}</div></div><div ng-show=\"editForm.printJobRecord.$invalid\"><p class=\"help-block\" ng-show=\"editForm.printJobRecord.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving || !vm.returnToSender.printJobRecord\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/return-to-sender/return-to-senders.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.returnToSender.home.title\">Return To Sender</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"return-to-sender.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.returnToSender.home.createLabel\">Create new Return To Sender</span></button> <button class=\"btn btn-primary\" ng-click=\"vm.sendNotifications()\"><span class=\"fa fa-paper-plane-o\"></span> <span class=\"hidden-xs\">Send pending RTS Notifications</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.returnToSender.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"printJobRecord.printJobId\">Print Job <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"printJobRecord.address1\"><span translate=\"crm2PrintApp.returnToSender.printJobRecord\">Print Job Record</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"created\" class=\"hidden-xs\"><span translate=\"crm2PrintApp.returnToSender.created\">Created</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"notifiedUser\"><span translate=\"crm2PrintApp.returnToSender.notifiedUser\">Notified User</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vendor.name\"><span translate=\"crm2PrintApp.returnToSender.vendor\">Vendor</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vendorStaff.userLogin\" class=\"hidden-xs\"><span translate=\"crm2PrintApp.returnToSender.vendorStaff\">Vendor Staff</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"returnToSender in vm.returnToSenders track by returnToSender.id\"><td><a ui-sref=\"return-to-sender-detail({id:returnToSender.id})\">{{returnToSender.id}}</a></td><td><a ui-sref=\"print-job-detail({id:returnToSender.printJobRecord.printJobId})\">PJ-{{returnToSender.printJobRecord.printJobId}}</a></td><td><a ui-sref=\"print-job-record-detail({id:returnToSender.printJobRecord.id})\">{{returnToSender.printJobRecord.c2p_streetaddress_1}}, {{returnToSender.printJobRecord.c2p_city}}, {{returnToSender.printJobRecord.c2p_state}}</a></td><td class=\"hidden-xs\">{{returnToSender.created | date:\'medium\'}}</td><td>{{returnToSender.notifiedUser | date:\'medium\'}}</td><td><a ui-sref=\"vendor-detail({id:returnToSender.vendor.id})\">{{returnToSender.vendor.name}}</a></td><td class=\"hidden-xs\"><a ui-sref=\"vendor-staff-detail({id:returnToSender.vendorStaff.id})\">{{returnToSender.vendorStaff.user.login}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"return-to-sender-detail({id:returnToSender.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"return-to-sender.edit({id:returnToSender.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"return-to-sender.delete({id:returnToSender.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div></div>");
$templateCache.put("app/entities/site/site-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.site.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.site.delete.question\" translate-values=\"{id: \'{{vm.site.id}}\'}\">Are you sure you want to delete this Site?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/site/site-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\"><span translate=\"crm2PrintApp.site.detail.title\">Site</span> {{vm.site.id}}</h3></div><div class=\"block-content\"><hr><dl class=\"dl-horizontal\"><dt><span translate=\"crm2PrintApp.site.name\">Name</span></dt><dd><span>{{vm.site.name}}</span></dd><hr><dt><span translate=\"crm2PrintApp.site.homepageUrl\">Homepage Url</span></dt><dd><a href=\"{{vm.site.homepageUrl}}\" target=\"_blank\">{{vm.site.homepageUrl}}</a></dd><hr><dt><span translate=\"crm2PrintApp.site.created\">Created</span></dt><dd><span>{{vm.site.created | date:\'medium\'}}</span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info push-10\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div>");
$templateCache.put("app/entities/site/site-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySiteLabel\" translate=\"crm2PrintApp.site.home.createOrEditLabel\">Create or edit a Site</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.site.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.site.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.site.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.site.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.site.homepageUrl\" for=\"field_homepageUrl\">Homepage Url</label><input type=\"text\" class=\"form-control\" name=\"homepageUrl\" id=\"field_homepageUrl\" ng-model=\"vm.site.homepageUrl\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.site.created\" for=\"field_created\">Created</label><div class=\"input-group\"><input id=\"field_created\" type=\"text\" class=\"form-control\" name=\"created\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.site.created\" is-open=\"vm.datePickerOpenStatus.created\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'created\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/site/sites.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.site.home.title\">Sites</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"site.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.site.home.createLabel\">Create new Site</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.site.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"crm2PrintApp.site.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"homepageUrl\"><span translate=\"crm2PrintApp.site.homepageUrl\">Homepage Url</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"created\"><span translate=\"crm2PrintApp.site.created\">Created</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"site in vm.sites track by site.id\"><td><a ui-sref=\"site-detail({id:site.id})\">{{site.id}}</a></td><td>{{site.name}}</td><td><a href=\"{{site.homepageUrl}}\" target=\"_blank\">{{site.homepageUrl}}</a></td><td>{{site.created | date:\'medium\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"site-detail({id:site.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"site.edit({id:site.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"site.delete({id:site.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div></div>");
$templateCache.put("app/entities/site-customisation/site-customisation-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.siteCustomisation.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.siteCustomisation.delete.question\" translate-values=\"{id: \'{{vm.siteCustomisation.id}}\'}\">Are you sure you want to delete this Site Customisation?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/site-customisation/site-customisation-detail.html","<div><h2><span translate=\"crm2PrintApp.siteCustomisation.detail.title\">Site Customisation</span> {{vm.siteCustomisation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.siteCustomisation.siteCustomisationId\">Site Customisation Id</span></dt><dd><span>{{vm.siteCustomisation.siteCustomisationId}}</span></dd><dt><span translate=\"crm2PrintApp.siteCustomisation.headerCss\">Header Css</span></dt><dd><span>{{vm.siteCustomisation.headerCss}}</span></dd><dt><span translate=\"crm2PrintApp.siteCustomisation.headerHtml\">Header Html</span></dt><dd><span>{{vm.siteCustomisation.headerHtml}}</span></dd><dt><span translate=\"crm2PrintApp.siteCustomisation.footerHtml\">Footer Html</span></dt><dd><span>{{vm.siteCustomisation.footerHtml}}</span></dd><dt><span translate=\"crm2PrintApp.siteCustomisation.userUrlPattern\">User Url Pattern</span></dt><dd><span>{{vm.siteCustomisation.userUrlPattern}}</span></dd><dt><span translate=\"crm2PrintApp.siteCustomisation.printUrlPattern\">Print Url Pattern</span></dt><dd><span>{{vm.siteCustomisation.printUrlPattern}}</span></dd><dt><span translate=\"crm2PrintApp.siteCustomisation.lastModified\">Last Modified</span></dt><dd><span>{{vm.siteCustomisation.lastModified | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.siteCustomisation.site\">Site</span></dt><dd><a ui-sref=\"site-detail({id:vm.siteCustomisation.site.id})\">{{vm.siteCustomisation.site.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/site-customisation/site-customisation-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySiteCustomisationLabel\" translate=\"crm2PrintApp.siteCustomisation.home.createOrEditLabel\">Create or edit a Site Customisation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.siteCustomisation.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.siteCustomisation.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteCustomisation.siteCustomisationId\" for=\"field_siteCustomisationId\">Site Customisation Id</label><input type=\"number\" class=\"form-control\" name=\"siteCustomisationId\" id=\"field_siteCustomisationId\" ng-model=\"vm.siteCustomisation.siteCustomisationId\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteCustomisation.headerCss\" for=\"field_headerCss\">Header Css</label><input type=\"text\" class=\"form-control\" name=\"headerCss\" id=\"field_headerCss\" ng-model=\"vm.siteCustomisation.headerCss\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteCustomisation.headerHtml\" for=\"field_headerHtml\">Header Html</label><input type=\"text\" class=\"form-control\" name=\"headerHtml\" id=\"field_headerHtml\" ng-model=\"vm.siteCustomisation.headerHtml\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteCustomisation.footerHtml\" for=\"field_footerHtml\">Footer Html</label><input type=\"text\" class=\"form-control\" name=\"footerHtml\" id=\"field_footerHtml\" ng-model=\"vm.siteCustomisation.footerHtml\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteCustomisation.userUrlPattern\" for=\"field_userUrlPattern\">User Url Pattern</label><input type=\"text\" class=\"form-control\" name=\"userUrlPattern\" id=\"field_userUrlPattern\" ng-model=\"vm.siteCustomisation.userUrlPattern\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteCustomisation.printUrlPattern\" for=\"field_printUrlPattern\">Print Url Pattern</label><input type=\"text\" class=\"form-control\" name=\"printUrlPattern\" id=\"field_printUrlPattern\" ng-model=\"vm.siteCustomisation.printUrlPattern\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteCustomisation.lastModified\" for=\"field_lastModified\">Last Modified</label><div class=\"input-group\"><input id=\"field_lastModified\" type=\"text\" class=\"form-control\" name=\"lastModified\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.siteCustomisation.lastModified\" is-open=\"vm.datePickerOpenStatus.lastModified\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'lastModified\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label translate=\"crm2PrintApp.siteCustomisation.site\" for=\"field_site\">Site</label><select class=\"form-control\" id=\"field_site\" name=\"site\" ng-model=\"vm.siteCustomisation.site\" ng-options=\"site as site.id for site in vm.sites | orderBy:\'id\' track by site.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/site-customisation/site-customisations.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.siteCustomisation.home.title\">Site Customisations</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"site-customisation.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.siteCustomisation.home.createLabel\">Create new Site Customisation</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.siteCustomisation.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"crm2PrintApp.siteCustomisation.siteCustomisationId\">Site Customisation Id</span></th><th><span translate=\"crm2PrintApp.siteCustomisation.headerCss\">Header Css</span></th><th><span translate=\"crm2PrintApp.siteCustomisation.headerHtml\">Header Html</span></th><th><span translate=\"crm2PrintApp.siteCustomisation.footerHtml\">Footer Html</span></th><th><span translate=\"crm2PrintApp.siteCustomisation.userUrlPattern\">User Url Pattern</span></th><th><span translate=\"crm2PrintApp.siteCustomisation.printUrlPattern\">Print Url Pattern</span></th><th><span translate=\"crm2PrintApp.siteCustomisation.lastModified\">Last Modified</span></th><th><span translate=\"crm2PrintApp.siteCustomisation.site\">Site</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"siteCustomisation in vm.siteCustomisations track by siteCustomisation.id\"><td><a ui-sref=\"site-customisation-detail({id:siteCustomisation.id})\">{{siteCustomisation.id}}</a></td><td>{{siteCustomisation.siteCustomisationId}}</td><td>{{siteCustomisation.headerCss}}</td><td>{{siteCustomisation.headerHtml}}</td><td>{{siteCustomisation.footerHtml}}</td><td>{{siteCustomisation.userUrlPattern}}</td><td>{{siteCustomisation.printUrlPattern}}</td><td>{{siteCustomisation.lastModified | date:\'medium\'}}</td><td><a ui-sref=\"site-detail({id:siteCustomisation.site.id})\">{{siteCustomisation.site.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"site-customisation-detail({id:siteCustomisation.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"site-customisation.edit({id:siteCustomisation.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"site-customisation.delete({id:siteCustomisation.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/entities/site-data-source/site-data-source-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.siteDataSource.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.siteDataSource.delete.question\" translate-values=\"{id: \'{{vm.siteDataSource.id}}\'}\">Are you sure you want to delete this Site Data Source?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/site-data-source/site-data-source-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\"><span translate=\"crm2PrintApp.siteDataSource.detail.title\">Site Data Source</span> {{vm.siteDataSource.id}}</h3></div><div class=\"block-content\"><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.siteDataSource.name\">Name</span></dt><dd><span>{{vm.siteDataSource.name}}</span></dd><dt><span translate=\"crm2PrintApp.siteDataSource.lastModified\">Last Modified</span></dt><dd><span>{{vm.siteDataSource.lastModified | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.siteDataSource.lastModifiedBy\">Last Modified By</span></dt><dd>{{vm.siteDataSource.lastModifiedByLogin}}</dd><dt><span translate=\"crm2PrintApp.siteDataSource.type\">Type</span></dt><dd><span translate=\"{{\'crm2PrintApp.DataSourceType.\' + vm.siteDataSource.type}}\">{{vm.siteDataSource.type}}</span></dd><dt><span translate=\"crm2PrintApp.siteDataSource.converter\">Converter</span></dt><dd><span>{{vm.siteDataSource.adapterName}}</span></dd><dt><span translate=\"crm2PrintApp.siteDataSource.sampleData\">Sample Data</span></dt><dd><span>{{vm.siteDataSource.sampleData}}</span></dd><dt><span translate=\"crm2PrintApp.siteDataSource.status\">Status</span></dt><dd><span translate=\"{{\'crm2PrintApp.FeatureStatus.\' + vm.siteDataSource.status}}\">{{vm.siteDataSource.status}}</span></dd><dt><span translate=\"crm2PrintApp.siteDataSource.requiresUser\">Requires User</span></dt><dd><span>{{vm.siteDataSource.requiresUser}}</span></dd><dt><span translate=\"crm2PrintApp.siteDataSource.disclaimer\">Disclaimer</span></dt><dd><span>{{vm.siteDataSource.disclaimer}}</span></dd><dt><span translate=\"crm2PrintApp.siteDataSource.site\">Site</span></dt><dd><a ui-sref=\"site-detail({id:vm.siteDataSource.siteId})\">{{vm.siteDataSource.siteName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info push-10-t\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div>");
$templateCache.put("app/entities/site-data-source/site-data-source-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySiteDataSourceLabel\" translate=\"crm2PrintApp.siteDataSource.home.createOrEditLabel\">Create or edit a Site Data Source</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.siteDataSource.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.siteDataSource.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label translate=\"crm2PrintApp.siteDataSource.site\" for=\"field_site\">Site</label><select class=\"form-control\" id=\"field_site\" name=\"site\" ng-model=\"vm.siteDataSource.siteId\" ng-options=\"site.id as site.name for site in vm.sites\" required><option value=\"\"></option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteDataSource.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.siteDataSource.name\" required><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteDataSource.type\" for=\"field_type\">Type</label><select class=\"form-control\" name=\"type\" ng-model=\"vm.siteDataSource.type\" id=\"field_type\" required><option value=\"CSV\" translate=\"crm2PrintApp.DataSourceType.CSV\">CSV</option><option value=\"API\" translate=\"crm2PrintApp.DataSourceType.API\">API</option><option value=\"NONE\" translate=\"crm2PrintApp.DataSourceType.NONE\">NONE</option></select><div ng-show=\"editForm.type.$invalid\"><p class=\"help-block\" ng-show=\"editForm.type.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteDataSource.converter\" for=\"field_converter\">Converter</label><input type=\"text\" class=\"form-control\" name=\"converter\" id=\"field_converter\" ng-model=\"vm.siteDataSource.adapterName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteDataSource.sampleData\" for=\"field_sampleData\">Sample Data</label><textarea class=\"form-control\" name=\"sampleData\" id=\"field_sampleData\" ng-model=\"vm.siteDataSource.sampleData\"></textarea><p class=\"help-block\">CSV Sample Data Header Names must match the properties of the Adapter Class (typically all lowercase and no spaces)</p></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteDataSource.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.siteDataSource.status\" id=\"field_status\" required><option value=\"ACTIVE\" translate=\"crm2PrintApp.FeatureStatus.ACTIVE\">ACTIVE</option><option value=\"BETA\" translate=\"crm2PrintApp.FeatureStatus.BETA\">BETA</option><option value=\"ALPHA\" translate=\"crm2PrintApp.FeatureStatus.ALPHA\">ALPHA</option><option value=\"DISABLED\" translate=\"crm2PrintApp.FeatureStatus.DISABLED\">DISABLED</option></select><div ng-show=\"editForm.status.$invalid\"><p class=\"help-block\" ng-show=\"editForm.status.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteDataSource.requiresUser\" for=\"field_requiresUser\">Requires User</label><input type=\"checkbox\" class=\"form-control\" name=\"requiresUser\" id=\"field_requiresUser\" ng-model=\"vm.siteDataSource.requiresUser\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteDataSource.disclaimer\" for=\"field_disclaimer\">Disclaimer</label><input type=\"text\" class=\"form-control\" name=\"disclaimer\" id=\"field_disclaimer\" ng-model=\"vm.siteDataSource.disclaimer\"></div><div ng-show=\"editForm.site.$invalid\"><p class=\"help-block\" ng-show=\"editForm.site.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/site-data-source/site-data-sources.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.siteDataSource.home.title\">Site Data Sources</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"site-data-source.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.siteDataSource.home.createLabel\">Create new Site Data Source</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.siteDataSource.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"siteName\"><span translate=\"crm2PrintApp.siteDataSource.site\">Site</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"crm2PrintApp.siteDataSource.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"type\"><span translate=\"crm2PrintApp.siteDataSource.type\">Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"adapterName\"><span translate=\"crm2PrintApp.siteDataSource.converter\">Converter</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sampleData\"><span translate=\"crm2PrintApp.siteDataSource.sampleData\">Sample Data</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"crm2PrintApp.siteDataSource.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"requiresUser\"><span translate=\"crm2PrintApp.siteDataSource.requiresUser\">Requires User</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"siteDataSource in vm.siteDataSources track by siteDataSource.id\"><td><a ui-sref=\"site-data-source-detail({id:siteDataSource.id})\">{{siteDataSource.id}}</a></td><td><a ui-sref=\"site-detail({id:siteDataSource.siteId})\">{{siteDataSource.siteName}}</a></td><td>{{siteDataSource.name}}</td><td translate=\"{{\'crm2PrintApp.DataSourceType.\' + siteDataSource.type}}\">{{siteDataSource.type}}</td><td>{{siteDataSource.adapterName}}</td><td><i ng-class=\"[\'fa\',siteDataSource.sampleData ? \'fa-check\' : \'fa-times\']\"></i></td><td translate=\"{{\'crm2PrintApp.FeatureStatus.\' + siteDataSource.status}}\">{{siteDataSource.status}}</td><td><i ng-class=\"[\'fa\',siteDataSource.requiresUser ? \'fa-check\' : \'fa-times\']\"></i></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"site-data-source-detail({id:siteDataSource.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"site-data-source.edit({id:siteDataSource.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"site-data-source.delete({id:siteDataSource.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div></div>");
$templateCache.put("app/entities/site-token/site-token-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.siteToken.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.siteToken.delete.question\" translate-values=\"{id: \'{{vm.siteToken.id}}\'}\">Are you sure you want to delete this Site Token?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/site-token/site-token-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.envelope.detail.title\">Site Token {{vm.siteToken.id}}</h3></div><div class=\"block-content\"><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.siteToken.siteTokenId\">Site Token Id</span></dt><dd><span>{{vm.siteToken.siteTokenId}}</span></dd><dt><span translate=\"crm2PrintApp.siteToken.authenticationMethod\">Authentication Method</span></dt><dd><span>{{vm.siteToken.authenticationMethod}}</span></dd><dt><span translate=\"crm2PrintApp.siteToken.clientId\">Client Id</span></dt><dd><span>{{vm.siteToken.clientId}}</span></dd><dt><span translate=\"crm2PrintApp.siteToken.clientSecret\">Client Secret</span></dt><dd><span>{{vm.siteToken.clientSecret}}</span></dd><dt><span translate=\"crm2PrintApp.siteToken.accessToken\">Access Token</span></dt><dd><span>{{vm.siteToken.accessToken}}</span></dd><dt><span translate=\"crm2PrintApp.siteToken.creationDate\">Creation Date</span></dt><dd><span>{{vm.siteToken.creationDate | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.siteToken.expiryDate\">Expiry Date</span></dt><dd><span>{{vm.siteToken.expiryDate | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.siteToken.refreshToken\">Refresh Token</span></dt><dd><span>{{vm.siteToken.refreshToken}}</span></dd><dt><span translate=\"crm2PrintApp.siteToken.refreshTokenExpiryDate\">Refresh Token Expiry Date</span></dt><dd><span>{{vm.siteToken.refreshTokenExpiryDate | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.siteToken.siteUser\">Site User</span></dt><dd><a ui-sref=\"site-user-detail({id:vm.siteToken.siteUser.id})\">{{vm.siteToken.siteUser.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info push-10\">class=\"btn btn-info\"> <span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div>");
$templateCache.put("app/entities/site-token/site-token-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySiteTokenLabel\" translate=\"crm2PrintApp.siteToken.home.createOrEditLabel\">Create or edit a Site Token</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.siteToken.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.siteToken.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteToken.siteTokenId\" for=\"field_siteTokenId\">Site Token Id</label><input type=\"number\" class=\"form-control\" name=\"siteTokenId\" id=\"field_siteTokenId\" ng-model=\"vm.siteToken.siteTokenId\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteToken.authenticationMethod\" for=\"field_authenticationMethod\">Authentication Method</label><input type=\"text\" class=\"form-control\" name=\"authenticationMethod\" id=\"field_authenticationMethod\" ng-model=\"vm.siteToken.authenticationMethod\" required><div ng-show=\"editForm.authenticationMethod.$invalid\"><p class=\"help-block\" ng-show=\"editForm.authenticationMethod.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteToken.clientId\" for=\"field_clientId\">Client Id</label><input type=\"text\" class=\"form-control\" name=\"clientId\" id=\"field_clientId\" ng-model=\"vm.siteToken.clientId\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteToken.clientSecret\" for=\"field_clientSecret\">Client Secret</label><input type=\"text\" class=\"form-control\" name=\"clientSecret\" id=\"field_clientSecret\" ng-model=\"vm.siteToken.clientSecret\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteToken.accessToken\" for=\"field_accessToken\">Access Token</label><input type=\"text\" class=\"form-control\" name=\"accessToken\" id=\"field_accessToken\" ng-model=\"vm.siteToken.accessToken\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteToken.creationDate\" for=\"field_creationDate\">Creation Date</label><div class=\"input-group\"><input id=\"field_creationDate\" type=\"text\" class=\"form-control\" name=\"creationDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.siteToken.creationDate\" is-open=\"vm.datePickerOpenStatus.creationDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'creationDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteToken.expiryDate\" for=\"field_expiryDate\">Expiry Date</label><div class=\"input-group\"><input id=\"field_expiryDate\" type=\"text\" class=\"form-control\" name=\"expiryDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.siteToken.expiryDate\" is-open=\"vm.datePickerOpenStatus.expiryDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'expiryDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteToken.refreshToken\" for=\"field_refreshToken\">Refresh Token</label><input type=\"text\" class=\"form-control\" name=\"refreshToken\" id=\"field_refreshToken\" ng-model=\"vm.siteToken.refreshToken\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteToken.refreshTokenExpiryDate\" for=\"field_refreshTokenExpiryDate\">Refresh Token Expiry Date</label><div class=\"input-group\"><input id=\"field_refreshTokenExpiryDate\" type=\"text\" class=\"form-control\" name=\"refreshTokenExpiryDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.siteToken.refreshTokenExpiryDate\" is-open=\"vm.datePickerOpenStatus.refreshTokenExpiryDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'refreshTokenExpiryDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label translate=\"crm2PrintApp.siteToken.siteUser\" for=\"field_siteUser\">Site User</label><select class=\"form-control\" id=\"field_siteUser\" name=\"siteUser\" ng-model=\"vm.siteToken.siteUser\" ng-options=\"siteUser as siteUser.id for siteUser in vm.siteusers | orderBy:\'id\' track by siteUser.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/site-token/site-tokens.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.siteToken.home.title\">Site Tokens</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"site-token.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.siteToken.home.createLabel\">Create new Site Token</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.siteToken.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"crm2PrintApp.siteToken.siteTokenId\">Site Token Id</span></th><th><span translate=\"crm2PrintApp.siteToken.authenticationMethod\">Authentication Method</span></th><th><span translate=\"crm2PrintApp.siteToken.clientId\">Client Id</span></th><th><span translate=\"crm2PrintApp.siteToken.clientSecret\">Client Secret</span></th><th><span translate=\"crm2PrintApp.siteToken.accessToken\">Access Token</span></th><th><span translate=\"crm2PrintApp.siteToken.creationDate\">Creation Date</span></th><th><span translate=\"crm2PrintApp.siteToken.expiryDate\">Expiry Date</span></th><th><span translate=\"crm2PrintApp.siteToken.refreshToken\">Refresh Token</span></th><th><span translate=\"crm2PrintApp.siteToken.refreshTokenExpiryDate\">Refresh Token Expiry Date</span></th><th><span translate=\"crm2PrintApp.siteToken.siteUser\">Site User</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"siteToken in vm.siteTokens track by siteToken.id\"><td><a ui-sref=\"site-token-detail({id:siteToken.id})\">{{siteToken.id}}</a></td><td>{{siteToken.siteTokenId}}</td><td>{{siteToken.authenticationMethod}}</td><td>{{siteToken.clientId}}</td><td>{{siteToken.clientSecret}}</td><td>{{siteToken.accessToken}}</td><td>{{siteToken.creationDate | date:\'medium\'}}</td><td>{{siteToken.expiryDate | date:\'medium\'}}</td><td>{{siteToken.refreshToken}}</td><td>{{siteToken.refreshTokenExpiryDate | date:\'medium\'}}</td><td><a ui-sref=\"site-user-detail({id:siteToken.siteUser.id})\">{{siteToken.siteUser.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"site-token-detail({id:siteToken.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"site-token.edit({id:siteToken.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"site-token.delete({id:siteToken.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/entities/site-user/site-user-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.siteUser.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.siteUser.delete.question\" translate-values=\"{id: \'{{vm.siteUser.id}}\'}\">Are you sure you want to delete this Site User?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/site-user/site-user-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\"><span translate=\"crm2PrintApp.siteUser.detail.title\">Site User</span> {{vm.siteUser.id}}</h3></div><div class=\"block-content\"><hr><dl class=\"dl-horizontal\"><dt><span translate=\"crm2PrintApp.siteUser.site\">Site</span></dt><dd><a ui-sref=\"site-detail({id:vm.siteUser.site.id})\">{{vm.siteUser.site.name}}</a></dd><hr><dt><span translate=\"crm2PrintApp.siteUser.externalUserId\">External User Id</span></dt><dd><span>{{vm.siteUser.externalUserId}}</span></dd><hr><dt><span translate=\"crm2PrintApp.siteUser.creationDate\">Creation Date</span></dt><dd><span>{{vm.siteUser.creationDate | date:\'medium\'}}</span></dd><hr><dt><span translate=\"crm2PrintApp.siteUser.username\">Username</span></dt><dd><span>{{vm.siteUser.username}}</span></dd><hr><dt><span translate=\"crm2PrintApp.siteUser.externalSubUserId\">External Sub User Id</span></dt><dd><span>{{vm.siteUser.externalSubUserId}}</span></dd><hr><dt><span translate=\"crm2PrintApp.siteUser.displayName\">Display Name</span></dt><dd><span>{{vm.siteUser.displayName}}</span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info push-10\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div>");
$templateCache.put("app/entities/site-user/site-user-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" autocomplete=\"off\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySiteUserLabel\" translate=\"crm2PrintApp.siteUser.home.createOrEditLabel\">Create or edit a Site User</h4></div><div class=\"modal-body\"><div class=\"form-group\" ng-show=\"vm.siteUser.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.siteUser.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label translate=\"crm2PrintApp.siteUser.site\" for=\"field_site\">Site</label><select class=\"form-control\" id=\"field_site\" name=\"site\" ng-model=\"vm.siteUser.site\" ng-options=\"site as site.name for site in vm.sites track by site.id\" required ng-change=\"vm.siteSelected()\"><option value=\"\"></option></select></div><div class=\"row\" ng-show=\"vm.siteAuthenticationMethod == \'OAUTH\'\"><div class=\"push-30 col-lg-6 col-lg-offset-4\"><span ng-show=\"vm.token\" class=\"glyphicon glyphicon-ok\"></span> <a ng-href=\"{{vm.siteOauthLoginUrl}}\" target=\"_blank\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-disabled=\"!vm.siteUser.site\" ng-show=\"!vm.token\" ng-click=\"vm.startTokenCheck()\"><span class=\"glyphicon glyphicon-transfer\"></span>&nbsp;Login to {{vm.siteUser.site.name}} and authorize access to CRM2Print</a></div></div><div class=\"row\" ng-show=\"vm.siteAuthenticationMethod == \'TOKEN\' || vm.siteAuthenticationMethod == \'BASIC\'\"><div class=\"col-lg-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteUser.username\" for=\"field_username\">Username</label><input type=\"text\" class=\"form-control\" name=\"field_username\" id=\"field_username\" ng-model=\"vm.siteUser.username\" autocomplete=\"off\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteUser.password\" for=\"field_password\">Password</label><input type=\"password\" class=\"form-control\" name=\"field_password\" id=\"field_password\" ng-model=\"vm.siteUser.password\" autocomplete=\"off\"></div></div><div class=\"col-lg-6 push-50-t\"><span ng-show=\"vm.token\" class=\"glyphicon glyphicon-ok\"></span> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-disabled=\"!vm.siteUser.site || !vm.siteUser.username || !vm.siteUser.password\" ng-show=\"!vm.token\" ng-click=\"vm.generateToken()\"><span class=\"glyphicon glyphicon-transfer\"></span>&nbsp;Verify username &amp; password</button></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteUser.externalUserId\" for=\"field_externalUserId\">External User Id</label><input type=\"text\" class=\"form-control\" name=\"externalUserId\" id=\"field_externalUserId\" ng-model=\"vm.siteUser.externalUserId\" readonly=\"readonly\"></div><div class=\"form-group\" ng-show=\"vm.token\"><label class=\"control-label\" for=\"field_accessToken\">Access Token</label><input type=\"text\" class=\"form-control\" name=\"accessToken\" id=\"field_accessToken\" ng-model=\"vm.token.accessToken\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteUser.externalSubUserId\" for=\"field_externalSubUserId\">External Sub User Id</label><input type=\"text\" class=\"form-control\" name=\"externalSubUserId\" id=\"field_externalSubUserId\" ng-model=\"vm.siteUser.externalSubUserId\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteUser.displayName\" for=\"field_displayName\">Display Name</label><input type=\"text\" class=\"form-control\" name=\"displayName\" id=\"field_displayName\" ng-model=\"vm.siteUser.displayName\" readonly=\"readonly\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/site-user/site-users.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.siteUser.home.title\">Site Users</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"site-user.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.siteUser.home.createLabel\">Create new Site User</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.siteUser.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"crm2PrintApp.siteUser.site\">Site</span></th><th><span translate=\"crm2PrintApp.siteUser.username\">Username</span></th><th><span translate=\"crm2PrintApp.siteUser.displayName\">Display Name</span></th><th><span translate=\"crm2PrintApp.siteUser.externalUserId\">External User Id</span></th><th><span translate=\"crm2PrintApp.siteUser.externalSubUserId\">External Sub User Id</span></th><th><span translate=\"crm2PrintApp.siteUser.creationDate\">Creation Date</span></th><th><span translate=\"crm2PrintApp.siteUser.status\">Status</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"siteUser in vm.siteUsers track by siteUser.id\"><td><a ui-sref=\"site-detail({id:siteUser.site.id})\">{{siteUser.site.name}}</a></td><td>{{siteUser.username}}</td><td>{{siteUser.displayName}}</td><td>{{siteUser.externalUserId}}</td><td>{{siteUser.externalSubUserId}}</td><td>{{siteUser.creationDate | date:\'medium\'}}</td><td translate=\"{{\'crm2PrintApp.EntityStatus.\' + siteUser.status}}\">{{siteUser.status}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"site-user-detail({id:siteUser.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"site-user.edit({id:siteUser.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"site-user.delete({id:siteUser.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/entities/site-web-service/site-web-service-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.siteAPI.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.siteAPI.delete.question\" translate-values=\"{id: \'{{vm.siteAPI.id}}\'}\">Are you sure you want to delete this Site API?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/site-web-service/site-web-service-detail.html","<div><h2><span translate=\"crm2PrintApp.siteAPI.detail.title\">Site API</span> {{vm.siteAPI.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.siteAPI.oauthLoginUrl\">Oauth Login Url</span></dt><dd><span>{{vm.siteAPI.oauthLoginUrl}}</span></dd><dt><span translate=\"crm2PrintApp.siteAPI.clientId\">Client Id</span></dt><dd><span>{{vm.siteAPI.clientId}}</span></dd><dt><span translate=\"crm2PrintApp.siteAPI.clientSecrect\">Client Secrect</span></dt><dd><span>{{vm.siteAPI.clientSecrect}}</span></dd><dt><span translate=\"crm2PrintApp.siteAPI.verified\">Verified</span></dt><dd><span>{{vm.siteAPI.verified | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.siteAPI.created\">Created</span></dt><dd><span>{{vm.siteAPI.created | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.siteAPI.lastModified\">Last Modified</span></dt><dd><span>{{vm.siteAPI.lastModified | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.siteAPI.apiKey\">Api Key</span></dt><dd><span>{{vm.siteAPI.apiKey}}</span></dd><dt><span translate=\"crm2PrintApp.siteAPI.site\">Site</span></dt><dd><a ui-sref=\"site-detail({id:vm.siteAPI.site.id})\">{{vm.siteAPI.site.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/site-web-service/site-web-service-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySiteAPILabel\" translate=\"crm2PrintApp.siteAPI.home.createOrEditLabel\">Create or edit a Site API</h4></div><div class=\"modal-body\"><div class=\"form-group\" ng-show=\"vm.siteAPI.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.siteAPI.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label translate=\"crm2PrintApp.siteAPI.site\" for=\"field_site\">Site</label><select class=\"form-control\" id=\"field_site\" name=\"site\" ng-model=\"vm.siteAPI.site\" ng-options=\"site as site.name for site in vm.sites | orderBy:\'id\' track by site.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteAPI.oauthLoginUrl\" for=\"field_oauthLoginUrl\">Oauth Login Url</label><input type=\"text\" class=\"form-control\" name=\"oauthLoginUrl\" id=\"field_oauthLoginUrl\" ng-model=\"vm.siteAPI.oauthLoginUrl\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteAPI.oauthTokenUrl\" for=\"field_oauthTokenUrl\">Oauth Token Url</label><input type=\"text\" class=\"form-control\" name=\"oauthTokenUrl\" id=\"field_oauthTokenUrl\" ng-model=\"vm.siteAPI.oauthTokenUrl\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteAPI.clientId\" for=\"field_clientId\">Client Id</label><input type=\"text\" class=\"form-control\" name=\"clientId\" id=\"field_clientId\" ng-model=\"vm.siteAPI.clientId\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteAPI.clientSecrect\" for=\"field_clientSecrect\">Client Secrect</label><input type=\"text\" class=\"form-control\" name=\"clientSecrect\" id=\"field_clientSecrect\" ng-model=\"vm.siteAPI.clientSecrect\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteAPI.verified\" for=\"field_verified\">Verified</label><div class=\"input-group\"><input id=\"field_verified\" type=\"text\" class=\"form-control\" name=\"verified\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.siteAPI.verified\" is-open=\"vm.datePickerOpenStatus.verified\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'verified\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteAPI.apiKey\" for=\"field_apiKey\">Api Key</label><input type=\"text\" class=\"form-control\" name=\"apiKey\" id=\"field_apiKey\" ng-model=\"vm.siteAPI.apiKey\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.siteAPI.tokenProvider\" for=\"field_tokenProvider\">Token Provider</label><input type=\"text\" class=\"form-control\" name=\"tokenProvider\" id=\"field_tokenProvider\" ng-model=\"vm.siteAPI.tokenProvider\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/site-web-service/site-web-services.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.siteAPI.home.title\">Site Apis</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"site-web-service.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.siteAPI.home.createLabel\">Create new Site API</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.siteAPI.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><!--<th><span translate=\"crm2PrintApp.siteAPI.clientId\">Client Id</span></th>--><th><span translate=\"crm2PrintApp.siteAPI.site\">Site</span></th><th><span translate=\"crm2PrintApp.siteAPI.lastModified\">Last Modified</span></th><th><span translate=\"crm2PrintApp.siteAPI.clientId\">Client Id</span></th><th><span translate=\"crm2PrintApp.siteAPI.apiKey\">Api Key</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"siteAPI in vm.siteAPIS track by siteAPI.id\"><td><a ui-sref=\"site-api-detail({id:siteAPI.id})\">{{siteAPI.id}}</a></td><!--<td>{{siteAPI.clientId}}</td>--><td><a ui-sref=\"site-detail({id:siteAPI.site.id})\">{{siteAPI.site.name}}</a></td><td>{{siteAPI.lastModified | date:\'medium\'}}</td><td>{{siteAPI.clientId}}</td><td>{{siteAPI.apiKey}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"site-api-detail({id:siteAPI.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"site-web-service.edit({id:siteAPI.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"site-web-service.delete({id:siteAPI.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/entities/stationery/stationeries.html","<jhi-alert></jhi-alert><style type=\"text/css\">.stationery-name.truncate {\n        width: 250px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n    .dz-clickable {\n        border: 2px solid transparent;\n    }\n    .dz-drag-hover {\n        border: 2px dashed #5c90d2;\n    }</style><!-- Side Content and Products --><div class=\"bg-gray-lighter\"><section class=\"content dz-nodragging\" data-js-dropzone=\"\" dropzone=\"dropzoneConfigStationery\"><div class=\"row\"><div class=\"col-xs-8\"><p class=\"content-mini content-mini-full bg-primary-light text-white\">To upload new stationery and letterheads just drag any doc/docx/pdf/rtf onto the page.</p><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.stationery.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div><div class=\"row\" style=\"margin-top: 15px\"><div class=\"col-lg-3\"><!-- Buttons which toggles side nav content content in smaller screens --><!-- Toggle class helper (for .js-nav-content below), functionality initialized in App() -> uiToggleClass() --><div class=\"block hidden-lg\"><div class=\"block-content\"><button class=\"btn btn-sm btn-block btn-default push\" type=\"button\" data-toggle=\"class-toggle\" data-target=\".js-nav-content\" data-class=\"visible-lg\"><i class=\"fa fa-list-ul push-5-r\"></i> Navigation</button></div></div></div><div class=\"col-lg-12\"><!-- Products --><div class=\"row\" infinite-scroll=\"vm.loadPage(vm.page + 1)\" infinite-scroll-disabled=\"true || vm.page >= vm.links[\'last\']\"><div class=\"col-sm-4 col-lg-3\" ng-repeat=\"stationery in vm.stationeries track by stationery.id\"><div class=\"block\"><div class=\"img-container ribbon-bookmark text-center ribbon ribbon-bookmark ribbon-crystal\"><img class=\"img-responsive\" ng-src=\"/api/assets/stationeries/{{stationery.id}}-thumb.png\" alt=\"\"><div class=\"img-options\"><div class=\"img-options-content\"><div class=\"push-20\"><div class=\"btn-group\"><button type=\"submit\" ui-sref=\"stationery-detail({id:stationery.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"stationery.delete({id:stationery.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></div></div></div></div><div class=\"block-content\"><div class=\"push-10\"><div class=\"h4 font-w600 text-success pull-right push-10-l\">{{stationery.size}}</div><a class=\"h4\" ui-sref=\"stationery-detail({id:stationery.id})\" class=\"stationery-name truncate\">{{stationery.name}}</a></div><div class=\"font-s12 text-center push\">Stationery ID #{{stationery.id}}</div></div></div></div></div><!-- END Products --></div></div></section></div><!-- END Side Content and Products -->");
$templateCache.put("app/entities/stationery/stationery-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.stationery.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.stationery.delete.question\" translate-values=\"{id: \'{{vm.stationery.id}}\'}\">Are you sure you want to delete this Stationery?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/stationery/stationery-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\"><span translate=\"crm2PrintApp.stationery.detail.title\">Stationery</span> {{vm.stationery.id}}</h3></div><div class=\"block-content\"><div class=\"row\"><div class=\"col-lg-4\"><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.stationery.status\">Status</span></dt><dd><span>{{vm.stationery.status}}</span></dd><dt><span translate=\"crm2PrintApp.stationery.name\">Name</span></dt><dd><span>{{vm.stationery.name}}</span> <a ng-href=\"/api/secure-assets/stationeries/{{vm.stationery.id}}.pdf?access_token={{vm.token}}\" target=\"_blank\" title=\"Download Stationery PDF\"><i class=\"fa fa-download\"></i></a></dd><dt><span translate=\"crm2PrintApp.stationery.fileFormat\">File Format</span></dt><dd><span>{{vm.stationery.fileFormat}}</span></dd><dt><span translate=\"crm2PrintApp.stationery.size\">Size</span></dt><dd><span>{{vm.stationery.size}}</span></dd><dt><span translate=\"crm2PrintApp.stationery.created\">Created</span></dt><dd><span>{{vm.stationery.created | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.stationery.creator\">Creator</span></dt><dd><span>{{vm.stationery.creator.firstName}}</span></dd></dl></div><div class=\"col-lg-8\"><img class=\"img-stationery\" ng-src=\"api/assets/stationeries/{{vm.stationery.id}}-detail.png\" alt=\"{{vm.stationery.name}}\" style=\"border: solid 1px black\"></div></div><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info push-10\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div>");
$templateCache.put("app/entities/stationery/stationery-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myStationeryLabel\" translate=\"crm2PrintApp.stationery.home.createOrEditLabel\">Create or edit a Stationery</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.stationery.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.stationery.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.stationery.status\" for=\"field_status\">Status</label><input type=\"text\" class=\"form-control\" name=\"status\" id=\"field_status\" ng-model=\"vm.stationery.status\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.stationery.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.stationery.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.stationery.fileFormat\" for=\"field_fileFormat\">File Format</label><input type=\"text\" class=\"form-control\" name=\"fileFormat\" id=\"field_fileFormat\" ng-model=\"vm.stationery.fileFormat\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.stationery.size\" for=\"field_size\">Size</label><input type=\"text\" class=\"form-control\" name=\"size\" id=\"field_size\" ng-model=\"vm.stationery.size\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.stationery.created\" for=\"field_created\">Created</label><div class=\"input-group\"><input id=\"field_created\" type=\"text\" class=\"form-control\" name=\"created\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.stationery.created\" is-open=\"vm.datePickerOpenStatus.created\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'created\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.stationery.creator\" for=\"field_creator\">Creator</label><select class=\"form-control\" id=\"field_creator\" name=\"creator\" ng-model=\"vm.stationery.creator\" ng-options=\"user as user.firstName for user in vm.users track by user.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.stationery.file\" for=\"field_file\">File</label><input type=\"text\" class=\"form-control\" name=\"file\" id=\"field_file\" ng-model=\"vm.stationery.file\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/template/field-mapping.modal.html","<style type=\"text/css\">.modal-dialog {margin-top: 20%}\n    .validation-color .form-control.ng-valid.ng-required, .validation-color .ui-select-container.ng-valid.ng-required .form-control {\n        border-color: green;\n    }\n    .validation-color .form-control.ng-invalid.ng-required, .validation-color .ui-select-container.ng-invalid.ng-required .form-control  {\n        border-color: red;\n    }</style><div class=\"modal-header\"><button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">Edit Merge Field Mapping</h4></div><div class=\"modal-body pad\"><div><div class=\"row push-20-t\"><div class=\"col-sm-5\"><h5>Template Field</h5></div><div class=\"col-sm-push-1 col-sm-6\"><h5>Mapped Field or Expression</h5></div></div><div class=\"row push-20-t select2-validation-color\"><div class=\"col-sm-5\" style=\"padding-top: 7px\">{{vm.mapping.templateField}}</div><div class=\"col-sm-1\"><button type=\"button\" ng-click=\"vm.updateFieldMappingMode()\" ng-class=\"[\'btn\',\'btn-default\',{\'focus\':vm.mapping.mode==\'FIELD\',\'text-muted\':vm.mapping.mode==\'EXPRESSION\'}]\"><i class=\"fa fa-chevron-right\"></i></button></div><div class=\"col-sm-6 validation-color\"><ui-select ng-model=\"vm.mapping.mappedField\" ng-required=\"vm.mapping.mode==\'FIELD\' || vm.mapping.mode==\'CUSTOM\'\" on-select=\"vm.updateFieldMappingMode($item)\" ng-class=\"{\'ng-required\':vm.mapping.mode==\'FIELD\' || vm.mapping.mode==\'CUSTOM\'}\"><ui-select-match><span ng-bind=\"$select.selected.field\"></span></ui-select-match><ui-select-choices group-by=\"\'group\'\" repeat=\"mapableField.field as mapableField in (vm.mapableFields | propsFilter: {field: $select.search})\"><span ng-bind=\"mapableField.field\"></span></ui-select-choices></ui-select></div></div><div class=\"row push-20-t\"><div class=\"col-sm-5\" style=\"padding-top: 7px\">&nbsp;</div><div class=\"col-sm-1\"><button type=\"button\" ng-click=\"vm.mapping.mode=\'EXPRESSION\'\" ng-class=\"[\'btn\',\'btn-default\',{\'focus\':vm.mapping.mode==\'EXPRESSION\',\'text-muted\':vm.mapping.mode!=\'EXPRESSION\'}]\"><i class=\"fa fa-chevron-right\"></i></button></div><div class=\"col-sm-6 validation-color\"><input type=\"text\" class=\"form-control\" ng-class=\"[\'form-control\',{\'ng-required\':vm.mapping.mode==\'EXPRESSION\'}]\" ng-model=\"vm.mapping.expression\" ng-required=\"vm.mapping.mode==\'EXPRESSION\'\" placeholder=\"{{\'e.g. {\'+\'{firstname}\'+\'} {\'+\'{lastname}\'+\'}\'}}\"></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.createCustomField(true)\">New Address Field</button> <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.createCustomField()\">New Custom Field</button> <button data-dismiss=\"modal\" class=\"btn btn-default\" type=\"button\" ng-click=\"vm.save()\">Done</button></div>");
$templateCache.put("app/entities/template/template-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.template.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.template.delete.question\" translate-values=\"{id: \'{{vm.template.id}}\'}\">Are you sure you want to delete this Template?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button> <button type=\"submit\" ng-click=\"vm.confirmArchive(vm.template.id)\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-primary\"><span class=\"fa fa-archive\"></span>&nbsp;Archive</button></div></form>");
$templateCache.put("app/entities/template/template-detail.html","<!-- Side Content and Product --><div class=\"bg-gray-lighter\"><section class=\"content content-boxed\"><div class=\"row\"><div class=\"col-lg-12\"><!-- Product --><div class=\"block\"><div class=\"block-content\"><div class=\"row items-push\"><div class=\"col-sm-6\"><h4>{{vm.template.name}}</h4><div class=\"push-10\"><span translate=\"crm2PrintApp.template.detail.title\">Template</span> #{{vm.template.id}}</div><!-- Images --><div class=\"row js-gallery\"><div class=\"col-xs-12 push-10\"><a class=\"img-link\" ng-href=\"/api/assets/templates/{{vm.template.id}}/full.png\" target=\"_blank\"><img class=\"img-responsive\" ng-src=\"/api/assets/templates/{{vm.template.id}}/detail.png\" alt=\"\" style=\"border: solid 1px black\"></a></div></div><!-- END Images --></div><div class=\"col-sm-6\"><!-- Vital Info --><div class=\"clearfix\"><div class=\"pull-right\"><span class=\"h2 font-w700 text-success\">{{vm.template.size}}</span></div><span class=\"h5\"><span class=\"font-w600 text-success\">{{vm.template.status}}</span><br><small><i ng-class=\"[\'fa\',{\'fa-eye\': vm.template.visibility == \'PUBLIC\',\'fa-eye-slash\': vm.template.visibility == \'PRIVATE\',\'fa-share\': vm.template.visibility == \'SHARED\'}]\"></i> {{vm.template.visibility}}</small> <span ng-show=\"vm.template.visibility == \'SHARED\'\" class=\"label label-default\">Token:&nbsp;&nbsp; <span style=\"font-family: courier, monospace\">{{vm.template.shareToken}}</span></span></span></div><hr><div style=\"height:30px\"><button type=\"button\" class=\"btn btn-sm btn-danger pull-right push-5-r\" ui-sref=\"template.delete({id:vm.template.id})\" ng-show=\"vm.canEdit()\"><i class=\"fa fa-trash push-5-r\"></i> <span translate=\"entity.action.delete\"></span></button> <button type=\"button\" class=\"btn btn-sm btn-primary pull-right push-5-r\" ng-click=\"vm.clearCacheAndPreviews()\" has-authority=\"ROLE_ADMIN\"><i class=\"fa fa-refresh\"></i></button> <button type=\"button\" class=\"btn btn-sm btn-primary pull-right push-5-r\" ng-click=\"vm.share()\" ng-show=\"vm.template.visibility==\'PRIVATE\'\" ng-show=\"vm.canEdit()\"><i class=\"fa fa-share push-5-r\"></i> Share</button> <button type=\"button\" class=\"btn btn-sm btn-primary pull-right push-5-r\" ng-click=\"vm.makePublic()\" has-authority=\"ROLE_ADMIN\" ng-show=\"vm.template.visibility!=\'PUBLIC\'\"><i class=\"fa fa-eye push-5-r\"></i> Make Public</button><!--</div>\n                                <div style=\"height:30px\">--> <button type=\"button\" class=\"btn btn-sm btn-success pull-right push-5-r\" ui-sref=\"print-job.new({templateId:vm.template.id, isTemplate:true})\"><!--ng-show=\"vm.template.dataSource.type == \'API\' && (vm.template.site.name == \'AgentInsight\' || vm.template.site.name == \'NEXU\')\"--> <i class=\"fa fa-play push-5-r\"></i><!--New Print Job--> Template</button> <button type=\"button\" class=\"btn btn-sm btn-success pull-right push-5-r\" ui-sref=\"print-job.new({templateId:vm.template.id})\"><i class=\"fa fa-play push-5-r\"></i> New Print Job</button></div><hr><div class=\"block block-rounded remove-margin-b\"><div class=\"block-content block-content-full bg-gray-lighter clearfix\"><div class=\"pull-right\"><img class=\"img-avatar\" src=\"content/images/avatars/avatar10.jpg\" alt=\"\"></div><div class=\"pull-left push-5-t\"><div class=\"push-10\">By <a class=\"font-w600\" ui-sref=\"user-management-detail({id:vm.template.creator.id})\">{{vm.template.creator.firstName}} {{vm.template.creator.lastName}}</a></div></div></div></div><hr><div class=\"block block-rounded remove-margin-b\"><div class=\"block-content block-content-full bg-gray-lighter clearfix\"><div class=\"push-5-t\"><div class=\"push-10\">Stationery/Letterhead: <a ng-show=\"vm.template.stationery\" class=\"font-w600\" ui-sref=\"stationery-detail({id:vm.template.stationery.id})\">{{vm.template.stationery.name}}</a> <span ng-hide=\"vm.template.stationery\" class=\"font-w600\">N/A</span></div></div><div style=\"margin-left: 25%\"><img ng-if=\"vm.template.stationery\" class=\"img-stationery\" ng-src=\"api/assets/stationeries/{{vm.template.stationery.id}}-thumb.png\" alt=\"{{vm.template.stationery.name}}\" style=\"border: solid 1px black\"></div></div></div><hr><div ng-show=\"vm.template.numberOfPages > 1\" class=\"block block-rounded remove-margin-b\"><div class=\"block-content block-content-full bg-gray-lighter clearfix\"><div class=\"push-5-t\"><div class=\"push-10\">Additional Pages:</div></div><div class=\"row js-gallery\"><div class=\"col-xs-4\" ng-repeat=\"pageIndex in vm.subsequentPageIndicies()\"><a class=\"img-link\" ng-href=\"/api/assets/templates/{{vm.template.id}}/full.png?pageIndex={{pageIndex}}\" target=\"_blank\"><img class=\"img-responsive\" ng-src=\"/api/assets/templates/{{vm.template.id}}/thumb.png?pageIndex={{pageIndex}}\" alt=\"\" style=\"border: solid 1px black\"></a></div></div></div></div></div><div class=\"col-xs-12\"><!-- Extra Info --><div class=\"block\"><ul class=\"nav nav-tabs nav-tabs-alt\" data-js-tabs><li class=\"active\"><a href=\"#template-info\">Info</a></li><li><a href=\"#data-source\" ng-show=\"vm.template.dataSource\">Data Source</a></li><li><a href=\"#field-mapping\">Field Mapping</a></li></ul><div class=\"block-content tab-content\"><!-- Info --><div class=\"tab-pane pull-r-l active\" id=\"template-info\"><table class=\"table table-striped table-borderless remove-margin-b\"><thead><tr><th colspan=\"2\">Download</th></tr></thead><tbody><tr><td>{{vm.template.fileFormat}} <a ng-href=\"/api/secure-assets/templates/{{vm.template.id}}/template.docx?access_token={{vm.token}}\" target=\"_blank\" title=\"Download DOCX Template\"><i class=\"fa fa-download\"></i></a></td><td><i class=\"fa fa-check text-success\"></i></td></tr><tr><td>PDF <a ng-show=\"vm.canEdit()\" ng-href=\"/api/secure-assets/templates/{{vm.template.id}}/approved.pdf?access_token={{vm.token}}\" target=\"_blank\" title=\"Download Approved PDF Preview\"><i class=\"fa fa-download\"></i></a></td><td><i class=\"fa fa-check text-success\"></i></td></tr></tbody></table><table class=\"table table-striped table-borderless remove-margin-b\"><thead><tr><th colspan=\"2\">Extra</th></tr></thead><tbody><tr><td style=\"width: 20%\"><i class=\"fa fa-calendar text-muted push-5-r\"></i> <span translate=\"crm2PrintApp.template.created\">Created</span></td><td>{{vm.template.created | date:\'medium\'}}</td></tr><tr><td style=\"width: 20%\"><i class=\"fa fa-calendar text-muted push-5-r\"></i> <span translate=\"crm2PrintApp.template.validated\">Validated</span></td><td>{{vm.template.validated | date:\'medium\'}} <i class=\"fa fa-check text-success\" ng-if=\"vm.template.validated\"></i></td></tr><tr><td style=\"width: 20%\"><i class=\"fa fa-calendar text-muted push-5-r\"></i> <span translate=\"crm2PrintApp.template.approved\">Approved</span></td><td>{{vm.template.approved | date:\'medium\'}} <i class=\"fa fa-check text-success\" ng-if=\"vm.template.approved\"></i></td></tr><tr><td style=\"width: 20%\"><i class=\"fa fa-calendar text-muted push-5-r\"></i> <span translate=\"crm2PrintApp.template.lastModified\">Last Modified</span></td><td>{{vm.template.lastModified | date:\'medium\'}}</td></tr><tr><td><i class=\"fa fa-anchor text-muted push-5-r\"></i> File Size</td><td>1.3 MB</td></tr><tr><td><i class=\"si si-vector text-muted push-5-r\"></i> <span translate=\"crm2PrintApp.template.fileFormat\">File Format</span></td><td>{{vm.template.fileFormat}}</td></tr><tr><td><i class=\"fa fa-expand text-muted push-5-r\"></i> <span translate=\"crm2PrintApp.template.size\">Size</span></td><td>{{vm.template.size}}</td></tr><tr><td><i class=\"fa fa-hashtag text-muted push-5-r\"></i> <span translate=\"crm2PrintApp.template.numberOfPages\">Number Of Pages</span></td><td>{{vm.template.numberOfPages}}</td></tr><tr><td><i class=\"fa fa-files-o text-muted push-5-r\"></i> <span translate=\"crm2PrintApp.template.stationeryFirstPageOnly\">Stationery First Page Only</span></td><td>{{vm.template.stationeryFirstPageOnly ? \'Yes\' : \'No\'}}</td></tr></tbody></table></div><!-- END Info --><!-- Field Mapping --><div class=\"tab-pane pull-r-l\" id=\"data-source\" ng-show=\"vm.template.dataSource\"><table class=\"table table-striped table-borderless remove-margin-b\"><thead><tr><th colspan=\"2\"><h2>{{vm.template.dataSource.type}}</h2></th></tr></thead><tbody><tr><td style=\"width: 20%\"><i class=\"fa fa-bolt text-muted push-5-r\"></i> CRM / Data Provider</td><td>{{vm.template.dataSource.site.name}}</td></tr><tr><td style=\"width: 20%\"><i class=\"fa fa-bolt text-muted push-5-r\"></i> Data Source</td><td>{{vm.template.dataSource.name}}</td></tr><tr><td style=\"width: 20%\"><i class=\"fa fa-bolt text-muted push-5-r\"></i> Type</td><td>{{vm.template.dataSource.type}}</td></tr></tbody></table></div><!-- END Field Mapping --><!-- Field Mapping --><div class=\"tab-pane pull-r-l\" id=\"field-mapping\"><table class=\"table table-striped table-borderless remove-margin-b\"><thead><tr><th>Template Field</th><th>Mapped Field / Expression</th></tr></thead><tbody><tr ng-repeat=\"field in vm.template.fields\"><td style=\"width: 20%\">{{field.templateField}}</td><td><span ng-show=\"field.generated\"><i class=\"fa fa-cogs\"></i> <em>automatic</em> </span><span ng-show=\"!field.display\"><i class=\"fa fa-times\"></i> <em>hidden</em> </span><span ng-show=\"field.display && field.mode==\'FIELD\'\">{{field.mappedField}} </span><span ng-show=\"field.display && field.mode==\'EXPRESSION\'\"><i class=\"fa fa-cog\"></i> Expression:<pre style=\"display: inline\">{{field.expression}}</pre></span></td><td has-authority=\"ROLE_ADMIN\"><button ng-show=\"field.display && !field.generated\" ng-disabled=\"field.readOnly\" type=\"button\" ng-click=\"vm.editFieldMapping(field)\"><i ng-show=\"!field.mappedField && !field.expression\" class=\"fa fa-chain-broken text-notice\" title=\"Field not mapped!\"></i> <i ng-show=\"field.mappedField || field.expression\" class=\"fa fa-chain\" title=\"Field mapped to: {{field.mappedField || field.expression}}\"></i></button></td></tr></tbody></table></div><!-- END Field Mapping --></div></div><!-- END Extra Info --></div></div></div></div><!-- END Product --></div></div><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info push-10-l\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button> <button type=\"submit\" has-authority=\"ROLE_ADMIN\" ng-show=\"vm.showSave\" ng-click=\"vm.saveFields()\" class=\"btn btn-success push-10-l\"><span class=\"glyphicon glyphicon-save\" title=\"Save\"></span>&nbsp;<span>Save</span></button></section></div><!-- END Side Content and Product -->");
$templateCache.put("app/entities/template/template-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTemplateLabel\" translate=\"crm2PrintApp.template.home.createOrEditLabel\">Create or edit a Template</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.template.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.template.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.status\" for=\"field_status\">Status</label><input type=\"text\" class=\"form-control\" name=\"status\" id=\"field_status\" ng-model=\"vm.template.status\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.template.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.fileFormat\" for=\"field_fileFormat\">File Format</label><input type=\"text\" class=\"form-control\" name=\"fileFormat\" id=\"field_fileFormat\" ng-model=\"vm.template.fileFormat\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.size\" for=\"field_size\">Size</label><input type=\"text\" class=\"form-control\" name=\"size\" id=\"field_size\" ng-model=\"vm.template.size\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.visibility\" for=\"field_visibility\">Visibility</label><input type=\"text\" class=\"form-control\" name=\"visibility\" id=\"field_visibility\" ng-model=\"vm.template.visibility\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.created\" for=\"field_created\">Created</label><div class=\"input-group\"><input id=\"field_created\" type=\"text\" class=\"form-control\" name=\"created\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.template.created\" is-open=\"vm.datePickerOpenStatus.created\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'created\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.validated\" for=\"field_validated\">Validated</label><div class=\"input-group\"><input id=\"field_validated\" type=\"text\" class=\"form-control\" name=\"validated\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.template.validated\" is-open=\"vm.datePickerOpenStatus.validated\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'validated\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.approved\" for=\"field_approved\">Approved</label><div class=\"input-group\"><input id=\"field_approved\" type=\"text\" class=\"form-control\" name=\"approved\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.template.approved\" is-open=\"vm.datePickerOpenStatus.approved\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'approved\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.lastModified\" for=\"field_lastModified\">Last Modified</label><div class=\"input-group\"><input id=\"field_lastModified\" type=\"text\" class=\"form-control\" name=\"lastModified\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.template.lastModified\" is-open=\"vm.datePickerOpenStatus.lastModified\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'lastModified\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.numberOfPages\" for=\"field_numberOfPages\">Number Of Pages</label><input type=\"number\" class=\"form-control\" name=\"numberOfPages\" id=\"field_numberOfPages\" ng-model=\"vm.template.numberOfPages\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.mailMergefields\" for=\"field_mailMergefields\">Mail Mergefields</label><input type=\"checkbox\" class=\"form-control\" name=\"mailMergefields\" id=\"field_mailMergefields\" ng-model=\"vm.template.mailMergefields\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.addressBoxSpace\" for=\"field_addressBoxSpace\">Address Box Space</label><input type=\"checkbox\" class=\"form-control\" name=\"addressBoxSpace\" id=\"field_addressBoxSpace\" ng-model=\"vm.template.addressBoxSpace\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.category\" for=\"field_category\">Category</label><input type=\"text\" class=\"form-control\" name=\"category\" id=\"field_category\" ng-model=\"vm.template.category\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.approvedCode\" for=\"field_approvedCode\">Approved Code</label><input type=\"text\" class=\"form-control\" name=\"approvedCode\" id=\"field_approvedCode\" ng-model=\"vm.template.approvedCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.wordCount\" for=\"field_wordCount\">Word Count</label><input type=\"number\" class=\"form-control\" name=\"wordCount\" id=\"field_wordCount\" ng-model=\"vm.template.wordCount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.documentText\" for=\"field_documentText\">Document Text</label><input type=\"text\" class=\"form-control\" name=\"documentText\" id=\"field_documentText\" ng-model=\"vm.template.documentText\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.documentLastSavedBy\" for=\"field_documentLastSavedBy\">Document Last Saved By</label><input type=\"text\" class=\"form-control\" name=\"documentLastSavedBy\" id=\"field_documentLastSavedBy\" ng-model=\"vm.template.documentLastSavedBy\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.documentLastSavedTime\" for=\"field_documentLastSavedTime\">Document Last Saved Time</label><div class=\"input-group\"><input id=\"field_documentLastSavedTime\" type=\"text\" class=\"form-control\" name=\"documentLastSavedTime\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.template.documentLastSavedTime\" is-open=\"vm.datePickerOpenStatus.documentLastSavedTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'documentLastSavedTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.shareToken\" for=\"field_shareToken\">Share Token</label><input type=\"text\" class=\"form-control\" name=\"shareToken\" id=\"field_shareToken\" ng-model=\"vm.template.shareToken\"></div><div class=\"form-group\"><label translate=\"crm2PrintApp.template.envelope\" for=\"field_envelope\">Envelope</label><select class=\"form-control\" id=\"field_envelope\" name=\"envelope\" ng-model=\"vm.template.envelope\" ng-options=\"envelope as envelope.id for envelope in vm.envelopes track by envelope.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"crm2PrintApp.template.site\" for=\"field_site\">Site</label><select class=\"form-control\" id=\"field_site\" name=\"site\" ng-model=\"vm.template.site\" ng-options=\"site as site.id for site in vm.sites track by site.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"crm2PrintApp.template.creator\" for=\"field_creator\">Creator</label><select class=\"form-control\" id=\"field_creator\" name=\"creator\" ng-model=\"vm.template.creator\" ng-options=\"user as user.id for user in vm.users track by user.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"crm2PrintApp.template.lastModifiedBy\" for=\"field_lastModifiedBy\">Last Modified By</label><select class=\"form-control\" id=\"field_lastModifiedBy\" name=\"lastModifiedBy\" ng-model=\"vm.template.lastModifiedBy\" ng-options=\"user as user.id for user in vm.users track by user.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"crm2PrintApp.template.stationery\" for=\"field_stationery\">Stationery</label><select class=\"form-control\" id=\"field_stationery\" name=\"stationery\" ng-model=\"vm.template.stationery\" ng-options=\"stationery as stationery.name for stationery in vm.stationeries track by stationery.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"crm2PrintApp.template.dataSource\" for=\"field_dataSource\">Data Source</label><select class=\"form-control\" id=\"field_dataSource\" name=\"dataSource\" ng-model=\"vm.template.dataSource\" ng-options=\"siteDataSource as siteDataSource.name for siteDataSource in vm.sitedatasources track by siteDataSource.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/template/template-edit.html","<!-- Page Content --><div class=\"content content-boxed\"><style type=\"text/css\">.dropzone {\n            min-height: 620px;\n        }\n        .dropzone .dz-message {\n            margin-top: 30%;\n        }\n        .dropzone .dz-file-preview.doc-preview {\n            margin: 0;\n        }\n        .dropzone .dz-preview.doc-preview .dz-image {\n            height: inherit;\n            width: inherit;\n            border-radius: initial;\n        }\n        .dropzone .dz-preview:hover .dz-image img {\n            -webkit-transform: inherit;\n            -moz-transform: inherit;\n            -ms-transform: inherit;\n            -o-transform: inherit;\n            transform: inherit;\n            -webkit-filter: initial;\n            filter: initial\n        }\n        .dropzone .dz-preview.doc-preview .dz-image img {\n            width: 100%;\n        }\n        input.ng-invalid, select.ng-invalid, .ui-select-container.ng-invalid .form-control {\n            border: salmon 1px solid;\n        }\n        .fieldnames {\n            background-color: lightgray;\n            padding: 10px 15px 10px 25px;\n            border: grey solid 1px;\n        }\n        .fieldnames .block-header {\n            margin-left: -15px;\n        }\n        .fieldnames .block-options {\n            margin-right: -10px;\n        }\n        .fieldnames .field-status {\n            padding: 4px 0 0 0;\n            margin: 0;\n            text-align: center;\n        }\n        .block-content .fieldnames .items-push > div {\n            margin-bottom: 5px;\n        }\n        .col-0pad {\n            padding: 0;\n        }\n\n        #stationery-selection .dropzone {\n            min-height: 152px;\n            height: 152px;\n        }\n        #stationery-selection .dz-message {\n            margin: 0;\n        }\n        #stationery-selection a.block {\n            cursor: pointer;\n        }\n        .dropzone .file-formats {\n            font-size: 36px;\n        }\n        .dropzone .file-formats i {\n            margin: 0 5px;\n        }\n        #template-options {\n            position: absolute;\n            right: 0px;\n            top: -45px;\n        }\n        .coming-soon {\n            color: #999999 !important;\n        }\n\n        #final-preview {\n            height: 855px;\n            width: 609px;\n            border: 1px solid black;\n            background-color: white;\n            position: relative;\n            overflow: visible;\n            z-index: 0;\n            display: block;\n        }\n        #final-preview img {\n            width: 607px;\n            height: 853px;\n        }\n        #final-preview.loading {\n            position: relative;\n        }\n        #final-preview.loading > img {\n            opacity: 0.2;\n        }\n        #final-preview.loading:after {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            margin: -20px 0 0 -20px;\n            width: 40px;\n            height: 40px;\n            line-height: 40px;\n            color: #646464;\n            font-size: 18px;\n            text-align: center;\n            z-index: 2;\n            -webkit-animation: fa-spin 2s infinite linear;\n            animation: fa-spin 2s infinite linear;\n            font-family: \'FontAwesome\';\n            content: \"\\f021\";\n        }\n\n        #final-preview.img-container .img-options {\n            z-index: 5;\n        }\n        #final-preview.img-container .img-options-content {\n            top: 10%;\n        }\n\n        .truncate {\n            /*width: 250px;*/\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n        .slick-slider {\n            margin-bottom: 0px;\n        }\n        .text-notice {\n            color: salmon;\n        }</style><script type=\"text/javascript\">function imgLoaded(img){\n            $(img).parents(\".loading:first\").removeClass(\"loading\");\n        };</script><form role=\"form\" name=\"editForm\" novalidate form-autofill-fix ng-submit=\"vm.save()\"><div class=\"block\"><div class=\"block-content\"><div id=\"stationery-selection\" class=\"block\" ng-show=\"vm.showStationery\"><div class=\"block-content block-content-full bg-primary ribbon ribbon-crystal\"><div class=\"ribbon-box font-w600\"><a ng-click=\"vm.showStationery = false\"><i class=\"fa fa-angle-double-up\"></i> Hide</a></div><div class=\"row\"><div class=\"col-xs-6 col-sm-4 col-lg-2\"><div class=\"block-content block-content-full dropzone\" data-js-dropzone=\"\" dropzone=\"dropzoneConfigStationery\"></div></div><div class=\"col-xs-6 col-sm-8 col-lg-10\"><div data-js-slider=\"{dots: true, arrows: true, autoplay: true, slidesToShow: 3}\" class=\"text-center row\"><div class=\"col-sm-6 col-lg-4 ng-scope\" ng-repeat=\"stationery in vm.stationeries track by stationery.id\"><a class=\"block block-link-hover3 text-center\" ng-click=\"vm.selectStationery(stationery)\" title=\"{{stationery.name}}\"><div class=\"block-content block-content-full bg-gray-lighter\" style=\"padding: 5px;overflow: hidden;height: 152px;position: relative\"><img class=\"img-stationery\" ng-src=\"api/assets/stationeries/{{stationery.id}}-thumb.png\" alt=\"{{stationery.name}}\"><div class=\"truncate push-10-t font-w600\" style=\"position: absolute;bottom: 0px;left: 5px\">{{stationery.name}}</div><div class=\"font-s13 text-muted\" style=\"position: absolute;right: 0;bottom: 0;margin-right: 5px\">{{stationery.size}}</div></div></a></div></div></div></div></div></div><div class=\"row\"><div class=\"col-0pad col-xs-3\"><div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\">About Template</h3></div><div class=\"block-content\"><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.template.name\" ng-required=\"vm.doc\"></div><div class=\"form-group\"><label class=\"control-label\">Category</label><ui-select ng-model=\"vm.template.category\" theme=\"bootstrap\" ng-required=\"vm.doc\" id=\"field_category\"><ui-select-match placeholder=\"Choose a category...\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"category in vm.categories | filter: $select.search\"><div ng-bind-html=\"category | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"block\" ng-show=\"vm.doc\"><div class=\"block-header\"><h3 class=\"block-title\">Mail Merge Options</h3></div><div class=\"block-content\"><div class=\"form-group\"><label for=\"field_datasource\">CRM / Mail Merge Data Source</label><select class=\"form-control\" ng-required=\"vm.doc\" id=\"field_datasource\" name=\"field_datasource\" ng-model=\"vm.template.dataSource\" ng-options=\"dataSource as dataSource.label for dataSource in vm.dataSources | orderBy: \'label\' track by dataSource.id\" ng-change=\"vm.dataSourceSelected()\"><option value=\"\"></option></select><span style=\"border-bottom: 1px dotted\" ng-hide=\"vm.hideCRMLinkWarning\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"In the top right corner of CRM2Print, click on the user icon, and then click on My CRM Accounts. When this opens, click on the Link A CRM Account, and enter your CRM user details. These will then be authenticated, and your CRM data will be accessible for your mail outs.\" data-popover-title=\"How do I link my CRM?\" data-popover-placement=\"top\">Your CRM not listed?</span></div><div class=\"form-group\"><label for=\"field_envelope\">Envelope (optional)</label><select class=\"form-control\" id=\"field_envelope\" name=\"field_envelope\" ng-model=\"vm.template.envelope\" ng-options=\"envelope as envelope.label for envelope in vm.envelopes | orderBy: \'code\' track by envelope.id\" ng-change=\"vm.envelopeSelected()\"><option value=\"\"></option></select></div><div class=\"block block-opt-hidden fieldnames\" id=\"standard_merge_fields_block\"><div class=\"block-header\" style=\"padding: 0\"><ul class=\"block-options\"><li><button type=\"button\" data-js-block-option=\"\" data-action=\"content_toggle\"><i class=\"si-arrow-down si\"></i></button></li></ul><h3 class=\"block-title\">Standard Merge Fields</h3></div><div class=\"block-content\" style=\"padding: 0px\"><div class=\"row\" ng-repeat=\"field in vm.getStandardMergeFields()\"><label class=\"css-input css-checkbox css-checkbox-primary col-0pad col-lg-10\" ng-class=\"{\'css-input-disabled\':field.readOnly}\" style=\"white-space: nowrap\"><input type=\"checkbox\" ng-model=\"field.display\" ng-change=\"vm.updatePreviewTrigger()\"><span></span> {{field.templateField}}</label><div class=\"field-status col-sm-2\"><i ng-show=\"!field.display\" class=\"fa fa-times-circle\" title=\"Field hidden\"></i> <button ng-show=\"field.display && !field.generated\" ng-disabled=\"field.readOnly\" type=\"button\" ng-click=\"vm.editFieldMapping(field)\"><i ng-show=\"!field.mappedField && !field.expression\" class=\"fa fa-chain-broken text-notice\" title=\"Field not mapped!\"></i> <i ng-show=\"field.mappedField || field.expression\" class=\"fa fa-chain\" title=\"Field mapped to: {{field.mappedField || field.expression}}\"></i></button> <i ng-show=\"field.generated\" class=\"fa fa-bolt\" title=\"Field gets auto-generated.\"></i><!--<i ng-show=\"field.readOnly\" class=\"fa fa-eye-slash\"></i>--></div></div></div></div><div class=\"block fieldnames\"><div class=\"block-header\" style=\"padding: 0\" id=\"user_defined_fields_block\"><ul class=\"block-options\"><li><button type=\"button\" data-js-block-option=\"\" data-action=\"content_toggle\"><i class=\"si-arrow-down si\"></i></button></li></ul><div><label class=\"css-input css-checkbox css-checkbox-primary\" style=\"white-space: nowrap;margin: 0\"><input type=\"checkbox\" ng-model=\"vm.allChecked\" ng-change=\"vm.tickAll()\"><span></span><h3 class=\"block-title\" style=\"display: inline-block\">User-defined Fields</h3></label></div></div><div class=\"block-content\" style=\"padding: 0px; min-height: 200px\"><!--<div class=\"row\" ng-show=\"vm.doc && !vm.template.site\">\n                                        <i class=\"fa fa-arrow-up\"></i> Please select mapping scheme <i class=\"fa fa-arrow-up\"></i>\n                                    </div>--><div class=\"row\" ng-repeat=\"field in vm.getUserMergeFields()\"><label class=\"css-input css-checkbox css-checkbox-primary col-0pad col-lg-10\" ng-class=\"{\'css-input-disabled\':field.readOnly}\" style=\"white-space: nowrap\"><input type=\"checkbox\" ng-model=\"field.display\" ng-disabled=\"field.readOnly\" ng-change=\"vm.updatePreviewTrigger()\"><span></span> {{field.templateField}}</label><div class=\"field-status col-sm-2\"><i ng-show=\"!field.display\" class=\"fa fa-times-circle\" title=\"Field hidden\"></i> <button ng-show=\"field.display && !field.generated\" ng-disabled=\"field.readOnly\" type=\"button\" ng-click=\"vm.editFieldMapping(field)\"><i ng-show=\"!field.mappedField && !field.expression && field.mode!=\'CUSTOM\'\" class=\"fa fa-chain-broken text-notice\" title=\"Field not mapped!\"></i> <i ng-show=\"field.mappedField || field.expression || field.mode==\'CUSTOM\'\" class=\"fa fa-chain\" title=\"Field mapped to: {{field.mappedField || field.expression || field.templateField}}\"></i></button> <i ng-show=\"field.generated\" class=\"fa fa-cogs\" title=\"Field gets auto-generated.\"></i><!--<i ng-show=\"field.readOnly\" class=\"fa fa-eye-slash\"></i>--></div></div></div></div><!--<div ng-show=\"vm.displayExpressionWarning\">\n                                <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.substituteExpressions()\">Substitute Expr. &amp; Update Fields!</button>\n                            </div>--><label class=\"css-input css-checkbox css-checkbox-primary\" id=\"field_sample_address_label\"><input type=\"checkbox\" ng-model=\"vm.showSampleAddress\" ng-change=\"vm.updatePreviewTrigger()\"><span></span> Preview With Sample Address</label><label class=\"css-input css-checkbox css-checkbox-primary\" id=\"field_address_box_space\" ng-hide=\"vm.windowLessEnvelope\"><input type=\"checkbox\" ng-model=\"vm.template.addressBoxSpace\" ng-change=\"vm.showLetterMatchingSurchargeWarning()\"><span></span> Letter has address block</label></div></div><div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\">Additional Information</h3></div><div class=\"block-content\"><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.size\" for=\"field_size\">Size</label><input type=\"text\" readonly=\"readonly\" class=\"form-control\" name=\"size\" id=\"field_size\" ng-model=\"vm.template.size\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.numberOfPages\" for=\"field_numberOfPages\">Number Of Pages</label><input type=\"number\" readonly=\"readonly\" class=\"form-control\" name=\"numberOfPages\" id=\"field_numberOfPages\" ng-model=\"vm.template.numberOfPages\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.wordCount\" for=\"field_wordCount\">Word Count</label><input type=\"number\" class=\"form-control\" readonly=\"readonly\" name=\"wordCount\" id=\"field_wordCount\" ng-model=\"vm.template.wordCount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.template.documentLastSavedBy\" for=\"field_documentLastSavedBy\">Document Last Saved By</label><input type=\"text\" class=\"form-control\" readonly=\"readonly\" name=\"documentLastSavedBy\" id=\"field_documentLastSavedBy\" ng-model=\"vm.template.documentLastSavedBy\"></div></div></div></div><div class=\"col-0pad col-xs-9\"><div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\">Upload / Preview</h3></div><div class=\"block-content block-content-full\"><!-- DropzoneJS Container --><div data-js-dropzone=\"\" dropzone=\"dropzoneConfig\" class=\"dropzone\" ng-hide=\"vm.doc\"></div><div id=\"final-preview\" class=\"img-container\" ng-show=\"vm.doc\"><div id=\"template-options\"><div class=\"push-20 form-inline\"><div class=\"form-group\" ng-show=\"vm.template.stationery\"><label class=\"css-input switch switch-success\"><span translate=\"crm2PrintApp.template.stationeryFirstPageOnly\" class=\"font-w600\">Stationery First Page Only</span> <input type=\"checkbox\" name=\"stationeryFirstPageOnly\" id=\"field_stationeryFirstPageOnly\" ng-model=\"vm.template.stationeryFirstPageOnly\"><span></span></label></div><div class=\"form-group\"><button class=\"btn btn-success\" type=\"button\" ng-hide=\"vm.showStationery\" ng-click=\"vm.showStationery = true\"><i class=\"fa fa-plus\"></i> Add Stationery/Letterhead</button></div></div></div><img ng-src=\"{{vm.stationeryPreviewUrl}}\" style=\"position: absolute; left: 0px; top: 0px; z-index: 1\"> <img ng-src=\"{{vm.previewUrl}}\" style=\"position: absolute; left: 0px; top: 0px;; z-index: 2\" onload=\"imgLoaded(this)\"></div></div><div class=\"block-content block-content-full bg-warning text-white\" ng-show=\"vm.doc\"><label class=\"css-input css-checkbox css-checkbox-danger\"><input type=\"checkbox\" ng-model=\"vm.confirmDisplayVariation\" required><span></span> I understand that slight display variances may occur between my uploaded template and the final printed version. These variances may be due to e.g. missing fonts on the CRM2Print mail merge server or other technical reasons. By checking this box I confirm that I have carefully verified the preview and confirm that it matches the uploaded template or that I am happy with the visual variances.</label><label class=\"css-input css-checkbox css-checkbox-danger\"><input type=\"checkbox\" ng-model=\"vm.confirmClearAddressBox\" required><span></span> I understand that it is my responsibility to ensure that the address box (shaded in red) is clear off any of my own mail merge fields to ensure that CMR2Print can print the address box in the correct position for the window envelope.</label><div class=\"form-group form-horizontal\"><div class=\"col-xs-3\"><a ng-href=\"{{vm.previewUrlPDF}}\" target=\"_blank\" class=\"btn btn-success\" id=\"previewTemplateButton\"><span class=\"glyphicon glyphicon-cloud-download\"></span>&nbsp;Preview PDF</a></div><label class=\"control-label col-xs-7\" for=\"field_approvedCode\">Please enter the template approval code from the PDF (top):</label><input type=\"text\" class=\"form-control col-xs-3\" name=\"approvedCode\" id=\"field_approvedCode\" data-js-masked-input=\"aaaaa\" required style=\"width: 6em\" ng-model=\"vm.template.approvedCode\" ng-change=\"vm.verifyApprovedCode()\" ng-paste=\"vm.onPasteCode(this)\"><div style=\"clear: both\"></div></div><div class=\"form-group\" style=\"clear: both\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><!--<span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span>--> <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;Reset</button> <button type=\"submit\" id=\"templateSaveButton\" ng-disabled=\"vm.approved || editForm.$invalid || isSaving || vm.displayExpressionWarning\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></div></div></div></div></div></div></form></div>");
$templateCache.put("app/entities/template/templates.html","<style type=\"text/css\">.template-name.truncate {\n        width: 250px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n    .site-logo {\n        background-size: 15%;\n        background-repeat: no-repeat;\n        background-position: right bottom;\n        background-color: transparent;\n    }\n    .site-MyDesktop {\n        background-image: url(content/images/logos/mydesktop-78px.png);\n    }\n    .site-NEXU {\n        background-image: url(content/images/logos/nexu_square.png);\n    }\n    .site-AgentInsight {\n        background-image: url(content/images/logos/agentinsight-78px.png);\n    }\n    .site-Pricefinder {\n        background-image: url(content/images/logos/pricefinder-78px.png);\n    }\n    .site-LockedOn {\n        background-image: url(content/images/logos/lockedon-logo-grey.png);\n    }\n    .site-SalesForce {\n        background-image: url(content/images/logos/salesforce.png);\n    }\n    .site-Rex {\n        background-image: url(content/images/logos/rex-78px.png);\n    }\n    .site-CoreLogic {\n        background-image: url(content/images/logos/corelogic-78px.png);\n    }\n    .site-PropertyTree {\n        background-image: url(content/images/logos/propertytree-78px.png);\n    }\n    .site-VaultRE {\n        background-image: url(content/images/logos/vaultre-78px.png);\n    }\n\n    @media (min-width: 1650px) {\n        .col-xl-2 {\n            width: 16.66666667%\n        }\n        .col-xl-3 {\n            width: 25%\n        }\n        .col-xl-9 {\n            width: 75%\n        }\n        .col-xl-10 {\n            width: 83.33333333%\n        }\n        .gallery .col-xl-3:nth-child(4n+1) {\n            clear: left;\n        }\n    }\n    @media (min-width: 1200px) and (max-width: 1649px) {\n        .gallery .col-lg-4:nth-child(3n+1) {\n            clear: left;\n        }\n    }\n    @media (max-width: 768px) {\n        .gallery .col-sm-6:nth-child(1n+1) {\n            clear: left;\n        }\n    }</style><!-- Side Content and Products --><div class=\"bg-gray-lighter\"><section class=\"content\"><div class=\"row\"><div class=\"col-xs-4\"><button class=\"btn btn-primary\" ui-sref=\"template.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.template.home.createLabel\">Create new Template</span></button></div><div class=\"col-xs-8\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.template.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div><div class=\"row\" style=\"margin-top: 15px\"><div class=\"col-lg-3 col-xl-2\"><!-- Side Content --><div class=\"js-nav-content visible-lg\"><!-- Categories --><div class=\"block\" ng-show=\"vm.categories.length > 0\"><div class=\"block-content\"><ul class=\"nav nav-pills nav-stacked push\"><li ng-repeat=\"(key, value) in vm.categories\"><a href=\"javascript:void(0)\"><span class=\"badge pull-right\">{{value}}</span> {{key}}</a></li></ul></div></div><!-- END Categories --><div class=\"block\"><a class=\"block block-link-hover3 block-transparent remove-margin-b\" ng-click=\"vm.showIndustry(null)\"><div ng-class=\"[\'block-content\',\'block-content-full\',\'clearfix\',{\'bg-primary-light\':!vm.industry}]\"><div class=\"pull-right\"><i class=\"fa fa-eye-slash font-s48\"></i></div><div class=\"pull-left\"><div class=\"font-w600 push-5\">My Templates</div><div class=\"text-muted\">Upload your own!</div></div></div></a><a class=\"block block-link-hover3 block-transparent remove-margin-b\" disabled=\"disabled\" href=\"javascript:void(0)\"><div class=\"block-content block-content-full clearfix\"><div class=\"pull-right\"><i class=\"fa fa-balance-scale font-s48\"></i></div><div class=\"pull-left\"><div class=\"font-w600 push-5\">Legal</div><div class=\"text-muted\">Coming soon</div></div></div></a><a class=\"block block-link-hover3 block-transparent remove-margin-b\" ng-click=\"vm.showIndustry(\'REALESTATE\');\"><div ng-class=\"[\'block-content\',\'block-content-full\',\'clearfix\',{\'bg-primary-light\':vm.industry==\'REALESTATE\'}]\"><div class=\"pull-right\" style=\"padding-right: 10px\"><i class=\"fa fa-home font-s48\"></i></div><div class=\"pull-left\"><div class=\"font-w600 push-5\">Real Estate</div><div ng-class=\"vm.industry==\'REALESTATE\' ? \'text-white\' : \'text-muted\'\">Available Now</div></div></div></a><a class=\"block block-link-hover3 block-transparent remove-margin-b\" disabled=\"disabled\" href=\"javascript:void(0)\"><div class=\"block-content block-content-full clearfix\"><div class=\"pull-right\"><i class=\"fa fa-bank font-s48\"></i></div><div class=\"pull-left\"><div class=\"font-w600 push-5\">Banking &amp; Finance</div><div class=\"text-muted\">Coming soon</div></div></div></a><a class=\"block block-link-hover3 block-transparent remove-margin-b\" disabled=\"disabled\" href=\"javascript:void(0)\"><div class=\"block-content block-content-full clearfix\"><div class=\"pull-right\" style=\"padding-right: 10px\"><i class=\"fa fa-shopping-cart font-s48\"></i></div><div class=\"pull-left\"><div class=\"font-w600 push-5\">Other Commerce</div><div class=\"text-muted\">Coming soon</div></div></div></a></div></div><!-- END Side Content --></div><div class=\"col-lg-9 col-xl-10\"><!-- Sort and Show Filters --><div class=\"form-inline clearfix\"><select id=\"ecom-results-show\" name=\"ecom-results-show\" class=\"form-control push pull-right\" size=\"1\"><option value=\"0\" disabled=\"disabled\" selected=\"selected\">SHOW</option><option value=\"9\">9</option><option value=\"18\">18</option><option value=\"36\">36</option><option value=\"72\">72</option></select><select id=\"ecom-results-sort\" name=\"ecom-results-sort\" class=\"form-control push\" size=\"1\"><option value=\"0\" disabled=\"disabled\" selected=\"selected\">SORT BY</option><option value=\"1\">Popularity</option><option value=\"2\">Name (A to Z)</option><option value=\"3\">Name (Z to A)</option></select></div><!-- END Sort and Show Filters --><!-- Templates --><div class=\"gallery row\" infinite-scroll=\"vm.loadPage(vm.page + 1)\" infinite-scroll-disabled=\"true || vm.page >= vm.links[\'last\']\"><div class=\"col-sm-6 col-lg-4 col-xl-3\" ng-repeat=\"template in vm.templates track by template.id\"><div class=\"block\"><div class=\"img-container ribbon-bookmark text-center ribbon ribbon-bookmark ribbon-crystal\"><img class=\"img-responsive\" ng-src=\"/api/assets/templates/{{template.id}}/thumb.png\" alt=\"\"><div class=\"ribbon-box font-w600 h4 font-w600\"><i ng-class=\"[\'fa\',{\'fa-eye\': template.visibility == \'PUBLIC\',\'fa-eye-slash\': template.visibility == \'PRIVATE\',\'fa-share\': template.visibility == \'SHARED\'}]\"></i></div><div class=\"img-options\"><div class=\"img-options-content\"><div class=\"push-20\"><div class=\"btn-group\"><button type=\"submit\" ui-sref=\"template-detail({id:template.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button><!--<button type=\"submit\"\n                                                        ui-sref=\"template.edit({id:template.id})\"\n                                                        class=\"btn btn-primary btn-sm\">\n                                                    <span class=\"glyphicon glyphicon-pencil\"></span>\n                                                    <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>\n                                                </button>--> <button type=\"submit\" ui-sref=\"template.delete({id:template.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></div><div class=\"text-warning\"><i class=\"fa fa-star\"></i> <i class=\"fa fa-star\"></i> <i class=\"fa fa-star\"></i> <i class=\"fa fa-star\"></i> <i class=\"fa fa-star\"></i><!--<span class=\"text-white\">(998)</span>--></div><div class=\"push-10-t\"><div class=\"btn-group\"><button type=\"submit\" ui-sref=\"print-job.new({templateId:template.id})\" class=\"btn btn-rounded btn-success\"><span class=\"si si-control-play\"></span> <span class=\"hidden-xs hidden-sm\">Start Print Job</span></button></div></div></div></div></div><div class=\"block-content site-logo site-{{template.site.name}}\"><div class=\"push-10\"><a class=\"h4\" ui-sref=\"template-detail({id:template.id})\" class=\"template-name truncate\">{{template.name}}</a></div><p class=\"text-muted\"><span class=\"label label-info\">{{template.dataSource.type}}</span> {{template.dataSource.name}}</p><div><div class=\"h4 font-w600 text-success pull-left\">{{template.size}}</div><div class=\"pull-right\"><i class=\"site-{{template.site.name}}\"></i></div><div class=\"font-s12 text-center push\" style=\"padding-right:20px\">Template ID #{{template.id}}</div></div></div></div><!--<div class=\"col-xs-12 push\">\n                        <ul class=\"pager\">\n                            <li class=\"next\">\n                                <a href=\"javascript:void(0)\">Next <i class=\"fa fa-arrow-right\"></i></a>\n                            </li>\n                        </ul>\n                    </div>--></div><!-- END Products --></div></div></div></section></div>");
$templateCache.put("app/entities/user-pricing/user-pricing-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.userPricing.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.userPricing.delete.question\" translate-values=\"{id: \'{{vm.userPricing.id}}\'}\">Are you sure you want to delete this User Pricing?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/user-pricing/user-pricing-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\"><span translate=\"crm2PrintApp.userPricing.detail.title\">User Pricing</span> {{vm.userPricing.id}}</h3></div><div class=\"block-content\"><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.userPricing.duplex\">Duplex</span></dt><dd><span>{{vm.userPricing.duplex}}</span></dd><dt><span translate=\"crm2PrintApp.userPricing.amount\">Amount</span></dt><dd><span>{{{vm.userPricing.currency}} {vm.userPricing.amount | currency}}</span></dd><dt><span translate=\"crm2PrintApp.userPricing.pageCount\">Page Count</span></dt><dd><span>{{vm.userPricing.pageCount}}</span></dd><dt><span translate=\"crm2PrintApp.userPricing.envelope\">Envelope</span></dt><dd><a ui-sref=\"envelope-detail({id:vm.userPricing.envelopeId})\">{{vm.userPricing.envelopeCode}}</a></dd><dt><span translate=\"crm2PrintApp.userPricing.country\">Country</span></dt><dd><a ui-sref=\"country-detail({id:vm.userPricing.countryId})\">{{vm.userPricing.countryName}}</a></dd><dt><span translate=\"crm2PrintApp.userPricing.lastModified\">Last Modified</span></dt><dd><span>{{vm.userPricing.lastModified | date:\'dd/mm/yyyy @ HH:mm\'}}</span></dd><dt><span translate=\"crm2PrintApp.userPricing.lastModifiedBy\">Last Modified By</span></dt><dd>{{vm.userPricing.lastModifiedByLogin}}</dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info push-10\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div>");
$templateCache.put("app/entities/user-pricing/user-pricing-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myUserPricingLabel\" translate=\"crm2PrintApp.userPricing.home.createOrEditLabel\">Create or edit a User Pricing</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.userPricing.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.userPricing.id\" readonly=\"readonly\"></div><div class=\"row\"><div class=\"col-xs-5 form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.userPricing.amount\" for=\"field_amount\">Amount</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-dollar\"></i></span> <input type=\"number\" class=\"form-control\" name=\"amount\" id=\"field_amount\" ng-model=\"vm.userPricing.amount\" placeholder=\"net price per letter e.g. 1.30\" required> <span class=\"input-group-addon\">ex. GST</span></div><div ng-show=\"editForm.amount.$invalid\"><p class=\"help-block\" ng-show=\"editForm.amount.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.amount.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"col-xs-7\"><div class=\"form-group\"><label translate=\"crm2PrintApp.userPricing.country\" for=\"field_country\">Country</label><select class=\"form-control\" id=\"field_country\" name=\"country\" ng-model=\"vm.userPricing.countryId\" ng-options=\"country.id as country.name for country in vm.countries\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.country.$invalid\"><p class=\"help-block\" ng-show=\"editForm.country.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"row\"><div class=\"col-xs-5 form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.userPricing.pageCount\">Page Count</label><div class=\"col-xs-12\"><label class=\"radio-inline\" for=\"page-count-1\"><input type=\"radio\" id=\"page-count-1\" name=\"page-count-1\" ng-model=\"vm.userPricing.pageCount\" value=\"1\"> 1</label><label class=\"radio-inline\" for=\"page-count-2\"><input type=\"radio\" id=\"page-count-2\" name=\"page-count-2\" ng-model=\"vm.userPricing.pageCount\" value=\"2\"> 2</label><label class=\"radio-inline\" for=\"page-count-1\"><input type=\"radio\" id=\"page-count-3\" name=\"page-count-3\" ng-model=\"vm.userPricing.pageCount\" value=\"3\"> 3</label><label class=\"radio-inline\" for=\"page-count-1\"><input type=\"radio\" id=\"page-count-4\" name=\"page-count-4\" ng-model=\"vm.userPricing.pageCount\" value=\"4\"> 4</label><label class=\"radio-inline\" for=\"page-count-1\"><input type=\"radio\" id=\"page-count-5\" name=\"page-count-5\" ng-model=\"vm.userPricing.pageCount\" value=\"5\"> 5</label></div><div ng-show=\"editForm.pageCount.$invalid\"><p class=\"help-block\" ng-show=\"editForm.pageCount.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.pageCount.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"1\">This field should be more than 1.</p><p class=\"help-block\" ng-show=\"editForm.pageCount.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"5\">This field cannot be more than 5.</p><p class=\"help-block\" ng-show=\"editForm.pageCount.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"col-xs-5 form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.userPricing.minQuantity\">Minimum Quantity</label><input type=\"number\" class=\"form-control\" name=\"minQuantity\" id=\"field_minQuantity\" ng-model=\"vm.userPricing.minQuantity\"><div ng-show=\"editForm.minQuantity.$invalid\"><p class=\"help-block\" ng-show=\"editForm.minQuantity.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.minQuantity.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"col-xs-2 form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.userPricing.duplex\" for=\"field_duplex\">Duplex</label><input type=\"checkbox\" class=\"form-control\" name=\"duplex\" id=\"field_duplex\" ng-model=\"vm.userPricing.duplex\"></div><div class=\"col-xs-3 form-group\"><label translate=\"crm2PrintApp.userPricing.envelope\" for=\"field_envelope\">Envelope</label><select class=\"form-control\" required id=\"field_envelope\" name=\"envelope\" ng-model=\"vm.userPricing.envelopeId\" ng-options=\"envelope.id as envelope.code for envelope in vm.envelopes\"><option value=\"\"></option></select><div ng-show=\"editForm.envelope.$invalid\"><p class=\"help-block\" ng-show=\"editForm.envelope.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"col-xs-2 form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.userPricing.addressedEnvelope\" for=\"field_addressedEnvelope\" title=\"Addressed Envelope\">Match</label><input type=\"checkbox\" class=\"form-control\" name=\"addressedEnvelope\" id=\"field_addressedEnvelope\" ng-model=\"vm.siteDataSource.addressedEnvelope\"></div></div><div class=\"form-group\" ng-show=\"vm.userPricing.id\"><label translate=\"crm2PrintApp.userPricing.lastModifiedBy\">Last Modified By</label>{{vm.userPricing.lastModifiedByLogin}}</div><div class=\"form-group\" ng-show=\"vm.userPricing.id\"><label class=\"control-label\" translate=\"crm2PrintApp.userPricing.lastModified\">Last Modified</label>{{vm.userPricing.lastModified | date:\'dd/NN/yyyy @ HH:mm\'}}</div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/user-pricing/user-pricings.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.userPricing.home.title\">User Pricings</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"user-pricing.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.userPricing.home.createLabel\">Create new User Pricing</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.userPricing.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"crm2PrintApp.userPricing.duplex\">Duplex</span></th><th><span translate=\"crm2PrintApp.userPricing.amount\">Amount</span></th><th><span translate=\"crm2PrintApp.userPricing.pageCount\">Page Count</span></th><th><span translate=\"crm2PrintApp.userPricing.addressedEnvelope\">Match</span></th><th><span translate=\"crm2PrintApp.userPricing.envelope\">Envelope</span></th><th><span translate=\"crm2PrintApp.userPricing.country\">Country</span></th><th><span translate=\"crm2PrintApp.userPricing.lastModified\">Last Updated</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"userPricing in vm.userPricings track by userPricing.id\"><td><a ui-sref=\"user-pricing-detail({id:userPricing.id})\">{{userPricing.id}}</a></td><td><i ng-class=\"[\'fa\',userPricing.duplex?\'fa-check\':\'fa-times\']\"></i></td><td>{{userPricing.amount | currency:\"$\"}}</td><td>{{userPricing.pageCount}}</td><td><i ng-class=\"[\'fa\',userPricing.addressedEnvelope?\'fa-check\':\'fa-times\']\"></i></td><td><a ui-sref=\"envelope-detail({id:userPricing.envelopeId})\">{{userPricing.envelopeCode}}</a></td><td><a ui-sref=\"country-detail({id:userPricing.countryId})\">{{userPricing.countryName}}</a></td><td>{{userPricing.lastModified | date:\'dd/mm/yyyy @ HH:mm\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"user-pricing-detail({id:userPricing.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"user-pricing.edit({id:userPricing.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"user-pricing.delete({id:userPricing.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/entities/user-profile/user-profile-dialog.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myUserProfileLabel\" translate=\"crm2PrintApp.userProfile.home.title\">User Profile</h4></div><div class=\"modal-body\"><div class=\"block push-10\"><ul class=\"nav nav-tabs nav-tabs-alt nav-justified\" data-js-tabs=\"\"><li class=\"active\"><a href=\"#btabs-contact-details\"><i class=\"fa fa-home\"></i> Contact Details</a></li><li class=\"\"><a href=\"#btabs-credit-card-details\"><i class=\"fa fa-credit-card-alt\"></i> Credit Card Details</a></li><li class=\"\"><a href=\"#btabs-defaults\"><i class=\"fa fa-pencil\"></i> Defaults</a></li></ul><div class=\"tab-content\"><div class=\"tab-pane active\" id=\"btabs-contact-details\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"block push-10 push-10-t\"><div class=\"block-header\"><h4 class=\"font-w300\">General</h4></div><div class=\"block-content form-horizontal\"><div class=\"form-group\"><div class=\"col-md-12\"><input type=\"text\" class=\"form-control\" name=\"companyName\" id=\"field_companyName\" placeholder=\"Company Name\" ng-model=\"vm.userProfile.companyName\"></div></div><div class=\"form-group\"><div class=\"col-md-12\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-phone\"></i></span> <input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" placeholder=\"Phone\" ng-model=\"vm.userProfile.phone\"></div></div></div></div></div><div class=\"block push-10 push-10-t\"><div class=\"block-header\"><h4 class=\"font-w300\">Letter Approval</h4></div><div class=\"block-content form-horizontal\"><div class=\"form-group\"><!--<div class=\"col-md-6 \">\n                                <div class=\"input-group\">\n                                    <span class=\"input-group-addon\"><i class=\"fa fa-envelope-o\"></i></span>\n                                    <input type=\"email\" class=\"form-control\" name=\"notifyEmail\" id=\"field_notifyEmail\" placeholder=\"Notification Email\" disabled\n                                           ng-model=\"vm.userProfile.notifyEmail\"\n                                    />\n                                </div>\n                            </div>--><div class=\"col-md-12\"><div class=\"help-block\"><b>Note:</b> Only specify an approver email if <span style=\"text-decoration: underline\">every</span> print job (incl. single letter) requires manual approval. Upon print job submission the nominated user will receive an email prompting them to login and finalise the printjob.</div><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-envelope-o\"></i></span> <input type=\"email\" class=\"form-control\" name=\"approverEmail\" id=\"field_approverEmail\" placeholder=\"Approver Email\" ng-model=\"vm.userProfile.approverEmail\"></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-6\"><div class=\"block push-10\"><div class=\"block-header\"><h4 class=\"font-w300\">Address</h4></div><div class=\"block-content form-horizontal\"><div class=\"form-group\"><div class=\"col-md-12\"><input type=\"text\" class=\"form-control\" name=\"address1\" id=\"field_address1\" placeholder=\"Address 1\" ng-model=\"vm.userProfile.address1\"></div></div><div class=\"form-group\"><div class=\"col-md-12\"><input type=\"text\" class=\"form-control\" name=\"address2\" id=\"field_address2\" placeholder=\"Address 2\" ng-model=\"vm.userProfile.address2\"></div></div><div class=\"form-group\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-xs-8\"><input type=\"text\" class=\"form-control\" name=\"city\" id=\"field_city\" placeholder=\"City\" ng-model=\"vm.userProfile.city\"></div><div class=\"col-xs-4\"><input type=\"text\" class=\"form-control\" name=\"state\" id=\"field_state\" placeholder=\"State\" ng-model=\"vm.userProfile.state\"></div></div></div></div><div class=\"form-group\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-xs-4\"><input type=\"text\" class=\"form-control\" name=\"postcode\" id=\"field_postcode\" placeholder=\"Postcode\" ng-model=\"vm.userProfile.postcode\" required><div ng-show=\"editForm.postcode.$invalid\"><p class=\"help-block\" ng-show=\"editForm.postcode.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"col-xs-8\"><select class=\"form-control\" id=\"field_country\" name=\"country\" ng-model=\"vm.userProfile.countryId\" ng-options=\"country.id as country.name for country in vm.countries\" ng-change=\"vm.selectedCountry()\" required><option value=\"\"></option></select><div ng-show=\"vm.vendorLimitation\" class=\"content-mini content-mini-full bg-warning\">{{vm.vendorLimitation}}</div><div ng-show=\"editForm.country.$invalid\"><p class=\"help-block\" ng-show=\"editForm.country.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></div></div></div></div></div><div class=\"col-xs-6\"><div class=\"block push-10\"><div class=\"block-header\"><h4 class=\"font-w300\" translate=\"crm2PrintApp.userProfile.billingContact\">Billing Contact</h4></div><div class=\"block-content form-horizontal\"><div class=\"col-md-12 form-group\"><input type=\"text\" class=\"form-control\" name=\"billingContact\" id=\"field_billingContact\" placeholder=\"Name\" ng-model=\"vm.userProfile.billingContact\"></div><div class=\"col-md-12 form-group\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-envelope-o\"></i></span> <input type=\"email\" class=\"form-control\" name=\"billingEmail\" id=\"field_billingEmail\" placeholder=\"Email\" ng-model=\"vm.userProfile.billingEmail\"></div></div><div class=\"col-md-12 form-group\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-phone\"></i></span> <input type=\"text\" class=\"form-control\" name=\"billingPhone\" id=\"field_billingPhone\" placeholder=\"Phone\" ng-model=\"vm.userProfile.billingPhone\"></div></div></div></div></div></div></form></div><div class=\"tab-pane\" id=\"btabs-credit-card-details\"><form name=\"editForm\" role=\"form\" stripe-form=\"handleStripe\" novalidate class=\"js-card-form form-horizontal\"><div class=\"block push-10 push-10-t\"><div class=\"block-header\"><h4 class=\"font-w300 push-15\">Credit Card Details</h4></div><div class=\"block-content form-horizontal\"><div ng-show=\"vm.hasExistingSource()\"><p>{{vm.getExistingSource().brand}} with card number ending in {{vm.getExistingSource().last4}}</p><button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.deleteCard()\"><i class=\"fa fa-times\"></i> Delete Card</button></div><div ng-hide=\"vm.hasExistingSource()\"><p>No stored credit card.</p><!-- Credit Card --><div class=\"block\"><!-- Card Container --><div class=\"js-card-container hidden-xs push-50\"></div><div class=\"row credit-card\"><div class=\"col-sm-6 col-sm-offset-3\"><div class=\"row text-danger\" has-authority=\"ROLE_DEMO_MODE\"><strong>Demo Mode is active for this user.</strong><p>No actual money will be transferred upon checkout<br>Use Card number 4242 4242 4242 4242</p></div><div class=\"form-group\"><div class=\"col-xs-12\"><div class=\"form-material\"><input class=\"form-control\" id=\"cc_number\" name=\"cc_number\" type=\"text\" placeholder=\"**** **** **** ****\" ng-model=\"number\" payments-validate=\"card\" payments-format=\"card\" payments-type-model=\"type\" ng-class=\"editForm.cc_number.$card.type\"><label for=\"cc_number\">Number</label></div></div></div><div class=\"form-group\"><div class=\"col-xs-12\"><div class=\"form-material\"><input class=\"form-control\" id=\"cc_name\" name=\"cc_name\" type=\"text\" placeholder=\"JOHN DOE\"><label for=\"cc_name\">Full Name</label></div></div></div><div class=\"form-group\"><div class=\"col-xs-6\"><div class=\"form-material\"><input class=\"form-control\" id=\"cc_expiry\" name=\"cc_expiry\" type=\"text\" placeholder=\"01/19\" ng-model=\"expiry\" payments-validate=\"expiry\" payments-format=\"expiry\"><label for=\"cc_expiry\">MM/YY</label></div></div><div class=\"col-xs-6\"><div class=\"form-material\"><input class=\"form-control\" id=\"cc_cvc\" name=\"cc_cvc\" type=\"text\" placeholder=\"***\" ng-model=\"cvc\" payments-validate=\"cvc\" payments-format=\"cvc\" payments-type-model=\"type\"><label for=\"cc_cvc\">CVC</label></div></div></div><div class=\"form-group\"><div class=\"col-xs-12 text-center\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"editForm.$invalid\"><i class=\"fa fa-plus\"></i> Add Card</button></div></div></div></div></div><!-- END Credit Card --></div></div></div></form></div><div class=\"tab-pane\" id=\"btabs-defaults\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"block push-10 push-10-t\"><div class=\"block-header\"><h4 class=\"font-w300\">General</h4></div><div class=\"block-content form-horizontal\"><div class=\"form-group\"><label translate=\"crm2PrintApp.userProfile.defaultLetterhead\" for=\"field_defaultLetterhead\">Default Letterhead</label><select class=\"form-control\" id=\"field_defaultLetterhead\" name=\"defaultLetterhead\" ng-model=\"vm.userProfile.defaultLetterheadId\" ng-options=\"stationery.id as stationery.name for stationery in vm.stationeries\"><option value=\"\"></option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.userProfile.rexLetterheadOption\" for=\"field_rexLetterheadOption\">Rex Letterhead Option</label><select class=\"form-control\" name=\"rexLetterheadOption\" ng-model=\"vm.userProfile.rexLetterheadOption\" id=\"field_rexLetterheadOption\"><option value=\"NONE\" translate=\"crm2PrintApp.LetterheadBehaviour.NONE\">NONE</option><option value=\"FIRST_PAGE_ONLY\" translate=\"crm2PrintApp.LetterheadBehaviour.FIRST_PAGE_ONLY\">FIRST_PAGE_ONLY</option><option value=\"ALL\" translate=\"crm2PrintApp.LetterheadBehaviour.ALL\">ALL</option><!--  <option value=\"ODD_PAGES_ONLY\" translate=\"crm2PrintApp.LetterheadBehaviour.ODD_PAGES_ONLY\">ODD_PAGES_ONLY</option>--></select><div class=\"help-block\">Specify how the default Letterhead should get applied to Letters submitted through <a href=\"https://www.rexsoftware.com\" target=\"_blank\">REX</a></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.userProfile.autoCreateCostCenters\" for=\"field_autoCreateCostCenters\">Auto Create Cost-Centers</label><input type=\"checkbox\" class=\"form-control\" name=\"ftpTls\" id=\"field_autoCreateCostCenters\" ng-model=\"vm.userProfile.autoCreateCostCenters\"><div class=\"help-block\">If unticked, print jobs submitted against non-existing cost centers will get rejected</div></div><!--<div class=\"form-group\">\n                                <label translate=\"crm2PrintApp.userProfile.defaultCostCenterStatus\" for=\"field_defaultCostCenterStatus\">Default Cost Center Status</label>\n                                <select class=\"form-control\" id=\"field_defaultCostCenterStatus\" name=\"defaultCostCenterStatus\" ng-model=\"vm.userProfile.defaultCostCenterStatus\" ng-disabled=\"!vm.userProfile.autoCreateCostCenters\">\n                                    <option value=\"OPEN\" translate=\"crm2PrintApp.CostCenterStatus.OPEN\">OPEN</option>\n                                    <option value=\"CLOSED\" translate=\"crm2PrintApp.CostCenterStatus.CLOSED\">CLOSED</option>\n                                </select>\n                                <div class=\"help-block\">Allow auto-created </div>\n                            </div>--></div></div></form></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button ng-click=\"vm.save()\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div>");
$templateCache.put("app/entities/vendor/vendor-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.vendor.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.vendor.delete.question\" translate-values=\"{id: \'{{vm.vendor.id}}\'}\">Are you sure you want to delete this Vendor?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/vendor/vendor-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\"><span translate=\"crm2PrintApp.vendor.detail.title\">Vendor</span> {{vm.vendor.id}}</h3></div><div class=\"block-content\"><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.vendor.name\">Name</span></dt><dd><span>{{vm.vendor.name}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.logo\">Logo</span></dt><dd><span>{{vm.vendor.logo}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.website\">Website</span></dt><dd><a href=\"{{vm.vendor.website}}\" target=\"_blank\">{{vm.vendor.website}}</a></dd><dt><span translate=\"crm2PrintApp.vendor.deliveryMethod\">Delivery Method</span></dt><dd><span translate=\"{{\'crm2PrintApp.DeliveryMethod.\' + vm.vendor.deliveryMethod}}\">{{vm.vendor.deliveryMethod}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.deliveryFormat\">Delivery Format</span></dt><dd><span>{{vm.vendor.deliveryFormat}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.deliveryPaperSize\">Delivery Paper Size</span></dt><dd><span>{{vm.vendor.deliveryPaperSize}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.email\">Email</span></dt><dd><span>{{vm.vendor.email}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.ftpUser\">Ftp User</span></dt><dd><span>{{vm.vendor.ftpUser}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.ftpPassword\">Ftp Password</span></dt><dd><span>{{vm.vendor.ftpPassword}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.ftpTls\">Ftp Tls</span></dt><dd><span>{{vm.vendor.ftpTls}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.barcodeScheme\">Barcode Scheme</span></dt><dd><span>{{vm.vendor.barcodeScheme}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.trayCapacity\">Tray Capacity</span></dt><dd><span>{{vm.vendor.trayCapacity}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.deliveryPaperSize\">Delivery Paper Size</span></dt><dd><span>{{vm.vendor.deliveryPaperSize}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.status\">Status</span></dt><dd><span translate=\"{{\'crm2PrintApp.FeatureStatus.\' + vm.vendor.status}}\">{{vm.vendor.status}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.maxPageCount\">Max Page Count</span></dt><dd><span>{{vm.vendor.maxPageCount}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.minLetterCount\">Min Letter Count</span></dt><dd><span>{{vm.vendor.minLetterCount}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.lodgementState\">Lodgement State</span></dt><dd><span>{{vm.vendor.lodgementState}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.envelopes\">Envelopes</span></dt><dd><span ng-repeat=\"envelopes in vm.vendor.envelopes\"><a ui-sref=\"envelope-detail({id: {{envelopes.id}}})\">{{envelopes.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"crm2PrintApp.vendor.country\">Country</span></dt><dd><a ui-sref=\"country-detail({id:vm.vendor.country.id})\">{{vm.vendor.country.name}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info push-10\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div>");
$templateCache.put("app/entities/vendor/vendor-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myVendorLabel\" translate=\"crm2PrintApp.vendor.home.createOrEditLabel\">Create or edit a Vendor</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.vendor.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.vendor.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.vendor.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.logo\" for=\"field_logo\">Logo</label><input type=\"text\" class=\"form-control\" name=\"logo\" id=\"field_logo\" ng-model=\"vm.vendor.logo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.website\" for=\"field_website\">Website</label><input type=\"text\" class=\"form-control\" name=\"website\" id=\"field_website\" ng-model=\"vm.vendor.website\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.deliveryMethod\" for=\"field_deliveryMethod\">Delivery Method</label><select class=\"form-control\" name=\"deliveryMethod\" ng-model=\"vm.vendor.deliveryMethod\" id=\"field_deliveryMethod\"><option value=\"FTP\" translate=\"crm2PrintApp.DeliveryMethod.FTP\">FTP</option><option value=\"EMAIL\" translate=\"crm2PrintApp.DeliveryMethod.EMAIL\">EMAIL</option><option value=\"CUSTOM\" translate=\"crm2PrintApp.DeliveryMethod.CUSTOM\">CUSTOM</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.deliveryFormat\" for=\"field_deliveryFormat\">Delivery Format</label><input type=\"text\" class=\"form-control\" name=\"deliveryFormat\" id=\"field_deliveryFormat\" ng-model=\"vm.vendor.deliveryFormat\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.email\" for=\"field_email\">Email</label><input type=\"text\" class=\"form-control\" name=\"email\" id=\"field_email\" ng-model=\"vm.vendor.email\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.ftpUser\" for=\"field_ftpUser\">Ftp User</label><input type=\"text\" class=\"form-control\" name=\"ftpUser\" id=\"field_ftpUser\" ng-model=\"vm.vendor.ftpUser\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.ftpPassword\" for=\"field_ftpPassword\">Ftp Password</label><input type=\"text\" class=\"form-control\" name=\"ftpPassword\" id=\"field_ftpPassword\" ng-model=\"vm.vendor.ftpPassword\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.ftpTls\" for=\"field_ftpTls\">Ftp Tls</label><input type=\"checkbox\" class=\"form-control\" name=\"ftpTls\" id=\"field_ftpTls\" ng-model=\"vm.vendor.ftpTls\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.barcodeScheme\" for=\"field_barcodeScheme\">Barcode Scheme</label><input type=\"text\" class=\"form-control\" name=\"barcodeScheme\" id=\"field_barcodeScheme\" ng-model=\"vm.vendor.barcodeScheme\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.trayCapacity\" for=\"field_trayCapacity\">Tray Capacity</label><input type=\"number\" class=\"form-control\" name=\"trayCapacity\" id=\"field_trayCapacity\" ng-model=\"vm.vendor.trayCapacity\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.deliveryPaperSize\" for=\"field_deliveryPaperSize\">Delivery Paper Size</label><input type=\"text\" class=\"form-control\" name=\"deliveryPaperSize\" id=\"field_deliveryPaperSize\" ng-model=\"vm.vendor.deliveryPaperSize\" ng-pattern=\"/((?:SR)?(A[0-4])|Letter|Legal|8x4)/\"><div ng-show=\"editForm.deliveryPaperSize.$invalid\"><p class=\"help-block\" ng-show=\"editForm.deliveryPaperSize.$error.pattern\" translate=\"entity.validation.pattern\" translate-value-pattern=\"((?:SR)?(A[0-4])|Letter|Legal|8x4)\">This field should follow pattern \"((?:SR)?(A[0-4])|Letter|Legal|8x4)\".</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.vendor.status\" id=\"field_status\" required><option value=\"ACTIVE\" translate=\"crm2PrintApp.FeatureStatus.ACTIVE\">ACTIVE</option><option value=\"BETA\" translate=\"crm2PrintApp.FeatureStatus.BETA\">BETA</option><option value=\"ALPHA\" translate=\"crm2PrintApp.FeatureStatus.ALPHA\">ALPHA</option><option value=\"DISABLED\" translate=\"crm2PrintApp.FeatureStatus.DISABLED\">DISABLED</option></select><div ng-show=\"editForm.status.$invalid\"><p class=\"help-block\" ng-show=\"editForm.status.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.maxPageCount\" for=\"field_maxPageCount\">Max Page Count</label><input type=\"number\" class=\"form-control\" name=\"maxPageCount\" id=\"field_maxPageCount\" ng-model=\"vm.vendor.maxPageCount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.minLetterCount\" for=\"field_minLetterCount\">Min Letter Count</label><input type=\"number\" class=\"form-control\" name=\"minLetterCount\" id=\"field_minLetterCount\" ng-model=\"vm.vendor.minLetterCount\" required min=\"0\"><div ng-show=\"editForm.minLetterCount.$invalid\"><p class=\"help-block\" ng-show=\"editForm.minLetterCount.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.minLetterCount.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.minLetterCount.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendor.lodgementState\" for=\"field_lodgementState\">Lodgement State</label><input type=\"text\" class=\"form-control\" name=\"lodgementState\" id=\"field_lodgementState\" ng-model=\"vm.vendor.lodgementState\"></div><div class=\"form-group\"><label translate=\"crm2PrintApp.vendor.envelopes\" for=\"field_envelopes\">Envelopes</label><select class=\"form-control\" id=\"field_envelopes\" multiple=\"multiple\" name=\"envelopes\" ng-model=\"vm.vendor.envelopes\" ng-options=\"envelope as envelope.code for envelope in vm.envelopes track by envelope.id\"></select></div><div class=\"form-group\"><label translate=\"crm2PrintApp.vendor.country\" for=\"field_country\">Country</label><select class=\"form-control\" id=\"field_country\" name=\"country\" ng-model=\"vm.vendor.country\" ng-options=\"country as country.name for country in vm.countries track by country.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/vendor/vendors.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.vendor.home.title\">Vendors</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"vendor.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.vendor.home.createLabel\">Create new Vendor</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.vendor.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"crm2PrintApp.vendor.name\">Name</span></th><th><span translate=\"crm2PrintApp.vendor.deliveryMethod\">Delivery Method</span></th><th><span translate=\"crm2PrintApp.vendor.deliveryFormat\">Format</span></th><th><span translate=\"crm2PrintApp.vendor.deliveryPaperSize\">Paper Size</span></th><th><span translate=\"crm2PrintApp.vendor.barcodeScheme\">Barcode Scheme</span></th><th><span translate=\"crm2PrintApp.vendor.status\">Status</span></th><th><span translate=\"crm2PrintApp.vendor.maxPageCount\">Max Page Count</span></th><th><span translate=\"crm2PrintApp.vendor.minLetterCount\">Min Letter Count</span></th><th><span translate=\"crm2PrintApp.vendor.lodgementState\">Lodgement State</span></th><th><span translate=\"crm2PrintApp.vendor.envelopes\">Envelopes</span></th><th><span translate=\"crm2PrintApp.vendor.country\">Country</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"vendor in vm.vendors track by vendor.id\"><td><a ui-sref=\"vendor-detail({id:vendor.id})\">{{vendor.id}}</a></td><td>{{vendor.name}}</td><td translate=\"{{\'crm2PrintApp.DeliveryMethod.\' + vendor.deliveryMethod}}\">{{vendor.deliveryMethod}}</td><td>{{vendor.deliveryFormat}}</td><td>{{vendor.deliveryPaperSize}}</td><td>{{vendor.barcodeScheme}}</td><td translate=\"{{\'crm2PrintApp.FeatureStatus.\' + vendor.status}}\">{{vendor.status}}</td><td>{{vendor.maxPageCount}}</td><td>{{vendor.minLetterCount}}</td><td>{{vendor.lodgementState}}</td><td><span ng-repeat=\"envelopes in vendor.envelopes\"><a class=\"form-control-static\" ui-sref=\"envelope-detail({id: {{envelopes.id}}})\">{{envelopes.code}}</a>{{$last ? \'\' : \', \'}}</span></td><td><a ui-sref=\"country-detail({id:vendor.country.id})\">{{vendor.country.name}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"vendor-detail({id:vendor.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"vendor.edit({id:vendor.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"vendor.delete({id:vendor.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/entities/vendor-staff/vendor-staff-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.vendorStaff.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.vendorStaff.delete.question\" translate-values=\"{id: \'{{vm.vendorStaff.id}}\'}\">Are you sure you want to delete this Vendor Staff?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/vendor-staff/vendor-staff-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\"><span translate=\"crm2PrintApp.vendorStaff.detail.title\">Vendor Staff</span> {{vm.vendorStaff.id}}</h3></div><div class=\"block-content\"><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.vendorStaff.created\">Created</span></dt><dd><span>{{vm.vendorStaff.created | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.vendorStaff.vendor\">Vendor</span></dt><dd><a ui-sref=\"vendor-detail({id:vm.vendorStaff.vendorId})\">{{vm.vendorStaff.vendorName}}</a></dd><dt><span translate=\"crm2PrintApp.vendorStaff.user\">User</span></dt><dd>{{vm.vendorStaff.userLogin}}</dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div>");
$templateCache.put("app/entities/vendor-staff/vendor-staff-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myVendorStaffLabel\" translate=\"crm2PrintApp.vendorStaff.home.createOrEditLabel\">Create or edit a Vendor Staff</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.vendorStaff.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.vendorStaff.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendorStaff.created\" for=\"field_created\">Created</label><div class=\"input-group\"><input id=\"field_created\" type=\"text\" class=\"form-control\" name=\"created\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.vendorStaff.created\" is-open=\"vm.datePickerOpenStatus.created\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'created\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.created.$invalid\"><p class=\"help-block\" ng-show=\"editForm.created.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.created.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label translate=\"crm2PrintApp.vendorStaff.vendor\" for=\"field_vendor\">Vendor</label><select class=\"form-control\" id=\"field_vendor\" name=\"vendor\" ng-model=\"vm.vendorStaff.vendorId\" ng-options=\"vendor.id as vendor.name for vendor in vm.vendors\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.vendor.$invalid\"><p class=\"help-block\" ng-show=\"editForm.vendor.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><label translate=\"crm2PrintApp.vendorStaff.user\" for=\"field_user\">User</label><select class=\"form-control\" id=\"field_user\" name=\"user\" ng-model=\"vm.vendorStaff.userId\" ng-options=\"user.id as user.login for user in vm.users\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.user.$invalid\"><p class=\"help-block\" ng-show=\"editForm.user.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/vendor-staff/vendor-staffs.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.vendorStaff.home.title\">Vendor Staff</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"vendor-staff.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.vendorStaff.home.createLabel\">Create new Vendor Staff</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.vendorStaff.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"created\"><span translate=\"crm2PrintApp.vendorStaff.created\">Created</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vendorName\"><span translate=\"crm2PrintApp.vendorStaff.vendor\">Vendor</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"userLogin\"><span translate=\"crm2PrintApp.vendorStaff.user\">User</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"vendorStaff in vm.vendorStaffs track by vendorStaff.id\"><td><a ui-sref=\"vendor-staff-detail({id:vendorStaff.id})\">{{vendorStaff.id}}</a></td><td>{{vendorStaff.created | date:\'medium\'}}</td><td><a ui-sref=\"vendor-detail({id:vendorStaff.vendorId})\">{{vendorStaff.vendorName}}</a></td><td>{{vendorStaff.userLogin}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"vendor-staff-detail({id:vendorStaff.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"vendor-staff.edit({id:vendorStaff.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"vendor-staff.delete({id:vendorStaff.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div></div>");
$templateCache.put("app/entities/vendor-job-ticket/vendor-job-ticket-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.vendorJobTicket.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.vendorJobTicket.delete.question\" translate-values=\"{id: \'{{vm.vendorJobTicket.id}}\'}\">Are you sure you want to delete this Vendor Job Ticket?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/vendor-job-ticket/vendor-job-ticket-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\"><span translate=\"crm2PrintApp.vendorJobTicket.detail.title\">Vendor Job Ticket</span> {{vm.vendorJobTicket.id}}</h3></div><div class=\"block-content\"><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.vendorJobTicket.created\">Created</span></dt><dd><span>{{vm.vendorJobTicket.created | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.vendorJobTicket.send\">Send</span></dt><dd><span>{{vm.vendorJobTicket.send | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.vendorJobTicket.received\">Received</span></dt><dd><span>{{vm.vendorJobTicket.received | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.vendorJobTicket.started\">Started</span></dt><dd><span>{{vm.vendorJobTicket.started | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.vendorJobTicket.finished\">Finished</span></dt><dd><span>{{vm.vendorJobTicket.finished | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.vendorJobTicket.letterCount\">Letter Count</span></dt><dd><span>{{vm.vendorJobTicket.letterCount}}</span></dd><!--        <dt><span translate=\"crm2PrintApp.vendorJobTicket.pageCount\">Page Count</span></dt>\n        <dd>\n            <span>{{vm.vendorJobTicket.pageCount}}</span>\n        </dd>\n        <dt><span translate=\"crm2PrintApp.vendorJobTicket.sheetCount\">Sheet Count</span></dt>\n        <dd>\n            <span>{{vm.vendorJobTicket.sheetCount}}</span>\n        </dd>--><dt><span translate=\"crm2PrintApp.vendorJobTicket.postalAccount\">Postal Account</span></dt><dd><a ui-sref=\"postal-account-detail({id:vm.vendorJobTicket.postalAccount.id})\">{{vm.vendorJobTicket.postalAccount.id}}</a></dd><dt><span translate=\"crm2PrintApp.vendorJobTicket.vendor\">Vendor</span></dt><dd><a ui-sref=\"vendor-detail({id:vm.vendorJobTicket.vendor.id})\">{{vm.vendorJobTicket.vendor.name}}</a></dd></dl><button type=\"submit\" ui-sref=\"vendor-job-ticket.edit({id:vm.vendorJobTicket.id})\" class=\"btn btn-primary push-10 push-10-t\"><span class=\"glyphicon glyphicon-pencil\" title=\"Edit\"></span>&nbsp;<span>Edit</span></button> <button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div>");
$templateCache.put("app/entities/vendor-job-ticket/vendor-job-ticket-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myVendorJobTicketLabel\" translate=\"crm2PrintApp.vendorJobTicket.home.createOrEditLabel\">Create or edit a Vendor Job Ticket</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.vendorJobTicket.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.vendorJobTicket.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendorJobTicket.created\" for=\"field_created\">Created</label><div class=\"input-group\"><input id=\"field_created\" type=\"text\" class=\"form-control\" name=\"created\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.vendorJobTicket.created\" is-open=\"vm.datePickerOpenStatus.created\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'created\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendorJobTicket.send\" for=\"field_send\">Send</label><div class=\"input-group\"><input id=\"field_send\" type=\"text\" class=\"form-control\" name=\"send\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.vendorJobTicket.send\" is-open=\"vm.datePickerOpenStatus.send\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'send\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendorJobTicket.received\" for=\"field_received\">Received</label><div class=\"input-group\"><input id=\"field_received\" type=\"text\" class=\"form-control\" name=\"received\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.vendorJobTicket.received\" is-open=\"vm.datePickerOpenStatus.received\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'received\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendorJobTicket.started\" for=\"field_started\">Started</label><div class=\"input-group\"><input id=\"field_started\" type=\"text\" class=\"form-control\" name=\"started\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.vendorJobTicket.started\" is-open=\"vm.datePickerOpenStatus.started\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'started\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendorJobTicket.finished\" for=\"field_finished\">Finished</label><div class=\"input-group\"><input id=\"field_finished\" type=\"text\" class=\"form-control\" name=\"finished\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.vendorJobTicket.finished\" is-open=\"vm.datePickerOpenStatus.finished\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'finished\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendorJobTicket.letterCount\" for=\"field_letterCount\">Letter Count</label><input type=\"number\" class=\"form-control\" name=\"letterCount\" id=\"field_letterCount\" ng-model=\"vm.vendorJobTicket.letterCount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendorJobTicket.pageCount\" for=\"field_pageCount\">Page Count</label><input type=\"number\" class=\"form-control\" name=\"pageCount\" id=\"field_pageCount\" ng-model=\"vm.vendorJobTicket.pageCount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.vendorJobTicket.sheetCount\" for=\"field_sheetCount\">Sheet Count</label><input type=\"number\" class=\"form-control\" name=\"sheetCount\" id=\"field_sheetCount\" ng-model=\"vm.vendorJobTicket.sheetCount\"></div><div class=\"form-group\"><label translate=\"crm2PrintApp.vendorJobTicket.postalAccount\" for=\"field_postalAccount\">Postal Account</label><select class=\"form-control\" id=\"field_postalAccount\" name=\"postalAccount\" ng-model=\"vm.vendorJobTicket.postalAccount\" ng-options=\"postalAccount as postalAccount.id for postalAccount in vm.postalaccounts track by postalAccount.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"crm2PrintApp.vendorJobTicket.vendor\" for=\"field_vendor\">Vendor</label><select class=\"form-control\" id=\"field_vendor\" name=\"vendor\" ng-model=\"vm.vendorJobTicket.vendor\" ng-options=\"vendor as vendor.id for vendor in vm.vendors track by vendor.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/vendor-job-ticket/vendor-job-tickets.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.vendorJobTicket.home.title\">Vendor Job Tickets</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-danger\" ng-click=\"vm.sendNewTickets()\"><span class=\"glyphicon glyphicon-send\"></span> <span class=\"hidden-xs\">Send New Tickets</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.vendorJobTicket.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"crm2PrintApp.vendorJobTicket.created\">Created</span></th><th><span translate=\"crm2PrintApp.vendorJobTicket.send\">Send</span></th><th><span translate=\"crm2PrintApp.vendorJobTicket.received\">Received</span></th><th><span translate=\"crm2PrintApp.vendorJobTicket.started\">Started</span></th><th><span translate=\"crm2PrintApp.vendorJobTicket.finished\">Finished</span></th><th><span translate=\"crm2PrintApp.vendorJobTicket.letterCount\">Letter Count</span></th><!--<th><span translate=\"crm2PrintApp.vendorJobTicket.pageCount\">Page Count</span></th>\n                        <th><span translate=\"crm2PrintApp.vendorJobTicket.sheetCount\">Sheet Count</span></th>--><th><span translate=\"crm2PrintApp.vendorJobTicket.postalAccount\">Postal Account</span></th><th><span translate=\"crm2PrintApp.vendorJobTicket.vendor\">Vendor</span></th><th>Manifest</th><th></th></tr></thead><tbody><tr ng-repeat=\"vendorJobTicket in vm.vendorJobTickets track by vendorJobTicket.id\"><td><a ui-sref=\"vendor-job-ticket-detail({id:vendorJobTicket.id})\">{{vendorJobTicket.id}}</a></td><td>{{vendorJobTicket.created | date:\'medium\'}}</td><td>{{vendorJobTicket.send | date:\'medium\'}}</td><td>{{vendorJobTicket.received | date:\'medium\'}}</td><td>{{vendorJobTicket.started | date:\'medium\'}}</td><td>{{vendorJobTicket.finished | date:\'medium\'}}</td><td>{{vendorJobTicket.letterCount}}</td><!--<td>{{vendorJobTicket.pageCount}}</td>\n                        <td>{{vendorJobTicket.sheetCount}}</td>--><td><a ui-sref=\"postal-account-detail({id:vendorJobTicket.postalAccount.id})\">{{vendorJobTicket.postalAccount.id}}</a></td><td><a ui-sref=\"vendor-detail({id:vendorJobTicket.vendor.id})\">{{vendorJobTicket.vendor.name}}</a></td><td><a href=\"/job-tickets/{{vendorJobTicket.id}}/manifest\" target=\"_blank\"><i class=\"fa fa-list\"></i></a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"vendor-job-ticket-detail({id:vendorJobTicket.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"vendor-job-ticket.edit({id:vendorJobTicket.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"vendor-job-ticket.delete({id:vendorJobTicket.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/entities/voucher-code/voucher-code-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.voucherCode.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"crm2PrintApp.voucherCode.delete.question\" translate-values=\"{id: \'{{vm.voucherCode.id}}\'}\">Are you sure you want to delete this Voucher Code?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/voucher-code/voucher-code-detail.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.voucherCode.detail.title\">Voucher Code {{vm.voucherCode.id}}</h3></div><div class=\"block-content\"><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"crm2PrintApp.voucherCode.code\">Code</span></dt><dd><span>{{vm.voucherCode.code}}</span></dd><dt><span translate=\"crm2PrintApp.voucherCode.created\">Created</span></dt><dd><span>{{vm.voucherCode.created | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.voucherCode.expires\">Expires</span></dt><dd><span>{{vm.voucherCode.expires | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.voucherCode.useCount\">Use Count</span></dt><dd><span>{{vm.voucherCode.useCount}}</span></dd><dt><span translate=\"crm2PrintApp.voucherCode.discount\">Discount</span></dt><dd><span>{{vm.voucherCode.discount}}</span></dd><dt><span translate=\"crm2PrintApp.voucherCode.minimumOrder\">Minimum Order</span></dt><dd><span>{{vm.voucherCode.minimumOrder}}</span></dd><dt><span translate=\"crm2PrintApp.voucherCode.used\">Used</span></dt><dd><span>{{vm.voucherCode.used | date:\'medium\'}}</span></dd><dt><span translate=\"crm2PrintApp.voucherCode.reference\">Reference</span></dt><dd><span>{{vm.voucherCode.reference}}</span></dd><dt><span translate=\"crm2PrintApp.voucherCode.demo\">Demo</span></dt><dd><span>{{vm.voucherCode.demo}}</span></dd><dt><span translate=\"crm2PrintApp.voucherCode.creator\">Creator</span></dt><dd>{{vm.voucherCode.creator.login}}</dd><dt><span translate=\"crm2PrintApp.voucherCode.user\">User</span></dt><dd>{{vm.voucherCode.user.login}}</dd><dt><span translate=\"crm2PrintApp.voucherCode.printJobCharge\">Print Job Charge</span></dt><dd><a ui-sref=\"print-job-charge-detail({id:vm.voucherCode.printJobCharge.id})\">{{vm.voucherCode.printJobCharge.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info push-10\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div>");
$templateCache.put("app/entities/voucher-code/voucher-code-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myVoucherCodeLabel\" translate=\"crm2PrintApp.voucherCode.home.createOrEditLabel\">Create or edit a Voucher Code</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\" ng-show=\"vm.voucherCode.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.voucherCode.id\" readonly=\"readonly\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.voucherCode.created\">Created</label><div class=\"form-control-static\">{{vm.voucherCode.created | date:\'dd/MM/yyyy HH:mm:ss\'}} by {{vm.voucherCode.creator.login}}</div></div></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.voucherCode.reference\" for=\"field_reference\">Reference</label><input type=\"text\" class=\"form-control\" name=\"reference\" id=\"field_reference\" ng-model=\"vm.voucherCode.reference\"></div><!--<div class=\"form-group\">\n            <label class=\"control-label\" translate=\"crm2PrintApp.voucherCode.code\" for=\"field_code\">Code</label>\n            <input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\"\n                    ng-model=\"vm.voucherCode.code\"\n                     />\n        </div>--><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.voucherCode.discount\" for=\"field_discount\">Discount</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-dollar\"></i></span> <input type=\"number\" class=\"form-control\" name=\"discount\" id=\"field_discount\" ng-model=\"vm.voucherCode.discount\"> <span class=\"input-group-addon\">.00</span></div></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.voucherCode.minimumOrder\" for=\"field_minimumOrder\">Minimum Order</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-envelope\"></i></span> <input type=\"number\" class=\"form-control\" name=\"minimumOrder\" id=\"field_minimumOrder\" min=\"50\" ng-model=\"vm.voucherCode.minimumOrder\"> <span class=\"input-group-addon\">letters</span></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.voucherCode.expires\" for=\"field_expires\">Expires</label><div class=\"input-group\"><input id=\"field_expires\" type=\"text\" class=\"form-control\" name=\"expires\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.voucherCode.expires\" is-open=\"vm.datePickerOpenStatus.expires\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'expires\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.voucherCode.demo\" for=\"field_demo\">Demo</label><input type=\"checkbox\" class=\"form-control\" name=\"demo\" id=\"field_demo\" ng-model=\"vm.voucherCode.demo\"><div ng-show=\"editForm.demo.$invalid\"><p class=\"help-block\" ng-show=\"editForm.demo.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.voucherCode.useCount\">Use Count</label><div class=\"form-control-static\">{{vm.voucherCode.useCount || 0}}</div></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"crm2PrintApp.voucherCode.used\">Used</label><div class=\"form-control-static\">{{vm.voucherCode.used | date:\'dd/MM/yyyy HH:mm:ss\'}}</div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"crm2PrintApp.voucherCode.user\" for=\"field_user\">User</label><select class=\"form-control\" id=\"field_user\" name=\"user\" ng-model=\"vm.voucherCode.user\" ng-options=\"user as user.login for user in vm.users track by user.id\"><option value=\"\"></option></select></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/voucher-code/voucher-codes.html","<div class=\"block\"><div class=\"block-header\"><h3 class=\"block-title\" translate=\"crm2PrintApp.voucherCode.home.title\">Voucher Codes</h3></div><div class=\"block-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"voucher-code.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"crm2PrintApp.voucherCode.home.createLabel\">Create new Voucher Code</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'crm2PrintApp.voucherCode.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th jh-sort-by=\"code\"><span translate=\"crm2PrintApp.voucherCode.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th jh-sort-by=\"created\"><span translate=\"crm2PrintApp.voucherCode.created\">Created</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th jh-sort-by=\"expires\"><span translate=\"crm2PrintApp.voucherCode.expires\">Expires</span> <span class=\"glyphicon glyphicon-sort\"></span></th>\n                        <th jh-sort-by=\"useCount\"><span translate=\"crm2PrintApp.voucherCode.useCount\">Use Count</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th jh-sort-by=\"discount\"><span translate=\"crm2PrintApp.voucherCode.discount\">Discount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"minimumOrder\"><span translate=\"crm2PrintApp.voucherCode.minimumOrder\">Minimum Order</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"used\"><span translate=\"crm2PrintApp.voucherCode.used\">Used</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"reference\"><span translate=\"crm2PrintApp.voucherCode.reference\">Reference</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"demo\"><span translate=\"crm2PrintApp.voucherCode.demo\">Demo</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"creator.login\"><span translate=\"crm2PrintApp.voucherCode.creator\">Creator</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"user.login\"><span translate=\"crm2PrintApp.voucherCode.user\">User</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"printJobCharge.id\"><span translate=\"crm2PrintApp.voucherCode.printJobCharge\">Print Job Charge</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"voucherCode in vm.voucherCodes track by voucherCode.id\"><td><a ui-sref=\"voucher-code-detail({id:voucherCode.id})\">{{voucherCode.id}}</a></td><!-- <td>{{voucherCode.code}}</td>--><td>{{voucherCode.created | date:\'medium\'}}</td><!--<td>{{voucherCode.expires | date:\'medium\'}}</td>\n                        <td>{{voucherCode.useCount}}</td>--><td>{{voucherCode.discount | currency:\"$\":0}}</td><td>{{voucherCode.minimumOrder}}</td><td>{{voucherCode.used | date:\'medium\'}}</td><td>{{voucherCode.reference}}</td><td>{{voucherCode.demo}}</td><td>{{voucherCode.creator.login}}</td><td>{{voucherCode.user.login}}</td><td><a ui-sref=\"print-job-charge-detail({id:voucherCode.printJobCharge.id})\">{{voucherCode.printJobCharge.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"voucher-code-detail({id:voucherCode.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"voucher-code.edit({id:voucherCode.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"voucher-code.delete({id:voucherCode.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div></div>");
$templateCache.put("app/layouts/error/accessdenied.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-4\"><a ui-sref=\"home\"><span class=\"crm2print-logo-large img-responsive img-rounded\"></span></a></div><div class=\"col-md-8\"><h1 translate=\"error.title\">Error Page!</h1><div class=\"alert alert-danger\" translate=\"error.403\">You are not authorized to access the page.</div></div></div></div>");
$templateCache.put("app/layouts/error/error.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-4\"><span class=\"crm2print-logo-large img-responsive img-rounded\"></span></div><div class=\"col-md-8\"><h1 translate=\"error.title\">Error Page!</h1><div ng-show=\"errorMessage\"><div class=\"alert alert-danger\">{{errorMessage}}</div></div></div></div></div>");
$templateCache.put("app/layouts/navbar/navbar-new.html","<nav class=\"navbar navbar-default\" role=\"navigation\"><div class=\"container\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle\" ng-click=\"vm.toggleNavbar()\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand logo\" href=\"#/\" ng-click=\"vm.collapseNavbar()\"><img class=\"logo-img\" src=\"content/images/logo-jhipster.png\"> <span translate=\"global.title\">Crm2print</span> <span class=\"navbar-version\">v{{VERSION}}</span></a></div><div class=\"navbar-collapse\" uib-collapse=\"vm.isNavbarCollapsed\" ng-switch=\"vm.isAuthenticated()\"><ul class=\"nav navbar-nav navbar-right\"><li ui-sref-active=\"active\"><a ui-sref=\"home\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-home\"></span> <span class=\"hidden-sm\" translate=\"global.menu.home\">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class=\"{active: vm.$state.includes(\'entity\')}\" ng-switch-when=\"true\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"entity-menu\"><span><span class=\"glyphicon glyphicon-th-list\"></span> <span class=\"hidden-sm\" translate=\"global.menu.entities.main\">Entities </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\"><a ui-sref=\"site\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.site\">Site</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"site-api\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.siteApi\">Site Api</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"user-pricing\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.userPricing\">User Pricing</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"print-and-mail-cost\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.printAndMailCost\">Print And Mail Cost</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"site-customisation\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.siteCustomisation\">Site Customisation</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"site-user\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.siteUser\">Site User</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"site-token\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.siteToken\">Site Token</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"vendor-job-ticket\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.vendorJobTicket\">Vendor Job Ticket</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"manifest-row\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.manifestRow\">Manifest Row</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"postal-account\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.postalAccount\">Postal Account</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"print-job\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.printJob\">Print Job</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"print-job-record\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.printJobRecord\">Print Job Record</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"print-job-history\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.printJobHistory\">Print Job History</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"vendor\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.vendor\">Vendor</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"template\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.template\">Template</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"envelope\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.envelope\">Envelope</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"country\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.country\">Country</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"stationery\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.stationery\">Stationery</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"voucher-code\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.voucherCode\">Voucher Code</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"cost-center\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.costCenter\">Cost Center</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"account-menu\"><span><span class=\"glyphicon glyphicon-user\"></span> <span class=\"hidden-sm\" translate=\"global.menu.account.main\">Account </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"settings\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-wrench\"></span>&nbsp; <span translate=\"global.menu.account.settings\">Settings</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"password\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-lock\"></span> <span translate=\"global.menu.account.password\">Password</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a href=\"\" ng-click=\"vm.logout()\" id=\"logout\"><span class=\"glyphicon glyphicon-log-out\"></span>&nbsp; <span translate=\"global.menu.account.logout\">Sign out</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"false\"><a href=\"\" ng-click=\"vm.login()\" id=\"login\"><span class=\"glyphicon glyphicon-log-in\"></span>&nbsp; <span translate=\"global.menu.account.login\">Sign in</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"false\"><a ui-sref=\"register\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-plus-sign\"></span>&nbsp; <span translate=\"global.menu.account.register\">Register</span></a></li></ul></li><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" ng-switch-when=\"true\" has-authority=\"ROLE_ADMIN\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"admin-menu\"><span><span class=\"glyphicon glyphicon-tower\"></span> <span class=\"hidden-sm\" translate=\"global.menu.admin.main\">Administration</span> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\"><a ui-sref=\"user-management\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-user\"></span>&nbsp; <span translate=\"global.menu.admin.userManagement\">User management</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-metrics\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-dashboard\"></span>&nbsp; <span translate=\"global.menu.admin.metrics\">Metrics</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-health\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-heart\"></span>&nbsp; <span translate=\"global.menu.admin.health\">Health</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-configuration\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.admin.configuration\">Configuration</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"audits\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-bell\"></span>&nbsp; <span translate=\"global.menu.admin.audits\">Audits</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"logs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-tasks\"></span>&nbsp; <span translate=\"global.menu.admin.logs\">Logs</span></a></li><li ng-hide=\"vm.inProduction || vm.swaggerDisabled\" ui-sref-active=\"active\"><a ui-sref=\"docs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-book\"></span>&nbsp; <span translate=\"global.menu.admin.apidocs\">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active=\"active\" uib-dropdown class=\"dropdown pointer\" ng-controller=\"JhiLanguageController as languageVm\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" ng-if=\"languageVm.languages.length > 1\"><span><span class=\"glyphicon glyphicon-flag\"></span> <span class=\"hidden-sm\" translate=\"global.menu.language\">Language</span> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu ng-if=\"languageVm.languages.length > 1\"><li active-menu=\"{{language}}\" ng-repeat=\"language in languageVm.languages\"><a href=\"\" ng-click=\"languageVm.changeLanguage(language);vm.collapseNavbar();\">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>");
$templateCache.put("app/layouts/navbar/navbar.html","<!-- Header Navigation Right --><div data-ng-controller=\"HeaderCtrl\" id=\"header-navbar\" class=\"content-mini content-mini-full\" ng-switch=\"vm.isAuthenticated()\"><ul class=\"nav-header pull-right\"><li ng-show=\"vm.costCenterInviteToken\"><a ng-href=\"/cost-centers/{{vm.costCenterInviteToken}}/confirm-invite\" class=\"btn btn-warning\"><span class=\"glyphicon glyphicon-inbox\"></span> <span class=\"hidden-xs\">Accept Cost Centre Invitation</span></a></li><li><button class=\"btn btn-primary\" ng-click=\"vm.showWelcomeGuide()\"><span class=\"si si-book-open\"></span> <span class=\"hidden-xs\">Welcome Guide</span></button></li><li><a ui-sref=\"home\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-home\"></span> <span class=\"hidden-xs\" translate=\"global.menu.home\">Home</span></a></li><li has-authority=\"ROLE_ADMIN\"><a ui-sref=\"admin-dashboard\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-dashboard\"></span> <span class=\"hidden-xs\" translate=\"global.menu.admin.dashboard\">Dashboard</span></a></li><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" ng-switch-when=\"true\" has-authority=\"ROLE_ADMIN\"><div class=\"btn-group\" data-on-toggle=\"toggled(open)\" data-uib-dropdown><button class=\"btn btn-default\" type=\"button\" data-uib-dropdown-toggle><span class=\"glyphicon glyphicon-tower\"></span> <span class=\"hidden-xs\" translate=\"global.menu.admin.main\">Administration</span> <span class=\"caret\"></span></button><ul class=\"dropdown-menu-right\" data-uib-dropdown-menu><li class=\"dropdown-header\" translate=\"global.menu.admin.main\">Administration</li><li ui-sref-active=\"active\"><a ui-sref=\"user-management\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-user\"></span>&nbsp; <span translate=\"global.menu.admin.userManagement\">User management</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-metrics\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-dashboard\"></span>&nbsp; <span translate=\"global.menu.admin.metrics\">Metrics</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-health\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-heart\"></span>&nbsp; <span translate=\"global.menu.admin.health\">Health</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-configuration\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.admin.configuration\">Configuration</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"audits\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-bell\"></span>&nbsp; <span translate=\"global.menu.admin.audits\">Audits</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"logs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-tasks\"></span>&nbsp; <span translate=\"global.menu.admin.logs\">Logs</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"docs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-book\"></span>&nbsp; <span translate=\"global.menu.admin.apidocs\">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></div></li><li ui-sref-active=\"active\" uib-dropdown class=\"dropdown pointer\" ng-controller=\"JhiLanguageController as languageVm\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" ng-if=\"languageVm.languages.length > 1\"><span><span class=\"glyphicon glyphicon-flag\"></span> <span class=\"hidden-xs\" translate=\"global.menu.language\">Language</span> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu ng-if=\"languageVm.languages.length > 1\"><li active-menu=\"{{language}}\" ng-repeat=\"language in languageVm.languages\"><a href=\"\" ng-click=\"languageVm.changeLanguage(language);vm.collapseNavbar();\">{{language | findLanguageFromKey}}</a></li></ul></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\"><div class=\"btn-group\" data-on-toggle=\"toggled(open)\" data-uib-dropdown><button class=\"btn btn-default btn-image\" type=\"button\" data-uib-dropdown-toggle><img src=\"content/images/avatars/avatar10.jpg\" alt=\"Avatar\"> <span class=\"caret\"></span></button><ul class=\"dropdown-menu-right\" data-uib-dropdown-menu><li class=\"dropdown-header\" ng-switch-when=\"true\">Profile</li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"settings\" ng-click=\"vm.collapseNavbar()\"><i class=\"si si-user pull-right\"></i> <span>Account</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"user-profile\" ng-click=\"vm.collapseNavbar()\"><i class=\"si si-settings pull-right\"></i> <span translate=\"global.menu.account.settings\">Settings</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"site-user\" ng-click=\"vm.collapseNavbar()\"><i class=\"si si-users pull-right\"></i> <span translate=\"global.menu.entities.siteUser\">My CRM Accounts</span></a></li><li class=\"divider\" ng-switch-when=\"true\"></li><li class=\"dropdown-header\" translate=\"global.menu.account.main\">Account</li><!--<li ui-sref-active=\"active\" ng-switch-when=\"true\">\n                        <a ui-sref=\"print-job-charge\" ng-click=\"vm.collapseNavbar()\">\n                            <i class=\"si si-wallet pull-right\"></i>\n                            <span>Payments</span>\n                        </a>\n                    </li>--><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"password\" ng-click=\"vm.collapseNavbar()\"><i class=\"si si-lock pull-right\"></i> <span translate=\"global.menu.account.password\">Password</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a tabindex=\"-1\" href=\"\" ng-click=\"vm.logout()\" id=\"logout\"><i class=\"si si-logout pull-right\"></i> <span translate=\"global.menu.account.logout\">Sign out</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"false\"><a href=\"\" ng-click=\"vm.login()\" id=\"login\"><i class=\"si si-login pull-right\"></i> <span translate=\"global.menu.account.login\">Sign in</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"false\"><a ui-sref=\"register\" ng-click=\"vm.collapseNavbar()\"><i class=\"si si-user-follow pull-right\"></i> <span translate=\"global.menu.account.register\">Register</span></a></li></ul></div></li><!--<li>\n            <button class=\"btn btn-default\" type=\"button\" data-ng-click=\"oneui.settings.sideOverlayOpen = ! oneui.settings.sideOverlayOpen\" data-js-blur>\n                <i class=\"fa fa-tasks\"></i>\n            </button>\n        </li>--></ul><!-- END Header Navigation Right --><!-- Header Navigation Left --><ul class=\"nav-header pull-left\"><li class=\"hidden-md hidden-lg\" ng-switch-when=\"true\"><button class=\"btn btn-default\" type=\"button\" data-ng-click=\"oneui.settings.sidebarOpenXs = ! oneui.settings.sidebarOpenXs\" data-js-blur><i class=\"fa fa-navicon\"></i></button></li><!--<li class=\"hidden-xs hidden-xs\" ng-switch-when=\"true\">\n            <button class=\"btn btn-default\" type=\"button\" data-ng-click=\"oneui.settings.sidebarMini = ! oneui.settings.sidebarMini\" data-js-blur>\n                <i class=\"fa fa-ellipsis-v\"></i>\n            </button>\n        </li>--><li has-authority=\"ROLE_DEMO_MODE\"><span class=\"h3 font-w300 text-primary animated flipInX\">DEMO<span class=\"hidden-xs\"> MODE</span></span></li><!--<li class=\"visible-xs\" ng-switch-when=\"true\">\n            <button class=\"btn btn-default\" type=\"button\" data-js-toggle-class=\"{target: \'.js-header-search\', class: \'header-search-xs-visible\'}\" data-js-blur>\n                <i class=\"fa fa-search\"></i>\n            </button>\n        </li>--><!--    <li class=\"js-header-search header-search\">\n            <form class=\"form-horizontal\" action=\"index.html\" method=\"post\">\n                <div class=\"form-material form-material-primary input-group remove-margin-t remove-margin-b\">\n                    <input class=\"form-control\" type=\"text\" id=\"base-material-text\" name=\"base-material-text\" placeholder=\"Search..\">\n                    <span class=\"input-group-addon\"><i class=\"si si-magnifier\"></i></span>\n                </div>\n            </form>\n        </li>--></ul><!-- END Header Navigation Left --></div>");
$templateCache.put("app/account/reset/finish/reset.finish.html","<div><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 translate=\"reset.finish.title\">Reset password</h1><div class=\"alert alert-danger\" translate=\"reset.finish.messages.keymissing\" ng-show=\"vm.keyMissing\"><strong>The password reset key is missing.</strong></div><div class=\"alert alert-warning\" ng-hide=\"vm.success || vm.keyMissing\"><p translate=\"reset.finish.messages.info\">Choose a new password</p></div><div class=\"alert alert-danger\" ng-show=\"vm.error\"><p translate=\"reset.finish.messages.error\">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success\"><p translate=\"reset.finish.messages.success\" translate-compile><strong>Your password has been reset.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</p></div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><div ng-hide=\"vm.keyMissing\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.finishReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.resetAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your password confirmation is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your password confirmation is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.finish.form.button\">Reset Password</button></form></div></div></div></div>");
$templateCache.put("app/account/reset/request/reset.request.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"reset.request.title\">Reset your password</h1><div class=\"alert alert-danger\" translate=\"reset.request.messages.notfound\" ng-show=\"vm.errorEmailNotExists\"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class=\"alert alert-warning\" ng-hide=\"vm.success\"><p translate=\"reset.request.messages.info\">Enter the e-mail address you used to register.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success == \'OK\'\"><p translate=\"reset.request.messages.success\">Check your e-mails for details on how to reset your password.</p></div><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.requestReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.request.form.button\">Reset</button></form></div></div></div>");}]);})();